import * as React from 'react';
import React__default, { useState, useCallback, useEffect } from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { Helmet } from 'react-helmet';
import ReactDOM from 'react-dom';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

var interfaces = {};

var consts = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONFIGURATION_TYPES = exports.SEMANTIC_TAG_VALUES = exports.ALIGNMENT_OPTIONS = exports.BOOLEAN_VALUES = exports.BOX_SHADOW_TYPES_VALUES = exports.COLORS = exports.WHITE = exports.BLACK = exports.LIGHT_GREY = exports.GREY = exports.DARK_GREY = exports.SECONDARY = exports.PRIMARY = exports.TYPOGRAPHY_SIZE = exports.SCREEN_SIZE = void 0;
exports.SCREEN_SIZE = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small'
};
exports.TYPOGRAPHY_SIZE = {
  GIGANTIC: 'gigantic',
  HUGE: 'huge',
  LARGE: 'large',
  BIGGER: 'bigger',
  BIG: 'big',
  NORMAL: 'normal',
  TINY: 'tiny'
};
exports.PRIMARY = 'primary';
exports.SECONDARY = 'secondary';
exports.DARK_GREY = 'darkGrey';
exports.GREY = 'grey';
exports.LIGHT_GREY = 'lightGrey';
exports.BLACK = 'black';
exports.WHITE = 'white';
exports.COLORS = {
  PRIMARY: exports.PRIMARY,
  SECONDARY: exports.SECONDARY,
  DARK_GREY: exports.DARK_GREY,
  GREY: exports.GREY,
  LIGHT_GREY: exports.LIGHT_GREY,
  BLACK: exports.BLACK,
  WHITE: exports.WHITE
};
exports.BOX_SHADOW_TYPES_VALUES = {
  LOW: 'LOW',
  HIGH: 'HIGH',
  NONE: 'NONE'
};
exports.BOOLEAN_VALUES = {
  FALSE: false,
  TRUE: true
};
exports.ALIGNMENT_OPTIONS = {
  CENTER: 'CENTER',
  START: 'START'
};
exports.SEMANTIC_TAG_VALUES = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
  P: 'p',
  SPAN: 'span'
};
exports.CONFIGURATION_TYPES = {
  COLOR: 'COLOR',
  TYPOGRAPHY: 'TYPOGRAPHY',
  NUMBER: 'NUMBER',
  BOX_SHADOW: 'BOX_SHADOW',
  BOOLEAN: 'BOOLEAN',
  ALIGNMENT: 'ALIGNMENT',
  RATIO: 'RATIO',
  SEMANTIC_TAG: 'SEMANTIC_TAG',
  FACTOR: 'FACTOR'
};
}(consts));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontFaceTypeName = exports.stylesheetUrlTypeName = void 0;

exports.stylesheetUrlTypeName = 'stylesheetUrl';
exports.fontFaceTypeName = 'fontFace';

var index_1 = consts;

Object.defineProperty(exports, "COLORS", {
  enumerable: true,
  get: function () {
    return index_1.COLORS;
  }
});
Object.defineProperty(exports, "CONFIGURATION_TYPES", {
  enumerable: true,
  get: function () {
    return index_1.CONFIGURATION_TYPES;
  }
});
}(interfaces));

class PaletteManager {
  constructor(palette) {
    _defineProperty(this, "palette", void 0);

    this.palette = palette;
  }

  getColorByKey(key) {
    return this.palette.colors[key];
  }

  getFonts() {
    return this.palette.fonts;
  }

  getFontSizeMap() {
    return { ...this.palette.typography
    };
  }

}

function translatePropertyValueByType(instructions, {
  value,
  type
}) {
  if (typeof instructions === 'undefined') {
    throw new Error('must supply instructions to the transformation');
  }

  if (typeof instructions[type] !== 'function') {
    throw new Error(`there is no instruction function to type: ${type}`);
  }

  return instructions[type](value);
}

function translateProperty(instructions, property) {
  return {
    [property.id]: translatePropertyValueByType(instructions, property)
  };
}

function translateComponent(instructions, themeProperties) {
  return themeProperties.reduce((accumulator, componentProperty) => ({ ...accumulator,
    ...translateProperty(instructions, componentProperty)
  }), {});
}

function translate(instructions, themeConfiguration) {
  return themeConfiguration.reduce((accumulator, component) => ({ ...accumulator,
    [component.id]: translateComponent(instructions, component.fields)
  }), {});
}

const noBorderBoxShadow = {
  borderWidthTypeNormal: 0,
  borderWidthTypeHover: 0,
  borderWidthTypeActive: 0,
  borderColorTypeNormal: '',
  borderColorTypeHover: '',
  borderColorTypeActive: ''
};
const elevationTypesMap = {
  LOW: '0 2px 4px 0 rgba(0,0,0,0.2)',
  HIGH: '0 8px 8px -8px rgba(0,0,0,0.2), 0 4px 20px 0px rgba(0,0,0,0.2), 0 12px 16px 0px rgba(0,0,0,0.2)',
  NONE: '0 0 0 0'
};
const getElevationType = key => elevationTypesMap[key];
const createStyleForBoxShadow = ({
  boxShadowTypeNormal = elevationTypesMap.NONE,
  boxShadowTypeHover,
  boxShadowTypeActive,
  boxShadowTypeDisable,
  borderBoxShadow = noBorderBoxShadow
}) => {
  const {
    borderColorTypeActive,
    borderColorTypeHover,
    borderColorTypeNormal,
    borderWidthTypeActive,
    borderWidthTypeHover,
    borderWidthTypeNormal
  } = borderBoxShadow;
  return StyleSheet.create({
    style: {
      transition: '0.2s box-shadow ease-in-out',
      willChange: 'box-shadow',
      boxShadow: `${boxShadowTypeNormal}, 0 0 0 ${borderWidthTypeNormal}px ${borderColorTypeNormal}`,
      ':hover': {
        boxShadow: `${boxShadowTypeHover || boxShadowTypeNormal}, 0 0 0 ${borderWidthTypeHover}px ${borderColorTypeHover}`
      },
      ':active': {
        boxShadow: `${boxShadowTypeActive || boxShadowTypeNormal}, 0 0 0 ${borderWidthTypeActive}px ${borderColorTypeActive}`
      },
      ':disabled': {
        boxShadow: boxShadowTypeDisable || boxShadowTypeNormal
      }
    }
  });
};

class ThemeManager {
  constructor(palette, themeConfiguration) {
    _defineProperty(this, "paletteManager", void 0);

    _defineProperty(this, "themeConfiguration", void 0);

    _defineProperty(this, "instructions", {
      [interfaces.CONFIGURATION_TYPES.COLOR]: key => this.paletteManager.getColorByKey(key),
      [interfaces.CONFIGURATION_TYPES.NUMBER]: key => key,
      [interfaces.CONFIGURATION_TYPES.BOX_SHADOW]: key => getElevationType(key),
      [interfaces.CONFIGURATION_TYPES.TYPOGRAPHY]: key => key,
      [interfaces.CONFIGURATION_TYPES.BOOLEAN]: key => key,
      [interfaces.CONFIGURATION_TYPES.ALIGNMENT]: key => key,
      [interfaces.CONFIGURATION_TYPES.RATIO]: key => key,
      [interfaces.CONFIGURATION_TYPES.SEMANTIC_TAG]: key => key,
      [interfaces.CONFIGURATION_TYPES.FACTOR]: key => key
    });

    this.themeConfiguration = themeConfiguration;
    this.paletteManager = new PaletteManager(palette);
  }

  getConfiguration() {
    return { ...translate(this.instructions, this.themeConfiguration),
      fontSizeMap: this.paletteManager.getFontSizeMap()
    };
  }

}

const lineHeightRatioMap = {
  gigantic: {
    large: 1.4,
    medium: 1.375,
    small: 1.333
  },
  huge: {
    large: 1.375,
    medium: 1.333,
    small: 1.4
  },
  large: {
    large: 1.4,
    medium: 1.4,
    small: 1.5
  },
  bigger: {
    large: 1.5,
    medium: 1.5,
    small: 1.43
  },
  big: {
    large: 1.43,
    medium: 1.43,
    small: 1.333
  },
  normal: {
    large: 1.5,
    medium: 1.5,
    small: 1.43
  },
  tiny: {
    large: 1.333,
    medium: 1.333,
    small: 1.4
  }
};

const getFontSize = size => `${size}px`;

const getLineHeightByFontSize = (fontSize, size, screenSize) => `${Math.round(fontSize * lineHeightRatioMap[size][screenSize])}px`;

const translateFontSizes = fontSizeMap => {
  return Object.keys(fontSizeMap).reduce((sizesObj, current) => {
    return { ...sizesObj,
      [current]: {
        breakpoints: {
          [consts.SCREEN_SIZE.LARGE]: {
            fontSize: getFontSize(fontSizeMap[current].screenSizes.large),
            lineHeight: getLineHeightByFontSize(fontSizeMap[current].screenSizes.large, current, consts.SCREEN_SIZE.LARGE)
          },
          [consts.SCREEN_SIZE.MEDIUM]: {
            fontSize: getFontSize(fontSizeMap[current].screenSizes.medium),
            lineHeight: getLineHeightByFontSize(fontSizeMap[current].screenSizes.medium, current, consts.SCREEN_SIZE.MEDIUM)
          },
          [consts.SCREEN_SIZE.SMALL]: {
            fontSize: getFontSize(fontSizeMap[current].screenSizes.small),
            lineHeight: getLineHeightByFontSize(fontSizeMap[current].screenSizes.small, current, consts.SCREEN_SIZE.SMALL)
          }
        },
        style: {
          fontWeight: fontSizeMap[current].fontWeight,
          fontFamily: fontSizeMap[current].fontFamily
        }
      }
    };
  }, {});
};

const ThemeContext = React.createContext({});
const MainCategoryContext = React.createContext({
  isMainCategoryEnabled: true
});

const Theme = ({
  configuration,
  children
}) => {
  const fontSizesStyles = translateFontSizes(configuration.fontSizeMap);
  const themeContext = { ...configuration,
    fontSizesStyles
  };
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContext
  }, children);
};

const DisableMainCategory = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(MainCategoryContext.Provider, {
    value: {
      isMainCategoryEnabled: false
    }
  }, children);
};
const ThemeProviderWithFonts = WebFontsComponent => {
  const ThemeProviderWithFontsComponent = props => {
    const {
      palette,
      themeConfiguration,
      children
    } = props;
    const themeManager = new ThemeManager(palette, themeConfiguration);
    const configuration = themeManager.getConfiguration();
    const fontsConfiguration = themeManager.paletteManager.getFonts();
    return /*#__PURE__*/React.createElement(WebFontsComponent, {
      fontsConfiguration: fontsConfiguration
    }, /*#__PURE__*/React.createElement(Theme, {
      configuration: configuration
    }, children));
  };

  return ThemeProviderWithFontsComponent;
};

class EmptyReporter {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
  reportException(err, additionalData) {} // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function


  reportWarning(message) {}

}
const ErrorReporting = React.createContext(new EmptyReporter());

const baseUnit = 20;

const useTheme = key => {
  const reporter = React__default.useContext(ErrorReporting);
  const themeContext = React__default.useContext(ThemeContext);
  const mainCategoryContext = React__default.useContext(MainCategoryContext); // eslint-disable-next-line no-mixed-operators

  if (key && themeContext[key] || !key) {
    return { ...(key && themeContext[key]),
      fontSizesStyles: themeContext.fontSizesStyles,
      baseUnit,
      ...mainCategoryContext
    };
  }

  reporter.reportWarning(`cannot find key: ${key} in configuration`);
  return {};
};

const HUGE_SCREEN_SIZE = 1440;
const LARGE_SCREEN_SIZE = 1080;
const MEDIUM_SCREEN_SIZE = 1079;
const SMALL_SCREEN_SIZE = 719;
const MEDIA_BREAKPOINTS = {
  large: `@media (min-width: ${LARGE_SCREEN_SIZE}px)`,
  medium: `@media (max-width: ${MEDIUM_SCREEN_SIZE}px)`,
  small: `@media (max-width:${SMALL_SCREEN_SIZE}px)`
};

const semanticCSS = (...styles) => styles;
const getLineHeightBySize = (fontSizesStyle, fontSize, screenSize) => {
  return parseFloat(fontSizesStyle[fontSize].breakpoints[screenSize].lineHeight);
};
const getStyleBySize = (fontSizesStyle, fontSizes) => {
  const {
    fontSizeLarge,
    fontSizeMedium,
    fontSizeSmall
  } = fontSizes;
  return StyleSheet.create({
    tagStyle: {
      [MEDIA_BREAKPOINTS.large]: { ...fontSizesStyle[fontSizeLarge].style,
        ...fontSizesStyle[fontSizeLarge].breakpoints.large
      },
      [MEDIA_BREAKPOINTS.medium]: { ...fontSizesStyle[fontSizeMedium].style,
        ...fontSizesStyle[fontSizeMedium].breakpoints.medium
      },
      [MEDIA_BREAKPOINTS.small]: { ...fontSizesStyle[fontSizeSmall].style,
        ...fontSizesStyle[fontSizeSmall].breakpoints.small
      },
      margin: 0
    }
  }).tagStyle;
};
const getFontSizesBySemanticTag = semanticTag => {
  switch (semanticTag) {
    case 'h1':
      return {
        fontSizeLarge: consts.TYPOGRAPHY_SIZE.GIGANTIC,
        fontSizeMedium: consts.TYPOGRAPHY_SIZE.GIGANTIC,
        fontSizeSmall: consts.TYPOGRAPHY_SIZE.GIGANTIC
      };

    case 'h2':
      return {
        fontSizeLarge: consts.TYPOGRAPHY_SIZE.HUGE,
        fontSizeMedium: consts.TYPOGRAPHY_SIZE.HUGE,
        fontSizeSmall: consts.TYPOGRAPHY_SIZE.HUGE
      };

    case 'h3':
      return {
        fontSizeLarge: consts.TYPOGRAPHY_SIZE.LARGE,
        fontSizeMedium: consts.TYPOGRAPHY_SIZE.LARGE,
        fontSizeSmall: consts.TYPOGRAPHY_SIZE.LARGE
      };

    case 'h4':
      return {
        fontSizeLarge: consts.TYPOGRAPHY_SIZE.BIGGER,
        fontSizeMedium: consts.TYPOGRAPHY_SIZE.BIGGER,
        fontSizeSmall: consts.TYPOGRAPHY_SIZE.BIGGER
      };

    case 'h5':
      return {
        fontSizeLarge: consts.TYPOGRAPHY_SIZE.BIG,
        fontSizeMedium: consts.TYPOGRAPHY_SIZE.BIG,
        fontSizeSmall: consts.TYPOGRAPHY_SIZE.BIG
      };

    case 'h6':
      return {
        fontSizeLarge: consts.TYPOGRAPHY_SIZE.TINY,
        fontSizeMedium: consts.TYPOGRAPHY_SIZE.TINY,
        fontSizeSmall: consts.TYPOGRAPHY_SIZE.TINY
      };

    case 'span':
      return {
        fontSizeLarge: consts.TYPOGRAPHY_SIZE.NORMAL,
        fontSizeMedium: consts.TYPOGRAPHY_SIZE.NORMAL,
        fontSizeSmall: consts.TYPOGRAPHY_SIZE.NORMAL
      };

    case 'p':
    default:
      return {
        fontSizeLarge: consts.TYPOGRAPHY_SIZE.NORMAL,
        fontSizeMedium: consts.TYPOGRAPHY_SIZE.NORMAL,
        fontSizeSmall: consts.TYPOGRAPHY_SIZE.NORMAL
      };
  }
};
const sanitizeAttributes = attributes => {
  const notAllowedAttributes = ['baseUnit', 'fontSizesStyles', 'isMainCategoryEnabled'];
  return Object.keys(attributes).reduce((newAttributes, attr) => {
    return { ...newAttributes,
      ...(notAllowedAttributes.includes(attr) ? null : {
        [attr]: attributes[attr]
      })
    };
  }, {});
};

const H1 = props => {
  const defaultFontSizes = getFontSizesBySemanticTag('h1');
  const {
    fontSizesStyles
  } = useTheme();
  const {
    children,
    styles = [],
    fontSizeSmall = defaultFontSizes.fontSizeSmall,
    fontSizeMedium = defaultFontSizes.fontSizeMedium,
    fontSizeLarge = defaultFontSizes.fontSizeLarge,
    ...attributes
  } = props;
  const styleBySize = getStyleBySize(fontSizesStyles, {
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge
  });
  return /*#__PURE__*/React.createElement("h1", _extends$1({
    className: css(styleBySize, ...styles)
  }, sanitizeAttributes(attributes)), children);
};

const H2 = props => {
  const defaultFontSizes = getFontSizesBySemanticTag('h2');
  const {
    fontSizesStyles
  } = useTheme();
  const {
    children,
    styles = [],
    fontSizeSmall = defaultFontSizes.fontSizeSmall,
    fontSizeMedium = defaultFontSizes.fontSizeMedium,
    fontSizeLarge = defaultFontSizes.fontSizeLarge,
    ...attributes
  } = props;
  const styleBySize = getStyleBySize(fontSizesStyles, {
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge
  });
  return /*#__PURE__*/React.createElement("h2", _extends$1({
    className: css(styleBySize, ...styles)
  }, sanitizeAttributes(attributes)), children);
};

const H3 = props => {
  const defaultFontSizes = getFontSizesBySemanticTag('h3');
  const {
    fontSizesStyles
  } = useTheme();
  const {
    children,
    styles = [],
    fontSizeSmall = defaultFontSizes.fontSizeSmall,
    fontSizeMedium = defaultFontSizes.fontSizeMedium,
    fontSizeLarge = defaultFontSizes.fontSizeLarge,
    ...attributes
  } = props;
  const styleBySize = getStyleBySize(fontSizesStyles, {
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge
  });
  return /*#__PURE__*/React.createElement("h3", _extends$1({
    className: css(styleBySize, ...styles)
  }, sanitizeAttributes(attributes)), children);
};

const H4 = props => {
  const defaultFontSizes = getFontSizesBySemanticTag('h4');
  const {
    fontSizesStyles
  } = useTheme();
  const {
    children,
    styles = [],
    fontSizeSmall = defaultFontSizes.fontSizeSmall,
    fontSizeMedium = defaultFontSizes.fontSizeMedium,
    fontSizeLarge = defaultFontSizes.fontSizeLarge,
    ...attributes
  } = props;
  const styleBySize = getStyleBySize(fontSizesStyles, {
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge
  });
  return /*#__PURE__*/React.createElement("h4", _extends$1({
    className: css(styleBySize, ...styles)
  }, sanitizeAttributes(attributes)), children);
};

const H5 = props => {
  const defaultFontSizes = getFontSizesBySemanticTag('h5');
  const {
    fontSizesStyles
  } = useTheme();
  const {
    children,
    styles = [],
    fontSizeSmall = defaultFontSizes.fontSizeSmall,
    fontSizeMedium = defaultFontSizes.fontSizeMedium,
    fontSizeLarge = defaultFontSizes.fontSizeLarge,
    ...attributes
  } = props;
  const styleBySize = getStyleBySize(fontSizesStyles, {
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge
  });
  return /*#__PURE__*/React.createElement("h5", _extends$1({
    className: css(styleBySize, ...styles)
  }, sanitizeAttributes(attributes)), children);
};

const P = props => {
  const defaultFontSizes = getFontSizesBySemanticTag('p');
  const {
    fontSizesStyles
  } = useTheme();
  const {
    children,
    styles = [],
    fontSizeSmall = defaultFontSizes.fontSizeSmall,
    fontSizeMedium = defaultFontSizes.fontSizeMedium,
    fontSizeLarge = defaultFontSizes.fontSizeLarge,
    ...attributes
  } = props;
  const styleBySize = getStyleBySize(fontSizesStyles, {
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge
  });
  return /*#__PURE__*/React.createElement("p", _extends$1({
    className: css(styleBySize, ...styles)
  }, sanitizeAttributes(attributes)), children);
};

const Span = props => {
  const defaultFontSizes = getFontSizesBySemanticTag('span');
  const {
    fontSizesStyles
  } = useTheme();
  const {
    children,
    styles = [],
    reference,
    fontSizeSmall = defaultFontSizes.fontSizeSmall,
    fontSizeMedium = defaultFontSizes.fontSizeMedium,
    fontSizeLarge = defaultFontSizes.fontSizeLarge,
    ...attributes
  } = props;
  const styleBySize = getStyleBySize(fontSizesStyles, {
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge
  });
  return /*#__PURE__*/React.createElement("span", _extends$1({
    className: css(styleBySize, ...styles)
  }, sanitizeAttributes(attributes), {
    ref: reference
  }), children);
};

const getSectionStyle$1 = (maxWidth = LARGE_SCREEN_SIZE) => {
  return StyleSheet.create({
    sectionStyle: {
      maxWidth: `${maxWidth}px`,
      width: '-webkit-fill-available'
    }
  }).sectionStyle;
};
const getLayoutComponentPadding = (paddingFactors = {
  large: 0.5,
  medium: 0.5,
  small: 0.5
}) => {
  return StyleSheet.create({
    padding: {
      [MEDIA_BREAKPOINTS.large]: {
        paddingLeft: `${paddingFactors.large * baseUnit}px`,
        paddingRight: `${paddingFactors.large * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        paddingLeft: `${paddingFactors.medium * baseUnit}px`,
        paddingRight: `${paddingFactors.medium * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        paddingLeft: `${paddingFactors.small * baseUnit}px`,
        paddingRight: `${paddingFactors.small * baseUnit}px`
      }
    }
  }).padding;
};
const getBackgroundColorStyle = backgroundColor => {
  return StyleSheet.create({
    style: {
      backgroundColor
    }
  }).style;
};

const EventContext = React.createContext({
  category: 'default category',
  action: ''
});
const EventProvider = ({
  children,
  category: newCategory,
  action: newAction
}) => {
  const {
    category,
    action
  } = React.useContext(EventContext);
  const newValue = {
    category: newCategory || category,
    action: newAction || action
  };
  return /*#__PURE__*/React.createElement(EventContext.Provider, {
    value: newValue
  }, children);
};

const DEFAULT_ANALYTICS_ACTION = 'click';
const DEFAULT_ANALYTICS_TYPE = 'click';
const Link = props => {
  const {
    category,
    action
  } = React.useContext(EventContext);
  const {
    children,
    onClick,
    href
  } = props;

  const sendClickAnalytics = () => {
    if (typeof category !== 'undefined') {
      window.mmClientApi = window.mmClientApi || [];
      window.mmClientApi.push('analytics', {
        event_category: category,
        event_action: action || DEFAULT_ANALYTICS_ACTION,
        event_label: href || '',
        event_type: DEFAULT_ANALYTICS_TYPE
      });
    }
  };

  const onClickHandler = (...args) => {
    if (onClick) {
      onClick(...args);
    }

    sendClickAnalytics();
  };

  return /*#__PURE__*/React.createElement("a", _extends$1({
    "data-mm-click-analytics": true,
    "data-vars-action": action || DEFAULT_ANALYTICS_ACTION,
    "data-vars-label": href || '',
    "data-vars-category": category,
    "data-vars-type": DEFAULT_ANALYTICS_TYPE
  }, props, {
    onClick: onClickHandler
  }), children);
};

const baseStyles = {
  base: {
    flex: '0 0 auto',
    display: 'inline-flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    textDecoration: 'none',
    color: 'initial',
    fontFamily: 'inherit',
    height: '100%',
    ':visited': {
      textDecoration: 'none',
      color: 'initial'
    },
    ':active': {
      textDecoration: 'none',
      color: 'initial'
    },
    ':hover': {
      color: 'initial'
    }
  }
};
const generateLinkStyleFromTheme = (themedLinkStyle, additionalStyle = {}) => {
  return {
    style: {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      color: themedLinkStyle.idleColor,
      textDecoration: 'none',
      ':visited': {
        color: themedLinkStyle.idleColor
      },
      ':active': {
        color: themedLinkStyle.activeStateColor
      },
      [MEDIA_BREAKPOINTS.large]: {
        ':hover': {
          color: themedLinkStyle.hoverStateColor
        }
      },
      [MEDIA_BREAKPOINTS.medium]: {
        ':hover': {
          color: themedLinkStyle.idleColor
        }
      },
      [MEDIA_BREAKPOINTS.small]: {
        ':hover': {
          color: themedLinkStyle.idleColor
        }
      }
    },
    additionalStyle
  };
};

const combineStyleWithBase = (base, newStyle) => {
  return newStyle ? css(StyleSheet.create(base).base, StyleSheet.create(newStyle).style, StyleSheet.create(newStyle).additionalStyle) : css(StyleSheet.create(base).base);
};

const TextLinkComponent = props => {
  const {
    children,
    href,
    target,
    rel,
    linkStyle = null
  } = props;
  const finalStyle = combineStyleWithBase(baseStyles, linkStyle);
  return /*#__PURE__*/React.createElement(Link, {
    href: href,
    target: target,
    rel: rel,
    className: finalStyle
  }, children);
};

class ErrorBoundary extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      hasError: false
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static getDerivedStateFromError(error) {
    return {
      hasError: true
    };
  }

  componentDidCatch(error, info) {
    const errorReporter = this.context;
    errorReporter.reportException(error, info);
  }

  render() {
    const {
      hasError
    } = this.state;
    const {
      children
    } = this.props;
    return hasError ? /*#__PURE__*/React.createElement("div", {
      className: "has-error"
    }) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }

}
ErrorBoundary.contextType = ErrorReporting;

const createArrowStyles = () => StyleSheet.create({
  arrow: {
    [MEDIA_BREAKPOINTS.large]: {
      width: '20px',
      height: '20px'
    },
    [MEDIA_BREAKPOINTS.medium]: {
      width: '20px',
      height: '20px'
    },
    [MEDIA_BREAKPOINTS.small]: {
      width: '15px',
      height: '15px'
    }
  }
});

const ArrowSvg = props => {
  const {
    arrowColor,
    alt
  } = props;
  const arrowStyle = createArrowStyles();
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("svg", {
    className: css(arrowStyle.arrow),
    "aria-label": alt,
    viewBox: "0 0 23 26",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-975.000000, -785.000000)",
    stroke: arrowColor,
    strokeWidth: "4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.000000, 760.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(905.000000, 38.000000) rotate(180.000000) translate(-905.000000, -38.000000) translate(895.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: "20",
    y1: "10",
    x2: "0",
    y2: "10",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("polyline", {
    strokeLinecap: "square",
    points: "10 20 0 10 10 0"
  })))))));
};

const componentConfigurationKey$r = 'moreButton';

const createLinkTextStyles = (idleColor, hoverStateColor, activeStateColor) => StyleSheet.create({
  linkText: {
    [MEDIA_BREAKPOINTS.large]: {
      ':hover': {
        textDecoration: 'underline'
      }
    },
    [MEDIA_BREAKPOINTS.medium]: {
      ':hover': {
        color: 'initial'
      }
    },
    [MEDIA_BREAKPOINTS.small]: {
      ':hover': {
        color: 'initial'
      }
    }
  },
  moreButtonSvg: {
    fill: idleColor,
    width: '30px',
    height: '25px',
    ':hover': {
      fill: hoverStateColor
    },
    ':active': {
      fill: activeStateColor
    }
  },
  moreButtonStroke: {
    stroke: idleColor,
    ':hover': {
      stroke: hoverStateColor
    },
    ':active': {
      stroke: activeStateColor
    }
  }
});

const createMoreButtonText = (href, text, titleStyle, linkStyle) => {
  return /*#__PURE__*/React.createElement(TextLinkComponent, {
    href: href,
    linkStyle: linkStyle
  }, /*#__PURE__*/React.createElement(H4, {
    fontSizeLarge: consts.TYPOGRAPHY_SIZE.BIGGER,
    fontSizeMedium: consts.TYPOGRAPHY_SIZE.BIGGER,
    fontSizeSmall: consts.TYPOGRAPHY_SIZE.BIGGER,
    styles: semanticCSS(titleStyle)
  }, text));
};

const MoreButton$1 = props => {
  const {
    moreButtonSvg,
    moreButtonText
  } = props;
  const themeProps = useTheme(componentConfigurationKey$r);
  const {
    showArrow,
    idleColor,
    hoverStateColor,
    activeStateColor
  } = themeProps;
  const style = createLinkTextStyles(idleColor, hoverStateColor, activeStateColor);
  const additionalStyle = {
    justifyContent: 'flex-end',
    marginLeft: 'auto'
  };
  const linkStyle = generateLinkStyleFromTheme({
    idleColor,
    activeStateColor,
    hoverStateColor
  }, additionalStyle);

  if (moreButtonSvg) {
    const svg = moreButtonSvg.src.replace(/<g/g, `<g class="${css(style.moreButtonStroke)}"`).replace(/<svg/g, `<svg class="${css(style.moreButtonSvg)}"`);
    return /*#__PURE__*/React.createElement(TextLinkComponent, {
      href: moreButtonSvg.href,
      linkStyle: linkStyle
    }, /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: svg
      }
    }));
  }

  if (moreButtonText) {
    if (showArrow) {
      return /*#__PURE__*/React.createElement(TextLinkComponent, {
        href: moreButtonText.href,
        linkStyle: linkStyle
      }, /*#__PURE__*/React.createElement(ArrowSvg, {
        arrowColor: idleColor,
        alt: moreButtonText.text
      }));
    }

    return createMoreButtonText(moreButtonText.href, moreButtonText.text, style.linkText, linkStyle);
  }

  return null;
};

const componentConfigurationKey$q = 'sectionHeader';

const createStyles$c = ({
  titleColor,
  titleBackgroundColor,
  borderTopColor,
  squareColor,
  showBorderTop,
  showBorderBottom,
  borderTopWidth,
  showStrikeThrowHorizontalLine,
  strikeThrowHorizontalLineColor,
  middleHorizontalLineColor,
  largeVerticalGap,
  mediumVerticalGap,
  smallVerticalGap,
  largeHorizontalGap,
  mediumHorizontalGap,
  smallHorizontalGap,
  largeWrapperGap,
  mediumWrapperGap,
  smallWrapperGap,
  descriptionColor,
  borderBottomColor,
  borderBottomWidth,
  largeMarginBottomFactor,
  mediumMarginBottomFactor,
  smallMarginBottomFactor
}) => {
  return StyleSheet.create({
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline',
      flexWrap: 'wrap',
      flexDirection: 'column',
      [MEDIA_BREAKPOINTS.large]: {
        marginBottom: `${baseUnit * largeMarginBottomFactor}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        marginBottom: `${baseUnit * mediumMarginBottomFactor}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        marginBottom: `${baseUnit * smallMarginBottomFactor}px`
      }
    },
    titleItem: {
      flex: '1 1 auto',
      color: titleColor,
      display: 'inline-flex',
      alignItems: 'center',
      width: '100%',
      position: 'relative',
      zIndex: 0,
      borderTop: showBorderTop ? `${baseUnit * borderTopWidth}px solid ${borderTopColor}` : 'unset',
      borderBottom: showBorderBottom ? `${baseUnit * borderBottomWidth}px solid ${borderBottomColor}` : 'unset',
      backgroundColor: titleBackgroundColor,
      [MEDIA_BREAKPOINTS.large]: {
        padding: `${largeHorizontalGap * baseUnit}px ${largeWrapperGap * baseUnit}px ${largeHorizontalGap * baseUnit}px ${largeWrapperGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        padding: `${mediumHorizontalGap * baseUnit}px ${mediumWrapperGap * baseUnit}px ${mediumHorizontalGap * baseUnit}px ${mediumWrapperGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        padding: `${smallHorizontalGap * baseUnit}px ${smallWrapperGap * baseUnit}px ${smallHorizontalGap * baseUnit}px ${smallWrapperGap * baseUnit}px`
      },
      ':before': { ...(showStrikeThrowHorizontalLine ? {
          content: '""',
          right: 0,
          left: 0,
          position: 'absolute',
          zIndex: -1,
          width: '100%',
          [MEDIA_BREAKPOINTS.large]: {
            borderTop: `${0.75 * baseUnit}px solid ${strikeThrowHorizontalLineColor}`
          },
          [MEDIA_BREAKPOINTS.medium]: {
            borderTop: `${0.5 * baseUnit}px solid ${strikeThrowHorizontalLineColor}`
          },
          [MEDIA_BREAKPOINTS.small]: {
            borderTop: `${0.5 * baseUnit}px solid ${strikeThrowHorizontalLineColor}`
          }
        } : null)
      }
    },
    square: {
      backgroundColor: squareColor,
      marginRight: `${baseUnit * 0.5}px`,
      [MEDIA_BREAKPOINTS.large]: {
        width: '28px',
        height: '28px'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        width: '24px',
        height: '24px'
      },
      [MEDIA_BREAKPOINTS.small]: {
        width: '20px',
        height: '20px'
      }
    },
    middleHorizontalLineContainer: {
      flexGrow: 1,
      ':before': {
        content: '""',
        display: 'block',
        borderTop: `2px solid ${middleHorizontalLineColor}`,
        flex: '2 0 0',
        [MEDIA_BREAKPOINTS.large]: {
          marginRight: `${largeVerticalGap * baseUnit}px`,
          marginLeft: `${largeVerticalGap * baseUnit}px`
        },
        [MEDIA_BREAKPOINTS.medium]: {
          marginRight: `${mediumVerticalGap * baseUnit}px`,
          marginLeft: `${mediumVerticalGap * baseUnit}px`
        },
        [MEDIA_BREAKPOINTS.small]: {
          marginRight: `${smallVerticalGap * baseUnit}px`,
          marginLeft: `${smallVerticalGap * baseUnit}px`
        }
      }
    },
    description: {
      color: descriptionColor
    }
  });
};

const SectionHeader = props => {
  const themeProps = useTheme(componentConfigurationKey$q);
  const {
    children,
    paddingFactors,
    description,
    moreButtonText,
    moreButtonSvg
  } = props;
  const {
    showSquare,
    showMiddleHorizontalLine,
    descriptionFontSizeLarge,
    descriptionFontSizeMedium,
    descriptionFontSizeSmall
  } = themeProps;
  const style = createStyles$c(themeProps);
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle, style.container)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(style.titleItem)
  }, showSquare ? /*#__PURE__*/React.createElement("div", {
    className: css(style.square)
  }) : null, children, showMiddleHorizontalLine ? /*#__PURE__*/React.createElement("div", {
    className: css(style.middleHorizontalLineContainer)
  }) : null, /*#__PURE__*/React.createElement(MoreButton$1, {
    moreButtonText: moreButtonText,
    moreButtonSvg: moreButtonSvg
  })), description ? /*#__PURE__*/React.createElement(P, {
    styles: semanticCSS(style.description),
    fontSizeSmall: descriptionFontSizeSmall,
    fontSizeMedium: descriptionFontSizeMedium,
    fontSizeLarge: descriptionFontSizeLarge
  }, description) : null));
};

const componentConfigurationKey$p = 'sectionHeaderWithBackground';

const createStyles$b = ({
  titleColor,
  titleBackgroundColor,
  borderTopColor,
  showBorderTop,
  showBorderBottom,
  borderTopWidth,
  largeHorizontalGap,
  mediumHorizontalGap,
  smallHorizontalGap,
  largeWrapperGap,
  mediumWrapperGap,
  smallWrapperGap,
  borderBottomColor,
  borderBottomWidth,
  largeMarginBottomFactor,
  mediumMarginBottomFactor,
  smallMarginBottomFactor
}) => {
  return StyleSheet.create({
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline',
      flexWrap: 'wrap',
      flexDirection: 'column',
      [MEDIA_BREAKPOINTS.large]: {
        marginBottom: `${baseUnit * largeMarginBottomFactor}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        marginBottom: `${baseUnit * mediumMarginBottomFactor}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        marginBottom: `${baseUnit * smallMarginBottomFactor}px`
      }
    },
    titleItem: {
      flex: '1 1 auto',
      color: titleColor,
      display: 'inline-flex',
      alignItems: 'center',
      width: '100%',
      position: 'relative',
      zIndex: 0,
      borderTop: showBorderTop ? `${baseUnit * borderTopWidth}px solid ${borderTopColor}` : 'unset',
      borderBottom: showBorderBottom ? `${baseUnit * borderBottomWidth}px solid ${borderBottomColor}` : 'unset',
      backgroundColor: 'transparent',
      [MEDIA_BREAKPOINTS.large]: {
        padding: `${largeHorizontalGap * baseUnit}px ${largeWrapperGap * baseUnit}px ${largeHorizontalGap * baseUnit}px ${largeWrapperGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        padding: `${mediumHorizontalGap * baseUnit}px ${mediumWrapperGap * baseUnit}px ${mediumHorizontalGap * baseUnit}px ${mediumWrapperGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        padding: `${smallHorizontalGap * baseUnit}px ${smallWrapperGap * baseUnit}px ${smallHorizontalGap * baseUnit}px ${smallWrapperGap * baseUnit}px`
      }
    },
    titleWrapper: {
      padding: '5px 10px',
      backgroundColor: titleBackgroundColor
    }
  });
};

const SectionHeaderWithBackground = props => {
  const themeProps = useTheme(componentConfigurationKey$p);
  const {
    children,
    paddingFactors,
    backgroundComponent
  } = props;
  const BackImageComponent = backgroundComponent;
  const style = createStyles$b(themeProps);
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle, style.container)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(style.titleItem)
  }, /*#__PURE__*/React.createElement(BackImageComponent, null), /*#__PURE__*/React.createElement("div", {
    className: css(style.titleWrapper)
  }, children))));
};

const PageDescription = ({
  description,
  favicon,
  pageUrl,
  title,
  ampURL,
  prevUrl,
  nextUrl
}) => /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("meta", {
  charSet: "utf-8"
}), /*#__PURE__*/React.createElement("meta", {
  name: "description",
  content: description
}), /*#__PURE__*/React.createElement("link", {
  rel: "icon",
  href: favicon,
  type: "image/png"
}), /*#__PURE__*/React.createElement("link", {
  rel: "canonical",
  href: pageUrl
}), ampURL ? /*#__PURE__*/React.createElement("link", {
  rel: "amphtml",
  href: ampURL
}) : null, prevUrl ? /*#__PURE__*/React.createElement("link", {
  rel: "prev",
  href: prevUrl
}) : null, nextUrl ? /*#__PURE__*/React.createElement("link", {
  rel: "next",
  href: nextUrl
}) : null);

const FacebookMeta = ({
  appId,
  pageId
}) => /*#__PURE__*/React.createElement(Helmet, null, appId ? /*#__PURE__*/React.createElement("meta", {
  property: "fb:app_id",
  content: appId
}) : null, pageId ? /*#__PURE__*/React.createElement("meta", {
  property: "fb:pages",
  content: pageId
}) : null);

let OpenGraphTypes;

(function (OpenGraphTypes) {
  OpenGraphTypes["Website"] = "website";
  OpenGraphTypes["Article"] = "article";
})(OpenGraphTypes || (OpenGraphTypes = {}));

const OpenGraph = ({
  title,
  siteName,
  image,
  pageUrl,
  imageWidth,
  imageHeight,
  description,
  type
}) => /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("meta", {
  property: "og:title",
  content: title
}), /*#__PURE__*/React.createElement("meta", {
  property: "og:site_name",
  content: siteName
}), image ? /*#__PURE__*/React.createElement("meta", {
  property: "og:image",
  content: image
}) : null, /*#__PURE__*/React.createElement("meta", {
  property: "og:url",
  content: pageUrl
}), imageWidth ? /*#__PURE__*/React.createElement("meta", {
  property: "og:image:width",
  content: `${imageWidth}`
}) : null, imageHeight ? /*#__PURE__*/React.createElement("meta", {
  property: "og:image:height",
  content: `${imageHeight}`
}) : null, /*#__PURE__*/React.createElement("meta", {
  property: "og:description",
  content: description
}), /*#__PURE__*/React.createElement("meta", {
  property: "og:type",
  content: type
}));

const TwitterShare = ({
  title,
  description,
  account,
  image,
  pageUrl,
  imageWidth,
  imageHeight
}) => /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("meta", {
  property: "twitter:title",
  content: title
}), /*#__PURE__*/React.createElement("meta", {
  property: "twitter:description",
  content: description
}), image ? /*#__PURE__*/React.createElement("meta", {
  property: "twitter:image",
  content: image
}) : null, /*#__PURE__*/React.createElement("meta", {
  property: "twitter:url",
  content: pageUrl
}), /*#__PURE__*/React.createElement("meta", {
  property: "twitter:card",
  content: "summary_large_image"
}), imageWidth ? /*#__PURE__*/React.createElement("meta", {
  property: "twitter:image:width",
  content: `${imageWidth}`
}) : null, imageHeight ? /*#__PURE__*/React.createElement("meta", {
  property: "twitter:image:height",
  content: `${imageHeight}`
}) : null, account ? /*#__PURE__*/React.createElement("meta", {
  property: "twitter:site",
  content: account
}) : null);

const componentConfigurationKey$o = 'articleBlock';

const calculateImageUrl = (host, path, manipulation) => `${host + manipulation}/${path}`;

const isHighDprInLargeImage = (width, dpr) => width >= 600 && dpr > 2;

const addCroppingParamsToPath = (path, croppingData) => {
  if (croppingData) {
    return `c_crop,w_${croppingData.width},h_${croppingData.height},x_${croppingData.x},y_${croppingData.y}/${path}`;
  }

  return path;
};

const createImageSrc = (host, path, width, aspectRatio, dpr, croppingData) => {
  if (isHighDprInLargeImage(width, dpr)) {
    return createImageSrc(host, path, width, aspectRatio, 2, croppingData);
  }

  return calculateImageUrl(host, path, addCroppingParamsToPath(`c_fill,w_${width * dpr},ar_${aspectRatio.x}:${aspectRatio.y},f_auto,q_auto,g_auto`, croppingData));
};
const getImageSrcAndSrcSet = (imageAspectRatios, imageWidths, host, path, cropping) => {
  return {
    srcSetSmallScreen: `${createImageSrc(host, path, imageWidths.small, imageAspectRatios.small, 1, cropping)} 1x, ${createImageSrc(host, path, imageWidths.small, imageAspectRatios.small, 2, cropping)} 2x, ${createImageSrc(host, path, imageWidths.small, imageAspectRatios.small, 3, cropping)} 3x`,
    srcSetMediumScreen: `${createImageSrc(host, path, imageWidths.medium, imageAspectRatios.medium, 1, cropping)} 1x, ${createImageSrc(host, path, imageWidths.medium, imageAspectRatios.medium, 2, cropping)} 2x, ${createImageSrc(host, path, imageWidths.medium, imageAspectRatios.medium, 3, cropping)} 3x`,
    srcSetLargeScreen: `${createImageSrc(host, path, imageWidths.large, imageAspectRatios.large, 1, cropping)} 1x, ${createImageSrc(host, path, imageWidths.large, imageAspectRatios.large, 2, cropping)} 2x, ${createImageSrc(host, path, imageWidths.large, imageAspectRatios.large, 3, cropping)} 3x`,
    lowResUrl: createImageSrc(host, path, 16, {
      x: 16,
      y: 9
    }, 1, cropping),
    fallbackSrc: createImageSrc(host, path, imageWidths.medium, imageAspectRatios.medium, 1, cropping)
  };
};
const imageStyle = StyleSheet.create({
  base: {
    position: 'absolute',
    top: '0',
    left: '0',
    bottom: '0',
    minWidth: '100%',
    maxWidth: '100%',
    maxHeight: '100%',
    transition: 'opacity 0.2s ease-in-out',
    objectFit: 'cover',
    minHeight: '100%'
  }
});
const createImageWidths = (small, medium, large) => ({
  small,
  medium,
  large
});
const createImageHeightCalculationMethods = (small, medium, large) => ({
  small,
  medium,
  large
});
const createImageAspectRatios = (small, medium, large) => ({
  small,
  medium,
  large
});

const getCreditStyle = linkColor => StyleSheet.create({
  style: {
    color: linkColor,
    textDecoration: 'none'
  }
}).style;

const useTransformCreditHTML = credit => {
  const {
    creditLinkColor
  } = useTheme(componentConfigurationKey$o);
  const styleForCredit = css(getCreditStyle(creditLinkColor));

  if (!credit) {
    return '';
  }

  return credit.replace(/<a/g, `<a class="${styleForCredit}"`).replace(/div/g, 'span');
};

const dateToIsoDate = date => {
  return new Date(date).toISOString();
};

const getAuthorsListSchema = authors => {
  if (authors.length === 1) {
    return {
      '@type': 'Person',
      name: authors[0].name
    };
  }

  return authors.map(author => ({
    '@type': 'Person',
    name: author.name
  }));
};

const getSchemaData = (canonical, title, image, datePublished, publisherName, logoUrl, dateModified, seoDescription, articleSection) => {
  return {
    '@context': 'http://schema.org',
    '@type': 'NewsArticle',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': canonical
    },
    headline: title,
    image,
    datePublished: dateToIsoDate(datePublished),
    dateModified: dateToIsoDate(dateModified),
    publisher: {
      '@type': 'Organization',
      name: publisherName,
      logo: {
        '@type': 'ImageObject',
        url: logoUrl
      }
    },
    description: seoDescription,
    articleSection
  };
};

const GoogleNewsSchema = props => {
  const {
    canonical,
    title,
    image,
    datePublished,
    authors,
    publisherName,
    logoUrl,
    dateModified,
    seoDescription,
    articleSection
  } = props;
  const schemaWithoutAuthors = getSchemaData(canonical, title, image, datePublished, publisherName, logoUrl, dateModified, seoDescription, articleSection);
  const schema = authors ? { ...schemaWithoutAuthors,
    author: getAuthorsListSchema(authors)
  } : schemaWithoutAuthors;
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(schema)));
};

const numArticlesForSchema = 5;
const sortByDate = (article1, article2) => {
  const article1Time = new Date(article1.featuredAt);
  const article2Time = new Date(article2.featuredAt);
  if (article2Time > article1Time) return 1;
  if (article2Time < article1Time) return -1;
  return 0;
};

const getTopArticlesByDate = articles => articles && [...articles].sort(sortByDate).splice(0, Math.min(numArticlesForSchema, articles.length));

const getUniqueArticles = topArticles => {
  return topArticles.reduce((uniqueElements, element) => {
    if (!uniqueElements.find(item => item.id === element.id)) {
      return [...uniqueElements, element];
    }

    return uniqueElements;
  }, []);
};

const getSchema = (topArticles, publisherName, logoUrl) => ({
  '@context': 'http://schema.org',
  '@type': 'ItemList',
  itemListElement: topArticles && getUniqueArticles(topArticles).map((item, position) => {
    const imageUrl = createImageSrc(item.image.host, item.image.path, 720, {
      x: 16,
      y: 9
    }, 1, item.image.cropping || null);
    return {
      '@type': 'NewsArticle',
      position: position + 1,
      url: item.articleUrl,
      headline: item.title,
      image: imageUrl,
      datePublished: item.featuredAt,
      author: getAuthorsListSchema(item.authors),
      publisher: {
        '@type': 'Organization',
        name: publisherName,
        logo: {
          '@type': 'ImageObject',
          url: logoUrl
        }
      },
      articleSection: item.mainCategory
    };
  })
});

const ItemsListSchema = ({
  itemListElement,
  publisherName,
  logoUrl
}) => {
  const topArticles = getTopArticlesByDate(itemListElement);
  const scriptContent = getSchema(topArticles, publisherName, logoUrl);
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(scriptContent)));
};

const createImageAttributes = pageImage => {
  const {
    host,
    aspectRatio = {
      x: 16,
      y: 9
    },
    cropping = null,
    path
  } = pageImage;
  const imageAspectRatioX = aspectRatio.x;
  const imageAspectRatioY = aspectRatio.y;
  const imageWidth = 1440;
  const drp = 1;
  const imageUrl = createImageSrc(host, path, imageWidth, aspectRatio, drp, cropping);
  const imageHeight = Number(imageWidth) * imageAspectRatioY / imageAspectRatioX;
  return {
    imageUrl,
    imageHeight,
    imageWidth
  };
};

const HreflangTags = ({
  locale,
  canonicalUrl,
  alternateUrls
}) => {
  if (!alternateUrls.length) return null;
  const linkTags = alternateUrls.map((item, index) => /*#__PURE__*/React.createElement("link", {
    key: index,
    rel: "alternate",
    hrefLang: item.langCode,
    href: item.url
  }));
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("link", {
    rel: "alternate",
    hrefLang: locale,
    href: canonicalUrl
  }), linkTags);
};

const MetaHeaderTags = ({
  canonicalUrl,
  favicon,
  description,
  facebookAppId,
  facebookPageId,
  title,
  twitterAccount,
  siteName,
  pageImage,
  articles,
  logo,
  ampURL,
  prevCanonicalUrl,
  locale,
  alternateUrls
}) => {
  const {
    imageHeight = null,
    imageUrl = null,
    imageWidth = null
  } = pageImage ? createImageAttributes(pageImage) : {};
  const logoImageAttributes = logo ? createImageAttributes(logo) : {
    imageUrl: ''
  };
  const faviconImageAttributes = favicon ? createImageAttributes(favicon) : {
    imageUrl: ''
  };
  const metaDescription = description || '';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageDescription, {
    pageUrl: canonicalUrl,
    favicon: faviconImageAttributes.imageUrl,
    description: metaDescription,
    title: title,
    ampURL: ampURL,
    prevUrl: prevCanonicalUrl,
    nextUrl: null
  }), /*#__PURE__*/React.createElement(FacebookMeta, {
    appId: facebookAppId,
    pageId: facebookPageId
  }), /*#__PURE__*/React.createElement(OpenGraph, {
    pageUrl: canonicalUrl,
    image: imageUrl,
    title: title,
    siteName: siteName,
    imageHeight: imageHeight,
    imageWidth: imageWidth,
    description: metaDescription,
    type: OpenGraphTypes.Website
  }), /*#__PURE__*/React.createElement(TwitterShare, {
    title: title,
    description: metaDescription,
    account: twitterAccount,
    image: imageUrl,
    pageUrl: canonicalUrl,
    imageHeight: imageHeight,
    imageWidth: imageWidth
  }), /*#__PURE__*/React.createElement(ItemsListSchema, {
    publisherName: siteName,
    logoUrl: logoImageAttributes.imageUrl,
    itemListElement: articles
  }), /*#__PURE__*/React.createElement(HreflangTags, {
    locale: locale,
    canonicalUrl: canonicalUrl,
    alternateUrls: alternateUrls
  }));
};

const getCombinedContent = actualContents => {
  return actualContents.reduce((combinedContent, content, index) => {
    if (index === 0) {
      return content;
    }

    return `${combinedContent}, ${content}`;
  }, '');
};

const RobotsMeta = props => {
  const contents = ['max-snippet:70', 'max-image-preview:large', 'max-video-preview:20'];
  const {
    noIndex
  } = props;

  if (noIndex === true) {
    contents.push('noindex', 'nofollow');
  }

  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("meta", {
    name: "robots",
    content: getCombinedContent(contents)
  }));
};

const OpenGraphArticleTags = ({
  title,
  siteName,
  image,
  pageUrl,
  imageWidth,
  imageHeight,
  description,
  createdAtISO,
  updatedAtISO,
  articleSection,
  tags
}) => {
  const articleTags = tags.map((tag, index) => /*#__PURE__*/React.createElement("meta", {
    key: index,
    property: "article:tag",
    content: tag
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OpenGraph, {
    siteName: siteName,
    image: image,
    title: title,
    pageUrl: pageUrl,
    imageHeight: imageHeight,
    imageWidth: imageWidth,
    description: description,
    type: OpenGraphTypes.Article
  }), /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("meta", {
    property: "article:published_time",
    content: createdAtISO
  }), /*#__PURE__*/React.createElement("meta", {
    property: "article:modified_time",
    content: updatedAtISO
  }), articleSection ? /*#__PURE__*/React.createElement("meta", {
    property: "article:section",
    content: articleSection
  }) : null, articleTags));
};

const PostMetaHeaderTags = props => {
  const {
    canonicalUrl,
    favicon,
    pageDescription,
    facebookAppId,
    facebookPageId,
    seoTitle,
    twitterAccount,
    siteName,
    pageImage,
    logo,
    authors,
    createdAtISO,
    updatedAtISO,
    noIndex,
    ampURL,
    prevUrl,
    nextUrl,
    ogDescription,
    ogImage,
    ogTitle,
    twitterDescription,
    twitterImage,
    twitterTitle,
    seoDescription,
    articleSection,
    tags
  } = props;
  const pageImageUrl = createImageAttributes(pageImage).imageUrl;
  const logoImageAttributes = logo ? createImageAttributes(logo) : {
    imageUrl: ''
  };
  const faviconImageAttributes = favicon ? createImageAttributes(favicon) : {
    imageUrl: ''
  };
  const facebookImageProperties = createImageAttributes(ogImage);
  const twitterImageProperties = createImageAttributes(twitterImage);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageDescription, {
    pageUrl: canonicalUrl,
    favicon: faviconImageAttributes.imageUrl,
    description: pageDescription,
    title: seoTitle,
    ampURL: ampURL,
    prevUrl: prevUrl,
    nextUrl: nextUrl
  }), /*#__PURE__*/React.createElement(FacebookMeta, {
    appId: facebookAppId,
    pageId: facebookPageId
  }), /*#__PURE__*/React.createElement(OpenGraphArticleTags, {
    pageUrl: canonicalUrl,
    image: facebookImageProperties.imageUrl,
    title: ogTitle,
    siteName: siteName,
    imageHeight: facebookImageProperties.imageHeight,
    imageWidth: facebookImageProperties.imageWidth,
    description: ogDescription,
    createdAtISO: createdAtISO,
    updatedAtISO: updatedAtISO,
    articleSection: articleSection,
    tags: tags
  }), /*#__PURE__*/React.createElement(TwitterShare, {
    title: twitterTitle,
    description: twitterDescription,
    account: twitterAccount,
    image: twitterImageProperties.imageUrl,
    pageUrl: canonicalUrl,
    imageHeight: twitterImageProperties.imageHeight,
    imageWidth: twitterImageProperties.imageWidth
  }), /*#__PURE__*/React.createElement(GoogleNewsSchema, {
    canonical: canonicalUrl,
    title: seoTitle,
    image: pageImageUrl,
    datePublished: createdAtISO,
    dateModified: updatedAtISO,
    authors: authors,
    publisherName: siteName,
    logoUrl: logoImageAttributes.imageUrl,
    seoDescription: seoDescription,
    articleSection: articleSection
  }), /*#__PURE__*/React.createElement(RobotsMeta, {
    noIndex: noIndex
  }));
};

const TYPE_OPTIONS = {
  URL: 'URL',
  CODE: 'code'
};
const LOADING_TYPE_OPTIONS = {
  DEFER: 'defer',
  ASYNC: 'async',
  BLOCKING: 'blocking'
};

function createScriptTag({
  type,
  source,
  name,
  attributes = {},
  loadingType
}) {
  if (type === TYPE_OPTIONS.URL && source.length > 0) {
    if (loadingType === LOADING_TYPE_OPTIONS.DEFER) {
      return /*#__PURE__*/React.createElement("script", _extends$1({
        defer: true,
        src: source,
        type: "text/javascript",
        key: name
      }, attributes));
    }

    if (loadingType === LOADING_TYPE_OPTIONS.ASYNC) {
      return /*#__PURE__*/React.createElement("script", _extends$1({
        async: true,
        src: source,
        type: "text/javascript",
        key: name
      }, attributes));
    }

    return /*#__PURE__*/React.createElement("script", _extends$1({
      src: source,
      type: "text/javascript",
      key: name
    }, attributes));
  } // TODO - add html sanitization in the builder side or here...


  if (type === TYPE_OPTIONS.CODE && source.length > 0) {
    return /*#__PURE__*/React.createElement("script", _extends$1({
      type: "text/javascript",
      key: name
    }, attributes), source);
  }

  return null;
}

const ExternalScriptsComponent = ({
  scripts
}) => {
  return /*#__PURE__*/React.createElement(Helmet, null, scripts.map(createScriptTag));
};
const ExternalScripts = props => /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(ExternalScriptsComponent, props));

const componentConfigurationKey$n = 'decorationLine';
const decorationLineHeight$1 = 2;

const getDecorationLineStyle = (cardDecorationColor, height) => {
  return StyleSheet.create({
    style: {
      height: `${height}px`,
      width: '100%',
      backgroundColor: cardDecorationColor
    }
  });
};

const DecorationLine = props => {
  const {
    height = decorationLineHeight$1
  } = props;
  const {
    cardDecorationColor
  } = useTheme(componentConfigurationKey$n);
  const decorationLineStyle = getDecorationLineStyle(cardDecorationColor, height);
  return /*#__PURE__*/React.createElement("div", {
    className: css(decorationLineStyle.style)
  });
};

const ellipsify = lines => {
  return {
    style: {
      overflow: 'hidden',
      display: '-webkit-box',
      '-webkitLineClamp': `${lines}`,
      '-webkitBoxOrient': 'vertical'
    }
  };
};

const createStyles$a = (borderColor, linksColor, linkHoverColor, baseUnit) => StyleSheet.create({
  sectionItem: {
    padding: `${baseUnit * 0.5}px 0`,
    margin: `0 ${baseUnit * 0.5}px`,

    /*
      width is calculation of 50% - margins. The list is 200% width
      therefore to fit the visual container we set the item width to 50%
     */
    width: `calc(50% - ${baseUnit}px)`,
    borderTop: `1px solid ${borderColor}`,
    flex: '0 0 auto',
    boxSizing: 'border-box',
    position: 'relative',
    ':first-child': {
      borderTop: 'none'
    },
    ':last-child': {
      [MEDIA_BREAKPOINTS.small]: {
        display: 'none'
      }
    }
  },
  link: {
    textDecoration: 'none',
    boxSizing: 'border-box',
    color: linksColor,
    ':visited': {
      color: linksColor,
      textDecoration: 'none'
    },
    ':active': {
      color: linksColor,
      textDecoration: 'none'
    },
    [MEDIA_BREAKPOINTS.large]: {
      ':hover': {
        color: linkHoverColor,
        textDecoration: 'none'
      }
    },
    [MEDIA_BREAKPOINTS.medium]: {
      ':hover': {
        color: 'initial'
      }
    },
    [MEDIA_BREAKPOINTS.small]: {
      '-webkitLineClamp': '2',
      ':hover': {
        color: 'initial'
      }
    }
  }
});

const componentConfigurationKey$m = 'listItem';
const ListItem = ({
  title,
  articleUrl,
  numberOfLines = 2
}) => {
  const {
    borderColor,
    linkColor,
    linkHoverColor,
    baseUnit
  } = useTheme(componentConfigurationKey$m);
  const styles = createStyles$a(borderColor, linkColor, linkHoverColor, baseUnit); // @ts-ignore TS2345

  const {
    style
  } = StyleSheet.create(ellipsify(numberOfLines));
  return /*#__PURE__*/React.createElement(Link, {
    href: articleUrl,
    className: css(styles.link, styles.sectionItem),
    key: articleUrl
  }, /*#__PURE__*/React.createElement(H4, {
    styles: semanticCSS(style)
  }, title));
};

const LIST_WRAPPER_STYLE = {
  flex: '1',
  position: 'relative'
};
const LIST_STYLE = {
  position: 'absolute',
  top: '0',
  left: '0',
  bottom: '0',
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  width: '200%',
  // we preserve width for two columns here to be able to hide wrapping children
  minWidth: '200%'
};

const componentConfigurationKey$l = 'listWithHeading';

const createStyles$9 = (titleColor, backgroundColor, baseUnit, borderWidth, borderRadius, borderColor) => StyleSheet.create({
  listWrapper: { ...LIST_WRAPPER_STYLE,
    backgroundColor,
    borderRadius: `${borderRadius}px`,
    border: `${borderWidth}px solid ${borderColor}`,
    overflow: 'hidden'
  },
  list: { ...LIST_STYLE,
    [MEDIA_BREAKPOINTS.small]: {
      position: 'relative'
    }
  },
  title: {
    color: titleColor,
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: `${baseUnit / 2}px`,
    [MEDIA_BREAKPOINTS.large]: {
      padding: `${baseUnit / 2}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      padding: `${baseUnit / 2}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      padding: `${baseUnit / 2}px`
    }
  }
});

const ListWithHeading = ({
  listProps = [],
  displayName = '',
  itemNumLines = 1
}) => {
  const {
    titleColor,
    backgroundColor,
    baseUnit,
    borderWidth,
    borderRadius,
    borderColor,
    boxShadowTypeNormal,
    boxShadowTypeActive,
    boxShadowTypeHover
  } = useTheme(componentConfigurationKey$l);
  const styles = createStyles$9(titleColor, backgroundColor, baseUnit, borderWidth, borderRadius, borderColor);
  const boxShadowStyle = createStyleForBoxShadow({
    boxShadowTypeNormal,
    boxShadowTypeHover,
    boxShadowTypeActive
  });

  const createHeading = () => /*#__PURE__*/React.createElement(H1, {
    styles: semanticCSS(styles.title)
  }, displayName);

  return /*#__PURE__*/React.createElement("div", {
    className: css(boxShadowStyle.style, styles.listWrapper)
  }, /*#__PURE__*/React.createElement(DecorationLine, null), /*#__PURE__*/React.createElement("div", {
    className: css(styles.list)
  }, createHeading(), listProps.map((listItemProps, index) => /*#__PURE__*/React.createElement(ListItem, _extends$1({}, listItemProps, {
    numberOfLines: itemNumLines,
    key: index
  })))));
};

const hex2rgba = (hex, alpha = 1) => {
  // @ts-ignore
  const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
};

const CardOverlayStyles = cardOverlayColor => {
  return StyleSheet.create({
    style: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      bottom: '0px',
      background: `linear-gradient(0deg, ${hex2rgba(cardOverlayColor, 0.7)} 0%, rgba(0,0,0,0) 100%)`
    }
  });
};

const CardOverlay = ({
  overlayColor
}) => {
  const cardOverlayStyle = CardOverlayStyles(overlayColor);
  return /*#__PURE__*/React.createElement("div", {
    className: css(cardOverlayStyle.style)
  });
};

const intersectionObserverOptions = {
  root: null,
  rootMargin: '0px',
  threshold: [0, 0.05, 0.1]
};
const createIntersectionObserver = (callback, target) => {
  // @ts-ignore
  const observer = new window.IntersectionObserver(callback, intersectionObserverOptions);

  if (target) {
    observer.observe(target);
  }
};

const placeholderStyle = StyleSheet.create({
  style: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    transition: 'opacity 0.2s ease-in-out',
    willChange: 'opacity, transform'
  },
  initial: {
    opacity: 1
  },
  ready: {
    opacity: 0
  }
});
const defaultBlurRadius = 40;
class BlurredImageComponent extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "img", void 0);

    _defineProperty(this, "canvasRef", void 0);

    _defineProperty(this, "drawImageOnCanvas", event => {
      const {
        blur
      } = this.props;
      const ctx = this.getCanvas().getContext('2d');
      const {
        width,
        height
      } = this.getDimensions();
      this.setCanvasDimensions(width, height);
      ctx.filter = `blur(${blur}px)`;
      ctx.drawImage(event.target, 0, 0, width, height);
    });

    _defineProperty(this, "removeCanvas", () => {
      this.setState({
        shouldShowCanvas: false
      });
    });

    this.state = {
      shouldShowCanvas: true
    };
    this.canvasRef = /*#__PURE__*/React.createRef();
  }

  componentDidMount() {
    this.createImage();
    const {
      getRefCallback
    } = this.props;

    if (typeof getRefCallback === 'function') {
      getRefCallback(this.canvasRef);
    }
  }

  componentWillUnmount() {
    if (this.img) {
      this.img.onload = null;
    }
  }

  getCanvas() {
    return this.canvasRef.current;
  }

  getDimensions() {
    return this.getCanvas().getBoundingClientRect();
  }

  setCanvasDimensions(width, height) {
    this.getCanvas().width = width;
    this.getCanvas().height = height;
  }

  createImage() {
    const {
      src
    } = this.props;
    this.img = new window.Image();
    this.img.onload = this.drawImageOnCanvas;
    this.img.src = src;
  }

  render() {
    const {
      status
    } = this.props;
    const {
      shouldShowCanvas
    } = this.state;
    return shouldShowCanvas ? /*#__PURE__*/React.createElement("canvas", {
      className: css(placeholderStyle.style, placeholderStyle[status]),
      ref: this.canvasRef,
      onTransitionEnd: this.removeCanvas
    }) : null;
  }

}
const BlurredImage = BlurredImageComponent;

const EagerImage = props => {
  const {
    fallbackSrc,
    alt,
    title,
    srcSetLargeScreen,
    srcSetMediumScreen,
    srcSetSmallScreen
  } = props;
  return /*#__PURE__*/React.createElement("picture", {
    className: css(imageStyle.base)
  }, /*#__PURE__*/React.createElement("source", {
    srcSet: srcSetSmallScreen,
    media: `(max-width: ${SMALL_SCREEN_SIZE}px)`
  }), /*#__PURE__*/React.createElement("source", {
    srcSet: srcSetMediumScreen,
    media: `(max-width: ${MEDIUM_SCREEN_SIZE}px)`
  }), /*#__PURE__*/React.createElement("source", {
    srcSet: srcSetLargeScreen,
    media: `(min-width: ${LARGE_SCREEN_SIZE}px)`
  }), /*#__PURE__*/React.createElement("img", {
    className: css(imageStyle.base),
    src: fallbackSrc,
    alt: alt,
    title: title
  }));
};

const statusLabels = {
  initial: 'initial',
  ready: 'ready'
};
const lazyImageStyle = StyleSheet.create({
  style: {
    willChange: 'opacity, transform'
  },
  initial: {
    opacity: 0
  },
  ready: {
    opacity: 1
  }
});
class LazyImageComponent extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "observer", null);

    _defineProperty(this, "blurRef", void 0);

    _defineProperty(this, "imageRef", void 0);

    _defineProperty(this, "imageLargeSourceRef", void 0);

    _defineProperty(this, "imageMediumSourceRef", void 0);

    _defineProperty(this, "imageSmallSourceRef", void 0);

    _defineProperty(this, "getBlurredImageRef", ref => {
      this.blurRef = ref;
      this.observer = this.createIntersectionObserver();
    });

    _defineProperty(this, "intersectionCallback", entries => entries.filter(entry => entry.intersectionRatio > 0).forEach(() => this.loadImage()));

    this.imageRef = /*#__PURE__*/React.createRef();
    this.imageLargeSourceRef = /*#__PURE__*/React.createRef();
    this.imageMediumSourceRef = /*#__PURE__*/React.createRef();
    this.imageSmallSourceRef = /*#__PURE__*/React.createRef();
    this.blurRef = /*#__PURE__*/React.createRef();
    this.state = {
      status: statusLabels.initial
    };
  }

  componentWillUnmount() {
    this.observer = this.stopObservingIntersections();
  }

  getImageStyle() {
    const {
      status
    } = this.state;
    return css(imageStyle.base, lazyImageStyle[status], lazyImageStyle.style);
  }

  getBlurRadius() {
    return defaultBlurRadius;
  }

  createIntersectionObserver() {
    return createIntersectionObserver(this.intersectionCallback, this.blurRef.current);
  }

  stopObservingIntersections() {
    if (this.observer && this.blurRef.current) {
      this.observer.unobserve(this.blurRef.current);
    }
  }

  loadImage() {
    const {
      fallbackSrc,
      srcSetLargeScreen,
      srcSetMediumScreen,
      srcSetSmallScreen
    } = this.props;
    const img = this.imageRef.current;
    const imgLargeSourceRef = this.imageLargeSourceRef.current;
    const imgMediumSourceRef = this.imageMediumSourceRef.current;
    const imgSmallSourceRef = this.imageSmallSourceRef.current;

    img.onload = () => this.setState({
      status: statusLabels.ready
    });

    this.stopObservingIntersections();
    img.src = fallbackSrc;
    imgLargeSourceRef.srcset = srcSetLargeScreen;
    imgLargeSourceRef.media = `(min-width: ${LARGE_SCREEN_SIZE}px)`;
    imgMediumSourceRef.srcset = srcSetMediumScreen;
    imgMediumSourceRef.media = `(max-width: ${MEDIUM_SCREEN_SIZE}px)`;
    imgSmallSourceRef.srcset = srcSetSmallScreen;
    imgSmallSourceRef.media = `(max-width: ${SMALL_SCREEN_SIZE}px)`;
  }

  render() {
    const {
      status
    } = this.state;
    const {
      alt,
      title,
      lowResUrl
    } = this.props;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BlurredImage, {
      src: lowResUrl,
      blur: this.getBlurRadius(),
      getRefCallback: this.getBlurredImageRef,
      status: status
    }), /*#__PURE__*/React.createElement("picture", {
      className: this.getImageStyle()
    }, /*#__PURE__*/React.createElement("source", {
      ref: this.imageSmallSourceRef
    }), /*#__PURE__*/React.createElement("source", {
      ref: this.imageMediumSourceRef
    }), /*#__PURE__*/React.createElement("source", {
      ref: this.imageLargeSourceRef
    }), /*#__PURE__*/React.createElement("img", {
      className: this.getImageStyle(),
      ref: this.imageRef,
      alt: alt,
      title: title
    })), /*#__PURE__*/React.createElement("noscript", null, /*#__PURE__*/React.createElement(EagerImage, this.props)));
  }

}
const LazyImage = LazyImageComponent;

const componentConfigurationKey$k = 'image';

const defaultImageHeightCalculationMethods = createImageHeightCalculationMethods('ASPECT_RATIO', 'ASPECT_RATIO', 'ASPECT_RATIO');
const getBaseStyle = (imageAspectRatios, backgroundColor, imageHeightCalculationMethods, transparent) => {
  const getBaseStyleByType = type => {
    switch (type) {
      case '100%_HEIGHT':
        return {
          paddingTop: 'unset',
          height: '100%'
        };

      case 'ASPECT_RATIO':
      default:
        return {
          [MEDIA_BREAKPOINTS.large]: {
            paddingTop: `calc(100% / (${imageAspectRatios.large.x / imageAspectRatios.large.y}))`
          },
          [MEDIA_BREAKPOINTS.medium]: {
            paddingTop: `calc(100% / (${imageAspectRatios.medium.x / imageAspectRatios.medium.y}))`
          },
          [MEDIA_BREAKPOINTS.small]: {
            paddingTop: `calc(100% / (${imageAspectRatios.small.x / imageAspectRatios.small.y}))`
          }
        };
    }
  };

  return StyleSheet.create({
    base: {
      backgroundColor: transparent ? 'transparent' : backgroundColor,
      position: 'relative',
      overflow: 'hidden',
      margin: 0,
      boxSizing: 'border-box',
      flex: '1 1 100%',
      minWidth: '0%',
      [MEDIA_BREAKPOINTS.large]: { ...getBaseStyleByType(imageHeightCalculationMethods.large)
      },
      [MEDIA_BREAKPOINTS.medium]: { ...getBaseStyleByType(imageHeightCalculationMethods.medium)
      },
      [MEDIA_BREAKPOINTS.small]: { ...getBaseStyleByType(imageHeightCalculationMethods.small)
      }
    }
  });
};
const ImageWrapper = props => {
  const {
    additionalStyle,
    dataId,
    children,
    imageHeightCalculationMethods = defaultImageHeightCalculationMethods,
    imageAspectRatios,
    transparent
  } = props;
  const {
    backgroundColor
  } = useTheme(componentConfigurationKey$k);
  const baseStyle = getBaseStyle(imageAspectRatios, backgroundColor, imageHeightCalculationMethods, transparent);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, additionalStyle ? /*#__PURE__*/React.createElement("figure", {
    "data-id": dataId,
    className: css(additionalStyle.style)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(baseStyle.base)
  }, children)) : /*#__PURE__*/React.createElement("figure", {
    "data-id": dataId,
    className: css(baseStyle.base)
  }, children));
};

const Image = props => {
  const {
    alt,
    host,
    path,
    aspectRatio = {
      x: 16,
      y: 9
    },
    additionalStyle,
    lazyLoad,
    dataId,
    imageHeightCalculationMethods,
    transparent = false,
    caption,
    cropping = null
  } = props;
  const {
    imageAspectRatios = createImageAspectRatios(aspectRatio, aspectRatio, aspectRatio),
    imageWidths
  } = props;
  const CalculatedImage = lazyLoad ? LazyImage : EagerImage;
  const {
    fallbackSrc,
    lowResUrl,
    srcSetLargeScreen,
    srcSetMediumScreen,
    srcSetSmallScreen
  } = getImageSrcAndSrcSet(imageAspectRatios, imageWidths, host, path, cropping);
  const actualAltAndTitle = alt || caption || '';
  return /*#__PURE__*/React.createElement(ImageWrapper, {
    imageAspectRatios: imageAspectRatios,
    additionalStyle: additionalStyle,
    dataId: dataId,
    imageHeightCalculationMethods: imageHeightCalculationMethods,
    transparent: transparent
  }, /*#__PURE__*/React.createElement(CalculatedImage, {
    alt: actualAltAndTitle,
    title: actualAltAndTitle,
    fallbackSrc: fallbackSrc,
    lowResUrl: lowResUrl,
    srcSetLargeScreen: srcSetLargeScreen,
    srcSetMediumScreen: srcSetMediumScreen,
    srcSetSmallScreen: srcSetSmallScreen
  }));
};

const componentConfigThemeKey$Q = 'playIcon';

const playIconStyle = ({
  baseUnit,
  backgroundColor,
  triangleColor
}) => StyleSheet.create({
  wrapper: {
    height: '15%',
    minHeight: '24px',
    width: 'auto',
    position: 'absolute',
    top: `${baseUnit * 0.75}px`,
    left: `${baseUnit * 0.75}px`
  },
  circle: {
    fill: backgroundColor
  },
  polygon: {
    fill: triangleColor
  }
});

const PlayIcon = () => {
  const themeProps = useTheme(componentConfigThemeKey$Q);
  const style = playIconStyle(themeProps);
  return /*#__PURE__*/React__default.createElement("svg", {
    className: css(style.wrapper),
    viewBox: "0 0 64 64",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("title", null, "Icon / Video"), /*#__PURE__*/React__default.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React__default.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("circle", {
    className: css(style.circle),
    fill: "#FE5000",
    cx: "32",
    cy: "32",
    r: "32"
  }), /*#__PURE__*/React__default.createElement("polygon", {
    className: css(style.polygon),
    fill: "#FFFFFF",
    transform: "translate(34.000000, 32.000000) rotate(90.000000) translate(-34.000000, -32.000000) ",
    points: "34 20 46 44 22 44"
  }))));
};

const createStyle$L = ({
  borderRadius,
  paddingLarge = 0,
  paddingMedium = 0,
  paddingSmall = 0
}) => StyleSheet.create({
  wrapper: {
    display: 'flex',
    width: '100%',
    height: '100%',
    borderRadius: `${borderRadius}px`,
    boxSizing: 'border-box',
    background: 'transparent',
    [MEDIA_BREAKPOINTS.large]: {
      padding: `${paddingLarge * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      padding: `${paddingMedium * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      padding: `${paddingSmall * baseUnit}px`
    }
  }
});

const WrapperForCard = props => {
  const {
    boxShadowStyle,
    children
  } = props;
  const style = createStyle$L(props);
  return /*#__PURE__*/React.createElement("article", {
    className: css(boxShadowStyle.style, style.wrapper)
  }, children);
};

const listAuthors = authors => {
  return authors.map(author => author.name).join(', ');
};
const showMetadataInAnyScreenSize = (showAuthor, showDate) => showAuthor || showDate;
const showAuthorInAnyScreenSize = (authors, showAuthorInLargeScreen, showAuthorInMediumScreen, showAuthorInSmallScreen) => authors && authors.length > 0 && (showAuthorInLargeScreen || showAuthorInMediumScreen || showAuthorInSmallScreen);
const showDateInAnyScreenSize = (showDateInLargeScreen, showDateInMediumScreen, showDateInSmallScreen) => showDateInLargeScreen || showDateInMediumScreen || showDateInSmallScreen;
const showDescriptionInAnyScreenSize = (showDescriptionInLargeScreen, showDescriptionInMediumScreen, showDescriptionInSmallScreen) => showDescriptionInLargeScreen || showDescriptionInMediumScreen || showDescriptionInSmallScreen;
const showPipeInAnyScreenSize = (showAuthor, showDate) => showAuthor && showDate;
const showMetadataInLargeScreenSize = (showAuthorInLargeScreen, showDateInLargeScreen) => showAuthorInLargeScreen || showDateInLargeScreen;
const showMetadataInMediumScreenSize = (showAuthorInMediumScreen, showDateInMediumScreen) => showAuthorInMediumScreen || showDateInMediumScreen;
const showMetadataInSmallScreenSize = (showAuthorInSmallScreen, showDateInSmallScreen) => showAuthorInSmallScreen || showDateInSmallScreen;
const shouldShowSponsored = (...params) => params.every(str => typeof str === 'string' && str.trim() !== '');

const DynamicSemanticTag = props => {
  const {
    semanticTag
  } = props;
  const defaultFontSizes = getFontSizesBySemanticTag(semanticTag);
  const {
    fontSizesStyles
  } = useTheme();
  const {
    children,
    styles = [],
    fontSizeSmall = defaultFontSizes.fontSizeSmall,
    fontSizeMedium = defaultFontSizes.fontSizeMedium,
    fontSizeLarge = defaultFontSizes.fontSizeLarge,
    ...attributes
  } = props;
  const styleBySize = getStyleBySize(fontSizesStyles, {
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge
  });
  const SemanticTag = semanticTag;
  delete attributes.semanticTag;
  return /*#__PURE__*/React.createElement(SemanticTag, _extends$1({
    className: css(styleBySize, ...styles)
  }, attributes), children);
};

const componentConfigThemeKey$P = 'sponsoredTextVertical';

const getStyles$K = ({
  baseUnit,
  sponsoredTextColor,
  alignment = consts.ALIGNMENT_OPTIONS.CENTER
}) => StyleSheet.create({
  wrapper: {
    textAlign: alignment === consts.ALIGNMENT_OPTIONS.CENTER ? 'center' : 'left',
    marginTop: `${baseUnit / 2}px`,
    [MEDIA_BREAKPOINTS.large]: {
      gridRowGap: `${baseUnit / 2}px`,
      marginTop: `${baseUnit / 2}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      gridRowGap: `${baseUnit / 2}px`,
      marginTop: `${baseUnit / 2}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      gridRowGap: `${baseUnit / 4}px`,
      marginTop: `${baseUnit / 4}px`
    }
  },
  sponsored: {
    color: sponsoredTextColor
  },
  image: {
    marginTop: `${baseUnit / 2}px`,
    [MEDIA_BREAKPOINTS.large]: {
      height: `${baseUnit * 2}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      height: `${baseUnit * 2}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      height: `${baseUnit}px`
    }
  }
});

const checkLogoExists = logo => typeof logo === 'string' && logo.trim() !== '';

const SponsoredTextVertical = props => {
  const {
    sponsoredText,
    logo,
    brandName
  } = props;
  const themeProps = useTheme(componentConfigThemeKey$P);
  const styles = getStyles$K(themeProps);
  const hasLogo = checkLogoExists(logo);
  const text = hasLogo ? sponsoredText : `${sponsoredText} ${brandName}`;
  const {
    sponsorFontSizeLarge,
    sponsorFontSizeMedium,
    sponsorFontSizeSmall
  } = themeProps;
  return /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapper)
  }, /*#__PURE__*/React.createElement(P, {
    fontSizeLarge: sponsorFontSizeLarge,
    fontSizeMedium: sponsorFontSizeMedium,
    fontSizeSmall: sponsorFontSizeSmall,
    styles: semanticCSS(styles.sponsored)
  }, text), hasLogo && /*#__PURE__*/React.createElement("img", {
    className: css(styles.image),
    alt: brandName,
    src: `data:image/svg+xml,${encodeURIComponent(logo || '')}`
  }));
};

const componentConfigThemeKey$O = 'onTopCard';

const createCardStyles = (cardTextColorTypeNormal, cardTextColorTypeHover, cardTextColorTypeActive, borderRadius) => StyleSheet.create({
  card: {
    width: '100%',
    height: '100%',
    position: 'relative',
    textDecoration: 'none',
    color: cardTextColorTypeNormal,
    ':hover': {
      color: cardTextColorTypeHover
    },
    ':active': {
      color: cardTextColorTypeActive
    },
    display: 'block',
    '-webkit-mask-image': '-webkit-radial-gradient(white, black)',
    borderRadius: `${borderRadius}px`
  }
});

const createFooterStyle$1 = metadataAlignment => StyleSheet.create({
  style: {
    justifySelf: metadataAlignment === consts.ALIGNMENT_OPTIONS.CENTER ? 'center' : 'left'
  }
}).style;

const createMetadataStyle$1 = (horizontalGapLarge, horizontalGapMedium, horizontalGapSmall, showMetadataInLargeScreen, showMetadataInMediumScreen, showMetadataInSmallScreen) => StyleSheet.create({
  style: {
    gridTemplateColumns: 'auto auto max-content',
    [MEDIA_BREAKPOINTS.large]: {
      display: showMetadataInLargeScreen ? 'inline-grid' : 'none',
      marginTop: `${baseUnit * horizontalGapLarge}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      display: showMetadataInMediumScreen ? 'inline-grid' : 'none',
      marginTop: `${baseUnit * horizontalGapMedium}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      display: showMetadataInSmallScreen ? 'inline-grid' : 'none',
      marginTop: `${baseUnit * horizontalGapSmall}px`
    }
  }
}).style;

const createTitleAlignmentStyle = titleAlignment => {
  switch (titleAlignment) {
    case consts.ALIGNMENT_OPTIONS.CENTER:
      return StyleSheet.create({
        style: {
          textAlign: 'center'
        }
      }).style;

    case consts.ALIGNMENT_OPTIONS.START:
    default:
      return StyleSheet.create({
        style: {
          textAlign: 'left'
        }
      }).style;
  }
};

const createAuthorsStyle$1 = (showAuthorSmallScreen, showAuthorMediumScreen, showAuthorLargeScreen, authorColor, numberOfLinesForAuthors) => StyleSheet.create({
  style: {
    color: authorColor,
    height: 'fit-content',
    alignSelf: 'flex-end',
    [MEDIA_BREAKPOINTS.large]: {
      marginRight: `${baseUnit * 0.25}px`,
      ...(showAuthorLargeScreen ? ellipsify(numberOfLinesForAuthors).style : {
        display: 'none'
      })
    },
    [MEDIA_BREAKPOINTS.medium]: {
      marginRight: `${baseUnit * 0.25}px`,
      ...(showAuthorMediumScreen ? ellipsify(numberOfLinesForAuthors).style : {
        display: 'none'
      })
    },
    [MEDIA_BREAKPOINTS.small]: {
      marginRight: `${baseUnit * 0.25}px`,
      ...(showAuthorSmallScreen ? ellipsify(numberOfLinesForAuthors).style : {
        display: 'none'
      })
    }
  }
}).style;

const createDateStyle$1 = (showDateSmallScreen, showDateMediumScreen, showDateLargeScreen, dateColor) => StyleSheet.create({
  style: {
    color: dateColor,
    alignSelf: 'flex-end',
    [MEDIA_BREAKPOINTS.large]: {
      display: showDateLargeScreen ? 'inline-block' : 'none'
    },
    [MEDIA_BREAKPOINTS.medium]: {
      display: showDateMediumScreen ? 'inline-block' : 'none'
    },
    [MEDIA_BREAKPOINTS.small]: {
      display: showDateSmallScreen ? 'inline-block' : 'none'
    }
  }
}).style;

const createPipeStyle$1 = (showDateSmallScreen, showDateMediumScreen, showDateLargeScreen, showAuthorSmallScreen, showAuthorMediumScreen, showAuthorLargeScreen, pipeColor) => StyleSheet.create({
  style: {
    color: pipeColor,
    alignSelf: 'flex-end',
    [MEDIA_BREAKPOINTS.large]: {
      display: showDateLargeScreen && showAuthorLargeScreen ? 'block' : 'none',
      marginRight: `${baseUnit * 0.25}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      display: showDateMediumScreen && showAuthorMediumScreen ? 'block' : 'none',
      marginRight: `${baseUnit * 0.25}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      display: showDateSmallScreen && showAuthorSmallScreen ? 'block' : 'none',
      marginRight: `${baseUnit * 0.25}px`
    }
  }
}).style;

const createTextWrapperStyle$1 = (horizontalGapLarge, horizontalGapMedium, horizontalGapSmall, verticalGapLarge, verticalGapMedium, verticalGapSmall) => StyleSheet.create({
  style: {
    overflow: 'hidden',
    width: '-webkit-fill-available',
    display: 'grid',
    backgroundColor: 'transparent',
    position: 'absolute',
    bottom: 0,
    [MEDIA_BREAKPOINTS.large]: {
      margin: `${baseUnit * horizontalGapLarge}px ${baseUnit * verticalGapLarge}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      margin: `${baseUnit * horizontalGapMedium}px ${baseUnit * verticalGapMedium}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      margin: `${baseUnit * horizontalGapSmall}px ${baseUnit * verticalGapSmall}px`
    }
  }
}).style;

const createMainCategoryStyle$3 = (showMainCategoryInLargeScreen, showMainCategoryInMediumScreen, showMainCategoryInSmallScreen, mainCategoryHorizontalGapLarge, mainCategoryHorizontalGapMedium, mainCategoryHorizontalGapSmall, mainCategoryVerticalGapLarge, mainCategoryVerticalGapMedium, mainCategoryVerticalGapSmall, mainCategoryBackgroundColor, mainCategoryTextColor, mainCategoryAlignment, horizontalGapLarge, horizontalGapMedium, horizontalGapSmall) => StyleSheet.create({
  style: {
    backgroundColor: mainCategoryBackgroundColor,
    color: mainCategoryTextColor,
    width: 'fit-content',
    [MEDIA_BREAKPOINTS.large]: {
      display: showMainCategoryInLargeScreen ? 'block' : 'none',
      padding: `${mainCategoryHorizontalGapLarge * baseUnit}px ${mainCategoryVerticalGapLarge * baseUnit}px`,
      margin: mainCategoryAlignment === consts.ALIGNMENT_OPTIONS.CENTER ? `${horizontalGapLarge * baseUnit}px auto` : `${horizontalGapLarge * baseUnit}px 0`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      display: showMainCategoryInMediumScreen ? 'block' : 'none',
      padding: `${mainCategoryHorizontalGapMedium * baseUnit}px ${mainCategoryVerticalGapMedium * baseUnit}px`,
      margin: mainCategoryAlignment === consts.ALIGNMENT_OPTIONS.CENTER ? `${horizontalGapMedium * baseUnit}px auto` : `${horizontalGapMedium * baseUnit}px 0`
    },
    [MEDIA_BREAKPOINTS.small]: {
      display: showMainCategoryInSmallScreen ? 'block' : 'none',
      padding: `${mainCategoryHorizontalGapSmall * baseUnit}px ${mainCategoryVerticalGapSmall * baseUnit}px`,
      margin: mainCategoryAlignment === consts.ALIGNMENT_OPTIONS.CENTER ? `${horizontalGapSmall * baseUnit}px auto` : `${horizontalGapSmall * baseUnit}px 0`
    }
  }
}).style;

const OnTopCard = props => {
  const {
    title,
    image,
    articleUrl,
    coverType,
    imageHeightCalculationMethods,
    imageWidths,
    lazyLoad = false,
    authors,
    mainCategory,
    logo,
    sponsoredText,
    brandName,
    updatedAt,
    updatedAtISO,
    createdAt,
    createdAtISO,
    onClick
  } = props;
  const {
    cardTitleColorTypeNormal,
    cardTitleColorTypeHover,
    cardTitleColorTypeActive,
    boxShadowTypeNormal,
    boxShadowTypeActive,
    boxShadowTypeHover,
    borderRadius,
    borderColorTypeActive,
    borderColorTypeHover,
    borderColorTypeNormal,
    borderWidthTypeActive,
    borderWidthTypeHover,
    borderWidthTypeNormal,
    titleFontSizeLarge,
    titleFontSizeSmall,
    titleFontSizeMedium,
    showAuthorInSmallScreen,
    showAuthorInMediumScreen,
    showAuthorInLargeScreen,
    aspectRatioLarge,
    aspectRatioMedium,
    aspectRatioSmall,
    authorColor,
    metadataFontSizeLarge,
    metadataFontSizeMedium,
    metadataFontSizeSmall,
    metadataAlignment,
    titleAlignment,
    horizontalGapLarge,
    horizontalGapMedium,
    horizontalGapSmall,
    overlayColor,
    verticalGapLarge,
    verticalGapMedium,
    verticalGapSmall,
    wrapperGapLarge,
    wrapperGapMedium,
    wrapperGapSmall,
    titleSemanticTag,
    metadataSemanticTag,
    showDateInSmallScreen,
    showDateInMediumScreen,
    showDateInLargeScreen,
    dateColor,
    pipeColor,
    showMainCategoryInLargeScreen,
    showMainCategoryInMediumScreen,
    showMainCategoryInSmallScreen,
    mainCategoryHorizontalGapLarge,
    mainCategoryHorizontalGapMedium,
    mainCategoryHorizontalGapSmall,
    mainCategoryVerticalGapLarge,
    mainCategoryVerticalGapMedium,
    mainCategoryVerticalGapSmall,
    mainCategoryBackgroundColor,
    mainCategoryFontSizeLarge,
    mainCategoryFontSizeMedium,
    mainCategoryFontSizeSmall,
    mainCategorySemanticTag,
    mainCategoryTextColor,
    mainCategoryAlignment,
    numberOfLinesForTitle,
    numberOfLinesForAuthors,
    isUpdatedAtTimestamp,
    isMainCategoryEnabled
  } = useTheme(componentConfigThemeKey$O);
  const cardStyles = createCardStyles(cardTitleColorTypeNormal, cardTitleColorTypeHover, cardTitleColorTypeActive, borderRadius);
  const borderBoxShadow = {
    borderColorTypeActive,
    borderColorTypeHover,
    borderColorTypeNormal,
    borderWidthTypeActive,
    borderWidthTypeHover,
    borderWidthTypeNormal
  };
  const showSponsored = shouldShowSponsored(sponsoredText, brandName);
  const boxShadowStyle = createStyleForBoxShadow({
    boxShadowTypeNormal,
    boxShadowTypeHover,
    boxShadowTypeActive,
    borderBoxShadow
  });
  const titleAlignmentStyle = createTitleAlignmentStyle(titleAlignment);
  const showMetadataInLargeScreen = showMetadataInLargeScreenSize(showAuthorInLargeScreen, showDateInLargeScreen);
  const showMetadataInMediumScreen = showMetadataInMediumScreenSize(showAuthorInMediumScreen, showDateInMediumScreen);
  const showMetadataInSmallScreen = showMetadataInSmallScreenSize(showAuthorInSmallScreen, showDateInSmallScreen);
  const footerStyle = createFooterStyle$1(metadataAlignment);
  const metadataStyle = createMetadataStyle$1(horizontalGapLarge, horizontalGapMedium, horizontalGapSmall, showMetadataInLargeScreen, showMetadataInMediumScreen, showMetadataInSmallScreen);
  const authorsStyle = createAuthorsStyle$1(showAuthorInSmallScreen, showAuthorInMediumScreen, showAuthorInLargeScreen, authorColor, numberOfLinesForAuthors);
  const dateStyle = createDateStyle$1(showDateInSmallScreen, showDateInMediumScreen, showDateInLargeScreen, dateColor);
  const pipeStyle = createPipeStyle$1(showDateInSmallScreen, showDateInMediumScreen, showDateInLargeScreen, showAuthorInSmallScreen, showAuthorInMediumScreen, showAuthorInLargeScreen, pipeColor);
  const showAuthor = showAuthorInAnyScreenSize(authors, showAuthorInLargeScreen, showAuthorInMediumScreen, showAuthorInSmallScreen);
  const showDate = showDateInAnyScreenSize(showDateInLargeScreen, showDateInMediumScreen, showDateInSmallScreen);
  const showMainCategory = isMainCategoryEnabled && mainCategory && (showMainCategoryInSmallScreen || showMainCategoryInMediumScreen || showMainCategoryInLargeScreen); // @ts-ignore TS2345

  const {
    style
  } = StyleSheet.create(ellipsify(numberOfLinesForTitle));
  const textWrapperStyle = createTextWrapperStyle$1(horizontalGapLarge, horizontalGapMedium, horizontalGapSmall, verticalGapLarge, verticalGapMedium, verticalGapSmall);
  const timestamp = isUpdatedAtTimestamp ? updatedAt : createdAt;
  const timestampISO = isUpdatedAtTimestamp ? updatedAtISO : createdAtISO;

  const MainCategory = () => {
    const mainCategoryStyle = createMainCategoryStyle$3(showMainCategoryInLargeScreen, showMainCategoryInMediumScreen, showMainCategoryInSmallScreen, mainCategoryHorizontalGapLarge, mainCategoryHorizontalGapMedium, mainCategoryHorizontalGapSmall, mainCategoryVerticalGapLarge, mainCategoryVerticalGapMedium, mainCategoryVerticalGapSmall, mainCategoryBackgroundColor, mainCategoryTextColor, mainCategoryAlignment, horizontalGapLarge, horizontalGapMedium, horizontalGapSmall);
    return /*#__PURE__*/React.createElement(DynamicSemanticTag, {
      semanticTag: mainCategorySemanticTag,
      fontSizeLarge: mainCategoryFontSizeLarge,
      fontSizeMedium: mainCategoryFontSizeMedium,
      fontSizeSmall: mainCategoryFontSizeSmall,
      styles: semanticCSS(mainCategoryStyle)
    }, mainCategory);
  };

  return /*#__PURE__*/React.createElement(WrapperForCard, {
    boxShadowStyle: boxShadowStyle,
    borderRadius: borderRadius,
    paddingLarge: wrapperGapLarge,
    paddingMedium: wrapperGapMedium,
    paddingSmall: wrapperGapSmall
  }, /*#__PURE__*/React.createElement(Link, {
    className: css(cardStyles.card, boxShadowStyle.style),
    href: articleUrl,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Image, _extends$1({}, image, {
    lazyLoad: lazyLoad,
    imageAspectRatios: createImageAspectRatios(aspectRatioSmall, aspectRatioMedium, aspectRatioLarge),
    imageHeightCalculationMethods: imageHeightCalculationMethods,
    imageWidths: imageWidths
  })), /*#__PURE__*/React.createElement(CardOverlay, {
    overlayColor: overlayColor
  }), /*#__PURE__*/React.createElement("div", {
    className: css(textWrapperStyle)
  }, /*#__PURE__*/React.createElement("header", null, showMainCategory ? /*#__PURE__*/React.createElement(MainCategory, null) : null, /*#__PURE__*/React.createElement(DynamicSemanticTag, {
    semanticTag: titleSemanticTag,
    fontSizeLarge: titleFontSizeLarge,
    fontSizeMedium: titleFontSizeMedium,
    fontSizeSmall: titleFontSizeSmall,
    styles: semanticCSS(titleAlignmentStyle, style)
  }, title)), showMetadataInAnyScreenSize(showAuthor, showDate) ? /*#__PURE__*/React.createElement("footer", {
    className: css(footerStyle)
  }, /*#__PURE__*/React.createElement(DynamicSemanticTag, {
    semanticTag: metadataSemanticTag,
    fontSizeLarge: metadataFontSizeLarge,
    fontSizeMedium: metadataFontSizeMedium,
    fontSizeSmall: metadataFontSizeSmall,
    styles: semanticCSS(metadataStyle)
  }, showAuthor ? /*#__PURE__*/React.createElement("div", {
    className: css(authorsStyle)
  }, listAuthors(authors)) : null, showPipeInAnyScreenSize(showAuthor, showDate) ? /*#__PURE__*/React.createElement("div", {
    className: css(pipeStyle)
  }, "|") : null, showDate ? /*#__PURE__*/React.createElement("time", {
    dateTime: timestampISO,
    className: css(dateStyle)
  }, timestamp) : null)) : null, showSponsored ? /*#__PURE__*/React.createElement(SponsoredTextVertical, {
    sponsoredText: sponsoredText,
    brandName: brandName,
    logo: logo
  }) : null), coverType === 'video' ? /*#__PURE__*/React.createElement(PlayIcon, null) : null));
};

const createStyles$8 = baseUnit => StyleSheet.create({
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap'
  },
  cardWrapper: {
    boxSizing: 'border-box',
    [MEDIA_BREAKPOINTS.large]: {
      paddingRight: `${baseUnit / 4}px`,
      flex: '0 0 66.67%'
    },
    [MEDIA_BREAKPOINTS.medium]: {
      paddingRight: `${baseUnit / 4}px`,
      flex: '0 0 66.67%'
    },
    [MEDIA_BREAKPOINTS.small]: {
      paddingRight: '0',
      flex: '0 0 100%',
      paddingBottom: `${baseUnit / 4}px`
    }
  },
  listWrapper: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    [MEDIA_BREAKPOINTS.large]: {
      paddingLeft: `${baseUnit / 4}px`,
      flex: '0 1 33.33%'
    },
    [MEDIA_BREAKPOINTS.medium]: {
      paddingLeft: `${baseUnit / 4}px`,
      flex: '0 1 33.33%'
    },
    [MEDIA_BREAKPOINTS.small]: {
      paddingLeft: '0',
      flex: '0 1 100%',
      paddingTop: `${baseUnit / 4}px`
    }
  }
});

const imageWidths$j = createImageWidths(360, 720, 720);
const HeadlinesArticleList = ({
  cardsProps,
  displayName,
  paddingFactors
}) => {
  const {
    baseUnit
  } = useTheme();
  const styles = createStyles$8(baseUnit);
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const [onTopCardProps, ...listProps] = cardsProps;
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cardsProps && cardsProps.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle, styles.container)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(styles.cardWrapper)
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, onTopCardProps, {
    imageWidths: imageWidths$j
  }))), /*#__PURE__*/React.createElement("div", {
    className: css(styles.listWrapper)
  }, /*#__PURE__*/React.createElement(ListWithHeading, {
    listProps: listProps,
    displayName: displayName,
    itemNumLines: 2
  }))));
};

function useThemeOverride(override, key) {
  const themeContext = React__default.useContext(ThemeContext);
  return { ...themeContext,
    [key]: { ...themeContext[key],
      ...override
    }
  };
}

const style$1 = StyleSheet.create({
  wrap: {
    position: 'relative',
    display: 'flex'
  }
});
const RelativeWrapper = ({
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: css(style$1.wrap)
}, children);
const ConditionalRelativeWrap = ({
  shouldWarp,
  children
}) => shouldWarp ? /*#__PURE__*/React.createElement(RelativeWrapper, null, children) : /*#__PURE__*/React.createElement(React.Fragment, null, children);

const componentConfigThemeKey$N = 'sponsoredTextHorizontal';

const getStyles$J = ({
  baseUnit,
  sponsoredTextColor,
  brandNameColor,
  alignment
}) => StyleSheet.create({
  wrapper: {
    textAlign: alignment === consts.ALIGNMENT_OPTIONS.CENTER ? 'center' : 'left',
    marginTop: `${baseUnit / 2}px`,
    height: 'fit-content'
  },
  sponsored: {
    color: sponsoredTextColor
  },
  brandName: {
    color: brandNameColor
  }
});

const SponsoredTextHorizontal = props => {
  const {
    sponsoredText,
    brandName
  } = props;
  const themeProps = useTheme(componentConfigThemeKey$N);
  const styles = getStyles$J(themeProps);
  const {
    sponsorFontSizeLarge,
    sponsorFontSizeMedium,
    sponsorFontSizeSmall
  } = themeProps;
  return /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapper)
  }, /*#__PURE__*/React.createElement(Span, {
    fontSizeLarge: sponsorFontSizeLarge,
    fontSizeMedium: sponsorFontSizeMedium,
    fontSizeSmall: sponsorFontSizeSmall,
    styles: semanticCSS(styles.sponsored)
  }, `${sponsoredText} `), /*#__PURE__*/React.createElement(Span, {
    fontSizeLarge: sponsorFontSizeLarge,
    fontSizeMedium: sponsorFontSizeMedium,
    fontSizeSmall: sponsorFontSizeSmall,
    styles: semanticCSS(styles.brandName)
  }, brandName));
};

const createTextWrapperStyle = (horizontalGapLarge, horizontalGapMedium, horizontalGapSmall, verticalGapLarge, verticalGapMedium, verticalGapSmall) => StyleSheet.create({
  style: {
    overflow: 'hidden',
    width: '-webkit-fill-available',
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    [MEDIA_BREAKPOINTS.large]: {
      margin: `${baseUnit * horizontalGapLarge}px ${baseUnit * verticalGapLarge}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      margin: `${baseUnit * horizontalGapMedium}px ${baseUnit * verticalGapMedium}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      margin: `${baseUnit * horizontalGapSmall}px ${baseUnit * verticalGapSmall}px`
    }
  }
}).style;

const createTopTextWrapperStyle = () => StyleSheet.create({
  style: {
    height: 'fit-content'
  }
}).style;

const createTitleStyle = numberOfLinesForTitle => {
  return StyleSheet.create({
    text: {
      overflow: 'hidden',
      height: 'fit-content',
      ...ellipsify(numberOfLinesForTitle).style
    }
  }).text;
};

const createDescriptionStyle = (showDescriptionLargeScreen, showDescriptionMediumScreen, showDescriptionSmallScreen, descriptionColor, numberOfLinesForDescription) => StyleSheet.create({
  style: {
    color: descriptionColor,
    height: 'fit-content',
    [MEDIA_BREAKPOINTS.large]: { ...(showDescriptionLargeScreen ? ellipsify(numberOfLinesForDescription).style : {
        display: 'none'
      })
    },
    [MEDIA_BREAKPOINTS.medium]: { ...(showDescriptionMediumScreen ? ellipsify(numberOfLinesForDescription).style : {
        display: 'none'
      })
    },
    [MEDIA_BREAKPOINTS.small]: { ...(showDescriptionSmallScreen ? ellipsify(numberOfLinesForDescription).style : {
        display: 'none'
      })
    }
  }
}).style;

const createBottomTextWrapperStyle = () => StyleSheet.create({
  style: {
    height: '100%',
    display: 'grid',
    alignItems: 'flex-end',
    gridTemplateRows: '1fr auto'
  }
}).style;

const createMetadataStyle = (horizontalGapLarge, horizontalGapMedium, horizontalGapSmall, showMetadataInLargeScreen, showMetadataInMediumScreen, showMetadataInSmallScreen) => StyleSheet.create({
  style: {
    gridTemplateColumns: 'auto auto max-content',
    width: 'fit-content',
    [MEDIA_BREAKPOINTS.large]: {
      display: showMetadataInLargeScreen ? 'inline-grid' : 'none',
      marginTop: `${baseUnit * horizontalGapLarge}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      display: showMetadataInMediumScreen ? 'inline-grid' : 'none',
      marginTop: `${baseUnit * horizontalGapMedium}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      display: showMetadataInSmallScreen ? 'inline-grid' : 'none',
      marginTop: `${baseUnit * horizontalGapSmall}px`
    }
  }
}).style;

const createAuthorsStyle = (showAuthorSmallScreen, showAuthorMediumScreen, showAuthorLargeScreen, authorColor, numberOfLinesForAuthors) => StyleSheet.create({
  style: {
    color: authorColor,
    alignSelf: 'flex-end',
    [MEDIA_BREAKPOINTS.large]: {
      marginRight: `${baseUnit * 0.25}px`,
      ...(showAuthorLargeScreen ? ellipsify(numberOfLinesForAuthors).style : {
        display: 'none'
      })
    },
    [MEDIA_BREAKPOINTS.medium]: {
      marginRight: `${baseUnit * 0.25}px`,
      ...(showAuthorMediumScreen ? ellipsify(numberOfLinesForAuthors).style : {
        display: 'none'
      })
    },
    [MEDIA_BREAKPOINTS.small]: {
      marginRight: `${baseUnit * 0.25}px`,
      ...(showAuthorSmallScreen ? ellipsify(numberOfLinesForAuthors).style : {
        display: 'none'
      })
    }
  }
}).style;

const createPipeStyle = (showDateSmallScreen, showDateMediumScreen, showDateLargeScreen, showAuthorSmallScreen, showAuthorMediumScreen, showAuthorLargeScreen, pipeColor) => StyleSheet.create({
  style: {
    color: pipeColor,
    alignSelf: 'flex-end',
    [MEDIA_BREAKPOINTS.large]: {
      display: showDateLargeScreen && showAuthorLargeScreen ? 'block' : 'none',
      marginRight: `${baseUnit * 0.25}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      display: showDateMediumScreen && showAuthorMediumScreen ? 'block' : 'none',
      marginRight: `${baseUnit * 0.25}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      display: showDateSmallScreen && showAuthorSmallScreen ? 'block' : 'none',
      marginRight: `${baseUnit * 0.25}px`
    }
  }
}).style;

const createDateStyle = (showDateSmallScreen, showDateMediumScreen, showDateLargeScreen, dateColor) => StyleSheet.create({
  style: {
    color: dateColor,
    alignSelf: 'flex-end',
    [MEDIA_BREAKPOINTS.large]: {
      display: showDateLargeScreen ? 'inline-block' : 'none'
    },
    [MEDIA_BREAKPOINTS.medium]: {
      display: showDateMediumScreen ? 'inline-block' : 'none'
    },
    [MEDIA_BREAKPOINTS.small]: {
      display: showDateSmallScreen ? 'inline-block' : 'none'
    }
  }
}).style;

const createTextAlignmentStyle = (alignment = consts.ALIGNMENT_OPTIONS.START) => {
  switch (alignment) {
    case consts.ALIGNMENT_OPTIONS.CENTER:
      return StyleSheet.create({
        style: {
          textAlign: 'center'
        }
      }).style;

    case consts.ALIGNMENT_OPTIONS.START:
    default:
      return StyleSheet.create({
        style: {
          textAlign: 'left'
        }
      }).style;
  }
};

const createFooterStyle = (metadataAlignment = consts.ALIGNMENT_OPTIONS.START) => StyleSheet.create({
  style: {
    justifySelf: metadataAlignment === consts.ALIGNMENT_OPTIONS.CENTER ? 'center' : 'left'
  }
}).style;

const TextNextToImage = props => {
  const {
    children,
    title,
    brandName,
    authors,
    description,
    timestamp,
    timestampISO,
    sponsoredText,
    horizontalGapLarge,
    horizontalGapMedium,
    horizontalGapSmall,
    verticalGapLarge,
    verticalGapMedium,
    verticalGapSmall,
    titleSemanticTag,
    titleFontSizeMedium,
    titleFontSizeSmall,
    titleFontSizeLarge,
    numberOfLinesForTitle,
    showDescriptionInLargeScreen,
    showDescriptionInMediumScreen,
    showDescriptionInSmallScreen,
    descriptionSemanticTag,
    descriptionFontSizeInSmallScreen,
    descriptionFontSizeInLargeScreen,
    descriptionFontSizeInMediumScreen,
    descriptionColor,
    numberOfLinesForDescription,
    showAuthorInLargeScreen,
    showAuthorInMediumScreen,
    showAuthorInSmallScreen,
    showDateInLargeScreen,
    showDateInMediumScreen,
    showDateInSmallScreen,
    metadataSemanticTag,
    metadataFontSizeLarge,
    metadataFontSizeMedium,
    metadataFontSizeSmall,
    showMetadataInLargeScreen,
    showMetadataInMediumScreen,
    showMetadataInSmallScreen,
    authorColor,
    numberOfLinesForAuthors,
    pipeColor,
    dateColor,
    titleAlignment,
    descriptionAlignment,
    metadataAlignment
  } = props;
  const textWrapperStyle = createTextWrapperStyle(horizontalGapLarge, horizontalGapMedium, horizontalGapSmall, verticalGapLarge, verticalGapMedium, verticalGapSmall);
  const topTextWrapperStyle = createTopTextWrapperStyle();
  const titleStyle = createTitleStyle(numberOfLinesForTitle);
  const descriptionStyle = createDescriptionStyle(showDescriptionInLargeScreen, showDescriptionInMediumScreen, showDescriptionInSmallScreen, descriptionColor, numberOfLinesForDescription);
  const bottomTextWrapperStyle = createBottomTextWrapperStyle();
  const metadataStyle = createMetadataStyle(horizontalGapLarge, horizontalGapMedium, horizontalGapSmall, showMetadataInLargeScreen, showMetadataInMediumScreen, showMetadataInSmallScreen);
  const authorsStyle = createAuthorsStyle(showAuthorInSmallScreen, showAuthorInMediumScreen, showAuthorInLargeScreen, authorColor, numberOfLinesForAuthors);
  const pipeStyle = createPipeStyle(showDateInSmallScreen, showDateInMediumScreen, showDateInLargeScreen, showAuthorInSmallScreen, showAuthorInMediumScreen, showAuthorInLargeScreen, pipeColor);
  const dateStyle = createDateStyle(showDateInSmallScreen, showDateInMediumScreen, showDateInLargeScreen, dateColor);
  const titleAlignmentStyle = createTextAlignmentStyle(titleAlignment);
  const descriptionAlignmentStyle = createTextAlignmentStyle(descriptionAlignment);
  const footerStyle = createFooterStyle(metadataAlignment);
  const showAuthor = showAuthorInAnyScreenSize(authors, showAuthorInLargeScreen, showAuthorInMediumScreen, showAuthorInSmallScreen);
  const showDate = showDateInAnyScreenSize(showDateInLargeScreen, showDateInMediumScreen, showDateInSmallScreen);
  const showSponsored = shouldShowSponsored(sponsoredText, brandName);
  const showBottomText = showSponsored || showMetadataInAnyScreenSize(showAuthor, showDate);
  return /*#__PURE__*/React.createElement("div", {
    className: css(textWrapperStyle)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(topTextWrapperStyle)
  }, /*#__PURE__*/React.createElement("header", null, children, /*#__PURE__*/React.createElement(DynamicSemanticTag, {
    semanticTag: titleSemanticTag,
    fontSizeLarge: titleFontSizeLarge,
    fontSizeMedium: titleFontSizeMedium,
    fontSizeSmall: titleFontSizeSmall,
    styles: semanticCSS(titleAlignmentStyle, titleStyle)
  }, title)), showDescriptionInAnyScreenSize(showDescriptionInLargeScreen, showDescriptionInMediumScreen, showDescriptionInSmallScreen) ? /*#__PURE__*/React.createElement(DynamicSemanticTag, {
    semanticTag: descriptionSemanticTag,
    fontSizeLarge: descriptionFontSizeInLargeScreen,
    fontSizeMedium: descriptionFontSizeInMediumScreen,
    fontSizeSmall: descriptionFontSizeInSmallScreen,
    styles: semanticCSS(descriptionAlignmentStyle, descriptionStyle)
  }, description) : null), showBottomText ? /*#__PURE__*/React.createElement("div", {
    className: css(bottomTextWrapperStyle)
  }, showMetadataInAnyScreenSize(showAuthor, showDate) ? /*#__PURE__*/React.createElement("footer", {
    className: css(footerStyle)
  }, /*#__PURE__*/React.createElement(DynamicSemanticTag, {
    semanticTag: metadataSemanticTag,
    fontSizeLarge: metadataFontSizeLarge,
    fontSizeMedium: metadataFontSizeMedium,
    fontSizeSmall: metadataFontSizeSmall,
    styles: semanticCSS(metadataStyle)
  }, showAuthor ? /*#__PURE__*/React.createElement("div", {
    className: css(authorsStyle)
  }, listAuthors(authors)) : null, showPipeInAnyScreenSize(showAuthor, showDate) ? /*#__PURE__*/React.createElement("div", {
    className: css(pipeStyle)
  }, "|") : null, showDate ? /*#__PURE__*/React.createElement("time", {
    dateTime: timestampISO,
    className: css(dateStyle)
  }, timestamp) : null)) : null, showSponsored ? /*#__PURE__*/React.createElement(SponsoredTextHorizontal, {
    sponsoredText: sponsoredText,
    brandName: brandName
  }) : null) : null);
};

const componentConfigThemeKey$M = 'verticalCard';

const createLinkStyle = (cardBackgroundColor, cardTextColorTypeNormal, cardTextColorTypeHover, cardTextColorTypeActive, borderRadius, showDecorationLine) => {
  return StyleSheet.create({
    wrapper: {
      width: '100%',
      height: '100%',
      textDecoration: 'none',
      color: cardTextColorTypeNormal,
      backgroundColor: cardBackgroundColor,
      '-webkit-mask-image': '-webkit-radial-gradient(white, black)',
      borderRadius: `${borderRadius}px`,
      position: 'relative',
      ':hover': {
        color: cardTextColorTypeHover
      },
      ':active': {
        color: cardTextColorTypeActive
      },
      display: 'grid',
      gridTemplateRows: showDecorationLine ? `min-content ${decorationLineHeight$1}px auto` : 'min-content auto'
    }
  }).wrapper;
};

const createMainCategoryStyle$2 = (showMainCategoryInLargeScreen, showMainCategoryInMediumScreen, showMainCategoryInSmallScreen, mainCategoryHorizontalGapLarge, mainCategoryHorizontalGapMedium, mainCategoryHorizontalGapSmall, mainCategoryVerticalGapLarge, mainCategoryVerticalGapMedium, mainCategoryVerticalGapSmall, mainCategoryBackgroundColor, mainCategoryTextColor) => StyleSheet.create({
  style: {
    backgroundColor: mainCategoryBackgroundColor,
    color: mainCategoryTextColor,
    position: 'absolute',
    bottom: 0,
    [MEDIA_BREAKPOINTS.large]: {
      display: showMainCategoryInLargeScreen ? 'block' : 'none',
      padding: `${mainCategoryHorizontalGapLarge * baseUnit}px ${mainCategoryVerticalGapLarge * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      display: showMainCategoryInMediumScreen ? 'block' : 'none',
      padding: `${mainCategoryHorizontalGapMedium * baseUnit}px ${mainCategoryVerticalGapMedium * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      display: showMainCategoryInSmallScreen ? 'block' : 'none',
      padding: `${mainCategoryHorizontalGapSmall * baseUnit}px ${mainCategoryVerticalGapSmall * baseUnit}px`
    }
  }
}).style;

const createMainCategoryAlignmentStyle = (alignment = consts.ALIGNMENT_OPTIONS.START) => {
  switch (alignment) {
    case consts.ALIGNMENT_OPTIONS.CENTER:
      return StyleSheet.create({
        style: {
          left: '50%',
          transform: 'translateX(-50%)'
        }
      }).style;

    case consts.ALIGNMENT_OPTIONS.START:
    default:
      return StyleSheet.create({
        style: {
          left: 0
        }
      }).style;
  }
};

const VerticalCard = props => {
  const {
    coverType,
    lazyLoad = true,
    showDecorationLine = true,
    title,
    articleUrl,
    image,
    imageWidths,
    authors,
    mainCategory,
    sponsoredText,
    brandName,
    description,
    updatedAt,
    updatedAtISO,
    createdAt,
    createdAtISO,
    onClick
  } = props;
  const {
    borderRadius,
    borderColorTypeActive,
    borderColorTypeHover,
    borderColorTypeNormal,
    borderWidthTypeActive,
    borderWidthTypeHover,
    borderWidthTypeNormal,
    boxShadowTypeNormal,
    boxShadowTypeHover,
    boxShadowTypeActive,
    cardBackgroundColor,
    cardTitleColorTypeNormal,
    cardTitleColorTypeHover,
    cardTitleColorTypeActive,
    titleFontSizeLarge,
    titleFontSizeSmall,
    titleFontSizeMedium,
    showAuthorInLargeScreen,
    showAuthorInMediumScreen,
    showAuthorInSmallScreen,
    aspectRatioLarge,
    aspectRatioMedium,
    aspectRatioSmall,
    authorColor,
    metadataFontSizeLarge,
    metadataFontSizeMedium,
    metadataFontSizeSmall,
    horizontalGapLarge,
    horizontalGapMedium,
    horizontalGapSmall,
    verticalGapLarge,
    verticalGapMedium,
    verticalGapSmall,
    wrapperGapLarge,
    wrapperGapMedium,
    wrapperGapSmall,
    titleSemanticTag,
    metadataSemanticTag,
    showDateInSmallScreen,
    showDateInMediumScreen,
    showDateInLargeScreen,
    dateColor,
    pipeColor,
    showMainCategoryInLargeScreen,
    showMainCategoryInMediumScreen,
    showMainCategoryInSmallScreen,
    mainCategoryHorizontalGapLarge,
    mainCategoryHorizontalGapMedium,
    mainCategoryHorizontalGapSmall,
    mainCategoryVerticalGapLarge,
    mainCategoryVerticalGapMedium,
    mainCategoryVerticalGapSmall,
    mainCategoryBackgroundColor,
    mainCategoryFontSizeLarge,
    mainCategoryFontSizeMedium,
    mainCategoryFontSizeSmall,
    mainCategorySemanticTag,
    mainCategoryTextColor,
    numberOfLinesForTitle,
    numberOfLinesForAuthors,
    showDescriptionInLargeScreen,
    showDescriptionInMediumScreen,
    showDescriptionInSmallScreen,
    numberOfLinesForDescription,
    descriptionColor,
    descriptionFontSizeInLargeScreen,
    descriptionFontSizeInMediumScreen,
    descriptionFontSizeInSmallScreen,
    descriptionSemanticTag,
    titleAlignment,
    descriptionAlignment,
    metadataAlignment,
    mainCategoryAlignment,
    isUpdatedAtTimestamp,
    isMainCategoryEnabled
  } = useTheme(componentConfigThemeKey$M);
  const borderBoxShadow = {
    borderColorTypeActive,
    borderColorTypeHover,
    borderColorTypeNormal,
    borderWidthTypeActive,
    borderWidthTypeHover,
    borderWidthTypeNormal
  };
  const linkStyle = createLinkStyle(cardBackgroundColor, cardTitleColorTypeNormal, cardTitleColorTypeHover, cardTitleColorTypeActive, borderRadius, showDecorationLine);
  const boxShadowStyle = createStyleForBoxShadow({
    boxShadowTypeNormal,
    boxShadowTypeHover,
    boxShadowTypeActive,
    borderBoxShadow
  });
  const showMetadataInLargeScreen = showMetadataInLargeScreenSize(showAuthorInLargeScreen, showDateInLargeScreen);
  const showMetadataInMediumScreen = showMetadataInMediumScreenSize(showAuthorInMediumScreen, showDateInMediumScreen);
  const showMetadataInSmallScreen = showMetadataInSmallScreenSize(showAuthorInSmallScreen, showDateInSmallScreen);
  const showMainCategory = isMainCategoryEnabled && mainCategory && (showMainCategoryInSmallScreen || showMainCategoryInMediumScreen || showMainCategoryInLargeScreen);
  const mainCategoryAlignmentStyle = createMainCategoryAlignmentStyle(mainCategoryAlignment);
  const timestamp = isUpdatedAtTimestamp ? updatedAt : createdAt;
  const timestampISO = isUpdatedAtTimestamp ? updatedAtISO : createdAtISO;

  const MainCategory = () => {
    const mainCategoryStyle = createMainCategoryStyle$2(showMainCategoryInLargeScreen, showMainCategoryInMediumScreen, showMainCategoryInSmallScreen, mainCategoryHorizontalGapLarge, mainCategoryHorizontalGapMedium, mainCategoryHorizontalGapSmall, mainCategoryVerticalGapLarge, mainCategoryVerticalGapMedium, mainCategoryVerticalGapSmall, mainCategoryBackgroundColor, mainCategoryTextColor);
    return /*#__PURE__*/React.createElement(DynamicSemanticTag, {
      semanticTag: mainCategorySemanticTag,
      fontSizeLarge: mainCategoryFontSizeLarge,
      fontSizeMedium: mainCategoryFontSizeMedium,
      fontSizeSmall: mainCategoryFontSizeSmall,
      styles: semanticCSS(mainCategoryStyle, mainCategoryAlignmentStyle)
    }, mainCategory);
  };

  return /*#__PURE__*/React.createElement(WrapperForCard, {
    boxShadowStyle: boxShadowStyle,
    borderRadius: borderRadius,
    paddingLarge: wrapperGapLarge,
    paddingMedium: wrapperGapMedium,
    paddingSmall: wrapperGapSmall
  }, /*#__PURE__*/React.createElement(Link, {
    className: css(linkStyle, boxShadowStyle.style),
    href: articleUrl,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(ConditionalRelativeWrap, {
    shouldWarp: showMainCategory || coverType === 'video'
  }, /*#__PURE__*/React.createElement(Image, _extends$1({}, image, {
    lazyLoad: lazyLoad,
    imageWidths: imageWidths,
    imageAspectRatios: createImageAspectRatios(aspectRatioSmall, aspectRatioMedium, aspectRatioLarge)
  })), coverType === 'video' ? /*#__PURE__*/React.createElement(PlayIcon, null) : null, showMainCategory ? /*#__PURE__*/React.createElement(MainCategory, null) : null), showDecorationLine ? /*#__PURE__*/React.createElement(DecorationLine, null) : null, /*#__PURE__*/React.createElement(TextNextToImage, {
    title,
    brandName,
    authors,
    description,
    timestamp,
    timestampISO,
    sponsoredText,
    horizontalGapLarge,
    horizontalGapMedium,
    horizontalGapSmall,
    verticalGapLarge,
    verticalGapMedium,
    verticalGapSmall,
    titleSemanticTag,
    titleFontSizeMedium,
    titleFontSizeSmall,
    titleFontSizeLarge,
    numberOfLinesForTitle,
    showDescriptionInLargeScreen,
    showDescriptionInMediumScreen,
    showDescriptionInSmallScreen,
    descriptionSemanticTag,
    descriptionFontSizeInSmallScreen,
    descriptionFontSizeInLargeScreen,
    descriptionFontSizeInMediumScreen,
    descriptionColor,
    numberOfLinesForDescription,
    showAuthorInLargeScreen,
    showAuthorInMediumScreen,
    showAuthorInSmallScreen,
    showDateInLargeScreen,
    showDateInMediumScreen,
    showDateInSmallScreen,
    metadataSemanticTag,
    metadataFontSizeLarge,
    metadataFontSizeMedium,
    metadataFontSizeSmall,
    showMetadataInLargeScreen,
    showMetadataInMediumScreen,
    showMetadataInSmallScreen,
    authorColor,
    numberOfLinesForAuthors,
    pipeColor,
    dateColor,
    titleAlignment,
    descriptionAlignment,
    metadataAlignment
  })));
};

const componentConfigThemeKey$L = 'threeThreeVC';
const maximumNumberOfCards$3 = 6;

const getStyle$C = themeProps => {
  const {
    largeHorizontalGap,
    largeVerticalGap,
    mediumHorizontalGap,
    mediumVerticalGap,
    smallHorizontalGap
  } = themeProps;
  return StyleSheet.create({
    wrapper: {
      display: 'grid',
      marginBottom: `${baseUnit}px`,
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: '1fr 1fr 1fr',
        gridColumnGap: `${baseUnit * largeVerticalGap}px`,
        gridRowGap: `${baseUnit * largeHorizontalGap}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridColumnGap: `${baseUnit * mediumVerticalGap}px`,
        gridTemplateColumns: '1fr 1fr',
        gridRowGap: `${baseUnit * mediumHorizontalGap}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateColumns: '1fr',
        gridRowGap: `${baseUnit * smallHorizontalGap}px`
      }
    }
  });
};

const imageWidths$i = createImageWidths(360, 360, 360);
const ThreeThreeVC = props => {
  const {
    cards,
    paddingFactors
  } = props;
  const themeProps = useTheme(componentConfigThemeKey$L);
  const style = getStyle$C(themeProps);
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const {
    titleFontSizeLarge,
    titleFontSizeMedium,
    titleFontSizeSmall,
    metadataFontSizeLarge,
    metadataFontSizeMedium,
    metadataFontSizeSmall
  } = themeProps;
  const themeContextVerticalCard = useThemeOverride({
    titleFontSizeLarge,
    titleFontSizeMedium,
    titleFontSizeSmall,
    metadataFontSizeLarge,
    metadataFontSizeMedium,
    metadataFontSizeSmall
  }, componentConfigThemeKey$M);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(style.wrapper, paddingStyle)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextVerticalCard
  }, cards.map(card => /*#__PURE__*/React.createElement(VerticalCard, _extends$1({
    key: card.id
  }, card, {
    imageWidths: imageWidths$i
  }))).slice(0, maximumNumberOfCards$3))));
};

const componentConfigThemeKey$K = 'horizontalCard';

const createStyle$K = (cardBackgroundColor, cardTextColorTypeNormal, cardTextColorTypeHover, cardTextColorTypeActive, borderRadius, shouldReverseImageAlignment, cardProportionsLarge, cardProportionsMedium, cardProportionsSmall, lineHeightSmallScreen) => {
  return StyleSheet.create({
    text: {
      overflow: 'hidden',
      [MEDIA_BREAKPOINTS.large]: {
        height: 'fit-content'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        height: 'fit-content'
      },
      [MEDIA_BREAKPOINTS.small]: {
        height: `${lineHeightSmallScreen * 3}px`
      }
    },
    wrapper: {
      width: '100%',
      height: '100%',
      textDecoration: 'none',
      color: cardTextColorTypeNormal,
      backgroundColor: cardBackgroundColor,
      '-webkit-mask-image': '-webkit-radial-gradient(white, black)',
      borderRadius: `${borderRadius}px`,
      position: 'relative',
      ':hover': {
        color: cardTextColorTypeHover
      },
      ':active': {
        color: cardTextColorTypeActive
      },
      display: 'grid',
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: shouldReverseImageAlignment ? `${cardProportionsLarge.y}fr ${cardProportionsLarge.x}fr` : `${cardProportionsLarge.x}fr ${cardProportionsLarge.y}fr`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateColumns: shouldReverseImageAlignment ? `${cardProportionsMedium.y}fr ${cardProportionsMedium.x}fr` : `${cardProportionsMedium.x}fr ${cardProportionsMedium.y}fr`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateColumns: shouldReverseImageAlignment ? `${cardProportionsSmall.y}fr ${cardProportionsSmall.x}fr` : `${cardProportionsSmall.x}fr ${cardProportionsSmall.y}fr`
      }
    }
  });
};

const createMainCategoryStyle$1 = (showMainCategoryInLargeScreen, showMainCategoryInMediumScreen, showMainCategoryInSmallScreen, mainCategoryHorizontalGapLarge, mainCategoryHorizontalGapMedium, mainCategoryHorizontalGapSmall, mainCategoryVerticalGapLarge, mainCategoryVerticalGapMedium, mainCategoryVerticalGapSmall, mainCategoryBackgroundColor, mainCategoryTextColor, horizontalGapLarge, horizontalGapMedium, horizontalGapSmall) => StyleSheet.create({
  style: {
    backgroundColor: mainCategoryBackgroundColor,
    color: mainCategoryTextColor,
    width: 'fit-content',
    [MEDIA_BREAKPOINTS.large]: {
      display: showMainCategoryInLargeScreen ? 'block' : 'none',
      padding: `${mainCategoryHorizontalGapLarge * baseUnit}px ${mainCategoryVerticalGapLarge * baseUnit}px`,
      marginBottom: `${horizontalGapLarge * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      display: showMainCategoryInMediumScreen ? 'block' : 'none',
      padding: `${mainCategoryHorizontalGapMedium * baseUnit}px ${mainCategoryVerticalGapMedium * baseUnit}px`,
      marginBottom: `${horizontalGapMedium * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      display: showMainCategoryInSmallScreen ? 'block' : 'none',
      padding: `${mainCategoryHorizontalGapSmall * baseUnit}px ${mainCategoryVerticalGapSmall * baseUnit}px`,
      marginBottom: `${horizontalGapSmall * baseUnit}px`
    }
  }
}).style;

const HorizontalCardWithImage = ImageComponent => {
  const HorizontalCardComponent = props => {
    const {
      title,
      articleUrl,
      coverType,
      authors,
      description,
      mainCategory,
      sponsoredText,
      brandName,
      updatedAt,
      updatedAtISO,
      createdAt,
      createdAtISO,
      onClick,
      ampAnalyticsAction,
      ampAnalyticsCategory,
      ampAnalyticsLabel
    } = props;
    const {
      cardBackgroundColor,
      cardTitleColorTypeNormal,
      cardTitleColorTypeHover,
      cardTitleColorTypeActive,
      boxShadowTypeNormal,
      boxShadowTypeActive,
      boxShadowTypeHover,
      borderRadius,
      borderColorTypeActive,
      borderColorTypeHover,
      borderColorTypeNormal,
      borderWidthTypeActive,
      borderWidthTypeHover,
      borderWidthTypeNormal,
      titleFontSizeLarge,
      titleFontSizeSmall,
      titleFontSizeMedium,
      showAuthorInLargeScreen,
      showAuthorInMediumScreen,
      showAuthorInSmallScreen,
      showDateInLargeScreen,
      showDateInMediumScreen,
      showDateInSmallScreen,
      showDescriptionInLargeScreen,
      showDescriptionInMediumScreen,
      showDescriptionInSmallScreen,
      authorColor,
      dateColor,
      pipeColor,
      descriptionColor,
      metadataFontSizeLarge,
      metadataFontSizeMedium,
      metadataFontSizeSmall,
      descriptionFontSizeLarge,
      descriptionFontSizeMedium,
      descriptionFontSizeSmall,
      shouldReverseImageAlignment,
      horizontalGapLarge,
      horizontalGapMedium,
      horizontalGapSmall,
      verticalGapLarge,
      verticalGapMedium,
      verticalGapSmall,
      wrapperGapLarge,
      wrapperGapMedium,
      wrapperGapSmall,
      titleSemanticTag,
      descriptionSemanticTag,
      metadataSemanticTag,
      cardProportionsLarge,
      cardProportionsMedium,
      cardProportionsSmall,
      showMainCategoryInLargeScreen,
      showMainCategoryInMediumScreen,
      showMainCategoryInSmallScreen,
      mainCategoryHorizontalGapLarge,
      mainCategoryHorizontalGapMedium,
      mainCategoryHorizontalGapSmall,
      mainCategoryVerticalGapLarge,
      mainCategoryVerticalGapMedium,
      mainCategoryVerticalGapSmall,
      mainCategoryBackgroundColor,
      mainCategoryFontSizeLarge,
      mainCategoryFontSizeMedium,
      mainCategoryFontSizeSmall,
      mainCategorySemanticTag,
      mainCategoryTextColor,
      fontSizesStyles,
      numberOfLinesForTitle,
      numberOfLinesForDescription,
      numberOfLinesForAuthors,
      isUpdatedAtTimestamp,
      isMainCategoryEnabled
    } = useTheme(componentConfigThemeKey$K);
    const borderBoxShadow = {
      borderColorTypeActive,
      borderColorTypeHover,
      borderColorTypeNormal,
      borderWidthTypeActive,
      borderWidthTypeHover,
      borderWidthTypeNormal
    };
    const titleLineHeight = getLineHeightBySize(fontSizesStyles, titleFontSizeSmall, 'small');
    const boxShadowStyle = createStyleForBoxShadow({
      boxShadowTypeNormal,
      boxShadowTypeHover,
      boxShadowTypeActive,
      borderBoxShadow
    });
    const titleStyle = createStyle$K(cardBackgroundColor, cardTitleColorTypeNormal, cardTitleColorTypeHover, cardTitleColorTypeActive, borderRadius, shouldReverseImageAlignment, cardProportionsLarge, cardProportionsMedium, cardProportionsSmall, titleLineHeight);
    const showMetadataInLargeScreen = showMetadataInLargeScreenSize(showAuthorInLargeScreen, showDateInLargeScreen);
    const showMetadataInMediumScreen = showMetadataInMediumScreenSize(showAuthorInMediumScreen, showDateInMediumScreen);
    const showMetadataInSmallScreen = showMetadataInSmallScreenSize(showAuthorInSmallScreen, showDateInSmallScreen);
    const timestamp = isUpdatedAtTimestamp ? updatedAt : createdAt;
    const timestampISO = isUpdatedAtTimestamp ? updatedAtISO : createdAtISO;
    const showMainCategory = isMainCategoryEnabled && mainCategory && (showMainCategoryInSmallScreen || showMainCategoryInMediumScreen || showMainCategoryInLargeScreen);

    const MainCategory = () => {
      const mainCategoryStyle = createMainCategoryStyle$1(showMainCategoryInLargeScreen, showMainCategoryInMediumScreen, showMainCategoryInSmallScreen, mainCategoryHorizontalGapLarge, mainCategoryHorizontalGapMedium, mainCategoryHorizontalGapSmall, mainCategoryVerticalGapLarge, mainCategoryVerticalGapMedium, mainCategoryVerticalGapSmall, mainCategoryBackgroundColor, mainCategoryTextColor, horizontalGapLarge, horizontalGapMedium, horizontalGapSmall);
      return /*#__PURE__*/React.createElement(DynamicSemanticTag, {
        semanticTag: mainCategorySemanticTag,
        fontSizeLarge: mainCategoryFontSizeLarge,
        fontSizeMedium: mainCategoryFontSizeMedium,
        fontSizeSmall: mainCategoryFontSizeSmall,
        styles: semanticCSS(mainCategoryStyle)
      }, mainCategory);
    };

    const ImageElement = () => /*#__PURE__*/React.createElement(ConditionalRelativeWrap, {
      shouldWarp: coverType === 'video'
    }, /*#__PURE__*/React.createElement(ImageComponent, null), coverType === 'video' ? /*#__PURE__*/React.createElement(PlayIcon, null) : null);

    const TextElement = () => /*#__PURE__*/React.createElement(TextNextToImage, {
      title,
      brandName,
      authors,
      description,
      timestamp,
      timestampISO,
      sponsoredText,
      horizontalGapLarge,
      horizontalGapMedium,
      horizontalGapSmall,
      verticalGapLarge,
      verticalGapMedium,
      verticalGapSmall,
      titleSemanticTag,
      titleFontSizeMedium,
      titleFontSizeSmall,
      titleFontSizeLarge,
      numberOfLinesForTitle,
      showDescriptionInLargeScreen,
      showDescriptionInMediumScreen,
      showDescriptionInSmallScreen,
      descriptionSemanticTag,
      descriptionFontSizeInSmallScreen: descriptionFontSizeSmall,
      descriptionFontSizeInLargeScreen: descriptionFontSizeMedium,
      descriptionFontSizeInMediumScreen: descriptionFontSizeLarge,
      descriptionColor,
      numberOfLinesForDescription,
      showAuthorInLargeScreen,
      showAuthorInMediumScreen,
      showAuthorInSmallScreen,
      showDateInLargeScreen,
      showDateInMediumScreen,
      showDateInSmallScreen,
      metadataSemanticTag,
      metadataFontSizeLarge,
      metadataFontSizeMedium,
      metadataFontSizeSmall,
      showMetadataInLargeScreen,
      showMetadataInMediumScreen,
      showMetadataInSmallScreen,
      authorColor,
      numberOfLinesForAuthors,
      pipeColor,
      dateColor
    }, showMainCategory ? /*#__PURE__*/React.createElement(MainCategory, null) : null);

    const elements = [/*#__PURE__*/React.createElement(ImageElement, {
      key: "image"
    }), /*#__PURE__*/React.createElement(TextElement, {
      key: "text"
    })];
    return /*#__PURE__*/React.createElement(WrapperForCard, {
      boxShadowStyle: boxShadowStyle,
      borderRadius: borderRadius,
      paddingLarge: wrapperGapLarge,
      paddingMedium: wrapperGapMedium,
      paddingSmall: wrapperGapSmall
    }, /*#__PURE__*/React.createElement(Link, {
      onClick: onClick,
      className: css(titleStyle.wrapper, boxShadowStyle.style),
      href: articleUrl,
      "data-vars-action": ampAnalyticsAction,
      "data-vars-category": ampAnalyticsCategory,
      "data-vars-label": ampAnalyticsLabel
    }, shouldReverseImageAlignment ? elements.reverse() : elements));
  };

  return HorizontalCardComponent;
};

const HorizontalCard = props => {
  const {
    image,
    lazyLoad = true,
    imageWidths,
    imageHeightCalculationMethods
  } = props;
  const {
    aspectRatioLarge,
    aspectRatioMedium,
    aspectRatioSmall
  } = useTheme(componentConfigThemeKey$K);

  const ImageComponent = () => /*#__PURE__*/React.createElement(Image, _extends$1({}, image, {
    lazyLoad: lazyLoad,
    imageWidths: imageWidths,
    imageAspectRatios: createImageAspectRatios(aspectRatioSmall, aspectRatioMedium, aspectRatioLarge),
    imageHeightCalculationMethods: imageHeightCalculationMethods
  }));

  const HorizontalCardComponent = HorizontalCardWithImage(ImageComponent);
  return /*#__PURE__*/React.createElement(HorizontalCardComponent, props);
};

const componentConfigThemeKey$J = 'sixHC';
const maximumNumberOfCards$2 = 6;

const getStyle$B = themeProps => {
  const {
    largeHorizontalGap,
    mediumHorizontalGap,
    smallHorizontalGap
  } = themeProps;
  return StyleSheet.create({
    wrapper: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto',
      height: 'fit-content',
      [MEDIA_BREAKPOINTS.large]: {
        gridRowGap: `${baseUnit * largeHorizontalGap}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridRowGap: `${baseUnit * mediumHorizontalGap}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridRowGap: `${baseUnit * smallHorizontalGap}px`
      }
    }
  });
};

const defaultImageWidths$1 = createImageWidths(180, 180, 360);
const SixHC = props => {
  const {
    cards,
    paddingFactors,
    imageWidths = defaultImageWidths$1,
    expandable = false
  } = props;
  const themeProps = useTheme(componentConfigThemeKey$J);
  const style = getStyle$B(themeProps);
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle, style.wrapper)
  }, expandable ? cards.map((card, index) => /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({
    key: index
  }, card, {
    imageWidths: imageWidths
  }))) : cards.map((card, index) => /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({
    key: index
  }, card, {
    imageWidths: imageWidths
  }))).slice(0, maximumNumberOfCards$2)));
};

const componentConfigThemeKey$I = 'sixSix';

const isNewChunk = (index, chunkSize) => index % chunkSize === 0;

const getArticlesInChunks = (articles, chunkSize) => {
  let currentChunk = [];
  return articles.reduce((chunks, item, index) => {
    if (isNewChunk(index, chunkSize)) {
      currentChunk = [item];
      chunks.push(currentChunk);
    } else {
      currentChunk.push(item);
    }

    return chunks;
  }, []);
};

const getSixSixArticleListStyle = baseUnit => {
  return StyleSheet.create({
    verticalCardsGrid: {
      marginBottom: `${baseUnit}px`
    },
    horizontalCardsGrid: {
      marginBottom: `${baseUnit / 2}px`,
      marginTop: `${baseUnit / 2}px`
    }
  });
};

const SixSixArticleList = ({
  cardsProps
}) => {
  const {
    baseUnit,
    showDescriptionInLargeScreen,
    showDescriptionInMediumScreen
  } = useTheme(componentConfigThemeKey$I);
  const SixSixArticleListStyle = getSixSixArticleListStyle(baseUnit);
  const firstSectionStyle = SixSixArticleListStyle.verticalCardsGrid;
  const secondSectionStyle = SixSixArticleListStyle.horizontalCardsGrid;
  const alteredThemeData = {
    showDescriptionInLargeScreen,
    showDescriptionInMediumScreen
  };
  const secondSectionTheme = useThemeOverride(alteredThemeData, componentConfigThemeKey$K);

  const createGrids = (cards, index) => {
    return index % 2 === 0 ? /*#__PURE__*/React.createElement("div", {
      className: css(firstSectionStyle),
      key: index
    }, /*#__PURE__*/React.createElement(ThreeThreeVC, {
      cards: cards
    })) : /*#__PURE__*/React.createElement("div", {
      className: css(secondSectionStyle),
      key: index
    }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
      value: secondSectionTheme
    }, /*#__PURE__*/React.createElement(SixHC, {
      cards: cards
    })));
  };

  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cardsProps && cardsProps.length > 0 && getArticlesInChunks(cardsProps, 6).map(createGrids));
};

const style = {
  '-webkit-font-smoothing': 'antialiased',
  margin: 0
};

const componentConfigThemeKey$H = 'button';

const getStyle$A = ({
  backgroundColorNormal,
  backgroundColorHover,
  backgroundColorActive,
  textColorNormal,
  textColorHover,
  textColorActive,
  borderRadius,
  baseUnit
}, disabled) => {
  const hoverAndActiveStyle = {
    ':hover': {
      backgroundColor: backgroundColorHover,
      color: textColorHover
    },
    ':active': {
      backgroundColor: backgroundColorActive,
      color: textColorActive
    }
  };
  return StyleSheet.create({
    button: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: disabled ? 'unset' : 'pointer',
      outline: 'none',
      border: 'none',
      padding: `0 ${baseUnit}px`,
      borderRadius: `${borderRadius}px`,
      backgroundColor: backgroundColorNormal,
      minWidth: '120px',
      height: '40px',
      boxSizing: 'border-box',
      color: textColorNormal,
      ...(disabled ? {} : hoverAndActiveStyle)
    }
  });
};

const getButtonStyles = (themeProps, disabled, secondary) => {
  const {
    fontSizesStyles,
    boxShadowTypeNormal,
    boxShadowTypeHover,
    boxShadowTypeActive,
    fontSizeLarge,
    fontSizeMedium,
    fontSizeSmall,
    borderRadius,
    baseUnit,
    borderColorNormal,
    borderColorActive,
    borderColorHover,
    borderWidthNormal,
    borderWidthActive,
    borderWidthHover,
    backgroundColorNormal,
    backgroundColorHover,
    backgroundColorActive,
    textColorNormal,
    textColorHover,
    textColorActive,
    borderColorNormalSecondary,
    borderColorActiveSecondary,
    borderColorHoverSecondary,
    backgroundColorNormalSecondary,
    backgroundColorHoverSecondary,
    backgroundColorActiveSecondary,
    textColorNormalSecondary,
    textColorHoverSecondary,
    textColorActiveSecondary
  } = themeProps;
  const borderBoxShadowPrimary = {
    borderColorTypeActive: borderColorActive,
    borderColorTypeHover: borderColorHover,
    borderColorTypeNormal: borderColorNormal,
    borderWidthTypeActive: borderWidthActive,
    borderWidthTypeHover: borderWidthHover,
    borderWidthTypeNormal: borderWidthNormal
  };
  const borderBoxShadowSecondary = {
    borderColorTypeActive: borderColorActiveSecondary,
    borderColorTypeHover: borderColorHoverSecondary,
    borderColorTypeNormal: borderColorNormalSecondary,
    borderWidthTypeActive: borderWidthActive,
    borderWidthTypeHover: borderWidthHover,
    borderWidthTypeNormal: borderWidthNormal
  };
  return {
    buttonStyle: secondary ? getStyle$A({
      backgroundColorNormal: backgroundColorNormalSecondary,
      backgroundColorHover: backgroundColorHoverSecondary,
      backgroundColorActive: backgroundColorActiveSecondary,
      textColorNormal: textColorNormalSecondary,
      textColorHover: textColorHoverSecondary,
      textColorActive: textColorActiveSecondary,
      borderRadius,
      baseUnit
    }, disabled) : getStyle$A({
      backgroundColorNormal,
      backgroundColorHover,
      backgroundColorActive,
      textColorNormal,
      textColorHover,
      textColorActive,
      borderRadius,
      baseUnit
    }, disabled),
    boxShadowStyle: createStyleForBoxShadow({
      boxShadowTypeNormal,
      boxShadowTypeHover,
      boxShadowTypeActive,
      borderBoxShadow: secondary ? borderBoxShadowSecondary : borderBoxShadowPrimary
    }),
    textStyle: getStyleBySize(fontSizesStyles, {
      fontSizeSmall,
      fontSizeMedium,
      fontSizeLarge
    })
  };
};

const useButtonTheme = (disabled = false, secondary = false) => {
  const themeProps = useTheme(componentConfigThemeKey$H);
  return getButtonStyles(themeProps, disabled, secondary);
};

const Button = props => {
  const {
    label,
    onClick,
    additionalStyle,
    disabled = false
  } = props;
  const {
    buttonStyle,
    boxShadowStyle,
    textStyle
  } = useButtonTheme(disabled);
  const regularClasses = [buttonStyle.button, boxShadowStyle.style, StyleSheet.create({
    style
  }).style, textStyle, additionalStyle && additionalStyle.style];
  const disabledClasses = [buttonStyle.button, StyleSheet.create({
    style
  }).style, textStyle, additionalStyle && additionalStyle.style];
  return /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    disabled: disabled,
    className: css(...(disabled ? disabledClasses : regularClasses)),
    onClick: onClick
  }, label);
};

const GLOBALS = '__GLOBAL_STYLES__';
const globalExtension = {
  selectorHandler: (selector, baseSelector, generateSubtreeStyles) => {
    return baseSelector.includes(GLOBALS) ? generateSubtreeStyles(selector) : null;
  }
};

const normalizeCss = () => ({
  a: {
    textDecoration: 'none'
  },
  figure: {
    margin: 0
  },
  ul: {
    margin: 0,
    padding: 0
  },
  li: {
    margin: 0,
    padding: 0
  },
  img: {
    borderStyle: 'none'
  },
  h1: {
    fontSize: '2em',
    margin: '0.67em 0',
    marginBlockEnd: 0,
    marginBlockStart: 0
  },
  hr: {
    boxSizing: 'content-box',
    height: 0
  },
  pre: {
    fontFamily: 'monospace, monospace',
    fontSize: '1em'
  },
  'abbr[title]': {
    borderBottom: 'none',
    textDecoration: 'underline'
  },
  strong: {
    fontWeight: 'bold'
  },
  b: {
    fontWeight: 'bolder'
  },
  samp: {
    fontFamily: 'monospace, monospace',
    fontSize: '1em'
  },
  kbd: {
    fontFamily: 'monospace, monospace',
    fontSize: '1em'
  },
  code: {
    fontFamily: 'monospace, monospace',
    fontSize: '1em'
  },
  small: {
    fontSize: '80%'
  },
  sup: {
    fontSize: '75%',
    lineHeight: 0,
    position: 'relative',
    verticalAlign: 'baseline',
    top: '-0.5em'
  },
  sub: {
    fontSize: '75%',
    lineHeight: 0,
    position: 'relative',
    verticalAlign: 'baseline',
    bottom: '-0.25em'
  },
  textarea: {
    fontFamily: 'inherit',
    fontSize: '100%',
    lineHeight: '1.15',
    margin: 0
  },
  select: {
    fontFamily: 'inherit',
    fontSize: '100%',
    lineHeight: '1.15',
    margin: 0,
    textTransform: 'none'
  },
  button: {
    fontFamily: 'inherit',
    fontSize: '100%',
    lineHeight: '1.15',
    margin: 0,
    overflow: 'visible',
    textTransform: 'none',
    padding: 0,
    border: 'unset',
    backgroundColor: 'unset',
    ':focus': {
      outline: 0
    }
  },
  input: {
    fontFamily: 'inherit',
    fontSize: '100%',
    lineHeight: '1.15',
    margin: 0
  },
  optgroup: {
    fontFamily: 'inherit',
    fontSize: '100%',
    lineHeight: '1.15',
    margin: 0
  },
  'button:-moz-focusring': {
    outline: '1px dotted ButtonText'
  },
  '[type="button"]:-moz-focusring': {
    outline: '1px dotted ButtonText'
  },
  '[type="submit"]:-moz-focusring': {
    outline: '1px dotted ButtonText'
  },
  '[type="reset"]:-moz-focusring': {
    outline: '1px dotted ButtonText'
  },
  fieldset: {
    padding: '0.35em 0.75em 0.625em'
  },
  legend: {
    padding: 0
  },
  progress: {
    verticalAlign: 'baseline'
  },
  details: {
    display: 'block'
  },
  summary: {
    display: 'list-item'
  },
  template: {
    display: 'none'
  },
  '[hidden]': {
    display: 'none'
  },
  section: {
    width: '-moz-available'
  }
});

const componentConfigurationKey$j = 'mobileTopBar';
const MobileTopBarColor = () => {
  const {
    backgroundColor
  } = useTheme(componentConfigurationKey$j);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("meta", {
    name: "theme-color",
    content: backgroundColor
  })));
};

/* eslint no-underscore-dangle: [1, { "allowAfterThis": true }] */
const extended$1 = StyleSheet.extend([globalExtension]); // This code causes aphrodite to ignore its caching system, and to create a new style object with every render
// The code is necessary due to a bug in aphrodite - the extended stylesheet seems to have issues with multiple re-renders

const potentialMemoryLeak$1 = prefix => {
  return prefix + Math.random().toString(36).substring(7);
};

const AppContent = props => {
  const normalizedCss = normalizeCss();
  const combinedStyles = Object.keys(normalizedCss).reduce((acc, key) => {
    return { ...acc,
      [key]: { ...acc[key],
        ...normalizedCss[key]
      }
    };
  }, {});
  const styles = extended$1.StyleSheet.create({
    [GLOBALS]: combinedStyles
  }); // eslint-disable-next-line no-underscore-dangle

  if (!styles[GLOBALS]._name) {
    // eslint-disable-next-line no-underscore-dangle
    styles[GLOBALS]._name = potentialMemoryLeak$1(GLOBALS);
  }

  try {
    extended$1.css(styles[GLOBALS]);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }

  const {
    children
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MobileTopBarColor, null), children);
};

/* eslint no-underscore-dangle: [1, { "allowAfterThis": true }] */
const extended = StyleSheet.extend([globalExtension]); // This code causes aphrodite to ignore its caching system, and to create a new style object with every render
// The code is necessary due to a bug in aphrodite - the extended stylesheet seems to have issues with multiple re-renders

const potentialMemoryLeak = () => {
  return GLOBALS + Math.random().toString(36).substring(7);
};

const getStyles$I = () => StyleSheet.create({
  style: {
    maxWidth: `${LARGE_SCREEN_SIZE}px`,
    margin: 'auto'
  }
});

const AMPAppContent = props => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const applyGlobalStyles = (reporter, context) => {
    const styles = extended.StyleSheet.create({
      [GLOBALS]: { ...normalizeCss()
      }
    }); // eslint-disable-next-line no-underscore-dangle

    styles[GLOBALS]._name = potentialMemoryLeak();
    const componentStyle = getStyles$I();
    const {
      children
    } = props;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("body", {
      className: extended.css(styles[GLOBALS])
    })), /*#__PURE__*/React.createElement(MobileTopBarColor, null), /*#__PURE__*/React.createElement("div", {
      className: css(componentStyle.style)
    }, children));
  };

  return /*#__PURE__*/React.createElement(ErrorReporting.Consumer, null, reporter => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, context => applyGlobalStyles()));
};

const createStyles$7 = baseUnit => StyleSheet.create({
  container: {
    display: 'flex',
    justifyContent: 'center',
    maxWidth: `${LARGE_SCREEN_SIZE}px`,
    margin: '0 auto',
    marginTop: `${baseUnit}px`,
    overflowAnchor: 'none'
  }
});

const LoadMoreButtonWrapper = ({
  children
}) => {
  const {
    baseUnit
  } = useTheme();
  const style = createStyles$7(baseUnit);
  return /*#__PURE__*/React.createElement("div", {
    className: css(style.container)
  }, children);
};

const componentConfigThemeKeyForContent = 'mainContent';
const componentConfigThemeKeyForArticleContent = 'mainArticleContent';

const componentConfigThemeKeyForTemplateBody = 'templateBody';
const componentConfigThemeKeyForTemplateArticleBody = 'templateArticleBody';
const BodyTag = ({
  mainConfigThemeKey
}) => {
  const getBodyTagConfigThemeKey = () => {
    switch (mainConfigThemeKey) {
      case componentConfigThemeKeyForContent:
        return componentConfigThemeKeyForTemplateBody;

      case componentConfigThemeKeyForArticleContent:
        return componentConfigThemeKeyForTemplateArticleBody;

      default:
        return componentConfigThemeKeyForTemplateBody;
    }
  };

  const {
    backgroundColor
  } = useTheme(getBodyTagConfigThemeKey());
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Helmet, null, /*#__PURE__*/React__default.createElement("style", null, `body {background-color: ${backgroundColor};}`)));
};

const componentConfigThemeKey$G = 'header';

const headerHeightsContextValue = {
  headerTwoRowsHeights: {
    large: 8,
    medium: 5,
    small: 5
  },
  headerFirstRowHeights: {
    large: 4,
    medium: 3,
    small: 3
  }
};
const HeaderHeightsContext = React.createContext(headerHeightsContextValue);

const createHeaderHeights = (firstRowHeightInLargeScreen, firstRowHeightInMediumScreen, firstRowHeightInSmallScreen, secondRowHeightInLargeScreen, secondRowHeightInMediumScreen, secondRowHeightInSmallScreen, doesSecondaryHeaderExist) => {
  return {
    headerTwoRowsHeights: {
      large: doesSecondaryHeaderExist ? firstRowHeightInLargeScreen + secondRowHeightInLargeScreen : firstRowHeightInLargeScreen,
      medium: firstRowHeightInMediumScreen + secondRowHeightInMediumScreen,
      small: firstRowHeightInSmallScreen + secondRowHeightInSmallScreen
    },
    headerFirstRowHeights: {
      large: firstRowHeightInLargeScreen,
      medium: firstRowHeightInMediumScreen,
      small: firstRowHeightInSmallScreen
    }
  };
};

const AmpHeaderHeights = props => {
  const {
    children,
    doesSecondaryHeaderExist
  } = props;
  const {
    firstRowHeightInLargeScreen,
    firstRowHeightInMediumScreen,
    firstRowHeightInSmallScreen,
    secondRowHeightInLargeScreen,
    secondRowHeightInMediumScreen,
    secondRowHeightInSmallScreen
  } = useTheme(componentConfigThemeKey$G);
  const ampHeaderHeights = createHeaderHeights(firstRowHeightInLargeScreen, firstRowHeightInMediumScreen, firstRowHeightInSmallScreen, secondRowHeightInLargeScreen, secondRowHeightInMediumScreen, secondRowHeightInSmallScreen, doesSecondaryHeaderExist);
  return /*#__PURE__*/React.createElement(HeaderHeightsContext.Provider, {
    value: ampHeaderHeights
  }, children);
};
const HeaderHeights = props => {
  const {
    children,
    doesSubHeaderExist
  } = props;
  const {
    firstRowHeightInLargeScreen,
    firstRowHeightInMediumScreen,
    firstRowHeightInSmallScreen,
    secondRowHeightInLargeScreen,
    secondRowHeightInMediumScreen,
    secondRowHeightInSmallScreen
  } = useTheme(componentConfigThemeKey$G);
  const headerHeights = createHeaderHeights(firstRowHeightInLargeScreen, firstRowHeightInMediumScreen, firstRowHeightInSmallScreen, secondRowHeightInLargeScreen, secondRowHeightInMediumScreen, secondRowHeightInSmallScreen, doesSubHeaderExist);
  return /*#__PURE__*/React.createElement(HeaderHeightsContext.Provider, {
    value: headerHeights
  }, children);
};
const useHeaderHeights = () => {
  const {
    headerTwoRowsHeights
  } = React.useContext(HeaderHeightsContext);
  return headerTwoRowsHeights;
};
const useFirstRowHeaderHeights = () => {
  const {
    headerFirstRowHeights
  } = React.useContext(HeaderHeightsContext);
  return headerFirstRowHeights;
};

const MainWrapperForAmpHeaderNavigation = ({
  children,
  configThemeKey
}) => {
  const {
    baseUnit,
    backgroundColor,
    maxWidth
  } = useTheme(configThemeKey);
  const headerHeights = useHeaderHeights();
  const style = {
    backgroundColor,
    maxWidth: `${maxWidth}px`,
    margin: '0 auto',
    paddingBottom: `${baseUnit}px`,
    [MEDIA_BREAKPOINTS.large]: {
      paddingTop: `${headerHeights.large * baseUnit + baseUnit / 4}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      paddingTop: `${headerHeights.medium * baseUnit + baseUnit / 4}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      paddingTop: `${headerHeights.small * baseUnit + baseUnit / 4}px`
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BodyTag, {
    mainConfigThemeKey: configThemeKey
  }), /*#__PURE__*/React__default.createElement("main", {
    className: css(StyleSheet.create({
      style
    }).style)
  }, children));
};

const MainWrapperForNavigation = ({
  children,
  configThemeKey
}) => {
  const {
    baseUnit,
    backgroundColor,
    paddingFactor,
    maxWidth
  } = useTheme(configThemeKey);
  const headerHeights = useHeaderHeights();
  const style = {
    backgroundColor,
    maxWidth: `${maxWidth}px`,
    margin: '0 auto',
    paddingBottom: `${baseUnit}px`,
    [MEDIA_BREAKPOINTS.large]: {
      marginTop: `${headerHeights.large * baseUnit + baseUnit * paddingFactor}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      marginTop: `${headerHeights.medium * baseUnit + baseUnit * paddingFactor}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      marginTop: `${headerHeights.small * baseUnit + baseUnit * paddingFactor}px`
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BodyTag, {
    mainConfigThemeKey: configThemeKey
  }), /*#__PURE__*/React__default.createElement("main", {
    className: css(StyleSheet.create({
      style
    }).style)
  }, children));
};

const AMPMainWrapper = ({
  children
}) => {
  const {
    baseUnit,
    backgroundColor
  } = useTheme(componentConfigThemeKeyForArticleContent);
  const headerHeights = useHeaderHeights();
  const style = {
    backgroundColor,
    paddingBottom: `${baseUnit}px`,
    [MEDIA_BREAKPOINTS.large]: {
      paddingTop: `${headerHeights.large * baseUnit + baseUnit / 4}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      paddingTop: `${headerHeights.medium * baseUnit + baseUnit / 4}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      paddingTop: `${headerHeights.small * baseUnit + baseUnit / 4}px`
    }
  };
  return /*#__PURE__*/React__default.createElement("main", {
    className: css(StyleSheet.create({
      style
    }).style)
  }, children);
};

const footerSectionPadding = baseUnit => ({
  padding: `${baseUnit}px 0`
});
const generateSeparatorSections = separatorStyle => (acc, section, index, arr) => {
  const res = section;
  return index < arr.length - 1 ? [...acc, res, /*#__PURE__*/React.createElement("div", {
    key: index,
    className: css(separatorStyle)
  })] : [...acc, res];
};

const componentConfigurationKey$i = 'footer';

const createStyle$J = (color, hoverColor) => StyleSheet.create({
  button: {
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    textAlign: 'start',
    color,
    ':hover': {
      color: hoverColor
    },
    ':active': {
      color
    },
    ':visited': {
      color
    },
    ':focus': {
      outline: 'none'
    }
  }
});

const LinkButton = props => {
  const {
    text,
    onClick,
    color,
    hoverColor
  } = props;
  const {
    buttonFontSizeLarge,
    buttonFontSizeMedium,
    buttonFontSizeSmall,
    fontSizesStyles
  } = useTheme(componentConfigurationKey$i);
  /* eslint-disable-next-line no-new-func */

  const onClickFunction = new Function(onClick);
  const style = createStyle$J(color, hoverColor);
  const fontStyles = getStyleBySize(fontSizesStyles, {
    fontSizeLarge: buttonFontSizeLarge,
    fontSizeMedium: buttonFontSizeMedium,
    fontSizeSmall: buttonFontSizeSmall
  });
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => onClickFunction(),
    className: css(style.button, fontStyles)
  }, text);
};

const getStyle$z = (baseUnit, titleColor) => {
  const padding = footerSectionPadding(baseUnit);
  return StyleSheet.create({
    section: { ...padding
    },
    title: {
      textAlign: 'center',
      color: titleColor
    },
    gridWrapper: {
      display: 'flex',
      justifyContent: 'center'
    },
    linksWrapper: {
      display: 'inline-grid',
      marginTop: `${baseUnit * 0.5}px`,
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: 'auto auto auto auto',
        width: '100%',
        justifyContent: 'space-between',
        gridGap: `${baseUnit * 0.5}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateColumns: 'auto auto auto',
        gridGap: `${baseUnit * 0.5}px ${baseUnit * 4}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateColumns: 'auto auto',
        gridGap: `${baseUnit * 0.5}px ${baseUnit * 2}px`
      }
    }
  });
};

const FooterLinksSection$1 = props => {
  const {
    linksIdleColor,
    linksActiveStateColor,
    linksHoverStateColor,
    baseUnit
  } = useTheme(componentConfigurationKey$i);
  const finalProps = { ...{
      idleColor: linksIdleColor,
      activeStateColor: linksActiveStateColor,
      hoverStateColor: linksHoverStateColor,
      baseUnit
    },
    ...props
  };
  const {
    title,
    links,
    buttons
  } = finalProps;
  const style = getStyle$z(baseUnit, linksIdleColor);
  const linkStyle = generateLinkStyleFromTheme({ ...finalProps
  });
  return /*#__PURE__*/React.createElement("div", {
    className: css(style.section)
  }, /*#__PURE__*/React.createElement(H4, {
    styles: semanticCSS(style.title)
  }, title), /*#__PURE__*/React.createElement("div", {
    className: css(style.gridWrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(style.linksWrapper)
  }, links ? links.map((navigationLink, index) => /*#__PURE__*/React.createElement(TextLinkComponent, {
    key: index,
    href: navigationLink.link.href,
    linkStyle: linkStyle
  }, /*#__PURE__*/React.createElement(P, null, navigationLink.link.text))) : null, buttons ? buttons.map((button, index) => /*#__PURE__*/React.createElement(LinkButton, {
    key: index,
    text: button.text,
    onClick: button.onClick,
    color: linksIdleColor,
    hoverColor: linksHoverStateColor
  })) : null)));
};

const getBottomFooterBarStyle = (backgroundColor, textColor, baseUnit) => StyleSheet.create({
  style: {
    color: textColor,
    padding: `${baseUnit * 0.5}px ${baseUnit}px`,
    boxSizing: 'border-box',
    textAlign: 'center',
    margin: '0 auto',
    maxWidth: `${HUGE_SCREEN_SIZE}px`
  },
  wrapper: {
    backgroundColor
  }
});

const BottomFooterBar = props => {
  const {
    bottomBarBackgroundColor,
    bottomBarTextColor,
    bottomBarLinkFontSizeLarge,
    bottomBarLinkFontSizeMedium,
    bottomBarLinkFontSizeSmall,
    baseUnit
  } = useTheme(componentConfigurationKey$i);
  const bottomFooterBarStyle = getBottomFooterBarStyle(bottomBarBackgroundColor, bottomBarTextColor, baseUnit);
  const {
    year,
    rightsReservedText,
    poweredByLink
  } = props;
  const linkStyle = generateLinkStyleFromTheme({
    idleColor: bottomBarTextColor,
    activeStateColor: bottomBarTextColor,
    hoverStateColor: bottomBarTextColor
  });
  return /*#__PURE__*/React.createElement("div", {
    className: css(bottomFooterBarStyle.wrapper)
  }, /*#__PURE__*/React.createElement(P, {
    styles: semanticCSS(bottomFooterBarStyle.style),
    fontSizeLarge: bottomBarLinkFontSizeLarge,
    fontSizeMedium: bottomBarLinkFontSizeMedium,
    fontSizeSmall: bottomBarLinkFontSizeSmall
  }, `© ${year} `, /*#__PURE__*/React.createElement(TextLinkComponent, {
    href: poweredByLink.href,
    linkStyle: linkStyle,
    rel: "noopener",
    target: "_blank"
  }, poweredByLink.text), ` - ${rightsReservedText}`));
};

const getSocialLinksStyle = (baseUnit, titleColor, circleColor, numberOfColumns, socialLinksColor, socialLinksHoverColor) => {
  const padding = footerSectionPadding(baseUnit);
  return StyleSheet.create({
    section: { ...padding
    },
    title: {
      textAlign: 'center',
      color: titleColor
    },
    storesWrapper: {
      display: 'grid',
      gridTemplateColumns: `repeat(${numberOfColumns}, 1fr)`,
      gridGap: `${baseUnit * 0.5}px`,
      marginTop: `${baseUnit * 0.5}px`
    },
    circle: {
      width: '40px',
      height: '40px',
      backgroundColor: circleColor,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    svgCircle: {
      fill: socialLinksColor,
      height: '16px',
      ':hover': {
        fill: socialLinksHoverColor
      }
    }
  });
};

const createStoreItem$1 = circleStyle => (socialLink, index) => {
  return /*#__PURE__*/React.createElement(TextLinkComponent, {
    href: socialLink.href,
    key: index,
    rel: "noopener",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("div", {
    className: css(circleStyle)
  }, /*#__PURE__*/React.createElement("img", {
    alt: socialLink.alt,
    src: socialLink.src,
    height: "16"
  })));
};

const createStoreItemSvg = (svgStyle, circleStyle) => (socialLink, index) => {
  const svg = socialLink.src.replace(/<svg/g, `<svg class="${css(svgStyle)}"`);
  return /*#__PURE__*/React.createElement(TextLinkComponent, {
    href: socialLink.href,
    key: index,
    rel: "noopener",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("div", {
    className: css(circleStyle),
    "aria-label": socialLink.alt,
    dangerouslySetInnerHTML: {
      __html: svg
    }
  }));
};

const maxSocialItemsPerRow = 8;
const FooterSocialLinks = props => {
  const {
    socialSection,
    oldSocialSection
  } = props;
  const {
    baseUnit,
    socialTitleColor,
    socialLinksCircleColor,
    socialLinksIconColor,
    socialLinksIconHoverColor,
    socialTitleFontSizeLarge,
    socialTitleFontSizeMedium,
    socialTitleFontSizeSmall
  } = useTheme(componentConfigurationKey$i); // eslint-disable-next-line no-nested-ternary

  const socialSectionLength = socialSection ? socialSection.imageLinks.length : oldSocialSection ? oldSocialSection.imageLinks.length : 0;
  const style = getSocialLinksStyle(baseUnit, socialTitleColor, socialLinksCircleColor, Math.min(socialSectionLength, maxSocialItemsPerRow), socialLinksIconColor, socialLinksIconHoverColor);
  return socialSection ? /*#__PURE__*/React.createElement("div", {
    className: css(style.section)
  }, /*#__PURE__*/React.createElement(H4, {
    styles: semanticCSS(style.title),
    fontSizeLarge: socialTitleFontSizeLarge,
    fontSizeMedium: socialTitleFontSizeMedium,
    fontSizeSmall: socialTitleFontSizeSmall
  }, socialSection && socialSection.title), /*#__PURE__*/React.createElement("div", {
    className: css(style.storesWrapper)
  }, socialSection && socialSection.imageLinks.map(createStoreItemSvg(style.svgCircle, style.circle)))) : /*#__PURE__*/React.createElement("div", {
    className: css(style.section)
  }, /*#__PURE__*/React.createElement(H4, {
    styles: semanticCSS(style.title),
    fontSizeLarge: socialTitleFontSizeLarge,
    fontSizeMedium: socialTitleFontSizeMedium,
    fontSizeSmall: socialTitleFontSizeSmall
  }, oldSocialSection && oldSocialSection.title), /*#__PURE__*/React.createElement("div", {
    className: css(style.storesWrapper)
  }, oldSocialSection && oldSocialSection.imageLinks.map(createStoreItem$1(style.circle))));
};

const getStyle$y = (titleColor, numColumns = 2, baseUnit) => {
  const padding = footerSectionPadding(baseUnit);
  const columns = Array(numColumns).fill('auto').join(' ');
  return StyleSheet.create({
    section: { ...padding
    },
    title: {
      textAlign: 'center',
      color: titleColor
    },
    storesWrapper: {
      display: 'grid',
      gridTemplateColumns: columns,
      justifyContent: 'center',
      gridGap: `${baseUnit * 0.5}px`,
      marginTop: `${baseUnit * 0.5}px`
    },
    storeItem: {
      backgroundColor: 'wheat'
    }
  });
};

const createStoreItem = (storeLink, index) => {
  return /*#__PURE__*/React.createElement(TextLinkComponent, {
    href: storeLink.href,
    key: index,
    target: "_blank",
    rel: "noopener"
  }, /*#__PURE__*/React.createElement("img", {
    alt: storeLink.alt,
    src: storeLink.src,
    height: "40"
  }));
};

const FooterMobileStores = props => {
  const {
    title,
    imageLinks
  } = props;
  const {
    mobileStoresTitleColor,
    mobileStoresTitleFontSizeLarge,
    mobileStoresTitleFontSizeMedium,
    mobileStoresTitleFontSizeSmall,
    baseUnit
  } = useTheme(componentConfigurationKey$i);
  const style = getStyle$y(mobileStoresTitleColor, imageLinks.length, baseUnit);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(style.section)
  }, /*#__PURE__*/React.createElement(H4, {
    styles: semanticCSS(style.title),
    fontSizeLarge: mobileStoresTitleFontSizeLarge,
    fontSizeMedium: mobileStoresTitleFontSizeMedium,
    fontSizeSmall: mobileStoresTitleFontSizeSmall
  }, title), /*#__PURE__*/React.createElement("div", {
    className: css(style.storesWrapper)
  }, imageLinks.map(createStoreItem))));
};

const getSeparatorStyle$2 = (borderTopColor, separatorHeight) => {
  return StyleSheet.create({
    style: {
      height: `${separatorHeight}px`,
      width: '100%',
      backgroundColor: borderTopColor,
      [MEDIA_BREAKPOINTS.large]: {
        display: 'none'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'block'
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'block'
      }
    }
  });
};

const getWrapperStyle$3 = numberOfSections => {
  return StyleSheet.create({
    style: {
      display: 'grid',
      justifyItems: 'center',
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: `repeat(${numberOfSections}, 1fr)`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateColumns: '1fr'
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateColumns: '1fr'
      }
    }
  });
};

const getSocialSection = (socialSection, oldSocialSection) => {
  // eslint-disable-next-line no-nested-ternary
  return socialSection ? /*#__PURE__*/React.createElement(FooterSocialLinks, {
    key: "social-links",
    socialSection: socialSection
  }) : oldSocialSection ? /*#__PURE__*/React.createElement(FooterSocialLinks, {
    key: "social-links",
    oldSocialSection: oldSocialSection
  }) : null;
};

const getAppsSection = appsSection => {
  return appsSection ? /*#__PURE__*/React.createElement(FooterMobileStores, _extends$1({
    key: "mobile-links"
  }, appsSection)) : null;
};

const AdditionalFooterSections = props => {
  const {
    socialSection,
    oldSocialSection,
    appsSection,
    separatorColor,
    separatorHeight
  } = props;
  const additionalFooterSections = [getSocialSection(socialSection, oldSocialSection), getAppsSection(appsSection)].filter(section => section !== null);
  return additionalFooterSections.length === 0 ? null : /*#__PURE__*/React.createElement("div", {
    className: css(getWrapperStyle$3(additionalFooterSections.length).style)
  }, additionalFooterSections.reduce(generateSeparatorSections(getSeparatorStyle$2(separatorColor, separatorHeight).style), []));
};

const getAdditionalFooterSection = (socialSection, oldSocialSection, appsSection, separatorColor, separatorHeight) => {
  if (socialSection === null && oldSocialSection === null && appsSection === null) return null;
  return /*#__PURE__*/React.createElement(AdditionalFooterSections, {
    key: "additional-links",
    oldSocialSection: oldSocialSection,
    socialSection: socialSection,
    appsSection: appsSection,
    separatorColor: separatorColor,
    separatorHeight: separatorHeight
  });
};

const SEPARATOR_HEIGHT$1 = 1;

const getFooterStyle = (baseUnit, borderTopColor, backgroundColor) => {
  return StyleSheet.create({
    footer: {
      borderTop: `solid 2px ${borderTopColor}`,
      [MEDIA_BREAKPOINTS.large]: {
        padding: `0 ${baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        padding: `0 ${baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        padding: `0 ${baseUnit * 0.75}px`
      },
      margin: '0 auto',
      maxWidth: `${HUGE_SCREEN_SIZE}px`
    },
    footerWrapper: {
      backgroundColor
    },
    footerContent: {
      margin: 'auto',
      [MEDIA_BREAKPOINTS.large]: {
        maxWidth: '852px'
      }
    }
  });
};

const getSeparatorStyle$1 = (separatorColor, separatorHeight) => {
  return StyleSheet.create({
    style: {
      height: `${separatorHeight}px`,
      backgroundColor: separatorColor
    }
  });
};

const getLinksSection$1 = linksSection => {
  return linksSection ? /*#__PURE__*/React.createElement(FooterLinksSection$1, _extends$1({
    key: "footer-links"
  }, linksSection)) : null;
};

const getFooterItems$1 = (linksSection, socialSection, oldSocialSection, appsSection, separatorColor, separatorHeight) => {
  return [getLinksSection$1(linksSection), getAdditionalFooterSection(socialSection, oldSocialSection, appsSection, separatorColor, separatorHeight)].filter(section => section !== null).reduce(generateSeparatorSections(getSeparatorStyle$1(separatorColor, separatorHeight).style), []);
};

const AmpFooter = props => {
  const {
    backgroundColor,
    ampSeparatorColor,
    baseUnit
  } = useTheme(componentConfigurationKey$i);
  const footerComponentStyle = getFooterStyle(baseUnit, ampSeparatorColor, backgroundColor);
  const {
    linksSection,
    socialSection,
    oldSocialSection,
    appsSection,
    bottomFooterBar
  } = props;
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("footer", null, /*#__PURE__*/React.createElement("div", {
    className: css(footerComponentStyle.footerWrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(footerComponentStyle.footer)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(footerComponentStyle.footerContent)
  }, getFooterItems$1(linksSection, socialSection, oldSocialSection, appsSection, ampSeparatorColor, SEPARATOR_HEIGHT$1)))), /*#__PURE__*/React.createElement(BottomFooterBar, bottomFooterBar)));
};

const AnimationDirection = {
  UP: 'foldingUp',
  DOWN: 'foldingDown',
  NONE: 'none'
};

const reducedLogoHeightFactor$1 = 0.5;

const calculateImageLogoAspectRatio = logoElement => {
  return {
    x: logoElement.getBoundingClientRect().width,
    y: logoElement.getBoundingClientRect().height
  };
};

const calculateVideoLogoAspectRatio = logoElement => {
  return {
    x: logoElement.videoWidth,
    y: logoElement.videoHeight
  };
};

const useAnimationLogoHeightsAndWidths = initialLogoHeight => {
  const [logoAspectRatio, setLogoAspectRatio] = React__default.useState(null);
  const {
    baseUnit
  } = useTheme();
  const ref = React__default.useCallback(node => {
    if (node) {
      if (node.tagName === 'VIDEO') {
        node.addEventListener('loadedmetadata', () => {
          setLogoAspectRatio(calculateVideoLogoAspectRatio(node));
        });
      } else {
        setLogoAspectRatio(calculateImageLogoAspectRatio(node));
      }
    }
  }, []);
  const animationLogoHeights = {
    height: baseUnit * initialLogoHeight,
    reducedHeight: baseUnit * initialLogoHeight * reducedLogoHeightFactor$1
  };
  const animationLogoWidths = {
    width: logoAspectRatio ? animationLogoHeights.height * (logoAspectRatio.x / logoAspectRatio.y) : -1,
    reducedWidth: logoAspectRatio ? animationLogoHeights.reducedHeight * (logoAspectRatio.x / logoAspectRatio.y) : -1
  };
  return [ref, { ...animationLogoHeights,
    ...animationLogoWidths
  }];
};

const getLogoStyle$2 = (logoHeightInMediumScreen, logoHeightInSmallScreen, menuAnimation, reduceHeightAnimationDuration, largeLogoHeightsAndWidths) => {
  return StyleSheet.create({
    base: {
      display: 'inline-flex',
      [MEDIA_BREAKPOINTS.large]: {
        height: menuAnimation === AnimationDirection.UP ? `${largeLogoHeightsAndWidths.reducedHeight}px` : `${largeLogoHeightsAndWidths.height}px`,
        width: menuAnimation === AnimationDirection.UP ? `${largeLogoHeightsAndWidths.reducedWidth}px` : `${largeLogoHeightsAndWidths.width}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        height: `${logoHeightInMediumScreen * baseUnit}px`,
        width: 'auto'
      },
      [MEDIA_BREAKPOINTS.small]: {
        height: `${logoHeightInSmallScreen * baseUnit}px`,
        width: 'auto'
      },
      alignItems: 'center',
      transition: `${reduceHeightAnimationDuration}ms`
    },
    image: {
      height: '100%'
    }
  });
};

const getImageResource$1 = svg => {
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

const Logo$1 = props => {
  const {
    href,
    alt,
    src,
    logoHeightInLargeScreen,
    logoHeightInMediumScreen,
    logoHeightInSmallScreen,
    menuAnimation = AnimationDirection.NONE,
    reduceHeightAnimationDuration = 0
  } = props;
  const [ref, largeLogoHeightsAndWidths] = useAnimationLogoHeightsAndWidths(logoHeightInLargeScreen);
  const style = getLogoStyle$2(logoHeightInMediumScreen, logoHeightInSmallScreen, menuAnimation, reduceHeightAnimationDuration, largeLogoHeightsAndWidths);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Link, {
    className: css(style.base),
    href: href
  }, /*#__PURE__*/React__default.createElement("img", {
    ref: ref,
    className: css(style.image),
    alt: alt,
    src: getImageResource$1(src)
  })));
};

const getStyle$x = (baseUnit, largePaddingFactor, mediumPaddingFactor, smallPaddingFactor) => {
  return StyleSheet.create({
    section: {
      [MEDIA_BREAKPOINTS.large]: {
        paddingTop: `${largePaddingFactor * baseUnit}px`,
        paddingBottom: `${largePaddingFactor * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        paddingTop: `${mediumPaddingFactor * baseUnit}px`,
        paddingBottom: `${mediumPaddingFactor * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        paddingTop: `${smallPaddingFactor * baseUnit}px`,
        paddingBottom: `${smallPaddingFactor * baseUnit}px`
      },
      display: 'flex',
      justifyContent: 'center'
    },
    linksWrapper: {
      display: 'inline-grid',
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: 'auto auto auto auto',
        gridGap: `${baseUnit * 0.5}px ${baseUnit * 4}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateColumns: 'auto auto auto',
        gridGap: `${baseUnit * 0.5}px ${baseUnit * 4}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateColumns: 'auto auto',
        gridGap: `${baseUnit * 0.5}px ${baseUnit * 2}px`
      }
    }
  });
};

const FooterLinksSection = props => {
  const {
    linksIdleColor,
    linksActiveStateColor,
    linksHoverStateColor,
    linksFontSizeLarge,
    linksFontSizeMedium,
    linksFontSizeSmall,
    linksPaddingFactorLargeScreen,
    linksPaddingFactorMediumScreen,
    linksPaddingFactorSmallScreen,
    baseUnit,
    fontSizesStyles
  } = useTheme(componentConfigurationKey$i);
  const {
    links,
    buttons
  } = props;
  const style = getStyle$x(baseUnit, linksPaddingFactorLargeScreen, linksPaddingFactorMediumScreen, linksPaddingFactorSmallScreen);
  const fontStyles = getStyleBySize(fontSizesStyles, {
    fontSizeLarge: linksFontSizeLarge,
    fontSizeMedium: linksFontSizeMedium,
    fontSizeSmall: linksFontSizeSmall
  });
  const linkColorsStyle = generateLinkStyleFromTheme({
    activeStateColor: linksActiveStateColor,
    hoverStateColor: linksHoverStateColor,
    idleColor: linksIdleColor
  });
  return /*#__PURE__*/React.createElement("div", {
    className: css(style.section)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(style.linksWrapper)
  }, links ? links.map((navigationLink, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: css(fontStyles)
  }, /*#__PURE__*/React.createElement(TextLinkComponent, {
    linkStyle: linkColorsStyle,
    href: navigationLink.link.href
  }, navigationLink.link.text))) : null, buttons ? buttons.map((button, index) => /*#__PURE__*/React.createElement(LinkButton, {
    key: index,
    text: button.text,
    onClick: button.onClick,
    color: linksIdleColor,
    hoverColor: linksHoverStateColor
  })) : null));
};

const createStyles$6 = (backgroundColor, separatorColor, largePaddingFactor, mediumPaddingFactor, smallPaddingFactor, separatorHeight, baseUnit) => {
  return StyleSheet.create({
    footerWrapper: {
      backgroundColor,
      [MEDIA_BREAKPOINTS.large]: {
        paddingTop: `${largePaddingFactor * baseUnit}px`,
        paddingBottom: `${largePaddingFactor * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        paddingTop: `${mediumPaddingFactor * baseUnit}px`,
        paddingBottom: `${mediumPaddingFactor * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        paddingTop: `${smallPaddingFactor * baseUnit}px`,
        paddingBottom: `${smallPaddingFactor * baseUnit}px`
      }
    },
    footerContent: {
      [MEDIA_BREAKPOINTS.large]: {
        padding: `0 ${baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        padding: `0 ${baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        padding: `0 ${baseUnit * 0.75}px`
      },
      margin: '0 auto',
      maxWidth: `${HUGE_SCREEN_SIZE}px`
    },
    logoSeparator: {
      height: `${separatorHeight}px`,
      width: '100%',
      backgroundColor: separatorColor,
      ':first-child': {
        marginRight: `${baseUnit}px`
      },
      ':last-child': {
        marginLeft: `${baseUnit}px`
      }
    },
    logoWrapper: {
      paddingTop: `${baseUnit}px`,
      display: 'flex',
      alignItems: 'center'
    }
  });
};

const getSeparatorStyle = (separatorColor, separatorHeight) => {
  return StyleSheet.create({
    separator: {
      height: `${separatorHeight}px`,
      backgroundColor: separatorColor
    }
  });
};

const logoBaseUnitHeight = 1.2;
const SEPARATOR_HEIGHT = 1;

const getLinksSection = linksSection => {
  return linksSection ? /*#__PURE__*/React.createElement(FooterLinksSection, _extends$1({
    key: "footer-links"
  }, linksSection)) : null;
};

const getFooterItems = (linksSection, oldSocialSection, socialSection, appsSection, separatorColor, separatorHeight) => {
  const separatorStyle = getSeparatorStyle(separatorColor, separatorHeight).separator;
  return [getLinksSection(linksSection), getAdditionalFooterSection(socialSection, oldSocialSection, appsSection, separatorColor, separatorHeight)].filter(section => section !== null).reduce(generateSeparatorSections(separatorStyle), []);
};

const Footer = props => {
  const {
    linksSection,
    socialSection,
    oldSocialSection,
    appsSection,
    logo,
    bottomFooterBar
  } = props;
  const {
    backgroundColor,
    separatorColor,
    baseUnit,
    sectionPaddingFactorLargeScreen,
    sectionPaddingFactorMediumScreen,
    sectionPaddingFactorSmallScreen
  } = useTheme(componentConfigurationKey$i);
  const styles = createStyles$6(backgroundColor, separatorColor, sectionPaddingFactorLargeScreen, sectionPaddingFactorMediumScreen, sectionPaddingFactorSmallScreen, SEPARATOR_HEIGHT, baseUnit);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("footer", {
    className: css(styles.footerWrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(styles.footerContent)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(styles.logoWrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(styles.logoSeparator)
  }), logo && /*#__PURE__*/React.createElement(Logo$1, _extends$1({}, logo, {
    logoHeightInSmallScreen: logoBaseUnitHeight,
    logoHeightInMediumScreen: logoBaseUnitHeight,
    logoHeightInLargeScreen: logoBaseUnitHeight
  })), /*#__PURE__*/React.createElement("div", {
    className: css(styles.logoSeparator)
  })), getFooterItems(linksSection, oldSocialSection, socialSection, appsSection, separatorColor, SEPARATOR_HEIGHT)), /*#__PURE__*/React.createElement(BottomFooterBar, bottomFooterBar)));
};

const reducedHeaderFirstRowHeightFactorsForOldHeader = {
  large: 1 / 2,
  medium: 2 / 3,
  small: 2 / 3
};
const reducedLogoHeightFactor = 0.5;
const notActiveLinkIdleColor = (isHoveredLink, hoverOtherLinksColors, idleColor) => isHoveredLink ? hoverOtherLinksColors : idleColor;
const getDoubleHeaderHeights = (large, medium, small) => ({
  small,
  medium,
  large
});

const radiusBorder$1 = 4;

const getLinkStyle$4 = (activeBorderBottom, isActive = false) => {
  return StyleSheet.create({
    link: {
      height: '100%',
      width: '100%',
      display: 'inline-flex',
      alignItems: 'center',
      position: 'relative',
      ':before': isActive ? {
        height: `${radiusBorder$1}px`,
        bottom: 0,
        left: 0,
        position: 'absolute',
        right: 0,
        content: "''",
        backgroundColor: activeBorderBottom
      } : {}
    }
  });
};

const getContainerStyle$3 = baseUnit => {
  return StyleSheet.create({
    linksContainer: {
      display: 'grid',
      gridAutoFlow: 'column',
      height: '100%',
      gridColumnGap: `${baseUnit}px`
    }
  });
};

const additionalStyle$1 = {
  [MEDIA_BREAKPOINTS.large]: {
    display: 'block'
  },
  [MEDIA_BREAKPOINTS.medium]: {
    display: 'none'
  },
  [MEDIA_BREAKPOINTS.small]: {
    display: 'none'
  }
};

const getContentStyle$2 = (isActiveLink, fontSizesStyles) => {
  const fontSizesActive = {
    fontSizeSmall: consts.TYPOGRAPHY_SIZE.BIGGER,
    fontSizeMedium: consts.TYPOGRAPHY_SIZE.BIGGER,
    fontSizeLarge: consts.TYPOGRAPHY_SIZE.BIGGER
  };
  const fontSizesNotActive = {
    fontSizeSmall: consts.TYPOGRAPHY_SIZE.NORMAL,
    fontSizeMedium: consts.TYPOGRAPHY_SIZE.NORMAL,
    fontSizeLarge: consts.TYPOGRAPHY_SIZE.NORMAL
  };
  return isActiveLink ? getStyleBySize(fontSizesStyles, fontSizesActive) : getStyleBySize(fontSizesStyles, fontSizesNotActive);
};

const createLink$1 = (idleColor, activeStateColor, hoverStateColor, activeBorderBottom, hoverOtherLinksColors, fontSizesStyles, isHoveredLink, pagePath) => (linkData, index) => {
  const isActiveLink = linkData.link.href === pagePath;
  const style = getLinkStyle$4(activeBorderBottom, isActiveLink);
  const calculatedIdleColor = isActiveLink ? activeStateColor : notActiveLinkIdleColor(isHoveredLink, hoverOtherLinksColors, idleColor);
  const linkStyle = generateLinkStyleFromTheme({
    idleColor: calculatedIdleColor,
    activeStateColor,
    hoverStateColor
  }, additionalStyle$1);
  const contentStyle = getContentStyle$2(isActiveLink, fontSizesStyles);
  return /*#__PURE__*/React__default.createElement(TextLinkComponent, {
    key: index,
    href: linkData.link.href,
    linkStyle: linkStyle
  }, /*#__PURE__*/React__default.createElement(Span, {
    styles: semanticCSS(contentStyle, style.link)
  }, linkData.link.text));
};

const PrimaryLinks = props => {
  const [isHoveredLink, setIsHoveredLink] = useState(false);
  const {
    baseUnit,
    firstRowLinkColorTypeNormal,
    firstRowLinkColorTypeActive,
    firstRowLinkColorTypeHover,
    firstRowLinkActiveBorderBottom,
    firstRowHoverOtherLinksColors,
    fontSizesStyles
  } = useTheme(componentConfigThemeKey$G);
  const {
    links,
    pagePath
  } = props;
  const style = getContainerStyle$3(baseUnit);
  return /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement("div", {
    className: css(style.linksContainer),
    onMouseEnter: () => setIsHoveredLink(true),
    onMouseLeave: () => setIsHoveredLink(false)
  }, links.map(createLink$1(firstRowLinkColorTypeNormal, firstRowLinkColorTypeActive, firstRowLinkColorTypeHover, firstRowLinkActiveBorderBottom, firstRowHoverOtherLinksColors, fontSizesStyles, isHoveredLink, pagePath))));
};

const defaultLogoHeights$1 = {
  large: 24,
  medium: 24,
  small: 24
};

const getLogoStyle$1 = (logoHeights, menuAnimation, reduceHeightAnimationDuration) => {
  return StyleSheet.create({
    base: {
      [MEDIA_BREAKPOINTS.large]: {
        height: menuAnimation === AnimationDirection.UP ? `${logoHeights.large * baseUnit * reducedLogoHeightFactor}px` : `${logoHeights.large * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        height: `${logoHeights.medium * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        height: `${logoHeights.small * baseUnit}px`
      },
      alignItems: 'center',
      paddingRight: `${baseUnit}px`,
      transition: `${reduceHeightAnimationDuration}ms`
    },
    largeSvg: {
      [MEDIA_BREAKPOINTS.large]: {
        display: 'inline-flex'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'none'
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'none'
      }
    },
    smallSvg: {
      [MEDIA_BREAKPOINTS.large]: {
        display: 'none'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'inline-flex'
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'inline-flex'
      }
    },
    image: {
      height: '100%'
    }
  });
};

const getImageResource = svg => {
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

const Logo = props => {
  const {
    href,
    alt,
    svgLarge,
    svgSmall,
    logoHeights = defaultLogoHeights$1,
    menuAnimation = AnimationDirection.NONE,
    reduceHeightAnimationDuration = 0
  } = props;
  const style = getLogoStyle$1(logoHeights, menuAnimation, reduceHeightAnimationDuration);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Link, {
    className: css(style.largeSvg, style.base),
    href: href
  }, /*#__PURE__*/React__default.createElement("img", {
    className: css(style.image),
    alt: alt,
    src: getImageResource(svgLarge)
  })), /*#__PURE__*/React__default.createElement(Link, {
    className: css(style.smallSvg, style.base),
    href: href
  }, /*#__PURE__*/React__default.createElement("img", {
    className: css(style.image),
    alt: alt,
    src: getImageResource(svgSmall)
  })));
};

let Directions$1;

(function (Directions) {
  Directions["UP"] = "180deg";
  Directions["DOWN"] = "0deg";
  Directions["LEFT"] = "90deg";
  Directions["RIGHT"] = "270deg";
})(Directions$1 || (Directions$1 = {}));

const getStyle$w = direction => StyleSheet.create({
  caret: {
    transform: `rotate(${direction})`,
    transition: 'transform 400ms'
  }
});

const ChevronIcon = props => {
  const {
    direction = Directions$1.DOWN,
    color = '#FFF'
  } = props;
  return /*#__PURE__*/React__default.createElement("svg", {
    className: css(getStyle$w(direction).caret),
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M11,8.09909655 L6.5,13 L5,11.3663655 L8.09099026,8 L5,4.63363448 L6.5,3 L11,7.90090345 L10.9090097,8 L11,8.09909655 Z",
    fill: color,
    fillRule: "nonzero",
    transform: "rotate(90 8 8)"
  })));
};

const getWrapperStyle$2 = baseUnit => StyleSheet.create({
  wrapper: {
    [MEDIA_BREAKPOINTS.large]: {
      padding: `${baseUnit / 4}px 0`
    }
  }
});

const getContentStyle$1 = (configThemeKey, hovering, isActive, fontSizesStyles, fontSizeSmall, fontSizeMedium, fontSizeLarge) => {
  switch (configThemeKey) {
    case 'editionsMenu':
      {
        return getStyleBySize(fontSizesStyles, {
          fontSizeSmall: consts.TYPOGRAPHY_SIZE.BIGGER,
          fontSizeMedium: consts.TYPOGRAPHY_SIZE.BIGGER,
          fontSizeLarge: consts.TYPOGRAPHY_SIZE.BIGGER
        });
      }

    case 'moreLinks':
      {
        const fontSizesForActive = {
          fontSizeSmall: consts.TYPOGRAPHY_SIZE.BIGGER,
          fontSizeMedium: consts.TYPOGRAPHY_SIZE.BIGGER,
          fontSizeLarge: consts.TYPOGRAPHY_SIZE.BIGGER
        };
        const fontSizesForNotActive = {
          fontSizeSmall,
          fontSizeMedium,
          fontSizeLarge
        };
        return getStyleBySize(fontSizesStyles, isActive ? fontSizesForActive : fontSizesForNotActive);
      }

    default:
      return getStyleBySize(fontSizesStyles, {
        fontSizeSmall: consts.TYPOGRAPHY_SIZE.NORMAL,
        fontSizeMedium: consts.TYPOGRAPHY_SIZE.NORMAL,
        fontSizeLarge: consts.TYPOGRAPHY_SIZE.NORMAL
      });
  }
};

const DropDownMenuLink = props => {
  const {
    linkColor,
    hoverColor,
    activeColor,
    href,
    text,
    baseUnit,
    isActive,
    fontSizesStyles,
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge,
    configThemeKey
  } = props;
  const [hovering, setHovering] = useState(false);
  const wrapperStyle = getWrapperStyle$2(baseUnit);
  const contentStyle = getContentStyle$1(configThemeKey, hovering, isActive, fontSizesStyles, fontSizeSmall, fontSizeMedium, fontSizeLarge);
  const linkStyle = generateLinkStyleFromTheme({
    idleColor: isActive ? activeColor : linkColor,
    activeStateColor: activeColor,
    hoverStateColor: isActive ? activeColor : hoverColor
  }, {
    width: '100%'
  });
  return /*#__PURE__*/React__default.createElement("li", {
    onMouseEnter: () => setHovering(true),
    onMouseLeave: () => setHovering(false),
    className: css(wrapperStyle.wrapper)
  }, /*#__PURE__*/React__default.createElement(TextLinkComponent, {
    href: href,
    linkStyle: linkStyle
  }, /*#__PURE__*/React__default.createElement(Span, {
    styles: semanticCSS(contentStyle)
  }, text)));
};

const getStyle$v = (baseUnit, menuBackgroundColor) => {
  return StyleSheet.create({
    menuWrapper: {
      position: 'absolute',
      top: '100%',
      width: '100%',
      minWidth: '160px',
      boxSizing: 'border-box',
      background: menuBackgroundColor,
      listStyle: 'none',
      padding: 0,
      margin: 0,
      display: 'flex',
      flexDirection: 'column',
      zIndex: 100,
      [MEDIA_BREAKPOINTS.large]: {
        padding: `${baseUnit / 4}px ${baseUnit / 2}px`
      }
    }
  });
};

const getLinksList = (menuLinks, linkColor, hoverColor, baseUnit, configThemeKey, activeEndpoint, fontSizesStyles, firstRowLinkFontSizeSmall, firstRowLinkFontSizeMedium, firstRowLinkFontSizeLarge) => {
  const isActive = navigationLink => navigationLink.link.href === activeEndpoint;

  return menuLinks.map((navigationLink, index) => /*#__PURE__*/React__default.createElement(DropDownMenuLink, {
    key: index,
    href: navigationLink.link.href,
    text: navigationLink.link.text,
    linkColor: linkColor,
    hoverColor: hoverColor,
    activeColor: hoverColor,
    baseUnit: baseUnit,
    isActive: isActive(navigationLink),
    configThemeKey: configThemeKey,
    fontSizesStyles: fontSizesStyles,
    fontSizeSmall: firstRowLinkFontSizeSmall,
    fontSizeMedium: firstRowLinkFontSizeMedium,
    fontSizeLarge: firstRowLinkFontSizeLarge
  }));
};

const DropDownMenu = props => {
  const {
    menuLinks,
    activeEndpoint,
    configThemeKey
  } = props;
  const themeProps = useTheme(componentConfigThemeKey$G);
  const {
    editionsBoxShadowTypeNormal,
    baseUnit,
    fontSizesStyles,
    editionsIconNormalColor,
    editionsIconHoverColor,
    firstRowLinkFontSizeSmall = consts.TYPOGRAPHY_SIZE.NORMAL,
    firstRowLinkFontSizeMedium = consts.TYPOGRAPHY_SIZE.NORMAL,
    firstRowLinkFontSizeLarge = consts.TYPOGRAPHY_SIZE.NORMAL,
    editionsMenuBackgroundColor
  } = themeProps;
  const style = getStyle$v(baseUnit, editionsMenuBackgroundColor);
  const boxShadowStyle = createStyleForBoxShadow({
    boxShadowTypeNormal: editionsBoxShadowTypeNormal
  });
  return /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement("ul", {
    className: css(style.menuWrapper, boxShadowStyle.style)
  }, getLinksList(menuLinks, editionsIconNormalColor, editionsIconHoverColor, baseUnit, configThemeKey, activeEndpoint, fontSizesStyles, firstRowLinkFontSizeSmall, firstRowLinkFontSizeMedium, firstRowLinkFontSizeLarge)));
};

const getEditionsStyle = color => {
  return StyleSheet.create({
    editionsWrapper: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'relative',
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'none'
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'none'
      }
    },
    editions: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      width: '144px',
      color,
      textDecoration: 'none',
      backgroundColor: 'transparent',
      border: 'none',
      outline: 'none',
      ':hover': {
        cursor: 'pointer'
      }
    }
  });
};

const getActiveEdition = (editions, editionEndpoint) => {
  return editions.find(edition => edition.link.href === editionEndpoint) || editions[0];
};
const Editions$1 = props => {
  const {
    editions,
    editionEndpoint
  } = props;
  const {
    editionsIconNormalColor
  } = useTheme(componentConfigThemeKey$G);
  const style = getEditionsStyle(editionsIconNormalColor);
  const activeEdition = getActiveEdition(editions, editionEndpoint);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const editionsClickHandler = useCallback(() => {
    setIsMenuOpen(!isMenuOpen);
  }, [isMenuOpen]);
  return /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement("div", {
    className: css(style.editionsWrapper)
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: css(style.editions),
    onClick: editionsClickHandler
  }, /*#__PURE__*/React__default.createElement(H4, null, activeEdition.link.text), /*#__PURE__*/React__default.createElement(ChevronIcon, {
    direction: isMenuOpen ? Directions$1.UP : Directions$1.DOWN,
    color: editionsIconNormalColor
  })), isMenuOpen && /*#__PURE__*/React__default.createElement(DropDownMenu, {
    menuLinks: editions,
    configThemeKey: "editionsMenu",
    activeEndpoint: editionEndpoint
  })));
};

const height = 25;

const getStyle$u = (backgroundColorNormal, textColorNormal, borderColorNormal, backgroundColorHover, textColorHover, borderColorHover, backgroundColorActive, textColorActive, borderColorActive, baseUnit, borderRadius) => {
  return StyleSheet.create({
    ctaButton: {
      borderRadius: `${borderRadius}px`,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: backgroundColorNormal,
      color: textColorNormal,
      border: `${borderColorNormal} 1px solid`,
      cursor: 'pointer',
      borderWidth: '1px',
      textDecoration: 'none',
      height: `${height}px`,
      ':hover': {
        backgroundColor: backgroundColorHover,
        color: textColorHover,
        border: `${borderColorHover} 1px solid`
      },
      ':active': {
        backgroundColor: backgroundColorActive,
        color: textColorActive,
        border: `${borderColorActive} 1px solid`
      },
      padding: `0 ${baseUnit / 2}px`
    }
  });
};

const CtaButton = props => {
  const {
    href,
    text
  } = props;
  const {
    fontSizesStyles,
    ctaBackgroundColorNormal,
    ctaTextColorNormal,
    ctaBorderColorNormal,
    ctaBackgroundColorHover,
    ctaTextColorHover,
    ctaBorderColorHover,
    ctaBackgroundColorActive,
    ctaTextColorActive,
    ctaBorderColorActive,
    baseUnit,
    ctaBorderRadius
  } = useTheme(componentConfigThemeKey$G);
  const style = getStyle$u(ctaBackgroundColorNormal, ctaTextColorNormal, ctaBorderColorNormal, ctaBackgroundColorHover, ctaTextColorHover, ctaBorderColorHover, ctaBackgroundColorActive, ctaTextColorActive, ctaBorderColorActive, baseUnit, ctaBorderRadius);
  const linkTextStyle = getStyleBySize(fontSizesStyles, {
    fontSizeSmall: consts.TYPOGRAPHY_SIZE.NORMAL,
    fontSizeMedium: consts.TYPOGRAPHY_SIZE.NORMAL,
    fontSizeLarge: consts.TYPOGRAPHY_SIZE.NORMAL
  });
  return /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement(Link, {
    className: css(style.ctaButton, linkTextStyle),
    href: href
  }, text));
};

const getMenuIconStyle$2 = (isOpen, color) => StyleSheet.create({
  style: {
    height: '16px'
  },
  wrapper: {
    width: '16px',
    height: '16px',
    position: 'relative',
    transition: '.5s ease-in-out',
    cursor: 'pointer'
  },
  span: {
    display: 'block',
    position: 'absolute',
    height: '2px',
    width: '100%',
    backgroundColor: color,
    opacity: 1,
    left: 0,
    transition: '.25s ease-in-out',
    transformOrigin: 'right center'
  },
  firstSpan: (() => {
    return isOpen ? {
      transform: 'rotate(-45deg)',
      width: '130%',
      left: '-6px',
      top: 0
    } : {
      top: 0
    };
  })(),
  secondSpan: (() => {
    return isOpen ? {
      top: '7px',
      transform: 'scaleX(0.1)',
      opacity: 0
    } : {
      top: '7px'
    };
  })(),
  thirdSpan: (() => {
    return isOpen ? {
      transform: 'rotate(45deg)',
      top: '14px',
      width: '130%',
      left: '-6px'
    } : {
      top: '14px'
    };
  })()
});

const MenuIcon = props => {
  const {
    isMenuOpen,
    onClick
  } = props;
  const {
    hamburgerMenuIconColor
  } = useTheme(componentConfigThemeKey$G);
  const style = getMenuIconStyle$2(isMenuOpen, hamburgerMenuIconColor);
  return /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement("div", {
    className: css(style.wrapper),
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement("span", {
    className: css(style.span, style.firstSpan)
  }), /*#__PURE__*/React__default.createElement("span", {
    className: css(style.span, style.secondSpan)
  }), /*#__PURE__*/React__default.createElement("span", {
    className: css(style.span, style.thirdSpan)
  })));
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.12.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(reactIs_production_min, "__esModule", {
  value: !0
});
var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.fundamental") : 60117,
    w = b ? Symbol.for("react.responder") : 60118,
    x = b ? Symbol.for("react.scope") : 60119;

function y(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;

              default:
                return u;
            }

        }

      case d:
        return u;
    }
  }
}

function z(a) {
  return y(a) === m;
}

reactIs_production_min.typeOf = y;
reactIs_production_min.AsyncMode = l;
reactIs_production_min.ConcurrentMode = m;
reactIs_production_min.ContextConsumer = k;
reactIs_production_min.ContextProvider = h;
reactIs_production_min.Element = c;
reactIs_production_min.ForwardRef = n;
reactIs_production_min.Fragment = e;
reactIs_production_min.Lazy = t;
reactIs_production_min.Memo = r;
reactIs_production_min.Portal = d;
reactIs_production_min.Profiler = g;
reactIs_production_min.StrictMode = f;
reactIs_production_min.Suspense = p;

reactIs_production_min.isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === v || a.$$typeof === w || a.$$typeof === x);
};

reactIs_production_min.isAsyncMode = function (a) {
  return z(a) || y(a) === l;
};

reactIs_production_min.isConcurrentMode = z;

reactIs_production_min.isContextConsumer = function (a) {
  return y(a) === k;
};

reactIs_production_min.isContextProvider = function (a) {
  return y(a) === h;
};

reactIs_production_min.isElement = function (a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};

reactIs_production_min.isForwardRef = function (a) {
  return y(a) === n;
};

reactIs_production_min.isFragment = function (a) {
  return y(a) === e;
};

reactIs_production_min.isLazy = function (a) {
  return y(a) === t;
};

reactIs_production_min.isMemo = function (a) {
  return y(a) === r;
};

reactIs_production_min.isPortal = function (a) {
  return y(a) === d;
};

reactIs_production_min.isProfiler = function (a) {
  return y(a) === g;
};

reactIs_production_min.isStrictMode = function (a) {
  return y(a) === f;
};

reactIs_production_min.isSuspense = function (a) {
  return y(a) === p;
};

var reactIs_development = {};

/** @license React v16.12.0
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (exports) {

if (process.env.NODE_ENV !== "production") {
  (function () {

    Object.defineProperty(exports, '__esModule', {
      value: true
    }); // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.

    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?

    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

    function isValidElementType(type) {
      return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE);
    }
    /**
     * Forked from fbjs/warning:
     * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
     *
     * Only change is we use console.warn instead of console.error,
     * and do nothing when 'console' is not supported.
     * This really simplifies the code.
     * ---
     * Similar to invariant but only logs a warning if the condition is not met.
     * This can be used to log issues in development environments in critical
     * paths. Removing the logging code for production environments will keep the
     * same logic and follow the same code paths.
     */


    var lowPriorityWarningWithoutStack = function () {};

    {
      var printWarning = function (format) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function () {
          return args[argIndex++];
        });

        if (typeof console !== 'undefined') {
          console.warn(message);
        }

        try {
          // --- Welcome to debugging React ---
          // This error was thrown as a convenience so that you can use this stack
          // to find the callsite that caused this warning to fire.
          throw new Error(message);
        } catch (x) {}
      };

      lowPriorityWarningWithoutStack = function (condition, format) {
        if (format === undefined) {
          throw new Error('`lowPriorityWarningWithoutStack(condition, format, ...args)` requires a warning ' + 'message argument');
        }

        if (!condition) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
            args[_key2 - 2] = arguments[_key2];
          }

          printWarning.apply(void 0, [format].concat(args));
        }
      };
    }
    var lowPriorityWarningWithoutStack$1 = lowPriorityWarningWithoutStack;

    function typeOf(object) {
      if (typeof object === 'object' && object !== null) {
        var $$typeof = object.$$typeof;

        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            var type = object.type;

            switch (type) {
              case REACT_ASYNC_MODE_TYPE:
              case REACT_CONCURRENT_MODE_TYPE:
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
                return type;

              default:
                var $$typeofType = type && type.$$typeof;

                switch ($$typeofType) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                  case REACT_PROVIDER_TYPE:
                    return $$typeofType;

                  default:
                    return $$typeof;
                }

            }

          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }

      return undefined;
    } // AsyncMode is deprecated along with isAsyncMode


    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

    function isAsyncMode(object) {
      {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
          hasWarnedAboutDeprecatedIsAsyncMode = true;
          lowPriorityWarningWithoutStack$1(false, 'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
        }
      }
      return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }

    function isConcurrentMode(object) {
      return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }

    function isContextConsumer(object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    }

    function isContextProvider(object) {
      return typeOf(object) === REACT_PROVIDER_TYPE;
    }

    function isElement(object) {
      return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }

    function isForwardRef(object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }

    function isFragment(object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    }

    function isLazy(object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    }

    function isMemo(object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    }

    function isPortal(object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    }

    function isProfiler(object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    }

    function isStrictMode(object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }

    function isSuspense(object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    }

    exports.typeOf = typeOf;
    exports.AsyncMode = AsyncMode;
    exports.ConcurrentMode = ConcurrentMode;
    exports.ContextConsumer = ContextConsumer;
    exports.ContextProvider = ContextProvider;
    exports.Element = Element;
    exports.ForwardRef = ForwardRef;
    exports.Fragment = Fragment;
    exports.Lazy = Lazy;
    exports.Memo = Memo;
    exports.Portal = Portal;
    exports.Profiler = Profiler;
    exports.StrictMode = StrictMode;
    exports.Suspense = Suspense;
    exports.isValidElementType = isValidElementType;
    exports.isAsyncMode = isAsyncMode;
    exports.isConcurrentMode = isConcurrentMode;
    exports.isContextConsumer = isContextConsumer;
    exports.isContextProvider = isContextProvider;
    exports.isElement = isElement;
    exports.isForwardRef = isForwardRef;
    exports.isFragment = isFragment;
    exports.isLazy = isLazy;
    exports.isMemo = isMemo;
    exports.isPortal = isPortal;
    exports.isProfiler = isProfiler;
    exports.isStrictMode = isStrictMode;
    exports.isSuspense = isSuspense;
  })();
}
}(reactIs_development));

if (process.env.NODE_ENV === 'production') {
  reactIs.exports = reactIs_production_min;
} else {
  reactIs.exports = reactIs_development;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function () {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;

  var loggedTypeFailures = {};
  var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning$1 = function (text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning$1((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$1('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes$1.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$1 = reactIs.exports;

var assign = objectAssign;

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;

var checkPropTypes = checkPropTypes_1;

var has = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning = function () {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function (text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function (isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */


  var ANONYMOUS = '<<anonymous>>'; // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  /*eslint-disable no-self-compare*/

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */


  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  } // Make `instanceof Error` still work for returned errors.


  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }

    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;

          if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }

      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }

          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }

        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }

      var propValue = props[propName];

      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }

      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);

        if (error instanceof Error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }

      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);

        if (type === 'symbol') {
          return String(value);
        }

        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }

      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }

      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

          if (error instanceof Error) {
            return error;
          }
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];

      if (typeof checker !== 'function') {
        printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];

        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }

      for (var key in shapeTypes) {
        var checker = shapeTypes[key];

        if (!checker) {
          continue;
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      } // We need to check all keys in case some are required but missing from
      // props.


      var allKeys = assign({}, props[propName], shapeTypes);

      for (var key in allKeys) {
        var checker = shapeTypes[key];

        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;

      case 'boolean':
        return !propValue;

      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }

        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);

        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;

          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;

              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;

      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    } // falsy value can't be a Symbol


    if (!propValue) {
      return false;
    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    } // Fallback for non-spec compliant Symbols which are polyfilled.


    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  } // Equivalent of `typeof` but with special handling for array and regexp.


  function getPropType(propValue) {
    var propType = typeof propValue;

    if (Array.isArray(propValue)) {
      return 'array';
    }

    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }

    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }

    return propType;
  } // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.


  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }

    var propType = getPropType(propValue);

    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }

    return propType;
  } // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"


  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);

    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;

      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;

      default:
        return type;
    }
  } // Returns class name of the object, if any.


  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }

    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;

  function getShim() {
    return shim;
  }
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs.exports; // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod


  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}

var PropTypes = propTypes.exports;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

function removeClass$1(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

var TransitionGroupContext = React__default.createContext(null);

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = ReactDOM.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      // allows for nested Transitions
      return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, children(status, childProps));
    }

    var child = React__default.Children.only(children);
    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, /*#__PURE__*/React__default.cloneElement(child, childProps))
    );
  };

  return Transition;
}(React__default.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the
   * `<Transition>` component mounts. If you want to transition on the first
   * mount set `appear` to `true`, and the component will transition in as soon
   * as the `<Transition>` mounts.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _addClass = function addClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass$1(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (node, appearing) {
      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    if (type === 'appear' && phase === 'done') {
      className += " " + this.getClassNames('enter').doneClassName;
    } // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
    }

    this.appliedClasses[type][phase] = className;

    _addClass(node, className);
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props;
        _this$props.classNames;
        var props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);

    return /*#__PURE__*/React__default.createElement(Transition, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(React__default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided and it
   * will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-appear`, `fade-appear-active`,
   * `fade-appear-done`, `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, and `fade-exit-done`.
   *
   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
   * This allows you to define different behavior for when appearing is done and
   * when regular entering is done, using selectors like
   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
   * epic entrance animation when element first appears in the DOM using
   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   * simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};

const animationFactor = 100;
const menuEnterDuration = animationFactor * 2;
const menuExitDuration = animationFactor * 3;
const menuExitDelay = animationFactor * 3;
const menuEnterTimeOut = menuEnterDuration;
const menuExitTimeOut = menuExitDuration + menuExitDelay;
const linkEnterDuration = animationFactor * 2;
const linkEnterDelay = animationFactor;
const linkExitDuration = animationFactor * 3;
const linkExitDelay = animationFactor * 3;
const linkEnterTimeOut = linkEnterDuration + linkEnterDelay;
const linkExitTimeOut = linkExitDuration + linkExitDelay;
const chevronIconEnterDuration = animationFactor * 3;
const chevronIconEnterDelay = animationFactor * 3;
const chevronIconExitDuration = animationFactor * 3;
const chevronIconEnterTimeOut = chevronIconEnterDuration + chevronIconEnterDelay;
const chevronIconExitTimeOut = chevronIconExitDuration;
const subLinkEnterDuration = animationFactor * 2;
const subLinksTotalDelay = animationFactor * 2;
const subLinkEnterTimeOut = subLinkEnterDuration + subLinksTotalDelay;

const getMenuSubLinkStyle = () => StyleSheet.create({
  style: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column'
  }
});

const MenuSubLink = props => {
  const {
    href,
    text
  } = props;
  const {
    hamburgerMenuSubLinksNormalColor,
    hamburgerMenuSubLinksFontSizeMedium,
    hamburgerMenuSubLinksFontSizeSmall
  } = useTheme(componentConfigThemeKey$G);
  const linkStyle = generateLinkStyleFromTheme({
    idleColor: hamburgerMenuSubLinksNormalColor
  });
  const style = getMenuSubLinkStyle();
  return /*#__PURE__*/React__default.createElement("li", {
    className: css(style.style)
  }, /*#__PURE__*/React__default.createElement(TextLinkComponent, {
    href: href,
    linkStyle: linkStyle
  }, /*#__PURE__*/React__default.createElement(P, {
    fontSizeMedium: hamburgerMenuSubLinksFontSizeMedium,
    fontSizeSmall: hamburgerMenuSubLinksFontSizeSmall
  }, text)));
};

const MAX_SUB_LINKS_FOR_ONE_COLUMN = 10;

const getSubLinkStyle = (index, currentSubLinkDelay) => StyleSheet.create({
  enter: {
    opacity: 0
  },
  enterActive: {
    opacity: 1,
    transition: `opacity ${subLinkEnterDuration}ms ease-out`,
    transitionDelay: `${currentSubLinkDelay * index}ms`
  }
});

const createMenuSubLinks = (numberOfSubLinks, isLinkOpen) => (menuLink, index) => {
  const style = getSubLinkStyle(index, subLinksTotalDelay / numberOfSubLinks);
  return /*#__PURE__*/React__default.createElement(CSSTransition, {
    key: index,
    in: isLinkOpen,
    unmountOnExit: true,
    mountOnEnter: true,
    timeout: {
      enter: subLinkEnterTimeOut,
      exit: 0
    },
    classNames: {
      enter: css(style.enter),
      enterActive: css(style.enterActive)
    }
  }, /*#__PURE__*/React__default.createElement(MenuSubLink, {
    href: menuLink.link.href,
    text: menuLink.link.text
  }));
};

const getSubLinksWrapperStyle = (numberOfLinks, baseUnit) => {
  const showTwoColumns = numberOfLinks > MAX_SUB_LINKS_FOR_ONE_COLUMN;
  return StyleSheet.create({
    wrapper: {
      display: 'grid',
      padding: 0,
      gridRowGap: `${baseUnit}px`,
      gridColumnGap: `${baseUnit}px`,
      gridTemplateColumns: showTwoColumns ? '1fr 1fr' : '1fr',
      gridTemplateRows: showTwoColumns ? `repeat(${Math.round(numberOfLinks / 2)}, auto)` : 'auto',
      marginRight: `${baseUnit}px`,
      marginLeft: `${baseUnit * 1.5}px`
    }
  });
};

const MenuSubLinks = props => {
  const {
    isLinkOpen,
    links
  } = props;
  const {
    baseUnit
  } = useTheme();
  const numberOfLinks = links.length;
  const style = getSubLinksWrapperStyle(numberOfLinks, baseUnit);
  return /*#__PURE__*/React__default.createElement("ul", {
    className: css(style.wrapper)
  }, links.map(createMenuSubLinks(numberOfLinks, isLinkOpen)));
};

const getMenuLinkStyle$2 = (baseUnit, linkColor) => StyleSheet.create({
  style: {
    color: linkColor,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [MEDIA_BREAKPOINTS.medium]: {
      margin: `${baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      margin: `${baseUnit}px`
    }
  },
  label: {
    color: linkColor,
    flex: '0 0 auto',
    display: 'inline-flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%'
  },
  enter: {
    opacity: 0
  },
  enterActive: {
    opacity: 1,
    transition: `opacity ${chevronIconEnterDuration}ms ease-out`,
    transitionDelay: `${chevronIconEnterDelay}ms`
  },
  exit: {
    opacity: 1
  },
  exitActive: {
    opacity: 0,
    transition: `opacity ${chevronIconExitDuration}ms ease-in`
  },
  chevronIcon: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row-reverse'
  }
});
const MenuLink = props => {
  const {
    hamburgerMenuLinksNormalColor,
    hamburgerMenuLinksActiveColor,
    baseUnit,
    hamburgerMenuLinksFontSizeMedium,
    hamburgerMenuLinksFontSizeSmall
  } = useTheme(componentConfigThemeKey$G);
  const {
    link,
    onClick,
    index,
    isLinkOpen,
    childrenLinks,
    startChevronIconAnimation
  } = props;
  const linkColor = isLinkOpen ? hamburgerMenuLinksActiveColor : hamburgerMenuLinksNormalColor;
  const linkStyle = generateLinkStyleFromTheme({
    idleColor: linkColor
  });
  const style = getMenuLinkStyle$2(baseUnit, linkColor);
  const doSubLinksExist = childrenLinks && childrenLinks.length !== 0;
  const {
    href
  } = link;
  const isFolder = href === '-';

  const LabelComponent = () => /*#__PURE__*/React__default.createElement(H4, {
    fontSizeMedium: hamburgerMenuLinksFontSizeMedium,
    fontSizeSmall: hamburgerMenuLinksFontSizeSmall,
    styles: semanticCSS(style.label)
  }, link.text);

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("div", {
    className: css(style.style)
  }, isFolder ? /*#__PURE__*/React__default.createElement(LabelComponent, null) : /*#__PURE__*/React__default.createElement(TextLinkComponent, {
    href: href,
    linkStyle: linkStyle
  }, /*#__PURE__*/React__default.createElement(LabelComponent, null)), doSubLinksExist ? /*#__PURE__*/React__default.createElement("div", {
    className: css(style.chevronIcon),
    onClick: () => onClick(index)
  }, /*#__PURE__*/React__default.createElement(CSSTransition, {
    in: startChevronIconAnimation,
    unmountOnExit: true,
    mountOnEnter: true,
    timeout: {
      enter: chevronIconEnterTimeOut,
      exit: chevronIconExitTimeOut
    },
    classNames: {
      enter: css(style.enter),
      enterActive: css(style.enterActive),
      exit: css(style.exit),
      exitActive: css(style.exitActive)
    }
  }, /*#__PURE__*/React__default.createElement(ChevronIcon, {
    direction: isLinkOpen ? Directions$1.UP : Directions$1.DOWN,
    color: linkColor
  }))) : null), doSubLinksExist && isLinkOpen ? /*#__PURE__*/React__default.createElement(MenuSubLinks, {
    links: childrenLinks,
    isLinkOpen: isLinkOpen
  }) : null));
};

const createStyle$I = (baseUnit, linkColor) => StyleSheet.create({
  button: {
    color: linkColor,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [MEDIA_BREAKPOINTS.medium]: {
      margin: `${baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      margin: `${baseUnit}px`
    }
  }
});

const MenuButton = props => {
  const {
    onClick,
    text
  } = props;
  /* eslint-disable-next-line no-new-func */

  const onClickFunction = new Function(onClick);
  const {
    hamburgerMenuLinksNormalColor,
    baseUnit,
    fontSizesStyles,
    hamburgerMenuLinksFontSizeMedium,
    hamburgerMenuLinksFontSizeSmall
  } = useTheme(componentConfigThemeKey$G);
  const style = createStyle$I(baseUnit, hamburgerMenuLinksNormalColor);
  const styleByFontSize = getStyleBySize(fontSizesStyles, {
    fontSizeLarge: hamburgerMenuLinksFontSizeMedium,
    fontSizeMedium: hamburgerMenuLinksFontSizeSmall,
    fontSizeSmall: hamburgerMenuLinksFontSizeSmall
  });
  return /*#__PURE__*/React.createElement("button", {
    className: css(style.button, styleByFontSize),
    type: "button",
    onClick: () => onClickFunction()
  }, text);
};

const getMenuLinksStyle$1 = (backgroundColor, dividerColor, baseUnit, headerHeights) => StyleSheet.create({
  style: {
    padding: 0,
    margin: 0,
    backgroundColor,
    position: 'fixed',
    width: '100%',
    zIndex: 2,
    left: 0,
    overflowY: 'auto',
    [MEDIA_BREAKPOINTS.medium]: {
      top: `${headerHeights.medium * baseUnit}px`,
      height: `calc(100vh - ${headerHeights.medium * baseUnit}px)`
    },
    [MEDIA_BREAKPOINTS.small]: {
      top: `${headerHeights.small * baseUnit}px`,
      height: `calc(100vh - ${headerHeights.small * baseUnit}px)`
    }
  },
  enter: {
    opacity: 0,
    transform: 'translate(-100%)'
  },
  enterActive: {
    opacity: 1,
    transform: 'translate(0)',
    transition: `transform ${menuEnterDuration}ms, opacity ${menuEnterDuration}ms`,
    transitionTimingFunction: 'ease-out'
  },
  exit: {
    opacity: 1,
    transform: 'translate(0)'
  },
  exitActive: {
    opacity: 0,
    transform: 'translate(-100%)',
    transition: `transform ${menuExitDuration}ms ease-in , opacity ${menuExitDuration}ms ease-in`,
    transitionDelay: `${menuExitDelay}ms`
  },
  divider: {
    backgroundColor: dividerColor,
    height: '1px',
    [MEDIA_BREAKPOINTS.medium]: {
      margin: `${baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      margin: `${baseUnit}px`
    }
  }
});

const getMenuLinkStyle$1 = () => StyleSheet.create({
  enter: {
    opacity: 0.5,
    transform: 'translate(-100%)'
  },
  enterActive: {
    opacity: 1,
    transform: 'translate(0)',
    transition: `transform ${linkEnterDuration}ms ease-out, opacity ${linkEnterDuration}ms ease-in`,
    transitionDelay: `${linkEnterDelay}ms`
  },
  exit: {
    transform: 'translate(0)',
    opacity: 1
  },
  exitActive: {
    opacity: 0.5,
    transform: 'translate(-100%)',
    transition: `transform ${linkExitDuration}ms ease-in, opacity ${linkExitDuration}ms ease-in`,
    transitionDelay: `${linkExitDelay}ms`
  }
});

const MenuLinkAnimationWrapper$1 = props => {
  const {
    children,
    shouldAppear
  } = props;
  const style = getMenuLinkStyle$1();
  return /*#__PURE__*/React.createElement(CSSTransition, {
    unmountOnExit: true,
    mountOnEnter: true,
    in: shouldAppear,
    timeout: {
      enter: linkEnterTimeOut,
      exit: linkExitTimeOut
    },
    classNames: {
      enter: css(style.enter),
      enterActive: css(style.enterActive),
      exit: css(style.exit),
      exitActive: css(style.exitActive)
    }
  }, children);
};

const createMenuLink$1 = (onClick, currentOpenLink, shouldAppear, startIndex = 0) => (menuLink, index) => {
  return /*#__PURE__*/React.createElement(MenuLinkAnimationWrapper$1, {
    shouldAppear: shouldAppear,
    key: index
  }, state => /*#__PURE__*/React.createElement(MenuLink, {
    key: index,
    link: menuLink.link,
    childrenLinks: menuLink.childrenLinks,
    index: startIndex + index,
    onClick: onClick,
    isLinkOpen: currentOpenLink !== -1 && currentOpenLink === startIndex + index,
    startChevronIconAnimation: state === 'entering' || state === 'entered'
  }));
};
const navigationLinkToMenuLinkDataProps = navigationLink => ({
  link: navigationLink.link,
  childrenLinks: navigationLink.children ? navigationLink.children.map(navigationLinkToMenuLinkDataProps) : null
});
const createEditionLink = (onClick, currentOpenLink, shouldAppear, startIndex = 0) => (navigationLink, index) => {
  return /*#__PURE__*/React.createElement(MenuLinkAnimationWrapper$1, {
    shouldAppear: shouldAppear,
    key: index
  }, state => /*#__PURE__*/React.createElement(MenuLink, {
    key: index,
    link: navigationLink.link,
    childrenLinks: navigationLink.children ? navigationLink.children.map(navigationLinkToMenuLinkDataProps) : null,
    index: startIndex + index,
    onClick: onClick,
    isLinkOpen: currentOpenLink !== -1 && currentOpenLink === startIndex + index,
    startChevronIconAnimation: state === 'entering' || state === 'entered'
  }));
};

const createMenuButton$1 = shouldAppear => ({
  text,
  onClick
}, key) => /*#__PURE__*/React.createElement(MenuLinkAnimationWrapper$1, {
  shouldAppear: shouldAppear,
  key: key
}, /*#__PURE__*/React.createElement(MenuButton, {
  text: text,
  onClick: onClick
}));

const createEditionsLinks = (editions, editionEndpoint) => {
  const activeEdition = getActiveEdition(editions, editionEndpoint);
  return [{
    link: {
      href: activeEdition.link.href,
      text: activeEdition.link.text
    },
    children: editions.map(edition => ({
      link: {
        href: edition.link.href,
        text: edition.link.text
      },
      children: null
    }))
  }];
};
const MenuLinks$1 = props => {
  const {
    menuLinks,
    editions,
    isMenuOpen,
    onClick,
    currentOpenLink,
    editionEndpoint,
    buttons = [],
    headerHeights
  } = props;
  const {
    hamburgerMenuLinksBackgroundColor,
    hamburgerMenuDividerColor,
    baseUnit
  } = useTheme(componentConfigThemeKey$G);
  const style = getMenuLinksStyle$1(hamburgerMenuLinksBackgroundColor, hamburgerMenuDividerColor, baseUnit, headerHeights);
  const editionsLinks = editions ? createEditionsLinks(editions, editionEndpoint) : [];
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(CSSTransition, {
    in: isMenuOpen,
    unmountOnExit: true,
    mountOnEnter: true,
    timeout: {
      enter: menuEnterTimeOut,
      exit: menuExitTimeOut
    },
    classNames: {
      enter: css(style.enter),
      enterActive: css(style.enterActive),
      exit: css(style.exit),
      exitActive: css(style.exitActive)
    }
  }, state => /*#__PURE__*/React.createElement("ul", {
    className: css(style.style)
  }, menuLinks.map(createMenuLink$1(onClick, currentOpenLink, state === 'entering' || state === 'entered')), buttons.map(createMenuButton$1(state === 'entering' || state === 'entered')), /*#__PURE__*/React.createElement("div", {
    className: css(style.divider)
  }), editionsLinks.map(createEditionLink(onClick, currentOpenLink, state === 'entering' || state === 'entered', menuLinks.length)))));
};

const getMenuStyle = () => StyleSheet.create({
  style: {
    [MEDIA_BREAKPOINTS.large]: {
      display: 'none'
    },
    [MEDIA_BREAKPOINTS.medium]: {
      display: 'inline-flex'
    },
    [MEDIA_BREAKPOINTS.small]: {
      display: 'inline-flex'
    }
  }
});

const Menu$1 = props => {
  const [state, setState] = useState({
    isMenuOpen: false,
    currentOpenLink: -1
  });
  const {
    isMenuOpen,
    currentOpenLink
  } = state;

  const clickOnMenuIcon = () => {
    setState({
      isMenuOpen: !isMenuOpen,
      currentOpenLink: isMenuOpen ? currentOpenLink : -1
    });
  };

  const clickOnLinkDropDown = index => {
    setState({
      isMenuOpen,
      currentOpenLink: currentOpenLink === index ? -1 : index
    });
  };

  const {
    links,
    editions,
    editionEndpoint,
    buttons,
    headerHeights
  } = props;
  const style = getMenuStyle();
  return /*#__PURE__*/React__default.createElement("div", {
    className: css(style.style)
  }, /*#__PURE__*/React__default.createElement(MenuIcon, {
    isMenuOpen: isMenuOpen,
    onClick: clickOnMenuIcon
  }), /*#__PURE__*/React__default.createElement(MenuLinks$1, {
    menuLinks: links,
    buttons: buttons,
    editions: editions,
    isMenuOpen: isMenuOpen,
    onClick: clickOnLinkDropDown,
    currentOpenLink: currentOpenLink,
    editionEndpoint: editionEndpoint,
    headerHeights: headerHeights
  }));
};

const injectArticleBlockByIndexEvent = 'injectArticleBlockByIndexEvent';
const viewabilityArticleBlockEvent = 'viewabilityArticleBlockEvent';
const injectVideoLogoSuccessfully = 'injectVideoLogoSuccessfully';
const setEventEmitter = (eventName, eventHandler) => {
  if (window.__mmClientApiSubscriptions__ && window.__mmClientApiSubscriptions__.get(eventName)) {
    window.__mmClientApiSubscriptions__.get(eventName).forEach(params => {
      try {
        eventHandler(params);
      } catch (e) {
        console.error(`ClientAPI Error. The error is in callback for one of the following events: "${injectArticleBlockByIndexEvent}", "${viewabilityArticleBlockEvent}" or "${injectVideoLogoSuccessfully}". Please check the callback value.`, e);
      }
    });
  }
};

const embeddedVideoLogoPaddingInPx = 20;

const getInjectedVideoLogoStyle$1 = (reduceHeightAnimationDuration, menuAnimation, headerHeights) => {
  return StyleSheet.create({
    wrapper: {
      [MEDIA_BREAKPOINTS.large]: {
        height: menuAnimation === AnimationDirection.UP ? `${headerHeights.large * baseUnit * reducedLogoHeightFactor}px` : `${headerHeights.large * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        height: `${headerHeights.medium * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        height: `${headerHeights.small * baseUnit}px`
      },
      transition: `${reduceHeightAnimationDuration}ms`
    },
    video: {
      height: '100%',
      alignItems: 'center',
      display: 'inline-flex',
      margin: `0 -${embeddedVideoLogoPaddingInPx}px`
    },
    source: {
      height: '100%'
    }
  });
};

const VideoLogo$1 = props => {
  const {
    videoPath,
    href,
    reduceHeightAnimationDuration = 0,
    menuAnimation = AnimationDirection.NONE,
    headerHeights
  } = props;
  const style = getInjectedVideoLogoStyle$1(reduceHeightAnimationDuration, menuAnimation, headerHeights);
  React__default.useEffect(() => {
    setEventEmitter(injectVideoLogoSuccessfully, callback => callback());
  }, [videoPath]);
  return /*#__PURE__*/React__default.createElement(Link, {
    className: css(style.wrapper),
    href: href
  }, /*#__PURE__*/React__default.createElement("video", {
    className: css(style.video),
    loop: true,
    autoPlay: true,
    muted: true
  }, /*#__PURE__*/React__default.createElement("source", {
    className: css(style.source),
    src: videoPath,
    type: "video/mp4"
  })));
};

const getStyle$t = (baseUnit, backgroundColor, menuAnimation, reduceHeightAnimationDuration, headerHeights) => {
  return StyleSheet.create({
    headerWrapper: {
      position: 'relative',
      backgroundColor,
      zIndex: 100
    },
    header: {
      [MEDIA_BREAKPOINTS.large]: {
        height: menuAnimation === AnimationDirection.UP ? `${headerHeights.large * baseUnit * reducedHeaderFirstRowHeightFactorsForOldHeader.large}px` : `${headerHeights.large * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        height: `${headerHeights.medium * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        height: `${headerHeights.small * baseUnit}px`
      },
      display: 'flex',
      justifyContent: 'space-between',
      maxWidth: `${HUGE_SCREEN_SIZE}px`,
      margin: '0 auto',
      transition: `${reduceHeightAnimationDuration}ms`
    },
    itemsBasicContainer: {
      display: 'grid',
      gridAutoFlow: 'column',
      height: '100%',
      width: 'fit-content',
      alignItems: 'center',
      gridColumnGap: `${baseUnit}px`
    },
    itemsRightContainer: {
      [MEDIA_BREAKPOINTS.large]: {
        paddingRight: `${baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        paddingRight: `${baseUnit / 2}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        paddingRight: `${baseUnit / 2}px`
      }
    },
    itemsLeftContainer: {
      paddingLeft: `${baseUnit}px`
    }
  });
};

const PrimaryHeader = props => {
  const {
    links,
    logo,
    editions,
    cta,
    menu,
    videoLogo,
    pagePath,
    editionEndpoint,
    menuAnimation = AnimationDirection.NONE,
    reduceHeightAnimationDuration = 0,
    headerHeights,
    logoHeights
  } = props;
  const {
    baseUnit,
    firstRowBackgroundColor,
    firstRowBoxShadow
  } = useTheme(componentConfigThemeKey$G);
  const style = getStyle$t(baseUnit, firstRowBackgroundColor, menuAnimation, reduceHeightAnimationDuration, headerHeights);
  const boxShadowStyle = createStyleForBoxShadow({
    boxShadowTypeNormal: firstRowBoxShadow
  });
  return /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement("div", {
    className: css(style.headerWrapper, boxShadowStyle.style)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css(style.header)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css(style.itemsBasicContainer, style.itemsLeftContainer)
  }, menu ? /*#__PURE__*/React__default.createElement(Menu$1, {
    links: menu.links,
    editions: editions,
    editionEndpoint: editionEndpoint,
    buttons: menu.buttons,
    headerHeights: headerHeights
  }) : null, videoLogo ? /*#__PURE__*/React__default.createElement(VideoLogo$1, _extends$1({}, videoLogo, {
    href: logo.href,
    menuAnimation: menuAnimation,
    reduceHeightAnimationDuration: reduceHeightAnimationDuration,
    headerHeights: headerHeights
  })) : /*#__PURE__*/React__default.createElement(Logo, _extends$1({}, logo, {
    logoHeights: {
      large: logoHeights.large,
      medium: logoHeights.medium,
      small: logoHeights.small
    },
    menuAnimation: menuAnimation,
    reduceHeightAnimationDuration: reduceHeightAnimationDuration
  })), links ? /*#__PURE__*/React__default.createElement(PrimaryLinks, {
    links: links,
    pagePath: pagePath
  }) : null), /*#__PURE__*/React__default.createElement("div", {
    className: css(style.itemsBasicContainer, style.itemsRightContainer)
  }, cta ? /*#__PURE__*/React__default.createElement(CtaButton, cta) : null, editions ? /*#__PURE__*/React__default.createElement(Editions$1, {
    editions: editions,
    editionEndpoint: editionEndpoint
  }) : null))));
};

const getStyle$s = (titleColor, menuBackground) => {
  return StyleSheet.create({
    wrapper: {
      position: 'relative',
      height: '100%',
      display: 'flex'
    },
    button: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: 'transparent',
      border: 'none',
      outline: 'none'
    },
    buttonTitle: {
      color: titleColor,
      marginRight: '9px'
    },
    menuBody: {
      listStyle: 'none',
      width: '100%',
      position: 'absolute',
      backgroundColor: menuBackground
    }
  });
};

const MoreLinks = props => {
  const {
    moreLinksText,
    links,
    pagePath
  } = props;
  const {
    secondRowSubMenuBackgroundColor,
    secondRowLinkCurrentColor,
    secondRowLinkFontSizeLarge,
    secondRowLinkFontSizeMedium,
    secondRowLinkFontSizeSmall
  } = useTheme(componentConfigThemeKey$G);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const toggleMenu = React.useCallback(() => {
    setIsMenuOpen(!isMenuOpen);
  }, [isMenuOpen]);
  const style = getStyle$s(secondRowLinkCurrentColor, secondRowSubMenuBackgroundColor);
  const chevronDirection = isMenuOpen ? Directions$1.UP : Directions$1.DOWN;
  return /*#__PURE__*/React.createElement("div", {
    className: css(style.wrapper)
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: css(style.button),
    onClick: toggleMenu
  }, /*#__PURE__*/React.createElement(Span, {
    styles: semanticCSS(style.buttonTitle),
    fontSizeLarge: secondRowLinkFontSizeLarge,
    fontSizeMedium: secondRowLinkFontSizeMedium,
    fontSizeSmall: secondRowLinkFontSizeSmall
  }, moreLinksText), /*#__PURE__*/React.createElement(ChevronIcon, {
    direction: chevronDirection
  })), isMenuOpen && /*#__PURE__*/React.createElement(DropDownMenu, {
    configThemeKey: "moreLinks",
    menuLinks: links,
    highlightActive: true,
    activeEndpoint: pagePath
  }));
};

const getTextStyle$3 = isLastLink => {
  return StyleSheet.create({
    link: {
      width: 'max-content',
      [MEDIA_BREAKPOINTS.medium]: {
        paddingRight: isLastLink ? `${baseUnit * 2}px` : 0
      },
      [MEDIA_BREAKPOINTS.small]: {
        paddingRight: isLastLink ? `${baseUnit * 2}px` : 0
      }
    }
  });
};

const isLastLink = (index, linksLength) => index + 1 === linksLength;

const getContentStyle = (isActiveLink, fontSizesStyles, fontSizeLarge, fontSizeMedium, fontSizeSmall) => {
  const fontSizesActive = {
    fontSizeSmall: consts.TYPOGRAPHY_SIZE.BIGGER,
    fontSizeMedium: consts.TYPOGRAPHY_SIZE.BIGGER,
    fontSizeLarge: consts.TYPOGRAPHY_SIZE.BIGGER
  };
  const fontSizesNotActive = {
    fontSizeSmall: fontSizeLarge,
    fontSizeMedium,
    fontSizeLarge: fontSizeSmall
  };
  return isActiveLink ? getStyleBySize(fontSizesStyles, fontSizesActive) : getStyleBySize(fontSizesStyles, fontSizesNotActive);
};

const SecondaryLink = props => {
  const {
    linksLength,
    index,
    isHoveredLink,
    pagePath,
    linkData,
    maxVisibleLinks = 6
  } = props;
  const {
    secondRowLinkColorTypeActive,
    secondRowHoverOtherLinksColors,
    secondRowLinkColorTypeNormal,
    secondRowLinkColorTypeHover,
    fontSizesStyles,
    secondRowLinkFontSizeLarge,
    secondRowLinkFontSizeMedium,
    secondRowLinkFontSizeSmall
  } = useTheme(componentConfigThemeKey$G);
  const isActiveLink = linkData.link.href === pagePath;
  const calculatedIdleColor = isActiveLink ? secondRowLinkColorTypeActive : notActiveLinkIdleColor(isHoveredLink, secondRowHoverOtherLinksColors, secondRowLinkColorTypeNormal);
  const calculatedHoverColor = isActiveLink ? secondRowLinkColorTypeActive : secondRowLinkColorTypeHover;
  const linkStyleBasedOnScreen = linksLength > maxVisibleLinks && index >= maxVisibleLinks - 1 ? {
    [MEDIA_BREAKPOINTS.large]: {
      display: 'none'
    },
    [MEDIA_BREAKPOINTS.small]: {
      display: 'inline-flex'
    },
    [MEDIA_BREAKPOINTS.medium]: {
      display: 'inline-flex'
    }
  } : {};
  const linkStyle = generateLinkStyleFromTheme({
    idleColor: calculatedIdleColor,
    activeStateColor: secondRowLinkColorTypeActive,
    hoverStateColor: calculatedHoverColor
  }, linkStyleBasedOnScreen);
  const style = getTextStyle$3(isLastLink(index, linksLength));
  const contentStyle = getContentStyle(isActiveLink, fontSizesStyles, secondRowLinkFontSizeLarge, secondRowLinkFontSizeMedium, secondRowLinkFontSizeSmall);
  return /*#__PURE__*/React.createElement(TextLinkComponent, {
    href: linkData.link.href,
    linkStyle: linkStyle
  }, /*#__PURE__*/React.createElement(Span, {
    styles: semanticCSS(contentStyle, style.link)
  }, linkData.link.text));
};

const getContainerStyle$2 = baseUnit => {
  return StyleSheet.create({
    container: {
      display: 'grid',
      gridAutoFlow: 'column',
      alignItems: 'center',
      height: '100%',
      gridColumnGap: `${baseUnit}px`,
      [MEDIA_BREAKPOINTS.medium]: {
        overflowX: 'auto'
      },
      [MEDIA_BREAKPOINTS.small]: {
        overflowX: 'auto'
      }
    },
    dropDownMenuWrapper: {
      height: '100%',
      [MEDIA_BREAKPOINTS.large]: {
        display: 'block'
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'none'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'none'
      }
    }
  });
};
const SecondaryLinks = props => {
  const {
    links,
    moreLinksText,
    maxVisibleLinks = 6,
    pagePath
  } = props;
  const {
    baseUnit
  } = useTheme();
  const [isHoveredLink, setIsHoveredLink] = React__default.useState(false);
  const style = getContainerStyle$2(baseUnit);
  const moreLinks = links.length > maxVisibleLinks ? links.slice(maxVisibleLinks - 1) : [];
  return /*#__PURE__*/React__default.createElement("div", {
    className: css(style.container)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css(style.container),
    onMouseEnter: () => setIsHoveredLink(true),
    onMouseLeave: () => setIsHoveredLink(false)
  }, links.map((linkData, index) => /*#__PURE__*/React__default.createElement(SecondaryLink, {
    key: index,
    linkData: linkData,
    index: index,
    linksLength: links.length,
    isHoveredLink: isHoveredLink,
    pagePath: pagePath,
    maxVisibleLinks: maxVisibleLinks
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: css(style.dropDownMenuWrapper)
  }, moreLinks.length > 0 && /*#__PURE__*/React__default.createElement(MoreLinks, {
    moreLinksText: moreLinksText,
    links: moreLinks,
    pagePath: pagePath
  })));
};

const maxVisibleLinksOnLargeAndXLarge = 6;

const getStyle$r = (baseUnit, backgroundColor, animationDuration, headerHeights) => {
  return StyleSheet.create({
    headerWrapper: {
      backgroundColor,
      zIndex: 50,
      position: 'relative'
    },
    header: {
      [MEDIA_BREAKPOINTS.large]: {
        height: `${headerHeights.large * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        height: `${headerHeights.medium * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        height: `${headerHeights.small * baseUnit}px`
      },
      display: 'grid',
      gridAutoFlow: 'column',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'flex-start',
      gridColumnGap: `${baseUnit}px`,
      paddingLeft: `${baseUnit}px`,
      maxWidth: `${HUGE_SCREEN_SIZE}px`,
      margin: '0 auto',
      boxSizing: 'border-box'
    },
    foldingUp: {
      transition: `${animationDuration}ms`,
      [MEDIA_BREAKPOINTS.medium]: {
        transform: 'translateY(-100%)'
      },
      [MEDIA_BREAKPOINTS.small]: {
        transform: 'translateY(-100%)'
      }
    },
    foldingDown: {
      transition: `${animationDuration}ms`,
      [MEDIA_BREAKPOINTS.medium]: {
        transform: 'translateY(0)',
        transitionDelay: '200ms',
        transition: `${animationDuration}ms`
      },
      [MEDIA_BREAKPOINTS.small]: {
        transform: 'translateY(0)',
        transitionDelay: '200ms'
      }
    }
  });
};

const getClassWithAnimations = (animation, baseStyle, boxShadow) => {
  switch (animation) {
    case AnimationDirection.UP:
      return css(baseStyle.headerWrapper, boxShadow.style, baseStyle.foldingUp);

    case AnimationDirection.DOWN:
      return css(baseStyle.headerWrapper, boxShadow.style, baseStyle.foldingDown);

    default:
      return css(baseStyle.headerWrapper, boxShadow.style);
  }
};

const SecondaryHeader = props => {
  const {
    links,
    logo,
    moreLinksText,
    pagePath,
    animationDuration = 0,
    animation = AnimationDirection.NONE,
    headerHeights,
    logoHeights
  } = props;
  const {
    baseUnit,
    secondRowBackgroundColor,
    secondRowBoxShadow
  } = useTheme(componentConfigThemeKey$G);
  const style = getStyle$r(baseUnit, secondRowBackgroundColor, animationDuration, headerHeights);
  const boxShadowStyle = createStyleForBoxShadow({
    boxShadowTypeNormal: secondRowBoxShadow
  });
  const combinedStyle = getClassWithAnimations(animation, style, boxShadowStyle);
  return /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement("div", {
    className: combinedStyle
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css(style.header)
  }, logo ? /*#__PURE__*/React__default.createElement(Logo, _extends$1({}, logo, {
    logoHeights: {
      large: logoHeights.large,
      medium: logoHeights.medium,
      small: logoHeights.small
    }
  })) : null, links ? /*#__PURE__*/React__default.createElement(SecondaryLinks, {
    links: links,
    maxVisibleLinks: maxVisibleLinksOnLargeAndXLarge,
    moreLinksText: moreLinksText,
    pagePath: pagePath
  }) : null)));
};

const getStyle$q = headerHeights => {
  return StyleSheet.create({
    anchor: {
      position: 'fixed',
      [MEDIA_BREAKPOINTS.large]: {
        top: headerHeights.large * baseUnit
      },
      [MEDIA_BREAKPOINTS.medium]: {
        top: headerHeights.medium * baseUnit
      },
      [MEDIA_BREAKPOINTS.small]: {
        top: headerHeights.small * baseUnit
      },
      left: 0,
      right: 0,
      height: 0,
      transition: '800ms'
    },
    foldingUp: {
      [MEDIA_BREAKPOINTS.medium]: {
        top: 0
      },
      [MEDIA_BREAKPOINTS.small]: {
        top: 0
      }
    },
    foldingDown: {
      [MEDIA_BREAKPOINTS.medium]: {
        top: headerHeights.medium * baseUnit
      },
      [MEDIA_BREAKPOINTS.small]: {
        top: headerHeights.small * baseUnit
      }
    }
  });
};

const MontiAnchor = props => {
  const {
    menuAnimation
  } = props;
  const headerHeights = useHeaderHeights();
  const style = getStyle$q(headerHeights);
  let finalStyle;

  switch (menuAnimation) {
    case 'foldingUp':
      finalStyle = css(style.anchor, style.foldingUp);
      break;

    case 'foldingDown':
      finalStyle = css(style.anchor, style.foldingDown);
      break;

    default:
      finalStyle = css(style.anchor);
  }

  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: `${finalStyle} video-top-anchor`
  }));
};

const animationDuration = 200;
const HeaderAnimationContextInitialValue = {
  menuFoldState: AnimationDirection.NONE,
  animationDuration
};
const HeaderAnimationContext = React__default.createContext(HeaderAnimationContextInitialValue);
const HeaderAnimation = ({
  children,
  headerHeights
}) => {
  const firstMenuFoldThreshold = 640;
  const secondMenuFoldThreshold = 100;
  const scrollUpThreshold = -400;
  const [scrollTicking, setScrollTicking] = useState(false);
  const [scrolledUpPixels, setScrolledUpPixels] = useState(0);
  const [menuFirstFolded, setMenuFirstFolded] = useState(false);
  const [menuFoldState, setMenuFoldState] = useState(HeaderAnimationContextInitialValue.menuFoldState);

  const isScrollingUp = deltaY => {
    return deltaY < 0;
  };

  const isScrollingDown = deltaY => {
    return deltaY > 0;
  };

  const getMenuAnimation = originalScrollPosition => {
    const currentScrollPosition = window.scrollY;
    const deltaY = currentScrollPosition - originalScrollPosition;

    if (currentScrollPosition > firstMenuFoldThreshold && !menuFirstFolded) {
      setMenuFirstFolded(true);
      return AnimationDirection.UP;
    }

    if (isScrollingUp(deltaY)) {
      setScrolledUpPixels(scrolledUpPixels + deltaY);

      if (scrolledUpPixels < scrollUpThreshold || currentScrollPosition <= headerHeights.small * baseUnit || currentScrollPosition <= headerHeights.medium) {
        return AnimationDirection.DOWN;
      }
    }

    if (isScrollingDown(deltaY) && menuFirstFolded && currentScrollPosition > secondMenuFoldThreshold) {
      setScrolledUpPixels(0);
      return AnimationDirection.UP;
    }

    return menuFoldState;
  };

  const scrollHandler = () => {
    if (!scrollTicking) {
      const originalY = window.scrollY;
      setScrollTicking(true);
      setTimeout(() => {
        const menuAnimation = getMenuAnimation(originalY);

        if (menuAnimation !== menuFoldState) {
          setMenuFoldState(menuAnimation);
        }

        setScrollTicking(false);
      }, 100);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', scrollHandler);
    return () => window.removeEventListener('scroll', scrollHandler);
  });
  return /*#__PURE__*/React__default.createElement(HeaderAnimationContext.Provider, {
    value: {
      menuFoldState,
      animationDuration
    }
  }, children);
};

const getStyle$p = animationDuration => {
  return StyleSheet.create({
    header: {
      position: 'fixed',
      width: '100%',
      zIndex: 1500,
      top: 0
    },
    foldingUp: {
      [MEDIA_BREAKPOINTS.medium]: {
        transition: `${animationDuration}ms`,
        transform: 'translateY(-100%)',
        transitionDelay: `${animationDuration}ms`
      },
      [MEDIA_BREAKPOINTS.small]: {
        transition: `${animationDuration}ms`,
        transform: 'translateY(-100%)',
        transitionDelay: `${animationDuration}ms`
      }
    },
    foldingDown: {
      [MEDIA_BREAKPOINTS.medium]: {
        transform: 'translateY(0)'
      },
      [MEDIA_BREAKPOINTS.small]: {
        transform: 'translateY(0)'
      }
    }
  });
};

const HeaderComponent$1 = props => {
  const {
    menuFoldState,
    animationDuration
  } = React__default.useContext(HeaderAnimationContext);
  const {
    primaryHeader,
    secondaryHeader,
    pagePath,
    editionEndpoint
  } = props;
  const {
    links,
    logo,
    editions,
    cta,
    menu,
    videoLogo
  } = primaryHeader;
  const themeProps = useTheme(componentConfigThemeKey$G);
  const firstRowHeights = getDoubleHeaderHeights(themeProps.firstRowHeightInLargeScreen, themeProps.firstRowHeightInMediumScreen, themeProps.firstRowHeightInSmallScreen);
  const firstRowLogoHeights = getDoubleHeaderHeights(themeProps.firstRowLogoHeightInLargeScreen, themeProps.firstRowLogoHeightInMediumScreen, themeProps.firstRowLogoHeightInSmallScreen);
  const secondRowHeights = getDoubleHeaderHeights(themeProps.secondRowHeightInLargeScreen, themeProps.secondRowHeightInMediumScreen, themeProps.secondRowHeightInSmallScreen);
  const secondRowLogoHeights = getDoubleHeaderHeights(themeProps.secondRowLogoHeightInLargeScreen, themeProps.secondRowLogoHeightInMediumScreen, themeProps.secondRowLogoHeightInSmallScreen);

  const generateSecondaryHeader = () => {
    if (!secondaryHeader) {
      return null;
    }

    return /*#__PURE__*/React__default.createElement(SecondaryHeader, {
      moreLinksText: secondaryHeader.moreLinksText,
      links: secondaryHeader.links,
      logo: secondaryHeader.logo,
      pagePath: pagePath,
      animation: menuFoldState,
      animationDuration: animationDuration,
      headerHeights: secondRowHeights,
      logoHeights: secondRowLogoHeights
    });
  };

  const getHeaderStyleWithAnimation = () => {
    const style = getStyle$p(animationDuration);

    if (menuFoldState === AnimationDirection.NONE) {
      return css(style.header);
    }

    const animationStyle = menuFoldState === AnimationDirection.UP ? style.foldingUp : style.foldingDown;
    return css(style.header, animationStyle);
  };

  return /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement(MontiAnchor, {
    isSecondaryHeaderEnabled: !!secondaryHeader,
    menuAnimation: menuFoldState
  }), /*#__PURE__*/React__default.createElement("header", {
    className: getHeaderStyleWithAnimation()
  }, /*#__PURE__*/React__default.createElement(PrimaryHeader, {
    links,
    logo,
    editions,
    cta,
    menu,
    videoLogo,
    pagePath,
    editionEndpoint,
    menuAnimation: menuFoldState,
    reduceHeightAnimationDuration: animationDuration,
    headerHeights: firstRowHeights,
    logoHeights: firstRowLogoHeights
  }), generateSecondaryHeader()));
};
const OldHeader = props => {
  const headerHeights = useHeaderHeights();
  return /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement(HeaderAnimation, {
    headerHeights: headerHeights
  }, /*#__PURE__*/React__default.createElement(HeaderComponent$1, props)));
};

const componentConfigThemeKey$F = 'errorPage';

const createErrorStyle = theme => {
  const {
    baseUnit,
    titleColor,
    textColor,
    buttonTextColorNormal,
    buttonTextColorHover,
    buttonTextColorActive,
    backgroundColorNormal,
    backgroundColorHover,
    backgroundColorActive,
    borderRadius
  } = theme;
  return StyleSheet.create({
    wrapperStyle: {
      paddingTop: `${2 * baseUnit}px`
    },
    title: {
      textAlign: 'center',
      color: titleColor
    },
    secondaryTitle: {
      textAlign: 'center',
      color: titleColor,
      [MEDIA_BREAKPOINTS.large]: {
        marginTop: 0
      },
      [MEDIA_BREAKPOINTS.medium]: {
        marginTop: `${baseUnit / 2}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        marginTop: `${baseUnit / 2}px`
      }
    },
    content: {
      textAlign: 'center',
      color: textColor
    },
    buttonWrapper: {
      display: 'flex',
      justifyContent: 'center',
      textAlign: 'center',
      marginTop: `${baseUnit}px`
    },
    button: {
      display: 'flex',
      height: '40px',
      paddingRight: `${baseUnit}px`,
      paddingLeft: `${baseUnit}px`,
      alignItems: 'center',
      color: buttonTextColorNormal,
      ':hover': {
        backgroundColor: backgroundColorHover,
        color: buttonTextColorHover
      },
      ':active': {
        backgroundColor: backgroundColorActive,
        color: buttonTextColorActive
      },
      backgroundColor: backgroundColorNormal,
      borderRadius: `${borderRadius}px`,
      textDecoration: 'none'
    }
  });
};

const createImageErrorStyle = theme => {
  const {
    baseUnit
  } = theme;
  return StyleSheet.create({
    style: {
      margin: `0px auto ${baseUnit}px auto`,
      [MEDIA_BREAKPOINTS.large]: {
        width: '300px',
        height: '300px'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        width: '180px',
        height: '180px'
      },
      [MEDIA_BREAKPOINTS.small]: {
        width: '180px',
        height: '180px'
      }
    }
  });
};

const imageWidths$h = createImageWidths(360, 360, 360);
const Error$1 = props => {
  const {
    title,
    image,
    secondaryTitle,
    content,
    button
  } = props;
  const themeProps = useTheme(componentConfigThemeKey$F);
  const aspectRatio = {
    x: 1,
    y: 1
  };
  const errorStyle = createErrorStyle(themeProps);
  const imageErrorStyle = createImageErrorStyle(themeProps);
  const {
    fontSizesStyles,
    boxShadowTypeNormal,
    boxShadowTypeHover,
    boxShadowTypeActive,
    borderColorNormal,
    borderColorActive,
    borderColorHover,
    borderWidthNormal,
    borderWidthActive,
    borderWidthHover,
    buttonFontSizeLarge,
    buttonFontSizeMedium,
    buttonFontSizeSmall
  } = themeProps;
  const borderBoxShadow = {
    borderColorTypeActive: borderColorActive,
    borderColorTypeHover: borderColorHover,
    borderColorTypeNormal: borderColorNormal,
    borderWidthTypeActive: borderWidthActive,
    borderWidthTypeHover: borderWidthHover,
    borderWidthTypeNormal: borderWidthNormal
  };
  const boxShadowStyle = createStyleForBoxShadow({
    boxShadowTypeNormal,
    boxShadowTypeHover,
    boxShadowTypeActive,
    borderBoxShadow
  });
  const textStyle = getStyleBySize(fontSizesStyles, {
    fontSizeSmall: buttonFontSizeSmall,
    fontSizeMedium: buttonFontSizeMedium,
    fontSizeLarge: buttonFontSizeLarge
  });
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(errorStyle.wrapperStyle)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(imageErrorStyle.style)
  }, /*#__PURE__*/React.createElement(Image, _extends$1({}, image, {
    additionalStyle: imageErrorStyle,
    aspectRatio: aspectRatio,
    imageWidths: imageWidths$h,
    transparent: true
  }))), /*#__PURE__*/React.createElement(H1, {
    styles: semanticCSS(errorStyle.title)
  }, title), /*#__PURE__*/React.createElement(P, {
    styles: semanticCSS(errorStyle.secondaryTitle)
  }, secondaryTitle), /*#__PURE__*/React.createElement(P, {
    styles: semanticCSS(errorStyle.content)
  }, content), /*#__PURE__*/React.createElement("div", {
    className: css(errorStyle.buttonWrapper)
  }, /*#__PURE__*/React.createElement(Link, {
    href: button.href,
    className: css(errorStyle.button, boxShadowStyle.style)
  }, /*#__PURE__*/React.createElement(Span, {
    className: css(textStyle)
  }, button.text)))));
};

const createStyle$H = setMinHeight => StyleSheet.create({
  ad: {
    display: 'flex',
    justifyContent: 'center',
    [MEDIA_BREAKPOINTS.large]: {
      minHeight: setMinHeight ? '90px' : 'unset'
    },
    [MEDIA_BREAKPOINTS.medium]: {
      minHeight: 'unset'
    },
    [MEDIA_BREAKPOINTS.small]: {
      minHeight: 'unset'
    }
  }
});

const Placeholder = ({
  id,
  onSuccess,
  additionalStyle,
  dataId,
  setMinHeight = false
}) => {
  React.useEffect(() => {
    if (onSuccess) {
      try {
        onSuccess();
      } catch (e) {
        console.error(`ClientAPI Error in callback for injecting ad event for ad id: ${id}. Please check the callback value.`, e);
      }
    }
  }, [id, onSuccess]);
  const style = createStyle$H(setMinHeight);
  const idProp = id ? {
    id
  } : {};
  return /*#__PURE__*/React.createElement("div", _extends$1({}, idProp, {
    "data-mm-id": dataId,
    "data-target": "ad",
    className: additionalStyle ? css(style.ad, additionalStyle.style) : css(style.ad)
  }));
};

const Ad = /*#__PURE__*/React.memo(props => {
  const {
    id,
    onSuccess,
    additionalStyle,
    dataId,
    setMinHeight = false
  } = props;
  return id || setMinHeight ? /*#__PURE__*/React.createElement(Placeholder, {
    id: id,
    onSuccess: onSuccess,
    additionalStyle: additionalStyle,
    dataId: dataId,
    setMinHeight: setMinHeight
  }) : null;
});

function getIntersectionThresholds() {
  const thresholds = [];

  for (let i = 0; i <= 1.0; i += 0.01) {
    thresholds.push(i);
  }

  return thresholds;
}

const options = {
  root: null,
  threshold: getIntersectionThresholds()
};

function isIntersectionAtBottomOfElementBiggerThanViewPort(subscriptionThreshold, entry) {
  return subscriptionThreshold === 1 && entry.boundingClientRect.bottom === entry.intersectionRect.bottom;
}

function isIntersectingAboveThreshold(subscriptionThreshold, entry) {
  return subscriptionThreshold < entry.intersectionRatio;
}

const observerCallback = subscriptions => (e, observer) => {
  e.forEach(entry => {
    if (entry.isIntersecting) {
      const elementSubscriptions = subscriptions.get(entry.target) || [];
      elementSubscriptions.filter(sub => sub && (isIntersectingAboveThreshold(sub.threshold, entry) || isIntersectionAtBottomOfElementBiggerThanViewPort(sub.threshold, entry))).forEach(sub => {
        observer.unobserve(entry.target);
        sub.handler(entry.target);
        delete elementSubscriptions[elementSubscriptions.findIndex(item => item === sub)];
      });
    }
  });
};

const ViewabilityHandlerContext = React.createContext({});
const useViewabilityHandler = (handler, threshold) => {
  const ref = React.useRef(null);
  const context = React.useContext(ViewabilityHandlerContext);
  const {
    intersectionObserver,
    viewabilityHandlers
  } = context;
  React.useEffect(() => {
    if (!ref.current || !intersectionObserver || !viewabilityHandlers) return;
    const element = ref.current;
    const subscription = {
      handler,
      threshold
    };
    viewabilityHandlers.set(element, [...(viewabilityHandlers.get(element) || []), subscription]);
    element.classList.add('viewablity-block');
    intersectionObserver.observe(element);
  }, [handler, intersectionObserver, threshold, viewabilityHandlers]);
  return ref;
};
const ViewabilityProvider = ({
  children
}) => {
  const {
    intersectionObserver,
    viewabilityHandlers
  } = React.useContext(ViewabilityHandlerContext);
  const context = React.useMemo(() => {
    const newViewabilityHandlers = viewabilityHandlers || new WeakMap();
    return {
      viewabilityHandlers: newViewabilityHandlers,
      intersectionObserver: typeof IntersectionObserver !== 'undefined' && (intersectionObserver || new IntersectionObserver(observerCallback(newViewabilityHandlers), options)) || undefined
    };
  }, [intersectionObserver, viewabilityHandlers]);

  if (typeof intersectionObserver !== 'undefined' && typeof viewabilityHandlers !== 'undefined' || typeof IntersectionObserver === 'undefined') {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }

  return /*#__PURE__*/React.createElement(ViewabilityHandlerContext.Provider, {
    value: context
  }, children);
};

const ViewabilityConsumer = props => {
  const {
    children,
    viewabilityCallback,
    threshold = 0
  } = props;
  const ref = useViewabilityHandler(viewabilityCallback, threshold);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, children);
};

const ViewabilityElement = props => {
  return /*#__PURE__*/React.createElement(ViewabilityProvider, null, /*#__PURE__*/React.createElement(ViewabilityConsumer, props));
};

const Article = ({
  children,
  articleStyleClassName
}) => {
  const viewabilityCallback = React.useCallback(() => {
    // @ts-ignore
    window.mmClientApi = window.mmClientApi || []; // @ts-ignore

    window.mmClientApi.push('analytics', {
      event_category: 'Article',
      event_action: 'article end',
      event_label: ''
    });
  }, []);
  const ref = useViewabilityHandler(viewabilityCallback, 1);
  return /*#__PURE__*/React.createElement("article", {
    ref: ref,
    className: articleStyleClassName
  }, children);
};

const createStyle$G = () => StyleSheet.create({
  style: {
    margin: '0 auto',
    maxWidth: '100%',
    minWidth: '100%',
    [MEDIA_BREAKPOINTS.large]: {
      paddingLeft: '80px',
      maxWidth: 'calc(100% - 80px)',
      minWidth: 'calc(100% - 80px)'
    }
  }
});

const PostMainContent = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(ViewabilityProvider, null, /*#__PURE__*/React.createElement(Article, {
    articleStyleClassName: css(createStyle$G().style)
  }, children));
};

const componentConfigurationKey$h = 'postMainContent';

const createStyle$F = backgroundColor => StyleSheet.create({
  style: {
    backgroundColor,
    margin: '0 auto',
    maxWidth: '100%',
    minWidth: '100%'
  }
});

const FullWidthPostMainContent = ({
  children
}) => {
  const {
    backgroundColor
  } = useTheme(componentConfigurationKey$h);
  return /*#__PURE__*/React.createElement(ViewabilityProvider, null, /*#__PURE__*/React.createElement(Article, {
    articleStyleClassName: css(createStyle$F(backgroundColor).style)
  }, children));
};

const createStyle$E = (baseUnit, disableDefaultWrapperPadding) => {
  return StyleSheet.create({
    sidebar: {
      gridRowEnd: 'span 2',
      [MEDIA_BREAKPOINTS.large]: {
        gridRowEnd: 'span 2',
        padding: disableDefaultWrapperPadding ? 'auto' : `${baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'none'
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'none'
      }
    }
  });
};

const createAdditionalStyleForStickyAd = (headerHeights, baseUnit) => {
  return StyleSheet.create({
    style: {
      position: 'sticky',
      paddingTop: `${baseUnit}px`,
      [MEDIA_BREAKPOINTS.large]: {
        top: headerHeights.large * baseUnit
      },
      [MEDIA_BREAKPOINTS.medium]: {
        top: headerHeights.medium * baseUnit
      },
      [MEDIA_BREAKPOINTS.small]: {
        top: headerHeights.small * baseUnit
      }
    }
  });
};

const PostAside = props => {
  const {
    adId1,
    adId2,
    adOnSuccess1,
    adOnSuccess2,
    disableDefaultWrapperPadding = false
  } = props;
  const {
    baseUnit
  } = useTheme();
  const style = createStyle$E(baseUnit, disableDefaultWrapperPadding);
  const headerHeights = useHeaderHeights();
  return /*#__PURE__*/React.createElement("aside", {
    className: css(style.sidebar)
  }, /*#__PURE__*/React.createElement(Ad, {
    id: adId1,
    onSuccess: adOnSuccess1
  }), /*#__PURE__*/React.createElement(Ad, {
    id: adId2,
    onSuccess: adOnSuccess2,
    additionalStyle: createAdditionalStyleForStickyAd(headerHeights, baseUnit)
  }));
};

const getStyles$H = baseUnit => {
  return StyleSheet.create({
    wrapper: {
      display: 'grid',
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: '660px 300px',
        gridColumnGap: `${baseUnit * 4}px`,
        paddingLeft: `${baseUnit * 4}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'block',
        paddingLeft: '90px',
        paddingRight: '20px'
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'block',
        padding: 0
      }
    }
  });
};

const PostContentWithAside = props => {
  const {
    adId1,
    adId2,
    children,
    adOnSuccess2,
    adOnSuccess1
  } = props;
  const {
    baseUnit
  } = useTheme();
  const styles = getStyles$H(baseUnit);
  return /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapper)
  }, /*#__PURE__*/React.createElement("main", null, children), /*#__PURE__*/React.createElement(PostAside, {
    adId1: adId1,
    adId2: adId2,
    adOnSuccess1: adOnSuccess1,
    adOnSuccess2: adOnSuccess2
  }));
};

const createStyle$D = () => StyleSheet.create({
  style: {
    overflow: 'hidden',
    maxWidth: '1440px',
    [MEDIA_BREAKPOINTS.large]: {
      width: '100%'
    },
    [MEDIA_BREAKPOINTS.medium]: {
      width: '100%'
    },
    [MEDIA_BREAKPOINTS.small]: {
      width: 'unset'
    }
  }
});

const PostWithoutSidebarMainContent = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(ViewabilityProvider, null, /*#__PURE__*/React.createElement(Article, {
    articleStyleClassName: css(createStyle$D().style)
  }, children));
};

const componentConfigurationKey$g = 'postMainContent';

const createEmbedPostStyle = backgroundColor => StyleSheet.create({
  style: {
    backgroundColor,
    overflow: 'hidden',
    maxWidth: '100%',
    minWidth: '100%'
  }
});

const EmbedPostMainContent = ({
  children
}) => {
  const {
    backgroundColor
  } = useTheme(componentConfigurationKey$g);
  return /*#__PURE__*/React.createElement(ViewabilityProvider, null, /*#__PURE__*/React.createElement(Article, {
    articleStyleClassName: css(createEmbedPostStyle(backgroundColor).style)
  }, children));
};

const getStyle$o = () => {
  return StyleSheet.create({
    wrapper: {
      maxWidth: `${LARGE_SCREEN_SIZE}px`,
      margin: 'auto',
      display: 'grid',
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: '2fr 1fr'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        width: '75%',
        gridTemplateColumns: '1fr'
      },
      [MEDIA_BREAKPOINTS.small]: {
        width: '100%',
        gridTemplateColumns: '1fr'
      }
    }
  });
};

const ContentAndSidebar = props => {
  const {
    children
  } = props;
  const style = getStyle$o();
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(style.wrapper)
  }, children));
};

const horizontalGap = 2;

const getStyle$n = (maxWidth, mediumWidth = 800) => {
  return StyleSheet.create({
    wrapper: {
      maxWidth: `${maxWidth}px`,
      margin: 'auto',
      display: 'grid',
      gridRowGap: `${horizontalGap * baseUnit}px`,
      [MEDIA_BREAKPOINTS.medium]: {
        maxWidth: `${mediumWidth}px`,
        width: '100%'
      },
      [MEDIA_BREAKPOINTS.small]: {
        width: '100%'
      }
    }
  });
};

const ContentWithoutSidebar = props => {
  const {
    children,
    maxWidth,
    mediumWidth
  } = props;
  const style = getStyle$n(maxWidth, mediumWidth);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(style.wrapper)
  }, children));
};

const getStyle$m = color => StyleSheet.create({
  author: {
    color
  }
});

const Author$1 = props => {
  const {
    name,
    link,
    color,
    prefix = ''
  } = props;
  const style = getStyle$m(color);

  if (link) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, prefix, /*#__PURE__*/React.createElement(Link, {
      href: link,
      className: css(style.author)
    }, name));
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, `${prefix}${name}`);
};

const getPrefix = index => {
  return index > 0 ? ', ' : '';
};

const AuthorsList = props => {
  const {
    authors,
    by,
    color
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, `${by} `, authors && authors.map((author, index) => /*#__PURE__*/React.createElement(Author$1, _extends$1({
    key: index
  }, author, {
    color: color,
    prefix: getPrefix(index)
  }))));
};

const componentConfigurationKey$f = 'articleTitle';

const createStyle$C = ({
  titleColor,
  metaDataColor,
  baseUnit
}) => StyleSheet.create({
  wrapper: {
    position: 'relative'
  },
  title: {
    color: titleColor,
    marginTop: `${baseUnit}px`,
    marginBottom: `${baseUnit * 0.5}px`
  },
  metaData: {
    color: metaDataColor
  },
  sidesPadding: {
    marginTop: `${baseUnit * 0.5}px`,
    marginLeft: 0,
    marginRight: 0,
    [MEDIA_BREAKPOINTS.small]: {
      marginLeft: `${baseUnit}px`,
      marginRight: `${baseUnit}px`
    }
  }
});

const shouldDisplayAuthors$1 = authors => {
  return authors && authors.length > 0;
};

const ArticleTitle = props => {
  const {
    title,
    by,
    updatedText,
    updatedAt,
    updatedAtISO,
    showUpdatedAt,
    createdAt,
    createdAtISO,
    children,
    authors
  } = props;
  const themeProps = useTheme(componentConfigurationKey$f);
  const {
    metaDataColor,
    showTimestamp
  } = themeProps;
  const style = createStyle$C(themeProps);
  const hasAuthors = shouldDisplayAuthors$1(authors);
  const separator = hasAuthors ? ' | ' : '';
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(H1, {
    styles: semanticCSS(style.title, style.sidesPadding)
  }, title), /*#__PURE__*/React.createElement("div", {
    className: css(style.wrapper)
  }, /*#__PURE__*/React.createElement(H4, {
    styles: semanticCSS(style.metaData, style.sidesPadding)
  }, hasAuthors && /*#__PURE__*/React.createElement(AuthorsList, {
    by: by,
    authors: authors,
    color: metaDataColor
  }), showTimestamp ? /*#__PURE__*/React.createElement("time", {
    dateTime: createdAtISO
  }, `${separator}${createdAt}`) : null, showTimestamp && showUpdatedAt ? /*#__PURE__*/React.createElement("time", {
    dateTime: updatedAtISO
  }, ` | ${updatedText} ${updatedAt}`) : null), children));
};

const componentConfigurationKey$e = 'ampArticleTitleWrapper';
const AMPArticleTitleWrapper = props => {
  const {
    title,
    by,
    updatedText,
    updatedAt,
    updatedAtDate,
    updatedAtISO,
    showUpdatedAt,
    createdAt,
    createdAtDate,
    createdAtISO,
    children,
    authors
  } = props;
  const themeProps = useTheme(componentConfigurationKey$e);
  const {
    showOnlyDate
  } = themeProps;
  const createdAtTimestamp = showOnlyDate ? createdAtDate : createdAt;
  const updatedAtTimestamp = showOnlyDate ? updatedAtDate : updatedAt;
  return /*#__PURE__*/React.createElement(ArticleTitle, {
    title: title,
    by: by,
    updatedText: updatedText,
    createdAt: createdAtTimestamp,
    createdAtISO: createdAtISO,
    updatedAt: updatedAtTimestamp,
    updatedAtISO: updatedAtISO,
    showUpdatedAt: showUpdatedAt,
    authors: authors
  }, children);
};

const componentConfigurationKey$d = 'articleTitleWithoutMetaData';

const createStyle$B = ({
  titleColor,
  baseUnit,
  horizontalPaddingFactorLarge,
  horizontalPaddingFactorMedium,
  horizontalPaddingFactorSmall
}) => StyleSheet.create({
  wrapper: {
    position: 'relative'
  },
  title: {
    color: titleColor,
    marginTop: `${baseUnit}px`,
    marginBottom: `${baseUnit * 0.5}px`,
    [MEDIA_BREAKPOINTS.small]: {
      padding: `0 ${baseUnit * horizontalPaddingFactorSmall}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      padding: `0 ${baseUnit * horizontalPaddingFactorMedium}px`
    },
    [MEDIA_BREAKPOINTS.large]: {
      padding: `0 ${baseUnit * horizontalPaddingFactorLarge}px`
    }
  },
  sidesPadding: {
    marginTop: `${baseUnit * 0.5}px`,
    marginLeft: 0,
    marginRight: 0,
    [MEDIA_BREAKPOINTS.small]: {
      marginLeft: `${baseUnit}px`,
      marginRight: `${baseUnit}px`
    }
  }
});

const ArticleTitleWithoutMetaData = props => {
  const {
    title
  } = props;
  const themeProps = useTheme(componentConfigurationKey$d);
  const style = createStyle$B(themeProps);
  const {
    fontSizeLarge,
    fontSizeMedium,
    fontSizeSmall
  } = themeProps;
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(H1, {
    fontSizeLarge: fontSizeLarge,
    fontSizeMedium: fontSizeMedium,
    fontSizeSmall: fontSizeSmall,
    styles: semanticCSS(style.title, style.sidesPadding)
  }, title));
};

const REGULAR_IMAGE_SIZE_TYPE = 'regular';
const FULL_BLEED_IMAGE_SIZE_TYPE = 'fullBleed';

const createStyle$A = backgroundColor => StyleSheet.create({
  style: {
    backgroundColor
  }
});

const StyleForMontiElement = () => {
  return (
    /*#__PURE__*/

    /* eslint-disable-next-line react/no-danger */
    React.createElement("style", {
      dangerouslySetInnerHTML: {
        __html: `
  .monti-placeholder-mm-article-player {
    margin: 0px;
  }
`
      }
    })
  );
};

const Jw = props => {
  const {
    html,
    additionalStyle,
    siteName,
    templateName,
    videoId,
    dataId
  } = props;
  const {
    placeholderBackgroundColor
  } = useTheme(componentConfigurationKey$o);
  const JwComponentStyle = createStyle$A(placeholderBackgroundColor);
  const figureRef = React.useRef();
  React.useEffect(() => {
    const initMonti = () => {
      if (figureRef.current !== null && figureRef.current.firstElementChild) {
        const jwHtmlRef = figureRef.current.firstElementChild; // @ts-ignore TS2339

        window.monti().initiate({
          config_name: `Editor Embedded player in ${siteName}`,
          uniq_key: 'mm-article-player',
          publisher_contribution: siteName,
          content_id: videoId,
          content_type: 'curated',
          player_pos: jwHtmlRef,
          category_name: templateName,
          monetization: {
            vpaid_mode: 'ENABLED',
            strategy: 'on_player_load',
            ad_type: 'auto_dynamic_tag',
            ad_request_timeout: '10000',
            ad_break_slots: {
              on: [0]
            }
          },
          brand_color: '#EEEEEE',
          playback_method: 'none',
          powered_by_strip: false
        });
      }
    }; // @ts-ignore TS2339


    if (typeof window.monti !== 'undefined') {
      initMonti();
    } else {
      window.addEventListener('mplayerPlayerLoaded', initMonti);
    }
  }, [figureRef, siteName, templateName, videoId]);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: true,
    defer: true,
    src: "https://www.oo-syringe.com/prod/players/mplayer_wrapper_v3_latest.js"
  })), /*#__PURE__*/React.createElement("figure", {
    ref: figureRef,
    "data-mm-id": dataId,
    className: css(JwComponentStyle.style, additionalStyle.style),
    dangerouslySetInnerHTML: {
      __html: html
    }
  }), /*#__PURE__*/React.createElement(StyleForMontiElement, null));
};

const createIframeWrapperStyle$1 = backgroundColor => StyleSheet.create({
  style: {
    backgroundColor,
    paddingTop: `calc(100% / (${16 / 9}))`,
    position: 'relative'
  }
});

const createIframeStyle = () => StyleSheet.create({
  style: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
  }
});

const parseIframeHtml$1 = html => {
  const iframeStyle = createIframeStyle();
  return html.replace(/<iframe/, `<iframe class="${css(iframeStyle.style)}"`);
};

const Iframe = props => {
  const {
    html,
    additionalStyle,
    dataId
  } = props;
  const {
    placeholderBackgroundColor
  } = useTheme(componentConfigurationKey$o);
  const iframeWrapperStyle = createIframeWrapperStyle$1(placeholderBackgroundColor);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(additionalStyle.style),
    "data-mm-id": dataId
  }, /*#__PURE__*/React.createElement("figure", {
    className: css(iframeWrapperStyle.style),
    dangerouslySetInnerHTML: {
      __html: parseIframeHtml$1(html)
    }
  })));
};

const createMMPlayerWrapperStyle = backgroundColor => StyleSheet.create({
  style: {
    backgroundColor,
    paddingTop: `calc(100% / (${16 / 9}))`,
    position: 'relative',
    margin: 0
  }
});

const createMMPlayerStyle = () => StyleSheet.create({
  style: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
  }
});

const MMPlayer = props => {
  const {
    html,
    additionalStyle,
    dataId
  } = props;
  const {
    placeholderBackgroundColor
  } = useTheme(componentConfigurationKey$o);
  const MMPlayerWrapperStyle = createMMPlayerWrapperStyle(placeholderBackgroundColor);
  const MMPlayerStyle = createMMPlayerStyle();
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    defer: true,
    src: "https://vms-players.minutemediaservices.com/mplayer_embed_mount.js"
  })), /*#__PURE__*/React.createElement("figure", {
    "data-mm-id": dataId,
    className: css(additionalStyle.style)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(MMPlayerWrapperStyle.style)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(MMPlayerStyle.style),
    dangerouslySetInnerHTML: {
      __html: html
    }
  }))));
};

const getStyles$G = color => StyleSheet.create({
  svg: {
    fill: color,
    [MEDIA_BREAKPOINTS.large]: {
      height: '15px'
    },
    [MEDIA_BREAKPOINTS.medium]: {
      height: '15px'
    },
    [MEDIA_BREAKPOINTS.small]: {
      height: '10px'
    }
  }
});

const CameraIcon = ({
  color
}) => {
  const styles = getStyles$G(color);
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 26",
    className: css(styles.svg)
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "15",
    r: "5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.09,4.33H23.27L20.36,0H11.64L8.73,4.33H2.91A2.9,2.9,0,0,0,0,7.22V23.11A2.9,2.9,0,0,0,2.91,26H29.09A2.9,2.9,0,0,0,32,23.11V7.22A2.9,2.9,0,0,0,29.09,4.33ZM16,22a7,7,0,1,1,7-7A7,7,0,0,1,16,22Z"
  }))));
};

const createBlockStyle$1 = (defaultBlocksWidths, paddingOverride = {
  largePadding: 1,
  mediumPadding: 1,
  smallPadding: 1
}) => {
  const {
    largeWidth,
    mediumWidth,
    smallWidth
  } = defaultBlocksWidths;
  const {
    largePadding,
    mediumPadding,
    smallPadding
  } = paddingOverride;
  return {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '100%',
    boxSizing: 'border-box',
    [MEDIA_BREAKPOINTS.large]: {
      width: `${largeWidth}px`,
      paddingRight: `${baseUnit * largePadding}px`,
      paddingLeft: `${baseUnit * largePadding}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      width: `${mediumWidth}px`,
      paddingRight: `${baseUnit * mediumPadding}px`,
      paddingLeft: `${baseUnit * mediumPadding}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      width: `${smallWidth}px`,
      paddingRight: `${baseUnit * smallPadding}px`,
      paddingLeft: `${baseUnit * smallPadding}px`
    }
  };
};

const getStyles$F = (textColor, borderColor, baseUnit, defaultBlocksWidths, captionPaddingFactor, showIcon) => {
  return StyleSheet.create({
    wrapper: {
      display: 'flex',
      alignItems: 'center',
      borderBottom: `1px solid ${borderColor}`,
      marginBottom: `${baseUnit}px`,
      [MEDIA_BREAKPOINTS.large]: {
        paddingTop: `${baseUnit}px`,
        paddingBottom: `${baseUnit}px`,
        margin: showIcon ? 'auto' : 'unset',
        width: showIcon ? `min(${defaultBlocksWidths.largeWidth - 2 * captionPaddingFactor * baseUnit}px, 100%)` : '100%'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        paddingTop: `${baseUnit}px`,
        paddingBottom: `${baseUnit / 2}px`,
        margin: showIcon ? `0 ${baseUnit}px` : 'unset'
      },
      [MEDIA_BREAKPOINTS.small]: {
        paddingTop: `${baseUnit}px`,
        paddingBottom: `${baseUnit / 2}px`,
        margin: showIcon ? `0 ${baseUnit}px` : 'unset'
      }
    },
    text: {
      color: textColor,
      [MEDIA_BREAKPOINTS.large]: {
        marginLeft: `${baseUnit / 2}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        marginLeft: `${baseUnit / 2}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        marginLeft: `${baseUnit / 4}px`
      }
    }
  });
};

const createFullBleedStyle$1 = style => {
  return StyleSheet.create({
    style: { ...style
    }
  }).style;
};

const getContainerStyle$1 = (style, defaultBlocksWidths, overrideBlockWidths, blocksPaddingOverride) => {
  const blockStyle = overrideBlockWidths ? createBlockStyle$1(overrideBlockWidths, blocksPaddingOverride) : createBlockStyle$1(defaultBlocksWidths, blocksPaddingOverride);
  return StyleSheet.create({
    style: { ...style,
      ...blockStyle
    }
  }).style;
};

const getCaption = (caption, credit) => {
  const hasCaption = typeof caption === 'string';
  const hasCredit = typeof credit === 'string';
  const separator = hasCaption && hasCredit ? ' / ' : '';
  return `${hasCaption ? caption : ''}${separator}${hasCredit ? credit : ''}`;
};

const ImageWithCaptionAndIcon = props => {
  const {
    image,
    lazyLoad,
    style,
    dataId,
    defaultBlocksWidths,
    overrideBlockWidths,
    sizeType,
    blocksPaddingOverride,
    imageWidths
  } = props;
  const {
    caption,
    credit
  } = image;
  const creditHTML = useTransformCreditHTML(credit);
  const {
    iconColor,
    textColor,
    borderBottomColor,
    fontSizeLarge,
    fontSizeMedium,
    fontSizeSmall,
    baseUnit,
    fontSizesStyles,
    captionPaddingFactor,
    showIcon
  } = useTheme(componentConfigurationKey$k);
  const styles = getStyles$F(textColor, borderBottomColor, baseUnit, defaultBlocksWidths, captionPaddingFactor, showIcon);
  const figcaptionText = getStyleBySize(fontSizesStyles, {
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge
  });
  const hasCaptionOrCredit = typeof caption === 'string' || typeof credit === 'string';
  const additionalStyle = sizeType === FULL_BLEED_IMAGE_SIZE_TYPE ? createFullBleedStyle$1(style) : getContainerStyle$1(style, defaultBlocksWidths, overrideBlockWidths, blocksPaddingOverride);
  return /*#__PURE__*/React.createElement("div", {
    className: css(additionalStyle)
  }, /*#__PURE__*/React.createElement(Image, _extends$1({
    imageWidths: imageWidths
  }, image, {
    lazyLoad: lazyLoad,
    dataId: dataId
  })), hasCaptionOrCredit && /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapper)
  }, showIcon ? /*#__PURE__*/React.createElement(CameraIcon, {
    color: iconColor
  }) : null, /*#__PURE__*/React.createElement("figcaption", {
    className: css(figcaptionText, styles.text),
    dangerouslySetInnerHTML: {
      __html: getCaption(caption, creditHTML)
    }
  })));
};

const getMainImageStyle$1 = () => {
  return {
    marginTop: `${baseUnit}px`,
    marginBottom: `${baseUnit * 0.25}px`
  };
};

const createBlockStyleForImageCover = (defaultBlocksWidths, paddingOverride = {
  largePadding: 1,
  mediumPadding: 1,
  smallPadding: 1
}) => {
  const {
    largeWidth,
    mediumWidth,
    smallWidth
  } = defaultBlocksWidths;
  const {
    largePadding,
    mediumPadding,
    smallPadding
  } = paddingOverride;
  return {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '100%',
    boxSizing: 'border-box',
    [MEDIA_BREAKPOINTS.large]: {
      width: `${largeWidth}px`,
      marginRight: `${baseUnit * largePadding}px`,
      marginLeft: `${baseUnit * largePadding}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      width: `${mediumWidth}px`,
      marginRight: `${baseUnit * mediumPadding}px`,
      marginLeft: `${baseUnit * mediumPadding}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      width: `${smallWidth}px`,
      marginRight: `${baseUnit * smallPadding}px`,
      marginLeft: `${baseUnit * smallPadding}px`
    }
  };
};

const getCoverStyles = (defaultBlocksWidths, paddingOverride = {
  largePadding: 1,
  mediumPadding: 1,
  smallPadding: 1
}) => {
  const {
    largePadding,
    mediumPadding,
    smallPadding
  } = paddingOverride;
  return StyleSheet.create({
    wrapper: {
      position: 'relative',
      ...createBlockStyleForImageCover(defaultBlocksWidths),
      [MEDIA_BREAKPOINTS.large]: {
        marginRight: `${baseUnit * largePadding}px`,
        marginLeft: `${baseUnit * largePadding}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        marginRight: `${baseUnit * mediumPadding}px`,
        marginLeft: `${baseUnit * mediumPadding}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        marginRight: `${baseUnit * smallPadding}px`,
        marginLeft: `${baseUnit * smallPadding}px`
      }
    }
  });
};

const getBlockStyle$6 = () => {
  return StyleSheet.create({
    style: {
      position: 'absolute',
      top: '0',
      left: '0',
      width: '100%',
      margin: 0
    }
  });
};

const imageWidths$g = createImageWidths(360, 720, 1080);

const createImageAdditionalStyle$2 = style => {
  return StyleSheet.create({
    style: { ...style
    }
  });
};

const getMainImage = (image, credit, caption, style, defaultBlocksWidths) => {
  const additionalStyle = createImageAdditionalStyle$2(style);
  const hasCreditOrCaption = typeof credit === 'string' || typeof caption === 'string';
  return hasCreditOrCaption ? /*#__PURE__*/React.createElement(ImageWithCaptionAndIcon, {
    image: image,
    style: style,
    imageWidths: imageWidths$g,
    defaultBlocksWidths: defaultBlocksWidths,
    sizeType: REGULAR_IMAGE_SIZE_TYPE
  }) : /*#__PURE__*/React.createElement(Image, _extends$1({}, image, {
    additionalStyle: additionalStyle,
    imageWidths: imageWidths$g
  }));
};

const getMedia$2 = (media, siteName, templateName) => {
  const additionalStyle = getBlockStyle$6();
  const {
    type
  } = media;

  switch (type) {
    case 'jw':
      {
        const {
          html,
          videoId
        } = media;
        return /*#__PURE__*/React.createElement(Jw, {
          html: html,
          additionalStyle: additionalStyle,
          videoId: videoId,
          siteName: siteName,
          templateName: templateName
        });
      }

    case 'youtube':
      {
        const {
          html
        } = media;
        return /*#__PURE__*/React.createElement(Iframe, {
          html: html,
          additionalStyle: additionalStyle
        });
      }

    case 'mmPlayer':
      {
        const {
          html
        } = media;
        return /*#__PURE__*/React.createElement(MMPlayer, {
          html: html,
          additionalStyle: additionalStyle
        });
      }

    default:
      return null;
  }
};

const ArticleMainImage = ({
  image,
  media,
  siteName,
  templateName,
  defaultBlocksWidths,
  paddingOverride
}) => {
  const mainImageStyle = getMainImageStyle$1();
  const {
    credit,
    caption
  } = image;
  const coverStyles = getCoverStyles(defaultBlocksWidths, paddingOverride);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(coverStyles.wrapper)
  }, getMainImage(image, credit, caption, mainImageStyle, defaultBlocksWidths), media && getMedia$2(media, siteName, templateName)));
};

const getStyle$l = (textColor, linkColor) => {
  return element => {
    switch (element) {
      case 'a':
        return StyleSheet.create({
          style: {
            color: linkColor,
            textDecoration: 'none'
          }
        }).style;

      case 'ol':
      case 'ul':
        return StyleSheet.create({
          style: {
            listStylePosition: 'inside',
            padding: 0,
            color: textColor
          }
        }).style;

      case 'p':
      case 'h2':
      case 'h3':
        return StyleSheet.create({
          style: {
            color: textColor
          }
        }).style;

      default:
        return null;
    }
  };
};

const getAllTypographyStyles = (fontSizesStyles, h2FontSizes, h3FontSizes) => {
  const typographyStyleP = getStyleBySize(fontSizesStyles, getFontSizesBySemanticTag('p'));
  const typographyStyleH2 = getStyleBySize(fontSizesStyles, h2FontSizes);
  const typographyStyleH3 = getStyleBySize(fontSizesStyles, h3FontSizes);
  return {
    p: typographyStyleP,
    h2: typographyStyleH2,
    h3: typographyStyleH3
  };
};

const getTypographyStyleForLinkByWrapperElement = (wrapper, typographyStyles) => {
  switch (wrapper) {
    case 'h2':
      return typographyStyles.h2;

    case 'h3':
      return typographyStyles.h3;

    default:
      return typographyStyles.p;
  }
};

const applyCssClasses = (html, paragraphTextColor, paragraphLinkColor, fontSizesStyles, h2FontSizes, h3FontSizes, wrapper) => {
  const style = getStyle$l(paragraphTextColor, paragraphLinkColor);
  const typographyStyles = getAllTypographyStyles(fontSizesStyles, h2FontSizes, h3FontSizes);
  return html.replace(/<p/g, `<p class="${css(typographyStyles.p)}"`).replace(/<h2/g, `<h2 class="${css(typographyStyles.h2)}"`).replace(/<h3/g, `<h3 class="${css(typographyStyles.h3)}"`).replace(/<ol/g, `<ol class="${css(typographyStyles.p, style('ol'))}"`).replace(/<ul/g, `<ul class="${css(typographyStyles.p, style('ul'))}"`).replace(/<a/g, `<a class="${css(getTypographyStyleForLinkByWrapperElement(wrapper, typographyStyles), style('a'))}"`);
};

const extractWrapper = html => {
  const regex = /^<(\w+).*?>/;
  const match = html.match(regex);

  if (!match) {
    return ['p', html];
  }

  const indexOfLastElement = html.lastIndexOf('<');
  return [match[1], html.substr(0, indexOfLastElement).replace(match[0], '')];
};

const getBlockStyle$5 = defaultBlocksWidths => {
  return StyleSheet.create({
    style: {
      overflowWrap: 'break-word',
      ...createBlockStyle$1(defaultBlocksWidths)
    }
  }).style;
};

const getWrapperAsElement = (wrapper, content, style, additionalStyle, dataId, fontSizesStyles, h2FontSizes, h3FontSizes, defaultBlocksWidths) => {
  const typographyStyles = getAllTypographyStyles(fontSizesStyles, h2FontSizes, h3FontSizes);
  const wrapperTypographyStyle = getTypographyStyleForLinkByWrapperElement(wrapper, typographyStyles);
  const marginStyle = getBlockStyle$5(defaultBlocksWidths);
  return /*#__PURE__*/React.createElement(wrapper, {
    dangerouslySetInnerHTML: {
      __html: content
    },
    className: css(wrapperTypographyStyle, style, additionalStyle.style, marginStyle),
    'data-mm-id': dataId
  });
};

const Paragraph = props => {
  const {
    html,
    additionalStyle,
    dataId,
    defaultBlocksWidths
  } = props;
  const {
    paragraphTextColor,
    paragraphLinkColor,
    fontSizesStyles,
    h2FontSizeLarge,
    h2FontSizeMedium,
    h2FontSizeSmall,
    h3FontSizeLarge,
    h3FontSizeMedium,
    h3FontSizeSmall
  } = useTheme(componentConfigurationKey$o);
  const h2FontSizes = {
    fontSizeSmall: h2FontSizeSmall,
    fontSizeMedium: h2FontSizeMedium,
    fontSizeLarge: h2FontSizeLarge
  };
  const h3FontSizes = {
    fontSizeSmall: h3FontSizeSmall,
    fontSizeMedium: h3FontSizeMedium,
    fontSizeLarge: h3FontSizeLarge
  };
  const [wrapper, content] = extractWrapper(html);
  const wrapperStyle = getStyle$l(paragraphTextColor, paragraphLinkColor)(wrapper);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, getWrapperAsElement(wrapper, applyCssClasses(content, paragraphTextColor, paragraphLinkColor, fontSizesStyles, h2FontSizes, h3FontSizes, wrapper), wrapperStyle, additionalStyle, dataId, fontSizesStyles, h2FontSizes, h3FontSizes, defaultBlocksWidths));
};

const PlaybuzzScript = "(function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0];if(d.getElementById(id))return;js=d.createElement(s);js.id=id;js.src='https://embed.playbuzz.com/sdk.js';fjs.parentNode.insertBefore(js,fjs);}(document,'script','playbuzz-sdk'));";

const getBlockStyle$4 = (defaultBlocksWidths, placeholderBackgroundColor) => {
  return StyleSheet.create({
    style: { ...createBlockStyle$1(defaultBlocksWidths),
      backgroundColor: placeholderBackgroundColor
    }
  }).style;
};

const PlaybuzzComponent = props => {
  const {
    html,
    additionalStyle,
    dataId,
    defaultBlocksWidths
  } = props;
  const {
    placeholderBackgroundColor
  } = useTheme(componentConfigurationKey$o);
  const style = getBlockStyle$4(defaultBlocksWidths, placeholderBackgroundColor);
  React.useEffect(() => {
    // @ts-ignore TS2339
    if (typeof window.Playbuzz !== 'undefined') {
      // @ts-ignore TS2339
      window.Playbuzz.render();
    }
  }, []);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", null, PlaybuzzScript)), /*#__PURE__*/React.createElement("figure", {
    "data-mm-id": dataId,
    dangerouslySetInnerHTML: {
      __html: html
    },
    className: css(additionalStyle.style, style)
  }));
};
const Playbuzz = props => /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(PlaybuzzComponent, props));

const createStyle$z = (style, defaultBlocksWidths) => {
  return StyleSheet.create({
    style: { ...style,
      ...createBlockStyle$1(defaultBlocksWidths)
    }
  });
};

const Streamable = props => {
  const {
    placeholderBackgroundColor
  } = useTheme(componentConfigurationKey$o);
  const {
    style,
    defaultBlocksWidths
  } = props;
  const additionalStyle = createStyle$z(style, defaultBlocksWidths);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Iframe, _extends$1({
    backgroundColor: placeholderBackgroundColor
  }, props, {
    additionalStyle: additionalStyle
  })));
};

const getBlockStyle$3 = defaultBlocksWidths => {
  return StyleSheet.create({
    style: { ...createBlockStyle$1(defaultBlocksWidths),
      display: 'flex',
      justifyContent: 'center'
    }
  }).style;
};

const TwitterScript = `window.twttr = (function(d, s, id) {
  var js, fjs = d.getElementsByTagName(s)[0],
    t = window.twttr || {};
  if (d.getElementById(id)) return t;
  js = d.createElement(s);
  js.id = id;
  js.src = "https://platform.twitter.com/widgets.js";
  fjs.parentNode.insertBefore(js, fjs);

  t._e = [];
  t.ready = function(f) {
    t._e.push(f);
  };

  return t;
}(document, "script", "twitter-wjs"));`;
const TwitterComponent = props => {
  const {
    html,
    additionalStyle,
    dataId,
    defaultBlocksWidths
  } = props;
  const twitterStyle = getBlockStyle$3(defaultBlocksWidths);
  React.useEffect(() => {
    // @ts-ignore TS2339
    if (typeof window.twttr !== 'undefined' && typeof window.twttr.widgets !== 'undefined') {
      // @ts-ignore TS2339
      window.twttr.widgets.load();
    }
  }, []);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", null, TwitterScript)), /*#__PURE__*/React.createElement("figure", {
    "data-mm-id": dataId,
    dangerouslySetInnerHTML: {
      __html: html
    },
    className: css(twitterStyle, additionalStyle.style)
  }));
};
const Twitter = props => /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(TwitterComponent, props));

const getStyle$k = (width, height, defaultBlocksWidths) => {
  return StyleSheet.create({
    wrapper: { ...createBlockStyle$1(defaultBlocksWidths)
    },
    figure: {
      position: 'relative',
      overflow: 'hidden',
      margin: 0,
      boxSizing: 'border-box',
      flex: '1 1 100%',
      minWidth: '0%',
      paddingTop: `calc(100% / (${width / height}))`
    },
    image: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%'
    }
  });
};

const GiphyComponent = props => {
  const {
    additionalStyle,
    url,
    width,
    height,
    description,
    dataId,
    defaultBlocksWidths
  } = props;
  const style = getStyle$k(width, height, defaultBlocksWidths);
  return /*#__PURE__*/React.createElement("div", {
    "data-mm-id": dataId,
    className: css(additionalStyle.style, style.wrapper)
  }, /*#__PURE__*/React.createElement("figure", {
    className: css(style.figure)
  }, /*#__PURE__*/React.createElement("img", {
    src: url,
    className: css(style.image),
    alt: description
  })));
};
const Giphy = props => /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(GiphyComponent, props));

const getBlockStyle$2 = defaultBlocksWidths => {
  return StyleSheet.create({
    style: { ...createBlockStyle$1(defaultBlocksWidths)
    }
  }).style;
};

const InstagramComponent = props => {
  const {
    html,
    additionalStyle,
    dataId,
    defaultBlocksWidths
  } = props;
  const instagramStyle = getBlockStyle$2(defaultBlocksWidths);
  React.useEffect(() => {
    // @ts-ignore TS2339
    if (typeof window.instgrm !== 'undefined') {
      // @ts-ignore TS2339
      window.instgrm.Embeds.process();
    }
  }, []);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: true,
    src: "https://www.instagram.com/embed.js"
  })), /*#__PURE__*/React.createElement("figure", {
    "data-mm-id": dataId,
    dangerouslySetInnerHTML: {
      __html: html
    },
    className: css(instagramStyle, additionalStyle.style)
  }));
};
const Instagram = props => /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(InstagramComponent, props));

const createStyle$y = defaultBlocksWidths => {
  return StyleSheet.create({
    style: { ...createBlockStyle$1(defaultBlocksWidths),
      display: 'flex',
      justifyContent: 'center'
    }
  });
};

const removeDataWidthFromHtml = html => html.replace(/data-width="\d+"/, 'data-width=""');
const facebookVersion = 'v3.3';
const FacebookComponent = props => {
  const {
    html,
    additionalStyle,
    dataId,
    defaultBlocksWidths
  } = props;
  const facebookStyle = createStyle$y(defaultBlocksWidths);
  React.useEffect(() => {
    // @ts-ignore TS2339
    if (typeof window.FB !== 'undefined') {
      // @ts-ignore TS2339
      // eslint-disable-next-line no-undef
      FB.init({
        xfbml: true,
        version: facebookVersion
      });
    }
  }, []);
  const htmlWithFluidWidth = removeDataWidthFromHtml(html);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: true,
    defer: true,
    src: `https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=${facebookVersion}`
  })), /*#__PURE__*/React.createElement("figure", {
    "data-mm-id": dataId,
    dangerouslySetInnerHTML: {
      __html: htmlWithFluidWidth
    },
    className: css(facebookStyle.style, additionalStyle.style)
  }));
};
const Facebook = props => /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(FacebookComponent, props));

const getStyle$j = (numberColor, titleColor, blockStyle) => {
  return StyleSheet.create({
    numberStyle: {
      color: numberColor
    },
    titleStyle: {
      color: titleColor,
      ...blockStyle
    }
  });
};

const ListItemTitle = props => {
  const {
    listItemNumber,
    text,
    additionalStyle,
    dataId,
    defaultBlocksWidths
  } = props;
  const {
    listTitleColor,
    listNumberColor,
    fontSizesStyles,
    listTitleFontSizeLarge,
    listTitleFontSizeMedium,
    listTitleFontSizeSmall
  } = useTheme(componentConfigurationKey$o);
  const blockStyle = createBlockStyle$1(defaultBlocksWidths);
  const {
    numberStyle,
    titleStyle
  } = getStyle$j(listTitleColor, listNumberColor, blockStyle);
  const contentStyle = getStyleBySize(fontSizesStyles, {
    fontSizeSmall: listTitleFontSizeSmall,
    fontSizeMedium: listTitleFontSizeMedium,
    fontSizeLarge: listTitleFontSizeLarge
  });
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(H2, {
    fontSizeLarge: listTitleFontSizeLarge,
    fontSizeMedium: listTitleFontSizeMedium,
    fontSizeSmall: listTitleFontSizeSmall,
    "data-mm-id": dataId,
    styles: semanticCSS(additionalStyle.style, titleStyle)
  }, /*#__PURE__*/React.createElement(Span, {
    styles: semanticCSS(numberStyle, contentStyle)
  }, `${listItemNumber}. `), text));
};

const emitInjectArticleBlockByIndexEvent = dataId => {
  setEventEmitter(injectArticleBlockByIndexEvent, callback => callback(dataId));
};

const getBlockDataId = block => {
  return block.getAttribute('data-id');
};

const sendViewabilityEvent = element => {
  const id = getBlockDataId(element);
  setEventEmitter(viewabilityArticleBlockEvent, callback => callback({
    id
  }));
};

const getStyle$i = defaultBlocksWidths => {
  return StyleSheet.create({
    style: { ...createBlockStyle$1(defaultBlocksWidths)
    }
  }).style;
};

const InjectedBlock = props => {
  const {
    html,
    additionalStyle,
    dataId,
    script,
    defaultBlocksWidths
  } = props;
  const style = getStyle$i(defaultBlocksWidths);
  React.useEffect(() => {
    emitInjectArticleBlockByIndexEvent(dataId);
  }, [dataId]);
  const ref = useViewabilityHandler(sendViewabilityEvent, 0.5);
  return /*#__PURE__*/React.createElement(ViewabilityProvider, null, /*#__PURE__*/React.createElement(ErrorBoundary, null, script ? /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", null, script)) : null, /*#__PURE__*/React.createElement("figure", {
    ref: ref,
    "data-mm-id": dataId,
    dangerouslySetInnerHTML: {
      __html: html
    },
    className: css(additionalStyle.style, style)
  })));
};

const createIframeEmbedWrapperStyle = (placeholderBackgroundColor, height, defaultBlocksWidths) => {
  return StyleSheet.create({
    style: { ...createBlockStyle$1(defaultBlocksWidths),
      backgroundColor: placeholderBackgroundColor,
      paddingTop: `${height}px`,
      position: 'relative'
    }
  });
};

const createIframeEmbedStyle = () => StyleSheet.create({
  style: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
  }
});

const parseIframeHtml = html => {
  const iframeStyle = createIframeEmbedStyle();
  return html.replace(/<iframe/, `<iframe class="${css(iframeStyle.style)}"`);
};

const IframeEmbed = props => {
  const {
    html,
    dataId,
    height,
    additionalStyle,
    defaultBlocksWidths
  } = props;
  const {
    placeholderBackgroundColor
  } = useTheme(componentConfigurationKey$o);
  const iframeWrapperStyle = createIframeEmbedWrapperStyle(placeholderBackgroundColor, height, defaultBlocksWidths);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("figure", {
    "data-mm-id": dataId,
    className: css(iframeWrapperStyle.style, additionalStyle.style),
    dangerouslySetInnerHTML: {
      __html: parseIframeHtml(html)
    }
  }));
};

const createIframeWrapperStyle = (placeholderBackgroundColor, defaultBlocksWidths) => {
  return StyleSheet.create({
    figure: {
      backgroundColor: placeholderBackgroundColor
    },
    wrapper: { ...createBlockStyle$1(defaultBlocksWidths)
    }
  });
};

const Gfycat = props => {
  const {
    html,
    additionalStyle,
    dataId,
    defaultBlocksWidths
  } = props;
  const {
    placeholderBackgroundColor
  } = useTheme(componentConfigurationKey$o);
  const style = createIframeWrapperStyle(placeholderBackgroundColor, defaultBlocksWidths);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(additionalStyle.style, style.wrapper)
  }, /*#__PURE__*/React.createElement("figure", {
    "data-mm-id": dataId,
    className: css(style.figure),
    dangerouslySetInnerHTML: {
      __html: html
    }
  })));
};

const getStyle$h = defaultBlocksWidths => {
  return StyleSheet.create({
    style: { ...createBlockStyle$1(defaultBlocksWidths)
    }
  }).style;
};

const Apester = props => {
  const {
    html,
    additionalStyle,
    dataId,
    defaultBlocksWidths
  } = props;
  const style = getStyle$h(defaultBlocksWidths);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: true,
    defer: true,
    src: "https://static.apester.com/js/sdk/latest/apester-sdk.js"
  })), /*#__PURE__*/React.createElement("div", {
    className: css(additionalStyle.style, style)
  }, /*#__PURE__*/React.createElement("figure", {
    "data-mm-id": dataId,
    dangerouslySetInnerHTML: {
      __html: html
    }
  })));
};

const getStyle$g = defaultBlocksWidths => {
  return StyleSheet.create({
    style: { ...createBlockStyle$1(defaultBlocksWidths)
    }
  }).style;
};

const Ceros = props => {
  const {
    html,
    additionalStyle,
    dataId,
    defaultBlocksWidths
  } = props;
  const style = getStyle$g(defaultBlocksWidths);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: true,
    defer: true,
    src: "https://static.apester.com/js/sdk/latest/apester-sdk.js"
  })), /*#__PURE__*/React.createElement("div", {
    className: css(additionalStyle.style, style)
  }, /*#__PURE__*/React.createElement("figure", {
    "data-mm-id": dataId,
    dangerouslySetInnerHTML: {
      __html: html
    }
  })));
};

const getStyle$f = defaultBlocksWidths => {
  return StyleSheet.create({
    style: { ...createBlockStyle$1(defaultBlocksWidths)
    }
  });
};

const ArticleAd = props => {
  const {
    defaultBlocksWidths
  } = props;
  const additionalStyle = getStyle$f(defaultBlocksWidths);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Ad, _extends$1({}, props, {
    additionalStyle: additionalStyle,
    onSuccess: null
  })));
};

const createStyle$x = (style, defaultBlocksWidths) => {
  return StyleSheet.create({
    style: { ...style,
      ...createBlockStyle$1(defaultBlocksWidths)
    }
  });
};

const ArticleIframe = props => {
  const {
    style,
    defaultBlocksWidths
  } = props;
  const additionalStyle = createStyle$x(style, defaultBlocksWidths);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Iframe, _extends$1({}, props, {
    additionalStyle: additionalStyle
  })));
};

const createStyle$w = (defaultBlocksWidths, style, backgroundColor) => {
  return StyleSheet.create({
    style: { ...style,
      ...createBlockStyle$1(defaultBlocksWidths),
      backgroundColor
    }
  });
};

const ArticleJw = props => {
  const {
    style,
    defaultBlocksWidths
  } = props;
  const {
    placeholderBackgroundColor
  } = useTheme(componentConfigurationKey$o);
  const additionalStyle = createStyle$w(defaultBlocksWidths, style, placeholderBackgroundColor);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Jw, _extends$1({}, props, {
    additionalStyle: additionalStyle
  })));
};

const createStyle$v = (defaultBlocksWidths, style) => {
  return StyleSheet.create({
    style: { ...style,
      ...createBlockStyle$1(defaultBlocksWidths)
    }
  });
};

const ArticleMMPlayer = props => {
  const {
    style,
    defaultBlocksWidths
  } = props;
  const additionalStyle = createStyle$v(defaultBlocksWidths, style);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(MMPlayer, _extends$1({}, props, {
    additionalStyle: additionalStyle
  })));
};

const componentConfigThemeKey$E = 'relatedPosts';

const createWrapperStyle$4 = (defaultBlocksWidths, backgroundColor, marginBetweenBlocksFactor) => StyleSheet.create({
  style: {
    backgroundColor,
    marginTop: `${marginBetweenBlocksFactor * baseUnit * 2}px`,
    marginBottom: `${marginBetweenBlocksFactor * baseUnit * 2}px`,
    ...createBlockStyle$1(defaultBlocksWidths)
  }
}).style;

const RelatedPostsWrapper = props => {
  const viewabilityCallback = React__default.useCallback(() => {
    // @ts-ignore
    window.mmClientApi = window.mmClientApi || []; // @ts-ignore

    window.mmClientApi.push('analytics', {
      event_category: 'Article',
      event_action: 'related posts viewable impression',
      event_label: ''
    });
  }, []);
  const ref = useViewabilityHandler(viewabilityCallback, 0.5);
  const {
    defaultBlocksWidths,
    marginBetweenBlocksFactor,
    children,
    dataId
  } = props;
  const {
    backgroundColor
  } = useTheme(componentConfigThemeKey$E);
  const wrapperStyle = createWrapperStyle$4(defaultBlocksWidths, backgroundColor, marginBetweenBlocksFactor);
  return /*#__PURE__*/React__default.createElement("aside", {
    ref: ref,
    className: css(wrapperStyle),
    "data-mm-id": dataId
  }, children);
};

const componentConfigThemeKey$D = 'relatedPosts';

const createWrapperStyle$3 = (backgroundColor, largeHorizontalGap, mediumHorizontalGap, smallHorizontalGap) => StyleSheet.create({
  style: {
    backgroundColor,
    display: 'grid',
    [MEDIA_BREAKPOINTS.large]: {
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto 1fr 1fr 1fr 1fr',
      gridRowGap: `${largeHorizontalGap * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto 1fr 1fr 1fr 1fr',
      gridRowGap: `${mediumHorizontalGap * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto 1fr 1fr 1fr 1fr',
      gridRowGap: `${smallHorizontalGap * baseUnit}px`
    }
  }
}).style;

const imageWidths$f = createImageWidths(180, 360, 540);

const getAnalyticsEventParams$1 = cardNumber => ({
  category: 'Article',
  action: 'related posts clicked',
  label: `link=[${cardNumber}]`
});

const RelatedPostsWithCard = Card => {
  const RelatedPostsComponent = props => {
    const relatedPostsAnalytics = cardNumber => {
      const analyticsEventParams = getAnalyticsEventParams$1(cardNumber);

      const sendClickAnalytics = () => {
        window.mmClientApi = window.mmClientApi || [];
        window.mmClientApi.push('analytics', {
          event_category: analyticsEventParams.category,
          event_action: analyticsEventParams.action,
          event_label: analyticsEventParams.label
        });
      };

      return sendClickAnalytics;
    };

    const {
      title,
      articles,
      marginBetweenBlocksFactor,
      defaultBlocksWidths,
      dataId
    } = props;
    const {
      titleColor,
      titleFontSizeLarge,
      titleFontSizeMedium,
      titleFontSizeSmall,
      backgroundColor,
      largeHorizontalGap,
      mediumHorizontalGap,
      smallHorizontalGap,
      articleTitleFontSizeLarge,
      articleTitleFontSizeMedium,
      articleTitleFontSizeSmall,
      cardProportionsLarge,
      cardProportionsMedium,
      cardProportionsSmall,
      descriptionFontSizeLarge,
      descriptionFontSizeMedium,
      descriptionFontSizeSmall,
      metadataFontSizeLarge,
      metadataFontSizeMedium,
      metadataFontSizeSmall,
      mainCategoryFontSizeLarge,
      mainCategoryFontSizeMedium,
      mainCategoryFontSizeSmall,
      cardBorderColorTypeActive,
      cardBorderColorTypeHover,
      cardBorderColorTypeNormal,
      cardBorderWidthTypeActive,
      cardBorderWidthTypeHover,
      cardBorderWidthTypeNormal,
      cardBoxShadowTypeActive,
      cardBoxShadowTypeHover,
      cardBoxShadowTypeNormal,
      cardHorizontalGapLarge,
      cardHorizontalGapMedium,
      cardHorizontalGapSmall,
      cardTitleColorTypeActive,
      cardTitleColorTypeHover,
      cardTitleColorTypeNormal,
      pipeColor
    } = useTheme(componentConfigThemeKey$D);
    const themeContextHC = useThemeOverride({
      cardBackgroundColor: backgroundColor,
      titleFontSizeLarge: articleTitleFontSizeLarge,
      titleFontSizeMedium: articleTitleFontSizeMedium,
      titleFontSizeSmall: articleTitleFontSizeSmall,
      borderColorTypeActive: cardBorderColorTypeActive,
      borderColorTypeHover: cardBorderColorTypeHover,
      borderColorTypeNormal: cardBorderColorTypeNormal,
      borderWidthTypeActive: cardBorderWidthTypeActive,
      borderWidthTypeHover: cardBorderWidthTypeHover,
      borderWidthTypeNormal: cardBorderWidthTypeNormal,
      boxShadowTypeActive: cardBoxShadowTypeActive,
      boxShadowTypeHover: cardBoxShadowTypeHover,
      boxShadowTypeNormal: cardBoxShadowTypeNormal,
      horizontalGapLarge: cardHorizontalGapLarge,
      horizontalGapMedium: cardHorizontalGapMedium,
      horizontalGapSmall: cardHorizontalGapSmall,
      cardTitleColorTypeActive,
      cardTitleColorTypeHover,
      cardTitleColorTypeNormal,
      metadataFontSizeLarge,
      metadataFontSizeMedium,
      metadataFontSizeSmall,
      descriptionFontSizeLarge,
      descriptionFontSizeMedium,
      descriptionFontSizeSmall,
      cardProportionsLarge,
      cardProportionsMedium,
      cardProportionsSmall,
      mainCategoryFontSizeLarge,
      mainCategoryFontSizeMedium,
      mainCategoryFontSizeSmall,
      pipeColor
    }, componentConfigThemeKey$K);
    const themeContextSectionHeader = useThemeOverride({
      titleColor,
      titleBackgroundColor: backgroundColor,
      largeMarginBottomFactor: 0,
      mediumMarginBottomFactor: 0,
      smallMarginBottomFactor: 0,
      largeHorizontalGap: 0.5,
      mediumHorizontalGap: 0.5,
      smallHorizontalGap: 0.5,
      largeWrapperGap: 0,
      mediumWrapperGap: 0,
      smallWrapperGap: 0
    }, componentConfigurationKey$q);
    const wrapperStyle = createWrapperStyle$3(backgroundColor, largeHorizontalGap, mediumHorizontalGap, smallHorizontalGap);
    const article1Props = articles[0] || {};
    const article2Props = articles[1] || {};
    const article3Props = articles[2] || {};
    const article4Props = articles[3] || {};
    const analyticsEventParamsForArticle1 = getAnalyticsEventParams$1(0);
    const analyticsEventParamsForArticle2 = getAnalyticsEventParams$1(1);
    const analyticsEventParamsForArticle3 = getAnalyticsEventParams$1(2);
    const analyticsEventParamsForArticle4 = getAnalyticsEventParams$1(3);
    return /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement(RelatedPostsWrapper, {
      defaultBlocksWidths: defaultBlocksWidths,
      marginBetweenBlocksFactor: marginBetweenBlocksFactor,
      dataId: dataId
    }, /*#__PURE__*/React__default.createElement("div", {
      className: css(wrapperStyle)
    }, /*#__PURE__*/React__default.createElement(ThemeContext.Provider, {
      value: themeContextSectionHeader
    }, /*#__PURE__*/React__default.createElement(SectionHeader, {
      moreButtonSvg: null,
      moreButtonText: null,
      paddingFactors: {
        large: 0,
        medium: 0,
        small: 0
      }
    }, /*#__PURE__*/React__default.createElement(H3, {
      fontSizeLarge: titleFontSizeLarge,
      fontSizeSmall: titleFontSizeSmall,
      fontSizeMedium: titleFontSizeMedium
    }, title))), /*#__PURE__*/React__default.createElement(ThemeContext.Provider, {
      value: themeContextHC
    }, /*#__PURE__*/React__default.createElement(Card, _extends$1({}, article1Props, {
      imageWidths: imageWidths$f,
      onClick: relatedPostsAnalytics(0),
      ampAnalyticsLabel: analyticsEventParamsForArticle1.label,
      ampAnalyticsCategory: analyticsEventParamsForArticle1.category,
      ampAnalyticsAction: analyticsEventParamsForArticle1.action
    })), /*#__PURE__*/React__default.createElement(Card, _extends$1({}, article2Props, {
      imageWidths: imageWidths$f,
      onClick: relatedPostsAnalytics(1),
      ampAnalyticsLabel: analyticsEventParamsForArticle2.label,
      ampAnalyticsCategory: analyticsEventParamsForArticle2.category,
      ampAnalyticsAction: analyticsEventParamsForArticle2.action
    })), /*#__PURE__*/React__default.createElement(Card, _extends$1({}, article3Props, {
      imageWidths: imageWidths$f,
      onClick: relatedPostsAnalytics(2),
      ampAnalyticsLabel: analyticsEventParamsForArticle3.label,
      ampAnalyticsCategory: analyticsEventParamsForArticle3.category,
      ampAnalyticsAction: analyticsEventParamsForArticle3.action
    })), /*#__PURE__*/React__default.createElement(Card, _extends$1({}, article4Props, {
      imageWidths: imageWidths$f,
      onClick: relatedPostsAnalytics(3),
      ampAnalyticsLabel: analyticsEventParamsForArticle4.label,
      ampAnalyticsCategory: analyticsEventParamsForArticle4.category,
      ampAnalyticsAction: analyticsEventParamsForArticle4.action
    }))))));
  };

  return RelatedPostsComponent;
};

const RelatedPosts = props => {
  const RelatedPostsComponent = RelatedPostsWithCard(HorizontalCard);
  return /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement(RelatedPostsComponent, props));
};

const getStyle$e = defaultBlocksWidths => {
  return StyleSheet.create({
    style: { ...createBlockStyle$1(defaultBlocksWidths)
    }
  }).style;
};

const ContentEnrichment = props => {
  const {
    html,
    additionalStyle,
    dataId,
    defaultBlocksWidths
  } = props;
  const style = getStyle$e(defaultBlocksWidths);
  React.useEffect(() => {
    // @ts-ignore TS2339
    // eslint-disable-next-line no-underscore-dangle
    if (typeof window.__mm_content_enrichment__ !== 'undefined') {
      // @ts-ignore TS2339
      // eslint-disable-next-line no-underscore-dangle
      window.__mm_content_enrichment__.renderEmbeds();
    }
  }, []);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: true,
    src: "https://assets.minutemediacdn.com/content-enrichment/embeds.js"
  })), /*#__PURE__*/React.createElement("div", {
    className: css(additionalStyle.style, style)
  }, /*#__PURE__*/React.createElement("figure", {
    "data-mm-id": dataId,
    dangerouslySetInnerHTML: {
      __html: html
    }
  })));
};

const getStyles$E = baseUnit => {
  return StyleSheet.create({
    wrapper: {
      display: 'flex',
      justifyContent: 'center',
      margin: 'auto',
      [MEDIA_BREAKPOINTS.large]: {
        marginTop: `${baseUnit * 4}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        marginTop: `${baseUnit * 2}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        marginTop: `${baseUnit}px`
      }
    }
  });
};

const getLinkStyle$3 = (baseUnit, buttonDisabledBackgroundColor, buttonBackgroundColor, buttonDisabledTextColor, buttonTextColor, isDisabled) => {
  return StyleSheet.create({
    style: {
      padding: `${baseUnit / 2}px ${baseUnit * 4}px`,
      textAlign: 'center',
      backgroundColor: isDisabled ? buttonDisabledBackgroundColor : buttonBackgroundColor,
      color: isDisabled ? buttonDisabledTextColor : buttonTextColor
    }
  });
};

const SlideshowBottomBar = ({
  nextText,
  isDisabled,
  onClick
}) => {
  const {
    baseUnit,
    slideshowButtonBackgroundColor,
    slideshowButtonDisabledBackgroundColor,
    slideshowButtonTextColor,
    slideshowButtonDisabledTextColor
  } = useTheme(componentConfigurationKey$o);
  const styles = getStyles$E(baseUnit);
  const additionalStyle = getLinkStyle$3(baseUnit, slideshowButtonDisabledBackgroundColor, slideshowButtonBackgroundColor, slideshowButtonDisabledTextColor, slideshowButtonTextColor, isDisabled);
  return /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapper)
  }, /*#__PURE__*/React.createElement(Button, {
    additionalStyle: additionalStyle,
    disabled: isDisabled,
    onClick: onClick,
    label: nextText
  }));
};

const getStyles$D = (baseUnit, slideNumberTextColor, dividerColor, blockStyle) => {
  return StyleSheet.create({
    wrapper: { ...blockStyle,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: `${baseUnit}px auto 0 auto`,
      position: 'relative'
    },
    divider: {
      height: '1px',
      backgroundColor: dividerColor,
      width: '100%',
      margin: `0 ${baseUnit / 2}px`
    },
    currentSlide: {
      whiteSpace: 'nowrap',
      color: slideNumberTextColor
    },
    anchor: {
      position: 'absolute',
      top: '-25px'
    }
  });
};

const getLinkStyle$2 = (baseUnit, shouldShow, backgroundColor, disabledBackgroundColor, textColor, disabledTextColor) => {
  return StyleSheet.create({
    style: {
      padding: `${baseUnit / 2}px ${baseUnit}px`,
      backgroundColor: shouldShow ? backgroundColor : disabledBackgroundColor,
      color: shouldShow ? textColor : disabledTextColor
    }
  });
};

const SlideshowTopBar = ({
  currentSlide,
  totalSlides,
  prevText,
  nextText,
  ofText,
  blockWidths,
  overrideBlockPadding,
  onClickNext,
  onClickPrev,
  anchorId
}) => {
  const themeProps = useTheme(componentConfigurationKey$o);
  const {
    baseUnit,
    slideshowButtonBackgroundColor,
    slideshowButtonDisabledBackgroundColor,
    slideshowButtonTextColor,
    slideshowButtonDisabledTextColor,
    slideshowNumberColor,
    slideshowDividerColor
  } = themeProps;
  const showPrev = currentSlide > 0;
  const showNext = currentSlide + 1 !== totalSlides;
  const blockStyle = createBlockStyle$1(blockWidths, overrideBlockPadding);
  const styles = getStyles$D(baseUnit, slideshowNumberColor, slideshowDividerColor, blockStyle);
  const prevStyle = getLinkStyle$2(baseUnit, showPrev, slideshowButtonBackgroundColor, slideshowButtonDisabledBackgroundColor, slideshowButtonTextColor, slideshowButtonDisabledTextColor);
  const nextStyle = getLinkStyle$2(baseUnit, showNext, slideshowButtonBackgroundColor, slideshowButtonDisabledBackgroundColor, slideshowButtonTextColor, slideshowButtonDisabledTextColor);
  return /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(styles.anchor),
    id: anchorId
  }), /*#__PURE__*/React.createElement(Button, {
    additionalStyle: prevStyle,
    disabled: !showPrev,
    onClick: onClickPrev,
    label: prevText
  }), /*#__PURE__*/React.createElement("div", {
    className: css(styles.divider)
  }), currentSlide !== null && /*#__PURE__*/React.createElement(Span, {
    styles: semanticCSS(styles.currentSlide)
  }, `${currentSlide + 1} ${ofText} ${totalSlides}`), /*#__PURE__*/React.createElement("div", {
    className: css(styles.divider)
  }), /*#__PURE__*/React.createElement(Button, {
    additionalStyle: nextStyle,
    disabled: !showNext,
    onClick: onClickNext,
    label: nextText
  }));
};

const SlideshowContext = React.createContext(null);
const Slideshow = props => {
  const {
    nextText,
    totalSlides,
    currentSlide,
    anchorId,
    children,
    ofText,
    prevText,
    blockWidths,
    overrideBlockPadding
  } = props;
  const [slideNumber, setSlideNumber] = React.useState(currentSlide);

  const onClickNext = () => setSlideNumber(slide => slide + 1);

  const onClickPrev = () => setSlideNumber(slide => slide - 1);

  const onClickBottomNext = () => {
    onClickNext();

    if (window) {
      window.location.href = `#${anchorId}`;
    }
  };

  if (totalSlides === 0) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }

  return /*#__PURE__*/React.createElement(SlideshowContext.Provider, {
    value: slideNumber
  }, /*#__PURE__*/React.createElement(SlideshowTopBar, {
    totalSlides: totalSlides,
    nextText: nextText,
    ofText: ofText,
    prevText: prevText,
    blockWidths: blockWidths,
    overrideBlockPadding: overrideBlockPadding,
    onClickNext: onClickNext,
    onClickPrev: onClickPrev,
    currentSlide: slideNumber,
    anchorId: anchorId
  }), children, /*#__PURE__*/React.createElement(SlideshowBottomBar, {
    nextText: nextText,
    onClick: onClickBottomNext,
    isDisabled: slideNumber + 1 === totalSlides
  }));
};

const createFullBleedStyle = style => {
  return { ...style
  };
};

const createStyle$u = (style, defaultBlocksWidths, overrideBlockWidths, blocksPaddingOverride) => {
  const blockStyle = overrideBlockWidths ? createBlockStyle$1(overrideBlockWidths, blocksPaddingOverride) : createBlockStyle$1(defaultBlocksWidths, blocksPaddingOverride);
  return { ...style,
    ...blockStyle
  };
};

const createImageAdditionalStyle$1 = style => {
  return StyleSheet.create({
    style: { ...style
    }
  });
};

const ArticleImage = props => {
  const {
    style,
    image,
    dataId,
    defaultBlocksWidths,
    overrideBlockWidths,
    sizeType,
    blocksPaddingOverride,
    imageWidthSmall = 540,
    imageWidthMedium = 720,
    imageWidthLarge = 720
  } = props;
  const largeScreenImageWidth = sizeType === FULL_BLEED_IMAGE_SIZE_TYPE ? 1440 : imageWidthLarge;
  const imageWidths = createImageWidths(imageWidthSmall, imageWidthMedium, largeScreenImageWidth);
  const imageWithCaptionAndIconStyle = sizeType === FULL_BLEED_IMAGE_SIZE_TYPE ? createFullBleedStyle(style) : createStyle$u(style, defaultBlocksWidths, overrideBlockWidths, blocksPaddingOverride);
  const additionalStyle = createImageAdditionalStyle$1(imageWithCaptionAndIconStyle);
  const hasCreditOrCaption = typeof image.credit === 'string' || typeof image.caption === 'string';
  return hasCreditOrCaption ? /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(ImageWithCaptionAndIcon, {
    image: image,
    lazyLoad: true,
    style: imageWithCaptionAndIconStyle,
    dataId: dataId,
    imageWidths: imageWidths,
    sizeType: sizeType,
    defaultBlocksWidths: defaultBlocksWidths,
    overrideBlockWidths: overrideBlockWidths
  })) : /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Image, _extends$1({}, image, {
    lazyLoad: true,
    additionalStyle: additionalStyle,
    dataId: dataId,
    imageWidths: imageWidths
  })));
};

const getStyles$C = baseUnit => {
  return StyleSheet.create({
    icon: {
      margin: 'auto',
      display: 'block',
      [MEDIA_BREAKPOINTS.large]: {
        width: '24px',
        height: '24px',
        flex: `0 0 ${(24 + baseUnit / 4) * 2}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        width: '16px',
        height: '16px',
        flex: `0 0 ${(16 + baseUnit / 4) * 2}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        width: '16px',
        height: '16px',
        flex: `0 0 ${(16 + baseUnit / 4) * 2}px`
      }
    }
  });
};

const QuoteIcon = props => {
  const {
    iconColor,
    baseUnit
  } = props;
  const styles = getStyles$C(baseUnit);
  return /*#__PURE__*/React.createElement("svg", {
    className: css(styles.icon),
    viewBox: "0 0 16 16",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.0788,1 L16.00005,1 L16.00005,5.6195 C16.00005,8.41675 15.5258,10.498 14.5773,11.86525 C13.6283,13.2325 12.2058,14.27725 10.3088,15 L9.0498,12.313 C11.44405,11.52775 12.6413,9.90875 12.6413,7.458 L9.0788,7.458 L9.0788,1 Z M0.029,1 L6.95025,1 L6.95025,5.6195 C6.95025,8.41675 6.476,10.498 5.5275,11.86525 C4.5785,13.2325 3.156,14.27725 1.259,15 L-8.8817842e-15,12.313 C2.39425,11.52775 3.5915,9.90875 3.5915,7.458 L0.029,7.458 L0.029,1 Z",
    fill: iconColor,
    fillRule: "nonzero"
  })));
};

const createCiteStyle = fontSizesStyles => {
  const citeFontSize = fontSizesStyles[consts.TYPOGRAPHY_SIZE.BIG];
  const {
    style: {
      fontFamily,
      fontWeight
    },
    breakpoints: {
      large,
      medium,
      small
    }
  } = citeFontSize;
  const fontFamilyConverted = fontFamily;
  const fontWeightConverted = fontWeight;
  return {
    fontFamily: fontFamilyConverted,
    fontWeight: fontWeightConverted,
    [MEDIA_BREAKPOINTS.large]: { ...large
    },
    [MEDIA_BREAKPOINTS.medium]: { ...medium
    },
    [MEDIA_BREAKPOINTS.small]: { ...small
    }
  };
};

const getStyles$B = (baseUnit, textColor, citeColor, borderColor, alignment, quoteShowIconAndBorder, fontSizesStyles, defaultBlocksWidths) => {
  const citeFontsSizes = createCiteStyle(fontSizesStyles);
  return StyleSheet.create({
    wrapper: {
      position: 'relative',
      marginTop: `${baseUnit}px`,
      borderBottom: quoteShowIconAndBorder ? `1px solid ${borderColor}` : 'unset',
      ...createBlockStyle$1(defaultBlocksWidths)
    },
    text: {
      fontStyle: 'italic',
      textAlign: alignment === consts.ALIGNMENT_OPTIONS.CENTER ? 'center' : 'left',
      color: textColor,
      margin: `${baseUnit * 0.5}px 0px`
    },
    cite: {
      textAlign: alignment === consts.ALIGNMENT_OPTIONS.CENTER ? 'center' : 'left',
      color: citeColor,
      marginTop: `${baseUnit * 0.5}px`,
      display: 'block',
      width: 'auto',
      ...citeFontsSizes
    },
    quoteTop: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      alignItems: 'center',
      ':before': {
        content: '""',
        display: 'block',
        height: '1px',
        borderTop: `1px solid ${borderColor}`,
        flex: '2 0 0'
      },
      ':after': {
        content: '""',
        display: 'block',
        height: '1px',
        borderTop: `1px solid ${borderColor}`,
        flex: '2 0 0'
      }
    }
  });
};

const Quote = props => {
  const {
    text,
    additionalStyle,
    dataId,
    defaultBlocksWidths,
    cite
  } = props;
  const {
    quoteTextColor,
    quoteCiteColor,
    quoteFontSizeLarge,
    quoteFontSizeMedium,
    quoteFontSizeSmall,
    quoteShowCite,
    quoteShowApostrophes,
    quoteAlignment,
    quoteIconColor,
    quoteBorderColor,
    quoteShowIconAndBorder,
    baseUnit,
    fontSizesStyles
  } = useTheme(componentConfigurationKey$o);
  const styles = getStyles$B(baseUnit, quoteTextColor, quoteCiteColor, quoteBorderColor, quoteAlignment, quoteShowIconAndBorder, fontSizesStyles, defaultBlocksWidths);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("blockquote", {
    "data-mm-id": dataId,
    className: css(styles.wrapper, additionalStyle.style)
  }, quoteShowIconAndBorder ? /*#__PURE__*/React.createElement("div", {
    className: css(styles.quoteTop)
  }, /*#__PURE__*/React.createElement(QuoteIcon, {
    iconColor: quoteIconColor,
    baseUnit: baseUnit
  })) : null, /*#__PURE__*/React.createElement(P, {
    styles: semanticCSS(styles.text),
    fontSizeLarge: quoteFontSizeLarge,
    fontSizeMedium: quoteFontSizeMedium,
    fontSizeSmall: quoteFontSizeSmall
  }, quoteShowApostrophes ? `"${text}"` : text), quoteShowCite && cite ? /*#__PURE__*/React.createElement("cite", {
    className: css(styles.cite)
  }, "-\xA0", cite) : null));
};

const getStyles$A = (baseUnit, lineColor, defaultBlocksWidths) => {
  return StyleSheet.create({
    wrapper: { ...createBlockStyle$1(defaultBlocksWidths),
      display: 'flex',
      alignItems: 'center'
    },
    line: {
      height: '1px',
      width: '100%',
      border: 0,
      margin: 0,
      backgroundColor: lineColor
    }
  });
};

const ArticleDividerWithIcon = props => {
  const {
    baseUnit,
    dividerLineColor,
    dividerShowIcon
  } = useTheme(componentConfigurationKey$o);
  const {
    defaultBlocksWidths,
    additionalStyle,
    iconComponent,
    dataId
  } = props;
  const styles = getStyles$A(baseUnit, dividerLineColor, defaultBlocksWidths);
  const IconComponent = iconComponent;
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapper, additionalStyle.style),
    "data-mm-id": dataId
  }, dividerShowIcon ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("hr", {
    className: css(styles.line)
  }), /*#__PURE__*/React.createElement(IconComponent, null), /*#__PURE__*/React.createElement("hr", {
    className: css(styles.line)
  })) : /*#__PURE__*/React.createElement("hr", {
    className: css(styles.line, additionalStyle.style)
  })));
};

/* eslint-disable */
const getQuoteSvg = color => `<?xml version="1.0" encoding="utf-8"?>
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 64 64" style="enable-background:new 0 0 64 64;" xml:space="preserve">
<path fill="${color}" d="M58.8,27c0-14.8-12-27-26.7-27C17.8,0,5.2,10.7,5.2,26.8c0,10.2,8.6,24.9,27,24.9c0,3.1-3.2,7.2-13.5,8.8l0.4,3.4
	C40.3,64,58.8,46.6,58.8,27z"/>
</svg>`;

const getStylesForQuoteIcon$1 = baseUnit => {
  return StyleSheet.create({
    quote: {
      margin: `0 ${baseUnit}px`,
      width: `${baseUnit * 1.5}px`
    }
  });
};
const QuoteIconForDivider = () => {
  const {
    baseUnit,
    dividerLogoColor
  } = useTheme(componentConfigurationKey$o);
  const styles = getStylesForQuoteIcon$1(baseUnit);
  const svg = getQuoteSvg(dividerLogoColor);
  const imgSrc = `data:image/svg+xml,${encodeURIComponent(svg)}`;
  return /*#__PURE__*/React.createElement("img", {
    className: css(styles.quote),
    src: imgSrc,
    alt: ""
  });
};

const createBlockStyle = (baseUnit, modifier) => {
  return {
    marginTop: `${baseUnit * modifier}px`
  };
};
const createBlockStyleSheet = (baseUnit, modifier) => StyleSheet.create({
  style: createBlockStyle(baseUnit, modifier)
});

const ConditionalImageLinkWrapper = props => {
  const {
    link,
    children,
    dataId
  } = props;
  const attributes = link ? { ...(link.relAttributeValue ? {
      rel: link.relAttributeValue
    } : {}),
    ...(link.targetAttributeValue ? {
      target: link.targetAttributeValue
    } : {}),
    'data-mm-id': dataId
  } : {};
  return link ? /*#__PURE__*/React__default.createElement(Link, _extends$1({
    href: link.linkURL
  }, attributes), children) : /*#__PURE__*/React__default.createElement("div", {
    "data-mm-id": dataId
  }, children);
};

const videoRatio = {
  x: 16,
  y: 9
};

const getDefaultBlocksWidthsStyle$1 = defaultBlocksWidths => {
  return StyleSheet.create({
    style: { ...createBlockStyle$1(defaultBlocksWidths)
    }
  }).style;
};

const createWrapperStyle$2 = () => StyleSheet.create({
  style: {
    backgroundColor: 'transparent',
    position: 'relative',
    overflow: 'hidden',
    boxSizing: 'border-box',
    minWidth: '0%',
    [MEDIA_BREAKPOINTS.large]: {
      paddingTop: `calc(100% / (${videoRatio.x / videoRatio.y}))`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      paddingTop: `calc(100% / (${videoRatio.x / videoRatio.y}))`
    },
    [MEDIA_BREAKPOINTS.small]: {
      paddingTop: `calc(100% / (${videoRatio.x / videoRatio.y}))`
    }
  }
}).style;

const createPlaceholderStyle = () => StyleSheet.create({
  style: {
    position: 'absolute',
    top: '0',
    left: '0',
    bottom: '0',
    minWidth: '100%',
    minHeight: '100%',
    maxWidth: '100%',
    maxHeight: '100%',
    marginTop: '-16px'
  }
}).style;

const createDisplayStyleByScreenSize = (smallAndMediumScreens, largeScreen) => StyleSheet.create({
  style: {
    [MEDIA_BREAKPOINTS.large]: {
      display: largeScreen ? 'block' : 'none'
    },
    [MEDIA_BREAKPOINTS.medium]: {
      display: smallAndMediumScreens ? 'block' : 'none'
    },
    [MEDIA_BREAKPOINTS.small]: {
      display: smallAndMediumScreens ? 'block' : 'none'
    }
  }
}).style;

const baseID = 'mm-player-placeholder';
const MMPlayerPlaceHolder = props => {
  const {
    smallAndMediumScreens = false,
    largeScreen = false,
    additionalStyle,
    defaultBlocksWidths
  } = props;
  const wrapperStyle = createWrapperStyle$2();
  const placeholderStyle = createPlaceholderStyle();
  const displayStyle = createDisplayStyleByScreenSize(smallAndMediumScreens, largeScreen);
  const id = smallAndMediumScreens ? `${baseID}-smallAndMedium-screens` : `${baseID}-large-screen`;
  return !smallAndMediumScreens && !largeScreen || smallAndMediumScreens && largeScreen ? null : /*#__PURE__*/React__default.createElement("figure", {
    className: css(defaultBlocksWidths ? getDefaultBlocksWidthsStyle$1(defaultBlocksWidths) : null, displayStyle)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css(wrapperStyle, additionalStyle ? additionalStyle.style : null, displayStyle)
  }, /*#__PURE__*/React__default.createElement("div", {
    id: id,
    className: css(placeholderStyle, displayStyle)
  })));
};

const getStyle$d = defaultBlocksWidths => {
  return StyleSheet.create({
    style: { ...createBlockStyle$1(defaultBlocksWidths)
    }
  }).style;
};

const OpenwebLiveblog = props => {
  const {
    defaultBlocksWidths,
    additionalStyle
  } = props;
  return /*#__PURE__*/React__default.createElement("div", {
    className: css(additionalStyle.style, getStyle$d(defaultBlocksWidths)),
    id: "mm-poc-openweb-liveblog"
  });
};

const componentConfigThemeKey$C = 'relatedTopics';

const getStyles$z = isDisabled => {
  return StyleSheet.create({
    style: {
      display: 'inline-flex',
      pointerEvents: isDisabled ? 'none' : 'unset'
    }
  });
};

const LinkWithButtonStyle = ({
  children,
  disabled,
  secondary,
  ...props
}) => {
  const isDisabled = !!disabled;
  const isSecondary = !!secondary;
  const {
    buttonStyle,
    boxShadowStyle,
    textStyle
  } = useButtonTheme(isDisabled, isSecondary);
  const linkStyle = getStyles$z(isDisabled);
  const {
    additionalStyle,
    ...finalProps
  } = props;
  const regularClasses = [buttonStyle.button, linkStyle.style, boxShadowStyle.style, StyleSheet.create({
    style
  }).style, textStyle, additionalStyle && additionalStyle.style];
  const disabledClasses = [buttonStyle.button, linkStyle.style, StyleSheet.create({
    style
  }).style, textStyle, additionalStyle && additionalStyle.style];
  return /*#__PURE__*/React.createElement(Link, _extends$1({}, finalProps, {
    className: css(...(isDisabled ? disabledClasses : regularClasses))
  }), children);
};

const createWrapperStyle$1 = (defaultBlocksWidths, backgroundColor, marginBetweenBlocksFactor) => StyleSheet.create({
  style: {
    backgroundColor,
    marginTop: `${marginBetweenBlocksFactor * baseUnit * 2}px`,
    marginBottom: `${marginBetweenBlocksFactor * baseUnit * 2}px`,
    ...createBlockStyle$1(defaultBlocksWidths)
  }
}).style;

const RelatedTopicsWrapper = props => {
  const viewabilityCallback = React__default.useCallback(() => {
    // @ts-ignore
    window.mmClientApi = window.mmClientApi || []; // @ts-ignore

    window.mmClientApi.push('analytics', {
      event_category: 'Article',
      event_action: 'Related Topics view-ability',
      event_label: ''
    });
  }, []);
  const ref = useViewabilityHandler(viewabilityCallback, 0.5);
  const {
    defaultBlocksWidths,
    marginBetweenBlocksFactor,
    children,
    dataId
  } = props;
  const {
    titleBackgroundColor
  } = useTheme(componentConfigThemeKey$C);
  const wrapperStyle = createWrapperStyle$1(defaultBlocksWidths, titleBackgroundColor, marginBetweenBlocksFactor);
  return /*#__PURE__*/React__default.createElement("aside", {
    ref: ref,
    className: css(wrapperStyle),
    "data-mm-id": dataId
  }, children);
};

const getStyles$y = (rowGapSmall, rowGapMedium, rowGapLarge, columnGapSmall, columnGapMedium, columnGapLarge, largeHorizontalGap, mediumHorizontalGap, smallHorizontalGap) => {
  return StyleSheet.create({
    linksStyle: {
      display: 'flex',
      flexWrap: 'wrap',
      [MEDIA_BREAKPOINTS.large]: {
        gap: `${rowGapLarge * baseUnit}px ${columnGapLarge * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gap: `${rowGapMedium * baseUnit}px ${columnGapMedium * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gap: `${rowGapSmall * baseUnit}px ${columnGapSmall * baseUnit}px`
      }
    },
    wrapperStyle: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto',
      [MEDIA_BREAKPOINTS.large]: {
        gridRowGap: `${largeHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridRowGap: `${smallHorizontalGap * baseUnit}px`
      }
    }
  });
};

const linkSizes = StyleSheet.create({
  style: {
    padding: '7px 8px',
    minWidth: '60px',
    height: 'unset'
  }
});

const getAnalyticsEventParams = page => ({
  category: 'Article',
  action: 'Related Topics clicked',
  label: `${page.name}`
});

const RelatedTopics = props => {
  const {
    title,
    pages,
    defaultBlocksWidths,
    dataId,
    marginBetweenBlocksFactor
  } = props;

  const relatedTopicsAnalytics = page => {
    const analyticsEventParams = getAnalyticsEventParams(page);
    return () => {
      window.mmClientApi = window.mmClientApi || [];
      window.mmClientApi.push('analytics', {
        event_category: analyticsEventParams.category,
        event_action: analyticsEventParams.action,
        event_label: analyticsEventParams.label
      });
    };
  };

  const {
    titleColor,
    titleBackgroundColor,
    titleLargeMarginBottomFactor,
    titleMediumMarginBottomFactor,
    titleSmallMarginBottomFactor,
    titleLargeHorizontalGap,
    titleMediumHorizontalGap,
    titleSmallHorizontalGap,
    titleLargeWrapperGap,
    titleMediumWrapperGap,
    titleSmallWrapperGap,
    linkBackgroundColorNormal,
    linkBackgroundColorHover,
    linkBackgroundColorActive,
    linkTextColorNormal,
    linkTextColorHover,
    linkTextColorActive,
    linkBorderColorNormal,
    linkBorderColorHover,
    linkBorderColorActive,
    linkFontSizeLarge,
    linkFontSizeMedium,
    linkFontSizeSmall,
    linkBoxShadowTypeNormal,
    linkBoxShadowTypeHover,
    linkBoxShadowTypeActive,
    linkBorderRadius,
    linkBorderWidthNormal,
    linkBorderWidthHover,
    linkBorderWidthActive,
    titleFontSizeSmall,
    titleFontSizeMedium,
    titleFontSizeLarge,
    rowGapSmall,
    rowGapMedium,
    rowGapLarge,
    columnGapSmall,
    columnGapMedium,
    columnGapLarge,
    largeHorizontalGap,
    mediumHorizontalGap,
    smallHorizontalGap
  } = useTheme(componentConfigThemeKey$C);
  const themeContextSectionHeader = useThemeOverride({
    titleColor,
    titleBackgroundColor,
    largeMarginBottomFactor: titleLargeMarginBottomFactor,
    mediumMarginBottomFactor: titleMediumMarginBottomFactor,
    smallMarginBottomFactor: titleSmallMarginBottomFactor,
    largeHorizontalGap: titleLargeHorizontalGap,
    mediumHorizontalGap: titleMediumHorizontalGap,
    smallHorizontalGap: titleSmallHorizontalGap,
    largeWrapperGap: titleLargeWrapperGap,
    mediumWrapperGap: titleMediumWrapperGap,
    smallWrapperGap: titleSmallWrapperGap
  }, componentConfigurationKey$q);
  const themeContextLinkButton = useThemeOverride({
    backgroundColorNormal: linkBackgroundColorNormal,
    backgroundColorHover: linkBackgroundColorHover,
    backgroundColorActive: linkBackgroundColorActive,
    textColorNormal: linkTextColorNormal,
    textColorHover: linkTextColorHover,
    textColorActive: linkTextColorActive,
    borderColorNormal: linkBorderColorNormal,
    borderColorHover: linkBorderColorHover,
    borderColorActive: linkBorderColorActive,
    fontSizeLarge: linkFontSizeLarge,
    fontSizeMedium: linkFontSizeMedium,
    fontSizeSmall: linkFontSizeSmall,
    boxShadowTypeNormal: linkBoxShadowTypeNormal,
    boxShadowTypeHover: linkBoxShadowTypeHover,
    boxShadowTypeActive: linkBoxShadowTypeActive,
    borderRadius: linkBorderRadius,
    borderWidthNormal: linkBorderWidthNormal,
    borderWidthHover: linkBorderWidthHover,
    borderWidthActive: linkBorderWidthActive
  }, componentConfigThemeKey$H);
  const {
    wrapperStyle,
    linksStyle
  } = getStyles$y(rowGapSmall, rowGapMedium, rowGapLarge, columnGapSmall, columnGapMedium, columnGapLarge, largeHorizontalGap, mediumHorizontalGap, smallHorizontalGap);

  const createLinkWithButtonArray = () => {
    return pages.map(page => {
      return /*#__PURE__*/React__default.createElement(LinkWithButtonStyle, {
        href: page.link,
        key: page.link,
        onClick: relatedTopicsAnalytics(page),
        additionalStyle: linkSizes
      }, page.name);
    });
  };

  return /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement(RelatedTopicsWrapper, {
    defaultBlocksWidths: defaultBlocksWidths,
    marginBetweenBlocksFactor: marginBetweenBlocksFactor,
    dataId: dataId
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css(wrapperStyle)
  }, /*#__PURE__*/React__default.createElement(ThemeContext.Provider, {
    value: themeContextSectionHeader
  }, /*#__PURE__*/React__default.createElement(SectionHeader, {
    moreButtonText: null,
    moreButtonSvg: null,
    paddingFactors: {
      large: 0,
      medium: 0,
      small: 0
    }
  }, /*#__PURE__*/React__default.createElement(H3, {
    fontSizeLarge: titleFontSizeLarge,
    fontSizeSmall: titleFontSizeSmall,
    fontSizeMedium: titleFontSizeMedium
  }, title))), /*#__PURE__*/React__default.createElement("div", {
    className: css(linksStyle)
  }, /*#__PURE__*/React__default.createElement(ThemeContext.Provider, {
    value: themeContextLinkButton
  }, createLinkWithButtonArray())))));
};

const componentConfigurationKey$c = 'articleContent';

const getSlideBlocks = (body, currentSlideNumber) => {
  const pageBreakBlockIndexes = body.reduce((indexes, block, index) => {
    if (block.type === 'page-break') {
      return [...indexes, index];
    }

    return indexes;
  }, []);
  const indexOfFirstBlock = currentSlideNumber === 0 ? 0 : pageBreakBlockIndexes[currentSlideNumber - 1] + 1;
  const indexOfLastBlock = pageBreakBlockIndexes[currentSlideNumber];
  return body.slice(indexOfFirstBlock, indexOfLastBlock);
};

const createBlocksComponents$1 = (body, templateName, siteName, overrideBlockWidths, defaultBlocksWidths, themeProps, blocksPaddingOverride, slideNumber, imageWidthLarge, imageWidthMedium, imageWidthSmall) => {
  const {
    baseUnit,
    marginBetweenBlocksFactorAfterTitle,
    marginBetweenBlocksFactor
  } = themeProps;
  let isPreviousElementTitle = false;
  const bodyBlocksToRender = slideNumber !== null ? getSlideBlocks(body, slideNumber) : body;
  return bodyBlocksToRender.map(block => {
    const {
      type
    } = block;
    const blockStyleSheet = isPreviousElementTitle ? createBlockStyleSheet(baseUnit, marginBetweenBlocksFactorAfterTitle) : createBlockStyleSheet(baseUnit, marginBetweenBlocksFactor);
    const blockStyle = isPreviousElementTitle ? createBlockStyle(baseUnit, marginBetweenBlocksFactorAfterTitle) : createBlockStyle(baseUnit, marginBetweenBlocksFactor);
    isPreviousElementTitle = false;

    switch (type) {
      case 'ad':
        {
          const {
            dataId,
            adId
          } = block;
          return /*#__PURE__*/React.createElement(ArticleAd, {
            key: dataId,
            additionalStyle: blockStyleSheet,
            id: adId,
            defaultBlocksWidths: defaultBlocksWidths,
            dataId: dataId
          });
        }

      case 'image':
        {
          const {
            image,
            dataId,
            sizeType
          } = block;
          const overrideBlockWidth = overrideBlockWidths && overrideBlockWidths.image;
          return /*#__PURE__*/React.createElement(ConditionalImageLinkWrapper, {
            link: image.link || null,
            key: `link-${dataId}`,
            dataId: dataId
          }, /*#__PURE__*/React.createElement(ArticleImage, {
            key: dataId,
            image: image,
            style: blockStyle,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths,
            overrideBlockWidths: overrideBlockWidth,
            sizeType: sizeType,
            blocksPaddingOverride: blocksPaddingOverride,
            imageWidthLarge: imageWidthLarge,
            imageWidthMedium: imageWidthMedium,
            imageWidthSmall: imageWidthSmall
          }));
        }

      case 'title':
        {
          isPreviousElementTitle = true;
          const {
            listItemNumber,
            text,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(ListItemTitle, {
            key: dataId,
            listItemNumber: listItemNumber,
            text: text,
            additionalStyle: blockStyleSheet,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths
          });
        }

      case 'inline-text':
        {
          const {
            html,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(Paragraph, {
            key: dataId,
            html: html,
            additionalStyle: blockStyleSheet,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths
          });
        }

      case 'quote':
        {
          const {
            text,
            cite,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(Quote, {
            key: dataId,
            text: text,
            cite: cite,
            additionalStyle: blockStyleSheet,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths
          });
        }

      case 'youtube':
        {
          const {
            html,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(ArticleIframe, {
            key: dataId,
            html: html,
            style: blockStyle,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths
          });
        }

      case 'twitter':
        {
          const {
            html,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(Twitter, {
            key: dataId,
            html: html,
            additionalStyle: blockStyleSheet,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths
          });
        }

      case 'instagram':
        {
          const {
            html,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(Instagram, {
            key: dataId,
            html: html,
            additionalStyle: blockStyleSheet,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths
          });
        }

      case 'facebook':
        {
          const {
            html,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(Facebook, {
            key: dataId,
            html: html,
            additionalStyle: blockStyleSheet,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths
          });
        }

      case 'jw':
        {
          const {
            html,
            videoId,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(ArticleJw, {
            key: dataId,
            html: html,
            videoId: videoId,
            templateName: templateName,
            siteName: siteName,
            style: blockStyle,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths
          });
        }

      case 'mmPlayer':
        {
          const {
            html,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(ArticleMMPlayer, {
            key: dataId,
            html: html,
            style: blockStyle,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths
          });
        }

      case 'giphy':
        {
          const {
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(Giphy, _extends$1({
            key: dataId
          }, block, {
            additionalStyle: blockStyleSheet,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths
          }));
        }

      case 'playbuzz':
        {
          const {
            html,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(Playbuzz, {
            key: dataId,
            html: html,
            additionalStyle: blockStyleSheet,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths
          });
        }

      case 'dailyMotion':
        {
          const {
            html,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(ArticleIframe, {
            key: dataId,
            html: html,
            style: blockStyle,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths
          });
        }

      case 'divider':
        {
          const {
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(ArticleDividerWithIcon, {
            key: dataId,
            additionalStyle: blockStyleSheet,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths,
            iconComponent: QuoteIconForDivider
          });
        }

      case 'streamable':
        {
          const {
            html,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(Streamable, {
            key: dataId,
            html: html,
            style: blockStyle,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths
          });
        }

      case 'injectedBlock':
        {
          const {
            html,
            dataId,
            script
          } = block;
          return /*#__PURE__*/React.createElement(InjectedBlock, {
            key: dataId,
            html: html,
            additionalStyle: blockStyleSheet,
            dataId: dataId,
            script: script,
            defaultBlocksWidths: defaultBlocksWidths
          });
        }

      case 'soundcloud':
        {
          const {
            html,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(ArticleIframe, {
            key: dataId,
            html: html,
            style: blockStyle,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths
          });
        }

      case 'vimeo':
        {
          const {
            html,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(ArticleIframe, {
            key: dataId,
            html: html,
            style: blockStyle,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths
          });
        }

      case 'iframeEmbed':
        {
          const {
            html,
            dataId,
            height
          } = block;
          return /*#__PURE__*/React.createElement(IframeEmbed, {
            key: dataId,
            height: height,
            html: html,
            additionalStyle: blockStyleSheet,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths
          });
        }

      case 'gfycat':
        {
          const {
            html,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(Gfycat, {
            key: dataId,
            html: html,
            additionalStyle: blockStyleSheet,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths
          });
        }

      case 'apester':
        {
          const {
            html,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(Apester, {
            key: dataId,
            html: html,
            additionalStyle: blockStyleSheet,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths
          });
        }

      case 'ceros':
        {
          const {
            html,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(Ceros, {
            key: dataId,
            html: html,
            additionalStyle: blockStyleSheet,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths
          });
        }

      case 'relatedPosts':
        {
          const {
            title,
            articles,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(RelatedPosts, {
            key: dataId,
            title: title,
            articles: articles,
            marginBetweenBlocksFactor: marginBetweenBlocksFactor,
            defaultBlocksWidths: defaultBlocksWidths,
            dataId: dataId
          });
        }

      case 'relatedTopics':
        {
          const {
            title,
            pages,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(RelatedTopics, {
            key: dataId,
            title: title,
            pages: pages,
            marginBetweenBlocksFactor: marginBetweenBlocksFactor,
            defaultBlocksWidths: defaultBlocksWidths,
            dataId: dataId
          });
        }

      case 'mm-content-embed':
        {
          const {
            html,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(ContentEnrichment, {
            key: dataId,
            html: html,
            additionalStyle: blockStyleSheet,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths
          });
        }

      default:
        return null;
    }
  });
};

const ArticleContentComponent = props => {
  const {
    body,
    templateName,
    siteName,
    overrideBlocksWidths,
    defaultBlocksWidths,
    blocksPaddingOverride,
    imageWidthLarge,
    imageWidthMedium,
    imageWidthSmall,
    addMMPlayerPlaceholder,
    addOpenwebLiveblogPlaceholder
  } = props;
  const themeProps = useTheme(componentConfigurationKey$c);
  const {
    baseUnit,
    marginBetweenBlocksFactor
  } = themeProps;
  const slideNumber = React.useContext(SlideshowContext);
  React.useEffect(() => {
    if (slideNumber !== null) {
      window.mmClientApi = window.mmClientApi || [];
      window.mmClientApi.push('analytics', {
        event_label: 'Slideshow page view',
        slideNumber: slideNumber + 1
      });
    }
  }, [slideNumber]);
  return /*#__PURE__*/React.createElement(ViewabilityProvider, null, addMMPlayerPlaceholder ? /*#__PURE__*/React.createElement(MMPlayerPlaceHolder, {
    largeScreen: true,
    additionalStyle: createBlockStyleSheet(baseUnit, marginBetweenBlocksFactor),
    defaultBlocksWidths: defaultBlocksWidths
  }) : null, body ? createBlocksComponents$1(body, templateName, siteName, overrideBlocksWidths, defaultBlocksWidths, themeProps, blocksPaddingOverride, slideNumber, imageWidthLarge, imageWidthMedium, imageWidthSmall) : null, addOpenwebLiveblogPlaceholder ? /*#__PURE__*/React.createElement(OpenwebLiveblog, {
    additionalStyle: createBlockStyleSheet(baseUnit, marginBetweenBlocksFactor),
    defaultBlocksWidths: defaultBlocksWidths
  }) : null);
};
const ArticleContent = props => {
  const {
    children
  } = props;
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, children, /*#__PURE__*/React.createElement(ArticleContentComponent, props));
};

const getStyles$x = (factor, baseUnit) => StyleSheet.create({
  wrapper: {
    position: 'relative',
    [MEDIA_BREAKPOINTS.large]: {
      minHeight: `${factor * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      minHeight: 'unset'
    },
    [MEDIA_BREAKPOINTS.small]: {
      minHeight: 'unset'
    }
  }
});

const SafeArticleContentWrapper = ({
  children,
  minHeightFactor
}) => {
  const {
    baseUnit
  } = useTheme();
  const styles = getStyles$x(minHeightFactor, baseUnit);
  return /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapper)
  }, children);
};

const ampImageWidths = createImageWidths(540, 720, 720);
const ampAspectRatio = {
  x: 16,
  y: 9
};
const preloadImage = (host, path, aspectRatio = ampAspectRatio, cropping) => {
  return [/*#__PURE__*/React.createElement("link", {
    key: "1",
    rel: "preload",
    href: createImageSrc(host, path, ampImageWidths.small, aspectRatio, 1, cropping),
    media: `(max-width: ${SMALL_SCREEN_SIZE}px)`,
    as: "image"
  }), /*#__PURE__*/React.createElement("link", {
    key: "2",
    rel: "preload",
    href: createImageSrc(host, path, ampImageWidths.medium, aspectRatio, 1, cropping),
    media: `(max-width: ${MEDIUM_SCREEN_SIZE}px)`,
    as: "image"
  }), /*#__PURE__*/React.createElement("link", {
    key: "3",
    rel: "preload",
    href: createImageSrc(host, path, ampImageWidths.large, aspectRatio, 1, cropping),
    media: `(min-width: ${LARGE_SCREEN_SIZE}px)`,
    as: "image"
  })];
};
const normalizeDimensions = (aspectRatio = {
  x: 16,
  y: 9
}) => {
  return [aspectRatio.x / aspectRatio.y, 1];
};

const getStyle$c = (baseUnit, figcaptionTextColor) => StyleSheet.create({
  figcaption: {
    color: figcaptionTextColor,
    marginTop: `${baseUnit * 0.25}px`,
    marginLeft: `${baseUnit * 0.25}px`
  }
});
const getAMPImageProps = image => {
  const {
    alt,
    caption,
    host,
    path,
    aspectRatio = ampAspectRatio,
    imageWidths = ampImageWidths,
    cropping = null
  } = image;
  const {
    imageAspectRatios = createImageAspectRatios(aspectRatio, aspectRatio, aspectRatio)
  } = image;
  const {
    srcSetMediumScreen,
    srcSetLargeScreen,
    fallbackSrc,
    srcSetSmallScreen
  } = getImageSrcAndSrcSet(imageAspectRatios, imageWidths, host, path, cropping);
  const [width, height] = normalizeDimensions(aspectRatio);
  const actualAlt = alt || caption || '';
  return {
    src: fallbackSrc,
    alt: actualAlt,
    width,
    height,
    srcSetMediumScreen,
    srcSetLargeScreen,
    srcSetSmallScreen
  };
};

const getAMPImage = imageProps => {
  const {
    width,
    height,
    src,
    alt,
    srcSetLargeScreen,
    srcSetMediumScreen,
    srcSetSmallScreen
  } = imageProps;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("amp-img", {
    src: src,
    srcSet: srcSetSmallScreen,
    alt: alt,
    layout: "responsive",
    width: width,
    height: height,
    media: `(max-width: ${SMALL_SCREEN_SIZE}px)`
  }), /*#__PURE__*/React.createElement("amp-img", {
    src: src,
    srcSet: srcSetMediumScreen,
    alt: alt,
    layout: "responsive",
    width: width,
    height: height,
    media: `(min-width: ${SMALL_SCREEN_SIZE + 1}px) and (max-width: ${MEDIUM_SCREEN_SIZE}px)`
  }), /*#__PURE__*/React.createElement("amp-img", {
    src: src,
    srcSet: srcSetLargeScreen,
    alt: alt,
    layout: "responsive",
    width: width,
    height: height,
    media: `(min-width: ${LARGE_SCREEN_SIZE}px)`
  }));
};

const getImageCaption = (credit, caption) => {
  return [caption, credit].filter(value => {
    return typeof value === 'string' && value.trim() !== '';
  }).join(' | ');
};

const AMPImage = props => {
  const {
    baseUnit,
    textColor,
    fontSizesStyles
  } = useTheme(componentConfigurationKey$k);
  const {
    additionalStyle,
    preload,
    credit,
    caption,
    host,
    path,
    aspectRatio = ampAspectRatio,
    dataId,
    hideFigcaption,
    cropping = null
  } = props;
  const imageProps = getAMPImageProps(props);
  const creditHTML = useTransformCreditHTML(credit);
  const figCaption = getImageCaption(creditHTML, caption);
  const figCaptionStyle = getStyle$c(baseUnit, textColor);
  const figcaptionText = getStyleBySize(fontSizesStyles, {
    fontSizeSmall: consts.TYPOGRAPHY_SIZE.NORMAL,
    fontSizeMedium: consts.TYPOGRAPHY_SIZE.NORMAL,
    fontSizeLarge: consts.TYPOGRAPHY_SIZE.NORMAL
  });
  const figureClassNameProp = additionalStyle ? {
    className: css(additionalStyle.style)
  } : {};
  return /*#__PURE__*/React.createElement("figure", _extends$1({
    "data-id": dataId
  }, figureClassNameProp), preload && preloadImage(host, path, aspectRatio, cropping), getAMPImage(imageProps), !hideFigcaption && figCaption && /*#__PURE__*/React.createElement("figcaption", {
    className: css(figCaptionStyle.figcaption, figcaptionText),
    dangerouslySetInnerHTML: {
      __html: figCaption
    }
  }));
};

const AMPJWPlayer = props => {
  const {
    playerId,
    videoId,
    additionalStyle
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-jwplayer",
    src: "https://cdn.ampproject.org/v0/amp-jwplayer-0.1.js"
  })), /*#__PURE__*/React.createElement("figure", {
    className: css(additionalStyle.style)
  }, /*#__PURE__*/React.createElement("amp-jwplayer", {
    width: "16",
    height: "9",
    layout: "responsive",
    "data-media-id": videoId,
    "data-player-id": playerId
  })));
};

const AMPYoutube = props => {
  const {
    mediaId,
    additionalStyle
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-youtube",
    src: "https://cdn.ampproject.org/v0/amp-youtube-0.1.js"
  })), /*#__PURE__*/React.createElement("figure", {
    className: css(additionalStyle.style)
  }, /*#__PURE__*/React.createElement("amp-youtube", {
    "data-videoid": mediaId,
    layout: "responsive",
    width: "480",
    height: "270"
  })));
};

const AMPMMPlayer = props => {
  const {
    playerId,
    playlistId,
    additionalStyle
  } = props;
  return playerId && playlistId ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-minute-media-player",
    src: "https://cdn.ampproject.org/v0/amp-minute-media-player-0.1.js"
  })), /*#__PURE__*/React.createElement("figure", {
    className: css(additionalStyle.style)
  }, /*#__PURE__*/React.createElement("amp-minute-media-player", {
    width: "16",
    height: "9",
    layout: "responsive",
    "data-content-type": "specific",
    "data-content-id": `${playlistId}#${playerId}`
  }))) : null;
};

const getStyles$w = () => StyleSheet.create({
  wrapper: {
    position: 'relative'
  }
});

const getMainImageStyle = baseUnit => {
  return StyleSheet.create({
    style: {
      marginTop: `${baseUnit}px`,
      marginBottom: `${baseUnit * 0.25}px`
    }
  });
};

const getBlockStyle$1 = () => {
  return StyleSheet.create({
    style: {
      position: 'absolute',
      top: '0',
      left: '0',
      width: '100%'
    }
  });
};

const getMedia$1 = media => {
  const {
    type
  } = media;
  const blockStyle = getBlockStyle$1();

  switch (type) {
    case 'jw':
      {
        const {
          videoId,
          playerId
        } = media; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

        return /*#__PURE__*/React.createElement(AMPJWPlayer, {
          videoId: videoId,
          playerId: playerId,
          additionalStyle: blockStyle
        });
      }

    case 'youtube':
      {
        const {
          mediaId
        } = media; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

        return /*#__PURE__*/React.createElement(AMPYoutube, {
          mediaId: mediaId,
          additionalStyle: blockStyle
        });
      }

    case 'mmPlayer':
      {
        const {
          mediaId,
          playerId
        } = media; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

        return /*#__PURE__*/React.createElement(AMPMMPlayer, {
          playlistId: mediaId,
          playerId: playerId,
          additionalStyle: blockStyle
        });
      }

    default:
      return null;
  }
};

const AMPCover = props => {
  const {
    baseUnit
  } = useTheme();
  const {
    media
  } = props;
  const styles = getStyles$w();
  const additionalStyle = getMainImageStyle(baseUnit);
  return /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapper)
  }, /*#__PURE__*/React.createElement(AMPImage, _extends$1({
    preload: true
  }, props, {
    additionalStyle: additionalStyle
  })), media && getMedia$1(media));
};

const getLogoStyle = logoHeights => {
  return StyleSheet.create({
    base: {
      height: `${logoHeights.small * baseUnit}px`,
      alignItems: 'center'
    },
    largeSvg: {
      [MEDIA_BREAKPOINTS.large]: {
        display: 'inline-flex'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'none'
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'none'
      }
    },
    smallSvg: {
      [MEDIA_BREAKPOINTS.large]: {
        display: 'none'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'inline-flex'
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'inline-flex'
      }
    },
    image: {
      height: '100%'
    }
  });
};

const getSvgWidthAndHeight = viewBoxValue => {
  const viewBowDimensions = viewBoxValue.split(' ');
  return {
    width: Number(viewBowDimensions[2]),
    height: Number(viewBowDimensions[3])
  };
};
const defaultLogoHeights = {
  large: 24,
  medium: 24,
  small: 24
};
const AMPLogo = props => {
  const {
    href,
    alt,
    svgLarge,
    svgSmall,
    svgLargeViewBox,
    svgSmallViewBox,
    logoHeights = defaultLogoHeights
  } = props;
  const style = getLogoStyle(logoHeights);
  const largeSvgWidthAndHeight = getSvgWidthAndHeight(svgLargeViewBox);
  const smallSvgWidthAndHeight = getSvgWidthAndHeight(svgSmallViewBox);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Link, {
    className: css(style.largeSvg, style.base),
    href: href
  }, /*#__PURE__*/React__default.createElement("amp-img", {
    layout: "fixed",
    class: css(style.image),
    alt: alt,
    src: `data:image/svg+xml,${encodeURIComponent(svgLarge)}`,
    height: `${logoHeights.small * baseUnit}`,
    width: `${logoHeights.small * baseUnit * largeSvgWidthAndHeight.width / largeSvgWidthAndHeight.height}`
  })), /*#__PURE__*/React__default.createElement(Link, {
    className: css(style.smallSvg, style.base),
    href: href
  }, /*#__PURE__*/React__default.createElement("amp-img", {
    layout: "fixed",
    class: css(style.image),
    alt: alt,
    src: `data:image/svg+xml,${encodeURIComponent(svgSmall)}`,
    height: `${logoHeights.small * baseUnit}`,
    width: `${logoHeights.small * baseUnit * smallSvgWidthAndHeight.width / smallSvgWidthAndHeight.height}`
  })));
};

const additionalStyle = {
  [MEDIA_BREAKPOINTS.large]: {
    display: 'block'
  },
  [MEDIA_BREAKPOINTS.medium]: {
    display: 'none'
  },
  [MEDIA_BREAKPOINTS.small]: {
    display: 'none'
  }
};
const radiusBorder = 4;

const createStyle$t = (isActive = false, activeBorderBottom) => {
  return StyleSheet.create({
    link: {
      height: '100%',
      width: '100%',
      display: 'inline-flex',
      alignItems: 'center',
      position: 'relative',
      ':before': isActive ? {
        height: `${radiusBorder}px`,
        bottom: 0,
        left: 0,
        position: 'absolute',
        right: 0,
        content: "''",
        backgroundColor: activeBorderBottom
      } : {}
    }
  });
};

const createLink = (idleColor, activeBorderBottom, hoverStateColor, activeStateColor, pagePath, fontSizesStyles, linkFontSizeLarge, linkFontSizeMedium, linkFontSizeSmall) => (navigationLink, index) => {
  const {
    href,
    text
  } = navigationLink.link;
  const isActiveLink = href === pagePath;
  const linkStyle = generateLinkStyleFromTheme({
    idleColor,
    activeStateColor,
    hoverStateColor
  }, additionalStyle);
  const style = createStyle$t(isActiveLink, activeBorderBottom);
  const fontStyle = getStyleBySize(fontSizesStyles, {
    fontSizeSmall: linkFontSizeSmall,
    fontSizeMedium: linkFontSizeMedium,
    fontSizeLarge: linkFontSizeLarge
  });
  return /*#__PURE__*/React.createElement(TextLinkComponent, {
    key: index,
    href: href,
    linkStyle: linkStyle
  }, /*#__PURE__*/React.createElement(Span, {
    styles: semanticCSS(fontStyle, style.link)
  }, text));
};

const AMPPrimaryLinks = props => {
  const {
    firstRowLinkColorTypeNormal,
    fontSizesStyles,
    firstRowLinkActiveBorderBottom,
    firstRowLinkColorTypeHover,
    firstRowLinkColorTypeActive,
    firstRowLinkFontSizeLarge,
    firstRowLinkFontSizeMedium,
    firstRowLinkFontSizeSmall
  } = useTheme(componentConfigThemeKey$G);
  const {
    links,
    pagePath
  } = props;
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, links.map(createLink(firstRowLinkColorTypeNormal, firstRowLinkActiveBorderBottom, firstRowLinkColorTypeHover, firstRowLinkColorTypeActive, pagePath, fontSizesStyles, firstRowLinkFontSizeLarge, firstRowLinkFontSizeMedium, firstRowLinkFontSizeSmall)));
};

const getStyle$b = (color, headerHeights) => {
  return StyleSheet.create({
    editionsWrapper: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'none'
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'none'
      }
    },
    editionsTitleWrapper: {
      width: '144px',
      color,
      textDecoration: 'none',
      backgroundColor: 'transparent',
      border: 'none',
      outline: 'none',
      ':hover': {
        cursor: 'pointer'
      },
      [MEDIA_BREAKPOINTS.large]: {
        height: `${headerHeights.large * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        height: `${headerHeights.medium * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        height: `${headerHeights.small * baseUnit}px`
      }
    },
    editionsTitle: {
      height: '100%',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between'
    }
  });
};

const AMPEditions = props => {
  const {
    editionsIconNormalColor
  } = useTheme(componentConfigThemeKey$G);
  const {
    editions,
    editionEndpoint,
    headerHeights
  } = props;
  const activeEdition = getActiveEdition(editions, editionEndpoint);
  const style = getStyle$b(editionsIconNormalColor, headerHeights);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-accordion",
    src: "https://cdn.ampproject.org/v0/amp-accordion-0.1.js"
  })), /*#__PURE__*/React.createElement("div", {
    className: css(style.editionsWrapper)
  }, /*#__PURE__*/React.createElement("amp-accordion", {
    id: "accordion-editions",
    "disable-session-states": undefined
  }, /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(H4, {
    styles: semanticCSS(style.editionsTitleWrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(style.editionsTitle)
  }, /*#__PURE__*/React.createElement("div", null, activeEdition.link.text), /*#__PURE__*/React.createElement(ChevronIcon, {
    direction: Directions$1.DOWN,
    color: editionsIconNormalColor
  }))), /*#__PURE__*/React.createElement(DropDownMenu, {
    menuLinks: editions,
    configThemeKey: "editionsMenu",
    activeEndpoint: editionEndpoint
  })))));
};

const getMenuIconStyle$1 = color => StyleSheet.create({
  wrapper: {
    width: '16px',
    height: '16px',
    position: 'relative',
    cursor: 'pointer',
    [MEDIA_BREAKPOINTS.large]: {
      display: 'none'
    },
    [MEDIA_BREAKPOINTS.medium]: {
      display: 'inline-flex'
    },
    [MEDIA_BREAKPOINTS.small]: {
      display: 'inline-flex'
    },
    ':focus': {
      outline: 'none'
    }
  },
  span: {
    display: 'block',
    position: 'absolute',
    backgroundColor: color,
    height: '2px',
    width: '100%',
    opacity: 1,
    left: 0
  },
  firstSpanClose: {
    top: 0
  },
  secondSpanClose: {
    top: '7px'
  },
  thirdSpanClose: {
    top: '14px'
  }
});

const AMPMenuIcon = () => {
  const {
    hamburgerMenuIconColor
  } = useTheme(componentConfigThemeKey$G);
  const menuIcon = getMenuIconStyle$1(hamburgerMenuIconColor);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    tabIndex: "0",
    on: "tap:sidebar.open",
    role: "button",
    className: css(menuIcon.wrapper)
  }, /*#__PURE__*/React.createElement(Span, {
    styles: semanticCSS(menuIcon.span, menuIcon.firstSpanClose)
  }), /*#__PURE__*/React.createElement(Span, {
    styles: semanticCSS(menuIcon.span, menuIcon.secondSpanClose)
  }), /*#__PURE__*/React.createElement(Span, {
    styles: semanticCSS(menuIcon.span, menuIcon.thirdSpanClose)
  })));
};

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */

const getPrimaryHeaderStyle = (backgroundColor, baseUnit, headerHeights) => StyleSheet.create({
  wrapper: {
    backgroundColor,
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    zIndex: 100,
    [MEDIA_BREAKPOINTS.large]: {
      height: `${headerHeights.large * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      height: `${headerHeights.medium * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      height: `${headerHeights.small * baseUnit}px`
    }
  },
  itemsBasicContainer: {
    display: 'grid',
    gridAutoFlow: 'column',
    height: '100%',
    width: 'fit-content',
    alignItems: 'center',
    gridColumnGap: `${baseUnit}px`
  },
  itemsRightContainer: {
    alignItems: 'baseline',
    [MEDIA_BREAKPOINTS.large]: {
      paddingRight: `${baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      paddingRight: `${baseUnit / 2}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      paddingRight: `${baseUnit / 2}px`
    }
  },
  itemsLeftContainer: {
    paddingLeft: `${baseUnit}px`
  },
  ctaWrapper: {
    [MEDIA_BREAKPOINTS.large]: {
      height: `${headerHeights.large * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      height: `${headerHeights.medium * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      height: `${headerHeights.small * baseUnit}px`
    },
    display: 'flex',
    alignItems: 'center'
  }
});

const AMPPrimaryHeader = props => {
  const {
    firstRowBoxShadow,
    firstRowBackgroundColor,
    baseUnit
  } = useTheme(componentConfigThemeKey$G);
  const {
    links,
    logo,
    cta,
    shouldShowClosedMenuIcon,
    editions,
    pagePath,
    editionEndpoint,
    headerHeights,
    logoHeights
  } = props;
  const style = getPrimaryHeaderStyle(firstRowBackgroundColor, baseUnit, headerHeights);
  const boxShadowStyle = createStyleForBoxShadow({
    boxShadowTypeNormal: firstRowBoxShadow
  });
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(style.wrapper, boxShadowStyle.style)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(style.itemsBasicContainer, style.itemsLeftContainer)
  }, shouldShowClosedMenuIcon ? /*#__PURE__*/React.createElement(AMPMenuIcon, null) : null, /*#__PURE__*/React.createElement(AMPLogo, _extends$1({}, logo, {
    logoHeights: {
      large: logoHeights.large,
      medium: logoHeights.medium,
      small: logoHeights.small
    }
  })), links ? /*#__PURE__*/React.createElement(AMPPrimaryLinks, {
    links: links,
    pagePath: pagePath
  }) : null), /*#__PURE__*/React.createElement("div", {
    className: css(style.itemsBasicContainer, style.itemsRightContainer)
  }, cta ? /*#__PURE__*/React.createElement("div", {
    className: css(style.ctaWrapper)
  }, /*#__PURE__*/React.createElement(CtaButton, cta)) : null, editions ? /*#__PURE__*/React.createElement(AMPEditions, {
    editions: editions,
    editionEndpoint: editionEndpoint,
    headerHeights: headerHeights
  }) : null)));
};

/* eslint-disable react/no-unknown-property */

const getAmpSideBarLinkStyle = (baseUnit, idleColor) => StyleSheet.create({
  wrapper: {
    [MEDIA_BREAKPOINTS.medium]: {
      margin: `${baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      margin: `${baseUnit}px`
    }
  },
  label: {
    color: idleColor,
    flex: '0 0 auto',
    display: 'inline-flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%'
  },
  title: {
    backgroundColor: 'inherit',
    border: 'inherit',
    paddingRight: 0,
    ':focus': {
      outline: 'none'
    }
  },
  titleAndChevronIconWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
});

const createAmpSideBarSubLink = (linkData, index) => {
  const {
    link
  } = linkData;
  return /*#__PURE__*/React.createElement(MenuSubLink, {
    text: link.text,
    href: link.href,
    key: index
  });
};

const AMPSideBarLink = props => {
  const {
    hamburgerMenuLinksNormalColor,
    baseUnit
  } = useTheme(componentConfigThemeKey$G);
  const {
    link,
    childrenLinks
  } = props;
  const {
    href
  } = link;
  const isFolder = href === '-';
  const style = getAmpSideBarLinkStyle(baseUnit, hamburgerMenuLinksNormalColor);
  const linkStyle = generateLinkStyleFromTheme({
    idleColor: hamburgerMenuLinksNormalColor
  });
  return /*#__PURE__*/React.createElement("section", {
    className: css(style.wrapper)
  }, /*#__PURE__*/React.createElement(H4, {
    styles: semanticCSS(style.title)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(style.titleAndChevronIconWrapper)
  }, isFolder ? /*#__PURE__*/React.createElement("div", {
    className: css(style.label)
  }, link.text) : /*#__PURE__*/React.createElement(TextLinkComponent, {
    href: href,
    linkStyle: linkStyle
  }, link.text), childrenLinks && childrenLinks.length > 0 ? /*#__PURE__*/React.createElement(ChevronIcon, {
    direction: Directions$1.DOWN,
    color: hamburgerMenuLinksNormalColor
  }) : null)), /*#__PURE__*/React.createElement("ul", null, childrenLinks && childrenLinks.map(createAmpSideBarSubLink)));
};

const createStyle$s = (dividerColor, baseUnit) => StyleSheet.create({
  divider: {
    backgroundColor: dividerColor,
    height: '1px',
    [MEDIA_BREAKPOINTS.medium]: {
      margin: `0 ${baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      margin: `0 ${baseUnit}px`
    }
  }
});

const AMPMenuEditions = props => {
  const {
    editions,
    dividerColor,
    baseUnit,
    editionEndpoint
  } = props;
  const activeEdition = getActiveEdition(editions, editionEndpoint);
  const {
    text
  } = activeEdition.link;
  const notActivatedEditions = editions.filter(edition => edition.link.text !== text).map(navigationLinkToMenuLinkDataProps);
  const style = createStyle$s(dividerColor, baseUnit);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: css(style.divider)
  }), /*#__PURE__*/React.createElement("amp-accordion", {
    id: "editions-accordion",
    "disable-session-states": undefined
  }, /*#__PURE__*/React.createElement(AMPSideBarLink, {
    link: activeEdition.link,
    childrenLinks: notActivatedEditions
  })));
};

/* eslint-disable react/no-unknown-property */

const getAmpSideBarStyle = backgroundColor => StyleSheet.create({
  wrapper: {
    backgroundColor,
    position: 'fixed',
    width: '100%',
    left: 0,
    overflowY: 'auto',
    flexDirection: 'column',
    [MEDIA_BREAKPOINTS.large]: {
      display: 'none'
    },
    [MEDIA_BREAKPOINTS.medium]: {
      display: 'inline-flex'
    },
    [MEDIA_BREAKPOINTS.small]: {
      display: 'inline-flex'
    }
  }
});

const getMenuIconStyle = (baseUnit, menuIconColor) => StyleSheet.create({
  wrapper: {
    width: '16px',
    height: '16px',
    minHeight: '16px',
    position: 'relative',
    transition: '.5s ease-in-out',
    cursor: 'pointer',
    [MEDIA_BREAKPOINTS.medium]: {
      margin: `${baseUnit}px`,
      marginBottom: 0
    },
    [MEDIA_BREAKPOINTS.small]: {
      margin: `${baseUnit}px`,
      marginBottom: 0
    },
    ':focus': {
      outline: 'none'
    }
  },
  span: {
    display: 'block',
    position: 'absolute',
    height: '2px',
    width: '100%',
    backgroundColor: menuIconColor,
    opacity: 1,
    left: 0,
    transition: '.25s ease-in-out',
    transformOrigin: 'right center'
  },
  firstSpanOpen: {
    transform: 'rotate(-45deg)',
    width: '130%',
    left: '-6px',
    top: 0
  },
  secondSpanOpen: {
    top: '7px',
    transform: 'scaleX(0.1)',
    opacity: 0
  },
  thirdSpanOpen: {
    transform: 'rotate(45deg)',
    top: '14px',
    width: '130%',
    left: '-6px'
  }
});

const createAMPSideBarLink = (menuLink, index) => {
  const {
    link,
    childrenLinks
  } = menuLink;
  return /*#__PURE__*/React.createElement(AMPSideBarLink, {
    link: link,
    childrenLinks: childrenLinks,
    key: index
  });
};

const AMPSideBar = props => {
  const {
    hamburgerMenuLinksBackgroundColor,
    hamburgerMenuDividerColor,
    hamburgerMenuAmpCloseIconColor,
    baseUnit
  } = useTheme(componentConfigThemeKey$G);
  const {
    menu,
    editions,
    editionEndpoint
  } = props;
  const menuIconStyle = getMenuIconStyle(baseUnit, hamburgerMenuAmpCloseIconColor);
  const ampSideBarStyle = getAmpSideBarStyle(hamburgerMenuLinksBackgroundColor);
  return (
    /*#__PURE__*/
    // @ts-ignore TS2339: Property 'amp-sidebar' does not exist on type 'JSX.IntrinsicElements'.
    React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
      async: undefined,
      "custom-element": "amp-sidebar",
      src: "https://cdn.ampproject.org/v0/amp-sidebar-0.1.js"
    }), /*#__PURE__*/React.createElement("script", {
      async: undefined,
      "custom-element": "amp-accordion",
      src: "https://cdn.ampproject.org/v0/amp-accordion-0.1.js"
    })), /*#__PURE__*/React.createElement("amp-sidebar", {
      id: "sidebar",
      layout: "nodisplay",
      side: "left",
      class: css(ampSideBarStyle.wrapper)
    }, /*#__PURE__*/React.createElement("div", {
      tabIndex: "0",
      on: "tap:sidebar.close,accordion.collapse,editions-accordion.collapse",
      role: "button",
      className: css(menuIconStyle.wrapper)
    }, /*#__PURE__*/React.createElement(Span, {
      styles: semanticCSS(menuIconStyle.span, menuIconStyle.firstSpanOpen)
    }), /*#__PURE__*/React.createElement(Span, {
      styles: semanticCSS(menuIconStyle.span, menuIconStyle.secondSpanOpen)
    }), /*#__PURE__*/React.createElement(Span, {
      styles: semanticCSS(menuIconStyle.span, menuIconStyle.thirdSpanOpen)
    })), /*#__PURE__*/React.createElement("amp-accordion", {
      id: "accordion",
      "disable-session-states": undefined
    }, menu.map(createAMPSideBarLink)), editions ? /*#__PURE__*/React.createElement(AMPMenuEditions, {
      editionEndpoint: editionEndpoint,
      editions: editions,
      baseUnit: baseUnit,
      dividerColor: hamburgerMenuDividerColor
    }) : null))
  );
};

const getStyle$a = (titleColor, headerHeights) => {
  return StyleSheet.create({
    wrapper: {
      height: 'inherit',
      [MEDIA_BREAKPOINTS.large]: {
        display: 'block'
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'none'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'none'
      }
    },
    titleWrapper: {
      width: 'fit-content',
      [MEDIA_BREAKPOINTS.large]: {
        height: `${headerHeights.large * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        height: `${headerHeights.medium * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        height: `${headerHeights.small * baseUnit}px`
      },
      color: titleColor,
      textDecoration: 'none',
      backgroundColor: 'transparent',
      border: 'none',
      outline: 'none',
      ':hover': {
        cursor: 'pointer'
      }
    },
    title: {
      height: '100%',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between'
    },
    text: {
      marginRight: '9px'
    }
  });
};
const AMPMoreLinks = props => {
  const {
    secondRowLinkCurrentColor,
    fontSizesStyles,
    secondRowLinkDropdownIconColor
  } = useTheme(componentConfigThemeKey$G);
  const {
    links,
    moreLinksText,
    pagePath,
    headerHeights
  } = props;
  const titleStyle = getStyleBySize(fontSizesStyles, {
    fontSizeSmall: consts.TYPOGRAPHY_SIZE.NORMAL,
    fontSizeMedium: consts.TYPOGRAPHY_SIZE.NORMAL,
    fontSizeLarge: consts.TYPOGRAPHY_SIZE.NORMAL
  });
  const style = getStyle$a(secondRowLinkCurrentColor, headerHeights);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Helmet, null, /*#__PURE__*/React__default.createElement("script", {
    async: undefined,
    "custom-element": "amp-accordion",
    src: "https://cdn.ampproject.org/v0/amp-accordion-0.1.js"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: css(style.wrapper)
  }, /*#__PURE__*/React__default.createElement("amp-accordion", {
    id: "accordion-more-links",
    "disable-session-states": undefined
  }, /*#__PURE__*/React__default.createElement("section", null, /*#__PURE__*/React__default.createElement(H4, {
    styles: semanticCSS(style.titleWrapper, titleStyle)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css(style.title)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css(style.text)
  }, moreLinksText), /*#__PURE__*/React__default.createElement(ChevronIcon, {
    color: secondRowLinkDropdownIconColor,
    direction: Directions$1.DOWN
  }))), /*#__PURE__*/React__default.createElement(DropDownMenu, {
    menuLinks: links,
    configThemeKey: "moreLinks",
    activeEndpoint: pagePath
  })))));
};

const getTextStyle$2 = (baseUnit, isActiveLink, lastLink) => {
  return StyleSheet.create({
    link: {
      width: 'max-content',
      [MEDIA_BREAKPOINTS.medium]: {
        paddingRight: lastLink ? `${baseUnit * 2}px` : 0
      },
      [MEDIA_BREAKPOINTS.small]: {
        paddingRight: lastLink ? `${baseUnit * 2}px` : 0
      }
    }
  });
};

const AMPSecondaryLink = props => {
  const {
    link,
    pagePath,
    linksLength,
    index
  } = props;
  const {
    secondRowLinkColorTypeActive,
    secondRowLinkColorTypeNormal,
    secondRowLinkColorTypeHover,
    baseUnit,
    fontSizesStyles,
    secondRowLinkFontSizeLarge,
    secondRowLinkFontSizeMedium,
    secondRowLinkFontSizeSmall
  } = useTheme(componentConfigThemeKey$G);
  const {
    href,
    text
  } = link.link;
  const isActiveLink = href === pagePath;
  const linkStyleBasedOnScreen = linksLength > maxVisibleLinksOnLargeAndXLarge && index >= maxVisibleLinksOnLargeAndXLarge - 1 ? {
    [MEDIA_BREAKPOINTS.large]: {
      display: 'none'
    },
    [MEDIA_BREAKPOINTS.small]: {
      display: 'inline-flex'
    },
    [MEDIA_BREAKPOINTS.medium]: {
      display: 'inline-flex'
    }
  } : {};
  const linkStyle = generateLinkStyleFromTheme({
    idleColor: isActiveLink ? secondRowLinkColorTypeActive : secondRowLinkColorTypeNormal,
    activeStateColor: secondRowLinkColorTypeActive,
    hoverStateColor: isActiveLink ? secondRowLinkColorTypeActive : secondRowLinkColorTypeHover
  }, linkStyleBasedOnScreen);
  const style = getTextStyle$2(baseUnit, isActiveLink, isLastLink(index, linksLength));
  const fontStyle = getStyleBySize(fontSizesStyles, {
    fontSizeSmall: secondRowLinkFontSizeSmall,
    fontSizeMedium: secondRowLinkFontSizeMedium,
    fontSizeLarge: secondRowLinkFontSizeLarge
  });
  return /*#__PURE__*/React.createElement(TextLinkComponent, {
    href: href,
    linkStyle: linkStyle
  }, /*#__PURE__*/React.createElement(Span, {
    styles: semanticCSS(fontStyle, style.link)
  }, text));
};

const getContainerStyle = baseUnit => {
  return StyleSheet.create({
    container: {
      display: 'grid',
      gridAutoFlow: 'column',
      alignItems: 'center',
      height: '100%',
      gridColumnGap: `${baseUnit}px`,
      [MEDIA_BREAKPOINTS.medium]: {
        overflowX: 'auto'
      },
      [MEDIA_BREAKPOINTS.small]: {
        overflowX: 'auto'
      }
    }
  });
};
const AMPSecondaryLinks = props => {
  const {
    moreLinksText,
    links,
    pagePath,
    headerHeights
  } = props;
  const {
    baseUnit
  } = useTheme();
  const moreLinks = links.length > maxVisibleLinksOnLargeAndXLarge ? links.slice(maxVisibleLinksOnLargeAndXLarge - 1) : [];
  const style = getContainerStyle(baseUnit);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: css(style.container)
  }, links.map((link, index) => /*#__PURE__*/React__default.createElement(AMPSecondaryLink, {
    link: link,
    index: index,
    key: index,
    linksLength: links.length,
    pagePath: pagePath
  }))), moreLinks.length > 0 ? /*#__PURE__*/React__default.createElement(AMPMoreLinks, {
    links: moreLinks,
    moreLinksText: moreLinksText,
    pagePath: pagePath,
    headerHeights: headerHeights
  }) : null);
};

const createStyle$r = (baseUnit, backgroundColor, headerHeights) => {
  return StyleSheet.create({
    wrapper: {
      backgroundColor,
      position: 'relative',
      [MEDIA_BREAKPOINTS.large]: {
        height: `${headerHeights.large * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        height: `${headerHeights.medium * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        height: `${headerHeights.small * baseUnit}px`
      },
      display: 'grid',
      gridAutoFlow: 'column',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'flex-start',
      zIndex: 50,
      gridColumnGap: `${baseUnit}px`,
      paddingLeft: `${baseUnit}px`
    }
  });
};

const AMPSecondaryHeader = props => {
  const {
    baseUnit,
    secondRowBackgroundColor,
    secondRowBoxShadow
  } = useTheme(componentConfigThemeKey$G);
  const {
    moreLinksText,
    links,
    logo,
    pagePath,
    logoHeights,
    headerHeights
  } = props;
  const style = createStyle$r(baseUnit, secondRowBackgroundColor, headerHeights);
  const boxShadowStyle = createStyleForBoxShadow({
    boxShadowTypeNormal: secondRowBoxShadow
  });
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(style.wrapper, boxShadowStyle.style)
  }, logo ? /*#__PURE__*/React.createElement(AMPLogo, _extends$1({}, logo, {
    logoHeights: {
      large: logoHeights.large,
      medium: logoHeights.medium,
      small: logoHeights.small
    }
  })) : null, links ? /*#__PURE__*/React.createElement(AMPSecondaryLinks, {
    links: links,
    moreLinksText: moreLinksText,
    pagePath: pagePath,
    headerHeights: headerHeights
  }) : null));
};

const getHeaderStyle = () => StyleSheet.create({
  wrapper: {
    position: 'fixed',
    width: '100%',
    zIndex: 1500,
    top: 0
  }
});

const AMPHeader = props => {
  const {
    primaryHeader,
    shouldShowClosedMenuIcon,
    secondaryHeader,
    editionEndpoint,
    pagePath
  } = props;
  const {
    links,
    logo,
    cta,
    editions
  } = primaryHeader;
  const style = getHeaderStyle();
  const themeProps = useTheme(componentConfigThemeKey$G);
  const firstRowHeights = getDoubleHeaderHeights(themeProps.firstRowHeightInLargeScreen, themeProps.firstRowHeightInMediumScreen, themeProps.firstRowHeightInSmallScreen);
  const firstRowLogoHeights = getDoubleHeaderHeights(themeProps.firstRowLogoHeightInLargeScreen, themeProps.firstRowLogoHeightInMediumScreen, themeProps.firstRowLogoHeightInSmallScreen);
  const secondRowHeights = getDoubleHeaderHeights(themeProps.secondRowHeightInLargeScreen, themeProps.secondRowHeightInMediumScreen, themeProps.secondRowHeightInSmallScreen);
  const secondRowLogoHeights = getDoubleHeaderHeights(themeProps.secondRowLogoHeightInLargeScreen, themeProps.secondRowLogoHeightInMediumScreen, themeProps.secondRowLogoHeightInSmallScreen);
  return /*#__PURE__*/React.createElement("header", {
    className: css(style.wrapper)
  }, /*#__PURE__*/React.createElement(AMPPrimaryHeader, {
    links: links,
    logo: logo,
    cta: cta,
    shouldShowClosedMenuIcon: shouldShowClosedMenuIcon,
    editions: editions,
    pagePath: pagePath,
    editionEndpoint: editionEndpoint,
    headerHeights: firstRowHeights,
    logoHeights: firstRowLogoHeights
  }), secondaryHeader ? /*#__PURE__*/React.createElement(AMPSecondaryHeader, _extends$1({}, secondaryHeader, {
    pagePath: pagePath,
    headerHeights: secondRowHeights,
    logoHeights: secondRowLogoHeights
  })) : null);
};
const AMPHeaderAndSideBar = props => {
  const {
    secondaryHeader,
    primaryHeader,
    editionEndpoint,
    pagePath
  } = props;
  const {
    editions,
    menu
  } = primaryHeader;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AMPHeader, {
    primaryHeader: primaryHeader,
    secondaryHeader: secondaryHeader,
    shouldShowClosedMenuIcon: !!menu,
    editionEndpoint: editionEndpoint,
    pagePath: pagePath
  }), menu ? /*#__PURE__*/React.createElement(AMPSideBar, {
    menu: menu.links,
    editions: editions,
    editionEndpoint: editionEndpoint
  }) : null);
};

const AMPComscore = props => {
  const {
    comscoreId
  } = props;
  const scriptJson = {
    vars: {
      c2: comscoreId
    },
    extraUrlParams: {
      comscorekw: 'amp'
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-analytics",
    src: "https://cdn.ampproject.org/v0/amp-analytics-0.1.js"
  })), /*#__PURE__*/React.createElement("amp-analytics", {
    type: "comscore"
  }, /*#__PURE__*/React.createElement("script", {
    type: "application/json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(scriptJson)
    }
  })));
};

const createPageViewParams = ({
  articleAuthor,
  articleId,
  articlePublicationTime,
  articleTemplate,
  articleTitle,
  contentTags,
  distributionChannels,
  mainMedia,
  language,
  markupFormat,
  commercialTags,
  articleContentCount,
  articleWordCount,
  siteName,
  property,
  ownerUsername,
  experiments,
  isSlideshow,
  mainCategoryEmbed
}) => ({
  siteName,
  property,
  articleAuthor,
  articleId,
  articlePublicationTime,
  articleTemplate,
  articleTitle,
  contentTags,
  distributionChannels,
  mainMedia,
  language,
  markupFormat,
  commercialTags,
  articleWordCount,
  articleContentCount,
  ownerUsername,
  experiments,
  isSlideshow,
  mainCategoryEmbed
});

const AMPConfigAnalytics = props => {
  const {
    analyticsConfigURL
  } = props;
  const scriptJson = {
    vars: createPageViewParams(props)
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("amp-analytics", {
    id: "analytics",
    config: analyticsConfigURL,
    "data-credentials": "include"
  }, /*#__PURE__*/React.createElement("script", {
    type: "application/json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(scriptJson)
    }
  })));
};

const AMPAmplitude = props => {
  const {
    amplitudeApiKey
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("amp-analytics", {
    type: "amplitude",
    id: "amplitude"
  }, /*#__PURE__*/React.createElement("script", {
    type: "application/json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify({
        vars: {
          apiKey: amplitudeApiKey
        },
        triggers: {
          pageView: {
            on: 'visible',
            request: 'event',
            extraUrlParams: {
              event: {
                event_type: 'Page View',
                event_properties: {
                  // eslint-disable-next-line no-template-curly-in-string
                  'Page URL': '${ampdocUrl}'
                },
                user_properties: {
                  // eslint-disable-next-line no-template-curly-in-string
                  utm_source: '${queryParam(utm_source)}',
                  // eslint-disable-next-line no-template-curly-in-string
                  utm_campaign: '${queryParam(utm_campaign)}',
                  // eslint-disable-next-line no-template-curly-in-string
                  utm_medium: '${queryParam(utm_medium)}'
                }
              }
            }
          }
        }
      })
    }
  })));
};

const AMPAnalytics = props => {
  const {
    comscoreId,
    analyticsConfigURL,
    owner,
    articleId,
    articlePublicationTime,
    articleTemplate,
    articleTitle,
    contentTags,
    distributionChannels,
    mainMedia,
    language,
    markupFormat = 'web',
    commercialTags,
    articleContentCount,
    articleWordCount,
    siteName,
    property,
    ownerUsername,
    experiments = [],
    isSlideshow,
    amplitudeApiKey,
    mainCategoryEmbed
  } = props;
  const {
    name: ownerName
  } = owner;
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-analytics",
    src: "https://cdn.ampproject.org/v0/amp-analytics-0.1.js"
  })), /*#__PURE__*/React.createElement(AMPConfigAnalytics, {
    analyticsConfigURL: analyticsConfigURL,
    siteName: siteName,
    property: property,
    articleAuthor: ownerName,
    articleId: articleId,
    articlePublicationTime: articlePublicationTime,
    articleTemplate: articleTemplate,
    articleTitle: articleTitle,
    contentTags: contentTags,
    distributionChannels: distributionChannels,
    mainMedia: mainMedia,
    language: language,
    markupFormat: markupFormat,
    commercialTags: commercialTags,
    articleWordCount: articleWordCount,
    articleContentCount: articleContentCount,
    ownerUsername: ownerUsername,
    experiments: experiments,
    isSlideshow: isSlideshow,
    mainCategoryEmbed: mainCategoryEmbed
  }), amplitudeApiKey ? /*#__PURE__*/React.createElement(AMPAmplitude, {
    amplitudeApiKey: amplitudeApiKey
  }) : null, /*#__PURE__*/React.createElement(AMPComscore, {
    comscoreId: comscoreId
  }));
};

const getStyle$9 = (baseUnit, type, src) => {
  const style = {
    backgroundSize: '32px',
    borderRadius: '100%',
    marginRight: `${baseUnit * 0.5}px`,
    ...(type === 'reddit' && {
      backgroundColor: '#ff4500',
      backgroundImage: `url("${src}")`
    })
  };
  return StyleSheet.create({
    style
  });
};

const preconfiguredProviders = ['twitter', 'facebook', 'email', 'linkedin', 'pinterest', 'tumblr', 'whatsapp'];

const isNotPreconfiguredProvider = type => preconfiguredProviders.indexOf(type) >= 0;

const AMPSocialButton = props => {
  const {
    type,
    shareURL,
    src,
    baseUnit
  } = props;
  const socialShareProps = {
    type,
    ...(isNotPreconfiguredProvider(type) && {
      'data-share-endpoint': shareURL
    })
  };
  const styles = getStyle$9(baseUnit, type, src); // @ts-ignore TS2339

  return /*#__PURE__*/React.createElement("amp-social-share", _extends$1({}, socialShareProps, {
    class: css(styles.style),
    width: "42",
    height: "42"
  }));
};

const getStyle$8 = baseUnit => StyleSheet.create({
  wrapper: {
    margin: `${baseUnit}px`
  }
});

const getSocialButtons = (shareConfig, baseUnit) => {
  return shareConfig.map((data, index) => /*#__PURE__*/React.createElement(AMPSocialButton, _extends$1({
    key: index
  }, data, {
    baseUnit: baseUnit
  })));
};

const AMPSocialContainer = props => {
  const {
    baseUnit
  } = useTheme();
  const {
    shareConfig
  } = props;
  const styles = getStyle$8(baseUnit);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-social-share",
    src: "https://cdn.ampproject.org/v0/amp-social-share-0.1.js"
  })), /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapper)
  }, getSocialButtons(shareConfig, baseUnit)));
};

const logoHeight = 40;

const createSponsorStyle$2 = (baseUnit, textColor) => StyleSheet.create({
  text: {
    color: textColor,
    marginBottom: `${0.5 * baseUnit}px`
  },
  wrapper: {
    textAlign: 'center',
    margin: `${1 * baseUnit}px 0px`
  }
});

const AMPSponsor = props => {
  const {
    text,
    logo,
    brandName,
    href,
    logoViewBox
  } = props;
  const {
    sponsorTextColor,
    baseUnit
  } = useTheme(componentConfigurationKey$o);
  const style = createSponsorStyle$2(baseUnit, sponsorTextColor);
  const svgWidthAndHeight = logoViewBox ? getSvgWidthAndHeight(logoViewBox) : null;
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(style.wrapper)
  }, /*#__PURE__*/React.createElement(H5, {
    styles: semanticCSS(style.text)
  }, text), /*#__PURE__*/React.createElement(Link, {
    href: href,
    rel: "nofollow sponsored"
  }, svgWidthAndHeight ? /*#__PURE__*/React.createElement("amp-img", {
    class: css(style.image),
    src: `data:image/svg+xml,${encodeURIComponent(logo)}`,
    alt: brandName,
    layout: "fixed",
    height: `${logoHeight}`,
    width: `${logoHeight * svgWidthAndHeight.width / svgWidthAndHeight.height}`
  }) : null)));
};

const getStyle$7 = baseUnit => StyleSheet.create({
  wrapper: {
    [MEDIA_BREAKPOINTS.small]: {
      margin: `0 ${baseUnit}px`
    }
  }
});
const AMPRecommendationsAdvertisement = props => {
  const {
    revcontentWidgetID
  } = props;
  const {
    baseUnit
  } = useTheme();
  const style = getStyle$7(baseUnit);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-ad",
    src: "https://cdn.ampproject.org/v0/amp-ad-0.1.js"
  })), /*#__PURE__*/React.createElement("amp-ad", {
    width: "100",
    height: "100",
    type: "revcontent",
    layout: "responsive",
    heights: "(min-width:1582px) 282%, (min-width:1116px) 288%,(min-width:782px) 297%, (min-width:561px) 309%,(min-width:460px) 328%, (min-width:395px) 350%,375%",
    "data-revcontent": undefined,
    "data-id": revcontentWidgetID,
    class: css(style.wrapper)
  }));
};

const AMPTwitter = props => {
  const {
    mediaId,
    additionalStyle
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-twitter",
    src: "https://cdn.ampproject.org/v0/amp-twitter-0.1.js"
  })), /*#__PURE__*/React.createElement("figure", {
    className: css(additionalStyle.style)
  }, /*#__PURE__*/React.createElement("amp-twitter", {
    width: "1",
    height: "1",
    layout: "responsive",
    "data-tweetid": mediaId
  })));
};

const mediaIdValidator = mediaId => {
  return typeof mediaId === 'string' && mediaId.trim() !== '';
};

const AMPMediaValidator = props => {
  const {
    mediaId,
    children
  } = props;
  const isMediaIdValid = mediaIdValidator(mediaId);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isMediaIdValid && children);
};

const AMPInstagram = props => {
  const {
    mediaId,
    additionalStyle
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-instagram",
    src: "https://cdn.ampproject.org/v0/amp-instagram-0.1.js"
  })), /*#__PURE__*/React.createElement("figure", {
    className: css(additionalStyle.style)
  }, /*#__PURE__*/React.createElement("amp-instagram", {
    "data-shortcode": mediaId,
    width: "1",
    height: "1",
    layout: "responsive"
  })));
};

const AMPFacebook = props => {
  const {
    mediaId,
    additionalStyle
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-facebook",
    src: "https://cdn.ampproject.org/v0/amp-facebook-0.1.js"
  })), /*#__PURE__*/React.createElement("figure", {
    className: css(additionalStyle.style)
  }, /*#__PURE__*/React.createElement("amp-facebook", {
    width: "552",
    height: "303",
    layout: "responsive",
    "data-href": mediaId
  })));
};

const AMPPlaybuzz = props => {
  const {
    mediaId,
    additionalStyle
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-playbuzz",
    src: "https://cdn.ampproject.org/v0/amp-playbuzz-0.1.js"
  })), /*#__PURE__*/React.createElement("figure", {
    className: css(additionalStyle.style)
  }, /*#__PURE__*/React.createElement("amp-playbuzz", {
    width: "552",
    height: "303",
    layout: "responsive",
    src: mediaId
  })));
};

const AMPDailymotion = props => {
  const {
    mediaId,
    additionalStyle
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-dailymotion",
    src: "https://cdn.ampproject.org/v0/amp-dailymotion-0.1.js"
  })), /*#__PURE__*/React.createElement("figure", {
    className: css(additionalStyle.style)
  }, /*#__PURE__*/React.createElement("amp-dailymotion", {
    width: "552",
    height: "303",
    layout: "responsive",
    "data-videoid": mediaId
  })));
};

const createStyle$q = () => StyleSheet.create({
  ad: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent'
  }
});

const AMPAd = props => {
  const {
    adUnit,
    additionalStyle,
    height,
    width,
    isBottomStick = false
  } = props;
  const style = createStyle$q();

  const ADUnit = () => {
    return (
      /*#__PURE__*/

      /*
      // @ts-ignore TS2339: Property 'amp-ad' does not exist on type 'JSX.IntrinsicElements'. */
      React.createElement("amp-ad", {
        width: width,
        height: height,
        type: "doubleclick",
        "data-slot": adUnit
      })
    );
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-ad",
    src: "https://cdn.ampproject.org/v0/amp-ad-0.1.js"
  }), isBottomStick ? /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-sticky-ad",
    src: "https://cdn.ampproject.org/v0/amp-sticky-ad-1.0.js"
  }) : null), /*#__PURE__*/React.createElement("div", {
    className: additionalStyle ? css(additionalStyle.style, style.ad) : css(style.ad)
  }, isBottomStick ? /*#__PURE__*/React.createElement("amp-sticky-ad", {
    layout: "nodisplay"
  }, /*#__PURE__*/React.createElement(ADUnit, null)) : /*#__PURE__*/React.createElement(ADUnit, null)));
};

const AMPSoundclound = props => {
  const {
    mediaId,
    additionalStyle
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-soundcloud",
    src: "https://cdn.ampproject.org/v0/amp-soundcloud-0.1.js"
  })), /*#__PURE__*/React.createElement("figure", {
    className: css(additionalStyle.style)
  }, /*#__PURE__*/React.createElement("amp-soundcloud", {
    width: "16",
    height: "9",
    layout: "responsive",
    "data-trackid": mediaId,
    "data-visual": "true"
  })));
};

const AMPIframe = props => {
  const {
    src,
    additionalStyle,
    height
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-iframe",
    src: "https://cdn.ampproject.org/v0/amp-iframe-0.1.js"
  })), /*#__PURE__*/React.createElement("figure", {
    className: css(additionalStyle.style)
  }, /*#__PURE__*/React.createElement("amp-iframe", {
    height: height,
    sandbox: "allow-scripts allow-same-origin",
    layout: "fixed-height",
    frameborder: "0",
    src: src
  })));
};

const AMPVimeo = props => {
  const {
    mediaId,
    additionalStyle
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-vimeo",
    src: "https://cdn.ampproject.org/v0/amp-vimeo-0.1.js"
  })), /*#__PURE__*/React.createElement("figure", {
    className: css(additionalStyle.style)
  }, /*#__PURE__*/React.createElement("amp-vimeo", {
    width: "16",
    height: "9",
    layout: "responsive",
    "data-videoid": mediaId
  })));
};

const AMPGfycat = props => {
  const {
    additionalStyle,
    mediaId
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-gfycat",
    src: "https://cdn.ampproject.org/v0/amp-gfycat-0.1.js"
  })), /*#__PURE__*/React.createElement("figure", {
    className: css(additionalStyle.style)
  }, /*#__PURE__*/React.createElement("amp-gfycat", {
    width: "16",
    height: "9",
    layout: "responsive",
    "data-gfyid": mediaId
  })));
};

const AMPApester = props => {
  const {
    mediaId,
    additionalStyle
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-apester-media",
    src: "https://cdn.ampproject.org/v0/amp-apester-media-0.1.js"
  })), /*#__PURE__*/React.createElement("figure", {
    className: css(additionalStyle.style)
  }, /*#__PURE__*/React.createElement("amp-apester-media", {
    width: "16",
    height: "9",
    layout: "responsive",
    "data-apester-media-id": mediaId
  })));
};

const AMPHorizontalCard = props => {
  const {
    image,
    imageWidths,
    imageHeightCalculationMethods
  } = props;
  const {
    aspectRatioLarge,
    aspectRatioMedium,
    aspectRatioSmall
  } = useTheme(componentConfigThemeKey$K);

  const ImageComponent = () => /*#__PURE__*/React.createElement(AMPImage, _extends$1({}, image, {
    imageWidths: imageWidths,
    imageAspectRatios: createImageAspectRatios(aspectRatioSmall, aspectRatioMedium, aspectRatioLarge),
    imageHeightCalculationMethods: imageHeightCalculationMethods,
    hideFigcaption: true
  }));

  const HorizontalCardComponent = HorizontalCardWithImage(ImageComponent);
  return /*#__PURE__*/React.createElement(HorizontalCardComponent, props);
};

const AMPRelatedPosts = props => {
  const RelatedPostsComponent = RelatedPostsWithCard(AMPHorizontalCard);
  return /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement(RelatedPostsComponent, props));
};

const AMPContentEnrichment = props => {
  const {
    additionalStyle,
    height,
    blockId,
    width
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-iframe",
    src: "https://cdn.ampproject.org/v0/amp-iframe-0.1.js"
  })), /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: `<figure class="${css(additionalStyle.style)}">
        <amp-iframe
          width="${width}"
          height="${height}"
          resizable
          sandbox="allow-scripts allow-same-origin allow-top-navigation"
          layout="responsive"
          src="https://assets.minutemediacdn.com/content-enrichment/amp.html?id=${blockId}"
        >
        <div overflow tabIndex="0" role="button" aria-label="Read more">
                  Read more!
        </div>
        </amp-iframe>
      </figure>
      `
    }
  }));
};

const getStylesForQuoteIcon = baseUnit => {
  return StyleSheet.create({
    quote: {
      margin: `0 ${baseUnit}px`
    }
  });
};
const AMPQuoteIconForDivider = () => {
  const {
    baseUnit,
    dividerLogoColor
  } = useTheme(componentConfigurationKey$o);
  const styles = getStylesForQuoteIcon(baseUnit);
  const svg = getQuoteSvg(dividerLogoColor);
  const imgSrc = `data:image/svg+xml,${encodeURIComponent(svg)}`;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("amp-img", {
    class: css(styles.quote),
    src: imgSrc,
    alt: "Quote Icon",
    layout: "fixed",
    width: baseUnit * 1.5,
    height: baseUnit * 1.5
  }));
};

const createBlocksComponents = (body, baseUnit, defaultBlocksWidths, marginFactorBetweenTitleAndBlock, marginFactorBetweenBlocks) => {
  let isPreviousElementTitle = false;
  return body.map(block => {
    const {
      type
    } = block;
    const blockStyle = isPreviousElementTitle ? createBlockStyleSheet(baseUnit, marginFactorBetweenTitleAndBlock) : createBlockStyleSheet(baseUnit, marginFactorBetweenBlocks);
    isPreviousElementTitle = false;

    switch (type) {
      case 'ad':
        {
          const {
            adWidth,
            adHeight,
            dataId,
            adUnitPath
          } = block;
          return /*#__PURE__*/React.createElement(AMPAd, {
            key: dataId,
            adUnit: adUnitPath,
            width: adWidth,
            height: adHeight,
            additionalStyle: blockStyle
          });
        }

      case 'image':
        {
          const {
            image,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(ConditionalImageLinkWrapper, {
            dataId: dataId,
            link: image.link || null,
            key: `link-${dataId}`
          }, /*#__PURE__*/React.createElement(AMPImage, _extends$1({
            key: dataId
          }, image, {
            additionalStyle: blockStyle
          })));
        }

      case 'title':
        {
          isPreviousElementTitle = true;
          const {
            listItemNumber,
            text,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(ListItemTitle, {
            key: dataId,
            listItemNumber: listItemNumber,
            text: text,
            additionalStyle: blockStyle,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths
          });
        }

      case 'inline-text':
        {
          const {
            html,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(Paragraph, {
            key: dataId,
            html: html,
            additionalStyle: blockStyle,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths
          });
        }

      case 'quote':
        {
          const {
            text,
            cite,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(Quote, {
            key: dataId,
            text: text,
            cite: cite,
            additionalStyle: blockStyle,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths
          });
        }

      case 'youtube':
        {
          const {
            dataId,
            mediaId
          } = block; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

          return /*#__PURE__*/React.createElement(AMPMediaValidator, {
            key: dataId,
            mediaId: mediaId
          }, /*#__PURE__*/React.createElement(AMPYoutube, {
            mediaId: mediaId,
            additionalStyle: blockStyle
          }));
        }

      case 'twitter':
        {
          const {
            mediaId,
            dataId
          } = block; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

          return /*#__PURE__*/React.createElement(AMPMediaValidator, {
            key: dataId,
            mediaId: mediaId
          }, /*#__PURE__*/React.createElement(AMPTwitter, {
            mediaId: mediaId,
            additionalStyle: blockStyle
          }));
        }

      case 'instagram':
        {
          const {
            mediaId,
            dataId
          } = block; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

          return /*#__PURE__*/React.createElement(AMPMediaValidator, {
            key: dataId,
            mediaId: mediaId
          }, /*#__PURE__*/React.createElement(AMPInstagram, {
            mediaId: mediaId,
            additionalStyle: blockStyle
          }));
        }

      case 'facebook':
        {
          const {
            mediaId,
            dataId
          } = block; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

          return /*#__PURE__*/React.createElement(AMPMediaValidator, {
            key: dataId,
            mediaId: mediaId
          }, /*#__PURE__*/React.createElement(AMPFacebook, {
            mediaId: mediaId,
            additionalStyle: blockStyle
          }));
        }

      case 'jw':
        {
          const {
            playerId,
            videoId,
            dataId
          } = block; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

          return /*#__PURE__*/React.createElement(AMPJWPlayer, {
            key: dataId,
            videoId: videoId,
            playerId: playerId,
            additionalStyle: blockStyle
          });
        }

      case 'giphy':
        {
          const {
            dataId
          } = block;
          const className = css(blockStyle.style); // @ts-ignore TS2339

          return /*#__PURE__*/React.createElement("amp-img", {
            key: dataId,
            alt: block.caption,
            src: block.url,
            layout: "responsive",
            width: block.width,
            height: block.height,
            class: className
          });
        }

      case 'playbuzz':
        {
          const {
            mediaId,
            dataId
          } = block; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

          return /*#__PURE__*/React.createElement(AMPMediaValidator, {
            key: dataId,
            mediaId: mediaId
          }, /*#__PURE__*/React.createElement(AMPPlaybuzz, {
            mediaId: mediaId,
            additionalStyle: blockStyle
          }));
        }

      case 'dailyMotion':
        {
          const {
            mediaId,
            dataId
          } = block; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

          return /*#__PURE__*/React.createElement(AMPMediaValidator, {
            key: dataId,
            mediaId: mediaId
          }, /*#__PURE__*/React.createElement(AMPDailymotion, {
            mediaId: mediaId,
            additionalStyle: blockStyle
          }));
        }

      case 'divider':
        {
          const {
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(ArticleDividerWithIcon, {
            key: dataId,
            additionalStyle: blockStyle,
            dataId: dataId,
            defaultBlocksWidths: defaultBlocksWidths,
            iconComponent: AMPQuoteIconForDivider
          });
        }

      case 'soundcloud':
        {
          const {
            mediaId,
            dataId
          } = block; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

          return /*#__PURE__*/React.createElement(AMPMediaValidator, {
            key: dataId,
            mediaId: mediaId
          }, /*#__PURE__*/React.createElement(AMPSoundclound, {
            mediaId: mediaId,
            additionalStyle: blockStyle
          }));
        }

      case 'iframeEmbed':
        {
          const {
            src,
            dataId,
            height
          } = block;
          return /*#__PURE__*/React.createElement(AMPIframe, {
            key: dataId,
            height: height,
            src: src,
            additionalStyle: blockStyle
          });
        }

      case 'mmPlayer':
        {
          const {
            dataId,
            playerId,
            mediaId
          } = block;
          return /*#__PURE__*/React.createElement(AMPMMPlayer, {
            key: dataId,
            playlistId: mediaId,
            additionalStyle: blockStyle,
            playerId: playerId
          });
        }

      case 'vimeo':
        {
          const {
            dataId,
            mediaId
          } = block;
          return /*#__PURE__*/React.createElement(AMPMediaValidator, {
            key: dataId,
            mediaId: mediaId
          }, /*#__PURE__*/React.createElement(AMPVimeo, {
            key: dataId,
            mediaId: mediaId,
            additionalStyle: blockStyle
          }));
        }

      case 'gfycat':
        {
          const {
            dataId,
            mediaId
          } = block; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

          return /*#__PURE__*/React.createElement(AMPMediaValidator, {
            key: dataId,
            mediaId: mediaId
          }, /*#__PURE__*/React.createElement(AMPGfycat, {
            key: dataId,
            additionalStyle: blockStyle,
            mediaId: mediaId
          }));
        }

      case 'apester':
        {
          const {
            dataId,
            mediaId
          } = block; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

          return /*#__PURE__*/React.createElement(AMPMediaValidator, {
            key: dataId,
            mediaId: mediaId
          }, /*#__PURE__*/React.createElement(AMPApester, {
            key: dataId,
            additionalStyle: blockStyle,
            mediaId: mediaId
          }));
        }

      case 'relatedPosts':
        {
          const {
            title,
            articles,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(AMPRelatedPosts, {
            dataId: dataId,
            key: dataId,
            title: title,
            articles: articles,
            marginBetweenBlocksFactor: marginFactorBetweenBlocks,
            defaultBlocksWidths: defaultBlocksWidths
          });
        }

      case 'mm-content-embed':
        {
          const {
            mediaId,
            dataId,
            height,
            width
          } = block;
          return /*#__PURE__*/React.createElement(AMPContentEnrichment, {
            key: dataId,
            height: height,
            blockId: mediaId,
            additionalStyle: blockStyle,
            width: width
          });
        }

      case 'relatedTopics':
        {
          const {
            title,
            pages,
            dataId
          } = block;
          return /*#__PURE__*/React.createElement(RelatedTopics, {
            key: dataId,
            title: title,
            pages: pages,
            marginBetweenBlocksFactor: marginFactorBetweenBlocks,
            defaultBlocksWidths: defaultBlocksWidths,
            dataId: dataId
          });
        }

      default:
        return null;
    }
  });
};

const createMMPlayer = (videoPlaylistId, videoPlayerId, baseUnit) => /*#__PURE__*/React.createElement(AMPMMPlayer, {
  key: "first-amp-mmPlayer",
  playlistId: videoPlaylistId,
  additionalStyle: createBlockStyleSheet(baseUnit, 1),
  playerId: videoPlayerId
});

const AMPArticleContentComponent = props => {
  const {
    videoPlaylistId,
    videoPlayerId,
    body,
    defaultBlocksWidths
  } = props;
  const {
    baseUnit,
    marginBetweenBlocksFactorAfterTitle,
    marginBetweenBlocksFactor
  } = useTheme(componentConfigurationKey$c);
  return /*#__PURE__*/React.createElement("div", null, videoPlaylistId && videoPlayerId ? createMMPlayer(videoPlaylistId, videoPlayerId, baseUnit) : null, body ? createBlocksComponents(body, baseUnit, defaultBlocksWidths, marginBetweenBlocksFactorAfterTitle, marginBetweenBlocksFactor) : null);
};
const AMPArticleContent = props => /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(AMPArticleContentComponent, props));

const componentConfigurationKey$b = 'copyLinkButton';

const getStyles$v = () => {
  return StyleSheet.create({
    copyLinkIcon: {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      width: '16px',
      transition: '200ms ease-in-out'
    },
    copyLinkIconAction: {
      left: '-150%'
    },
    successIcon: {
      left: '150%'
    },
    successIconAction: {
      left: '50%'
    }
  });
};

const copyToClipboard$1 = text => {
  const el = document.createElement('textarea');
  el.value = text;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.opacity = '0';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};

const CopyLinkButton$1 = props => {
  const {
    canonical,
    buttonClass
  } = props;
  const {
    color
  } = useTheme(componentConfigurationKey$b);
  const styles = getStyles$v();
  let timeout;
  const [wasCopied, setWasCopied] = React.useState(false);

  const onClickCopy = () => {
    copyToClipboard$1(canonical);
    clearTimeout(timeout);
    setWasCopied(true);
    timeout = setTimeout(() => {
      setWasCopied(false);
    }, 1000);
  };

  const copyIconAction = wasCopied ? styles.copyLinkIconAction : styles.copyLinkIcon;
  const succcessIconAction = wasCopied ? styles.successIconAction : styles.successIcon;
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: buttonClass,
    onClick: onClickCopy
  }, /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    className: css(styles.copyLinkIcon, copyIconAction)
  }, /*#__PURE__*/React.createElement("g", {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.3,49.8c-0.9,0-1.8-0.3-2.6-0.9C0.6,48.1,0,46.8,0,45.5L0,4.3C0,1.9,1.9,0,4.3,0l41.2,0c2.4,0,4.3,1.9,4.3,4.3l0,6.5 l-7.1,0l0-3.7l-35.6,0l0,35.5l3.8,0l0,7.1l-6.3,0C4.5,49.8,4.4,49.8,4.3,49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6,64c-2.4,0-4.3-1.9-4.3-4.3l0-41.1c0-2.4,1.9-4.3,4.3-4.3l41,0c2.4,0,4.3,1.9,4.3,4.3L64,59.7c0,2.4-1.9,4.3-4.3,4.3 L18.6,64z M21.3,21.3l0,35.5l35.5,0l-0.1-35.5L21.3,21.3z M56.8,18.5C56.8,18.5,56.8,18.5,56.8,18.5L56.8,18.5z"
  }))), /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    className: css(styles.copyLinkIcon, succcessIconAction)
  }, /*#__PURE__*/React.createElement("g", {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5,10.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1,56L1,32.9c-1.4-1.4-1.3-3.7,0.1-5.1c1.4-1.4,3.7-1.4,5,0.1l17,17.8L57.9,9.1c1.4-1.4,3.6-1.5,5-0.1 c1.4,1.4,1.4,3.7,0.1,5.1L23.1,56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4,43.4"
  })))));
};

const componentConfigurationKey$a = 'articleShareButton';
const socialButtonAnimation$1 = {
  '0%': {
    opacity: 0
  },
  '100%': {
    opacity: 1
  }
};

const getStyles$u = (baseUnit, backgroundColor) => {
  return StyleSheet.create({
    shareMenu: {
      marginTop: `${baseUnit / 2}px`,
      [MEDIA_BREAKPOINTS.large]: {
        width: '48px'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        width: '40px'
      },
      [MEDIA_BREAKPOINTS.small]: {
        width: '40px'
      }
    },
    socialButton: {
      backgroundColor,
      border: 'none',
      borderRadius: '100%',
      position: 'relative',
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      cursor: 'pointer',
      outline: 'none',
      overflow: 'hidden',
      opacity: 0,
      animationName: [socialButtonAnimation$1],
      animationDuration: '500ms',
      animationFillMode: 'forwards',
      [MEDIA_BREAKPOINTS.large]: {
        marginBottom: `${baseUnit / 4}px`,
        width: '40px',
        height: '40px'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        marginBottom: `${baseUnit / 4}px`,
        width: '40px',
        height: '40px'
      },
      [MEDIA_BREAKPOINTS.small]: {
        marginBottom: `${baseUnit / 3}px`,
        width: '36px',
        height: '36px'
      }
    },
    socialIcon: {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      [MEDIA_BREAKPOINTS.large]: {
        height: '20px'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        height: '20px'
      },
      [MEDIA_BREAKPOINTS.small]: {
        height: '16px'
      }
    }
  });
};

const getAnimationDelayClass$1 = index => {
  return StyleSheet.create({
    animationModifier: {
      animationDelay: `${index * 50}ms`
    }
  });
};

const getShareButtons$1 = (buttons, styles) => buttons.map((button, index) => {
  const {
    shareURL,
    src,
    type
  } = button;
  const animationDurationClass = getAnimationDelayClass$1(index);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    React.createElement(Link, {
      className: css(styles.socialButton, animationDurationClass.animationModifier),
      key: index,
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: () => {
        window.open(shareURL, '_blank', 'noopener');
        return false;
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: src,
      alt: type,
      className: css(styles.socialIcon)
    }))
  );
});

const ShareMenu = props => {
  const {
    shareConfig,
    canonical
  } = props;
  const {
    baseUnit,
    buttonBackgroundColor
  } = useTheme(componentConfigurationKey$a);
  const styles = getStyles$u(baseUnit, buttonBackgroundColor);
  const copyLinkAnimationClass = getAnimationDelayClass$1(shareConfig.length);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(styles.shareMenu)
  }, getShareButtons$1(shareConfig, styles), /*#__PURE__*/React.createElement(CopyLinkButton$1, {
    canonical: canonical,
    buttonClass: css(styles.socialButton, copyLinkAnimationClass.animationModifier)
  })));
};

const componentConfigurationKey$9 = 'articleShareButton';
const shareButtonSize = {
  xLarge: 48,
  large: 48,
  medium: 40,
  small: 40
};

const getStyles$t = (baseUnit, backgroundColor, buttonHoverColor) => {
  return StyleSheet.create({
    wrapper: {
      position: 'absolute',
      right: 0,
      zIndex: 1000,
      marginRight: `${baseUnit}px`,
      [MEDIA_BREAKPOINTS.large]: {
        width: '40px',
        top: `calc((${shareButtonSize.large}px - 100%)/-2)`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        width: '32px',
        top: `calc((${shareButtonSize.medium}px - 100%)/-2)`
      },
      [MEDIA_BREAKPOINTS.small]: {
        width: '32px',
        top: `calc((${shareButtonSize.small}px - 100%)/-2)`
      }
    },
    shareButton: {
      outline: 'none',
      border: 'none',
      background: 'transparent',
      borderRadius: '100%',
      '-webkit-tap-highlight-color': 'transparent',
      [MEDIA_BREAKPOINTS.large]: {
        width: `${shareButtonSize.large}px`,
        height: `${shareButtonSize.large}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        width: `${shareButtonSize.medium}px`,
        height: `${shareButtonSize.medium}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        width: `${shareButtonSize.small}px`,
        height: `${shareButtonSize.small}px`
      },
      '@media (hover: hover)': {
        ':hover': {
          backgroundColor: buttonHoverColor
        }
      }
    },
    shareButtonOpen: {
      backgroundColor: buttonHoverColor
    },
    shareIcon: {
      margin: 'auto',
      display: 'block',
      cursor: 'pointer',
      [MEDIA_BREAKPOINTS.large]: {
        width: '32px'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        width: '24px'
      },
      [MEDIA_BREAKPOINTS.small]: {
        width: '24px'
      }
    }
  });
};

const ShareButton = props => {
  const {
    shareConfig,
    canonical
  } = props;
  const {
    baseUnit,
    buttonBackgroundColor,
    buttonHoverColor
  } = useTheme(componentConfigurationKey$9);
  const styles = getStyles$t(baseUnit, buttonBackgroundColor, buttonHoverColor);
  const [isOpen, setIsOpen] = React.useState(false);
  const shareButtonClass = isOpen ? css(styles.shareButton, styles.shareButtonOpen) : css(styles.shareButton);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapper)
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: shareButtonClass,
    "aria-label": "share-button"
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 16 16",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    className: css(styles.shareIcon),
    onClick: () => setIsOpen(!isOpen)
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.58105,13.3911 L9.58105,9.7861 C9.58105,9.7861 4.17905,9.4641 5.00000001e-05,14.0001 C5.00000001e-05,14.0001 1.13705,5.6716 9.57955,4.6051 L9.57955,1.0001 L16.00005,7.1946 L9.58105,13.3911 Z",
    fill: buttonBackgroundColor,
    fillRule: "nonzero"
  })))), isOpen ? /*#__PURE__*/React.createElement(ShareMenu, {
    shareConfig: shareConfig,
    canonical: canonical
  }) : null));
};

const ShareConfigLinks = props => {
  const {
    shareConfig,
    linkStyle
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, shareConfig.map((button, index) => {
    const {
      shareURL,
      src,
      type
    } = button;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      React.createElement(Link, {
        key: index,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: () => {
          window.open(shareURL, '_blank', 'noopener');
          return false;
        },
        className: css(linkStyle)
      }, /*#__PURE__*/React.createElement("img", {
        src: src,
        alt: type,
        height: "16"
      }))
    );
  }));
};

const componentConfigurationKey$8 = 'verticalShareMenu';

const getStyles$s = (backgroundColor, baseUnit, smallScreenOnly = false) => {
  return StyleSheet.create({
    sticky: {
      [MEDIA_BREAKPOINTS.large]: {
        position: 'sticky',
        top: `${baseUnit * 4}px`,
        display: smallScreenOnly ? 'none' : 'block',
        marginBottom: 0,
        paddingLeft: `${baseUnit}px`,
        marginLeft: 'unset'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        position: 'sticky',
        top: `${baseUnit * 5}px`,
        display: smallScreenOnly ? 'none' : 'block',
        marginBottom: 0,
        paddingLeft: 0,
        marginLeft: `-${baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        position: 'relative',
        top: 'unset',
        display: 'block',
        marginBottom: `${baseUnit}px`,
        paddingLeft: 0,
        marginLeft: 'unset'
      }
    },
    wrapperBase: {
      display: 'flex',
      marginTop: `${baseUnit}px`
    },
    wrapperDefault: {
      [MEDIA_BREAKPOINTS.large]: {
        flexDirection: 'column',
        position: 'absolute',
        transform: 'unset'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        flexDirection: 'column',
        position: 'absolute',
        transform: 'translateX(50px)'
      },
      [MEDIA_BREAKPOINTS.small]: {
        flexDirection: 'row',
        justifyContent: 'center',
        position: 'relative',
        transform: 'unset'
      }
    },
    link: {
      position: 'relative',
      display: 'grid',
      height: '40px',
      width: '40px',
      borderRadius: '100%',
      backgroundColor,
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden',
      ':not(:first-child)': {
        [MEDIA_BREAKPOINTS.large]: {
          marginTop: '10px',
          marginLeft: 0
        },
        [MEDIA_BREAKPOINTS.medium]: {
          marginTop: '10px',
          marginLeft: 0
        },
        [MEDIA_BREAKPOINTS.small]: {
          marginTop: 0,
          marginLeft: '10px'
        }
      }
    }
  });
};

const SwitchableShareMenu = props => {
  const {
    shareConfig,
    canonical,
    smallScreenOnly
  } = props;
  const {
    backgroundColor,
    baseUnit
  } = useTheme(componentConfigurationKey$8);
  const styles = getStyles$s(backgroundColor, baseUnit, smallScreenOnly);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(styles.sticky)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapperBase, styles.wrapperDefault)
  }, /*#__PURE__*/React.createElement(ShareConfigLinks, {
    shareConfig: shareConfig,
    linkStyle: styles.link
  }), /*#__PURE__*/React.createElement(CopyLinkButton$1, {
    canonical: canonical,
    buttonClass: css(styles.link)
  }))));
};

const componentConfigurationKey$7 = 'bottomPageRecommendations';

const getRecommendationCardPlaceHolderStyle = (baseUnit, backgroundColor) => StyleSheet.create({
  cardPlaceHolderWrapper: {
    width: '100%',
    marginTop: `${baseUnit * 0.5}px`
  },
  cardPlaceHolder: {
    paddingTop: 'calc(100% / (16 / 9))',
    backgroundColor
  }
});
const RecommendationCardPlaceHolder = () => {
  const {
    baseUnit,
    placeholderBackgroundColor
  } = useTheme(componentConfigurationKey$7);
  const style = getRecommendationCardPlaceHolderStyle(baseUnit, placeholderBackgroundColor);
  return /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement("div", {
    className: css(style.cardPlaceHolderWrapper)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css(style.cardPlaceHolder)
  })));
};

const useRecommendationScrollTrigger = onScrolledIntoView => {
  const wrapper = React.useRef(null);
  React.useEffect(() => {
    if (!wrapper.current || typeof IntersectionObserver === 'undefined') return;
    const options = {
      rootMargin: '0px 0px 100px 0px',
      threshold: 0.1
    };
    const obsrever = new IntersectionObserver(e => {
      if (e[0].isIntersecting) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        obsrever.unobserve(wrapper.current);
        onScrolledIntoView();
      }
    }, options); // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

    obsrever.observe(wrapper.current);
  }, [onScrolledIntoView]);
  return wrapper;
};
const getSectionStyle = baseUnit => StyleSheet.create({
  section: {
    margin: `0 ${baseUnit}px`,
    [MEDIA_BREAKPOINTS.large]: {
      margin: `0 ${baseUnit}px 0 ${baseUnit + 80}px`
    }
  }
});

const createArrayWithPlaceHoldersNumberLength = numberOfPlaceHolders => new Array(numberOfPlaceHolders).fill(0);

const createPlaceholders = numberOfPlaceHolders => {
  return createArrayWithPlaceHoldersNumberLength(numberOfPlaceHolders).map((item, index) => /*#__PURE__*/React.createElement(RecommendationCardPlaceHolder, {
    key: index
  }));
};

const getStyle$6 = (color, baseUnit) => StyleSheet.create({
  square: {
    width: `${baseUnit}px`,
    height: `${baseUnit}px`,
    marginRight: `${baseUnit * 0.5}px`,
    backgroundColor: color
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color,
    marginTop: `${baseUnit * 2}px`
  }
});

const PostRecommendationsHeader = ({
  header
}) => {
  const {
    titleColor,
    baseUnit
  } = useTheme(componentConfigurationKey$7);
  const style = getStyle$6(titleColor, baseUnit);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(style.container)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(style.square)
  }), /*#__PURE__*/React.createElement(H2, null, header)));
};

const SixSixPostRecommendations = props => {
  const {
    sectionName,
    sectionCards,
    onScrolledIntoView
  } = props;
  const {
    baseUnit
  } = useTheme();
  const memoizedOnScrolledIntoView = React.useCallback(onScrolledIntoView, []);
  const wrapper = useRecommendationScrollTrigger(memoizedOnScrolledIntoView);
  const sectionStyle = getSectionStyle(baseUnit);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("section", {
    ref: wrapper,
    className: css(sectionStyle.section)
  }, /*#__PURE__*/React.createElement(EventProvider, {
    category: "Recommendations",
    action: "click"
  }, /*#__PURE__*/React.createElement(PostRecommendationsHeader, {
    header: sectionName
  }), sectionCards && sectionCards.length !== 0 ? /*#__PURE__*/React.createElement(SixSixArticleList, {
    cardsProps: sectionCards
  }) : createPlaceholders(12))));
};

const getStyle$5 = baseUnit => StyleSheet.create({
  card: {
    marginTop: `${baseUnit * 0.5}px`
  }
});

const imageWidths$e = createImageWidths(540, 720, 720);
const OnTopCardsPostRecommendations = props => {
  const {
    sectionName,
    sectionCards,
    onScrolledIntoView
  } = props;
  const {
    baseUnit
  } = useTheme();
  const memoizedOnScrolledIntoView = React.useCallback(onScrolledIntoView, []);
  const wrapper = useRecommendationScrollTrigger(memoizedOnScrolledIntoView);
  const style = getStyle$5(baseUnit);
  const sectionStyle = getSectionStyle(baseUnit);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("section", {
    ref: wrapper,
    className: css(sectionStyle.section)
  }, /*#__PURE__*/React.createElement(EventProvider, {
    category: "Recommendations",
    action: "click"
  }, /*#__PURE__*/React.createElement(PostRecommendationsHeader, {
    header: sectionName
  }), sectionCards && sectionCards.length !== 0 ? sectionCards.map((card, index) => /*#__PURE__*/React.createElement("div", {
    className: css(style.card),
    key: index
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, card, {
    imageWidths: imageWidths$e
  })))) : createPlaceholders(4))));
};

const createFontFaceSRC = fonts => {
  return fonts.reduce((acc, currentFont, index) => {
    if (index === 0) {
      return `url("${currentFont.url}") format("${currentFont.type}")`;
    }

    return `${acc}, url("${currentFont.url}") format("${currentFont.type}")`;
  }, '');
};

const FontFace = props => {
  const {
    fontConfiguration
  } = props;
  const {
    family,
    weight,
    fontURLs
  } = fontConfiguration;
  const customFont = {
    fontFamily: family,
    fontWeight: weight,
    src: createFontFaceSRC(fontURLs),
    fontDisplay: 'swap'
  };
  const customFontStyle = StyleSheet.create({
    style: {
      fontFamily: [customFont]
    }
  });
  css(customFontStyle.style);
  return null;
};

const FontLink = ({
  fontConfiguration
}) => {
  const stylesheetByProvider = fontConfiguration.stylesheetUrl;
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("link", {
    rel: "preload",
    as: "style",
    href: stylesheetByProvider,
    onLoad: "this.onload=null;this.rel='stylesheet'"
  }), /*#__PURE__*/React.createElement("noscript", null, `
      <link rel="stylesheet" href=${stylesheetByProvider} />
      `));
};

const createFontFamilyLinkOrFontFace$1 = (fontConfiguration, index) => {
  switch (fontConfiguration.type) {
    case interfaces.stylesheetUrlTypeName:
      return /*#__PURE__*/React.createElement(FontLink, {
        fontConfiguration: fontConfiguration,
        key: index
      });

    case interfaces.fontFaceTypeName:
      {
        return /*#__PURE__*/React.createElement(FontFace, {
          fontConfiguration: fontConfiguration,
          key: index
        });
      }

    default:
      return null;
  }
}; // @ts-ignore TS2339


const haveAllWebFontsLoaded = fontsConfiguration => fontsConfiguration.every(font => document.fonts.check(`1em ${font.family}`));

const WebFontsLoadingFlagContext = React.createContext(false);
const WebFonts = props => {
  const {
    fontsConfiguration,
    children
  } = props;
  const [webFontsLoadingFlag, setWebFontsLoadingFlag] = React.useState(false);
  const waitForFontsToRender = React.useCallback(() => {
    setTimeout(() => {
      setWebFontsLoadingFlag(true);
    }, 100);
  }, []);
  const waitForFontsToLoad = React.useCallback(() => {
    const interval = setInterval(() => {
      if (haveAllWebFontsLoaded(fontsConfiguration)) {
        clearInterval(interval);
        waitForFontsToRender();
      }
    }, 60);
  }, [waitForFontsToRender, fontsConfiguration]);
  React.useEffect(() => {
    // @ts-ignore TS2339
    const documentFonts = document.fonts;

    if (documentFonts) {
      if (haveAllWebFontsLoaded(fontsConfiguration)) {
        waitForFontsToRender();
      } else {
        documentFonts.ready.then(waitForFontsToLoad);
      }
    }
  }, [fontsConfiguration, waitForFontsToRender, waitForFontsToLoad]);
  return /*#__PURE__*/React.createElement(WebFontsLoadingFlagContext.Provider, {
    value: webFontsLoadingFlag
  }, fontsConfiguration.map(createFontFamilyLinkOrFontFace$1), children);
};

const FontAmpLink = ({
  fontConfiguration
}) => {
  const errorReporting = React.useContext(ErrorReporting);
  const stylesheetByProvider = fontConfiguration.stylesheetUrl;

  try {
    return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("link", {
      rel: "stylesheet",
      href: stylesheetByProvider
    }));
  } catch (e) {
    errorReporting.reportException(e);
    return null;
  }
};

const createFontFamilyLinkOrFontFace = (fontConfiguration, index) => {
  switch (fontConfiguration.type) {
    case interfaces.stylesheetUrlTypeName:
      return /*#__PURE__*/React.createElement(FontAmpLink, {
        key: index,
        fontConfiguration: fontConfiguration
      });

    case interfaces.fontFaceTypeName:
      {
        return /*#__PURE__*/React.createElement(FontFace, {
          key: index,
          fontConfiguration: fontConfiguration
        });
      }

    default:
      return null;
  }
};

const AmpWebFonts = props => {
  const {
    children,
    fontsConfiguration
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, fontsConfiguration.map(createFontFamilyLinkOrFontFace), children);
};

const createSponsorStyle$1 = (baseUnit, textColor) => StyleSheet.create({
  logo: {
    height: '40px'
  },
  text: {
    color: textColor,
    marginBottom: `${0.5 * baseUnit}px`
  },
  wrapper: {
    textAlign: 'center',
    margin: `${1 * baseUnit}px 0px`
  }
});

const Sponsor = props => {
  const {
    text,
    logo,
    brandName,
    href
  } = props;
  const {
    sponsorTextColor,
    baseUnit
  } = useTheme(componentConfigurationKey$o);
  const style = createSponsorStyle$1(baseUnit, sponsorTextColor);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(style.wrapper)
  }, /*#__PURE__*/React.createElement(H5, {
    styles: semanticCSS(style.text)
  }, text), /*#__PURE__*/React.createElement(Link, {
    href: href,
    rel: "nofollow sponsored"
  }, logo ? /*#__PURE__*/React.createElement("img", {
    className: css(style.logo),
    alt: brandName,
    src: `data:image/svg+xml,${encodeURIComponent(logo)}`
  }) : null)));
};

const componentConfigThemeKey$B = 'authorPage';

const getStyle$4 = baseUnit => StyleSheet.create({
  wrapper: {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    boxSizing: 'border-box',
    border: '5px solid white',
    marginTop: `${baseUnit * 2}px`,
    [MEDIA_BREAKPOINTS.large]: {
      width: '160px',
      height: '160px'
    },
    [MEDIA_BREAKPOINTS.medium]: {
      width: '120px',
      height: '120px'
    },
    [MEDIA_BREAKPOINTS.small]: {
      width: '120px',
      height: '120px'
    }
  }
});

const imageWidths$d = createImageWidths(180, 180, 180);
const AuthorImage = props => {
  const {
    image
  } = props;
  const {
    baseUnit,
    imageBoxShadowTypeNormal
  } = useTheme(componentConfigThemeKey$B);
  const style = getStyle$4(baseUnit);
  const aspectRatio = {
    x: 1,
    y: 1
  };
  const boxShadowStyle = createStyleForBoxShadow({
    boxShadowTypeNormal: imageBoxShadowTypeNormal
  });
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(boxShadowStyle.style, style.wrapper)
  }, /*#__PURE__*/React.createElement(Image, _extends$1({}, image, {
    aspectRatio: aspectRatio,
    imageWidths: imageWidths$d
  }))));
};

const numOnTop = 4;
const numHorizontal = 8;
const numVertical = 4;

const getStyles$r = baseUnit => StyleSheet.create({
  wrapper: {
    maxWidth: '640px',
    margin: 'auto',
    display: 'grid',
    gridTemplateColumns: '1fr',
    marginTop: `${baseUnit}px`,
    gridRowGap: `${baseUnit}px`
  }
});

const imageWidthsOnTopCard$3 = createImageWidths(360, 1080, 1080);
const imageWidthsHorizontalCard$4 = createImageWidths(180, 360, 360);
const imageWidthsVerticalCard$1 = createImageWidths(360, 1080, 1080);

const arrangeCards = articles => {
  const structure = [numOnTop, numHorizontal, numVertical];
  let section = 0;
  let counter = 0;
  return articles.reduce((acc, article) => {
    let Component;

    switch (section) {
      case 0:
        Component = /*#__PURE__*/React.createElement(OnTopCard, _extends$1({
          key: article.id
        }, article, {
          imageWidths: imageWidthsOnTopCard$3
        }));
        break;

      case 1:
        Component = /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({
          key: article.id
        }, article, {
          imageWidths: imageWidthsHorizontalCard$4
        }));
        break;

      case 2:
        Component = /*#__PURE__*/React.createElement(VerticalCard, _extends$1({
          key: article.id
        }, article, {
          imageWidths: imageWidthsVerticalCard$1
        }));
        break;

      default:
        Component = null;
        break;
    }

    counter += 1;

    if (counter >= structure[section]) {
      counter = 0;
      section = section === structure.length - 1 ? 0 : section + 1;
    }

    return [...acc, Component];
  }, []);
};

const AuthorPageFeed = props => {
  const {
    baseUnit
  } = useTheme();
  const {
    articles
  } = props;
  const styles = getStyles$r(baseUnit);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, articles && articles.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapper)
  }, arrangeCards(articles)));
};

const getOverlayHeight = (baseUnit, imageHeight, menuHeight) => {
  return baseUnit * 2.5 + imageHeight / 2 + menuHeight;
};

const getStyles$q = (baseUnit, color, headerHeights) => StyleSheet.create({
  wrapper: {
    position: 'absolute',
    background: `linear-gradient(0deg, rgba(0,0,0,0) 0%, ${hex2rgba(color, 1)} 100%)`,
    top: 0,
    left: 0,
    right: 0,
    [MEDIA_BREAKPOINTS.large]: {
      height: `${getOverlayHeight(baseUnit, 160, headerHeights.large * baseUnit)}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      height: `${getOverlayHeight(baseUnit, 120, headerHeights.medium * baseUnit)}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      height: `${getOverlayHeight(baseUnit, 120, headerHeights.small * baseUnit)}px`
    }
  }
});

const AuthorTopGradient = props => {
  const {
    headerHeights
  } = props;
  const {
    baseUnit,
    backgroundGradientColor
  } = useTheme(componentConfigThemeKey$B);
  const styles = getStyles$q(baseUnit, backgroundGradientColor, headerHeights);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapper)
  }));
};

const getStyle$3 = (baseUnit, backgroundColor) => StyleSheet.create({
  wrapper: {
    display: 'flex',
    justifyContent: 'center'
  },
  socialButton: {
    display: 'flex',
    width: '32px',
    height: '32px',
    borderRadius: '100%',
    overflow: 'hidden',
    backgroundColor,
    justifyContent: 'center',
    alignItems: 'center',
    margin: `0 ${baseUnit / 4}px`
  }
});

const createSocialButtonStyle$1 = (socialIconsNormalColor, socialIconsHoverColor) => {
  return StyleSheet.create({
    style: {
      height: '16px',
      fill: socialIconsNormalColor,
      ':hover': {
        fill: socialIconsHoverColor
      }
    }
  }).style;
};

const OldHorizontalSocialButtonsWrapper = props => {
  const {
    buttons
  } = props;
  const {
    baseUnit,
    socialIconsBackgroundColor
  } = useTheme(componentConfigThemeKey$B);
  const style = getStyle$3(baseUnit, socialIconsBackgroundColor);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(style.wrapper)
  }, buttons.map((button, index) => /*#__PURE__*/React.createElement(Link, {
    className: css(style.socialButton),
    key: index,
    href: button.link
  }, /*#__PURE__*/React.createElement("img", {
    src: button.src,
    alt: button.alt
  })))));
};
const HorizontalSocialButtonsWrapper = props => {
  const {
    buttons
  } = props;
  const {
    socialIconsNormalColor,
    socialIconsHoverColor,
    socialIconsBackgroundColor,
    baseUnit
  } = useTheme(componentConfigThemeKey$B);
  const style = getStyle$3(baseUnit, socialIconsBackgroundColor);
  const socialButtonStyle = createSocialButtonStyle$1(socialIconsNormalColor, socialIconsHoverColor);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(style.wrapper)
  }, buttons.map((link, index) => {
    const svg = link.src.replace(/<svg/g, `<svg class="${css(socialButtonStyle)}"`);
    return /*#__PURE__*/React.createElement(Link, {
      href: link.href,
      key: index,
      rel: "noopener",
      target: "_blank",
      dangerouslySetInnerHTML: {
        __html: svg
      },
      alt: link.alt,
      className: css(style.socialButton)
    });
  })));
};

const getStyles$p = (titleColor, metaDataColor, bioColor, baseUnit) => StyleSheet.create({
  title: {
    color: titleColor,
    textAlign: 'center',
    maxWidth: '640px',
    margin: `${baseUnit / 2}px auto`
  },
  metaData: {
    textAlign: 'center',
    color: metaDataColor,
    maxWidth: '640px',
    margin: 'auto',
    marginTop: `${baseUnit}px`,
    marginBottom: `${baseUnit / 2}px`
  },
  description: {
    color: bioColor,
    maxWidth: '640px',
    margin: 'auto',
    textAlign: 'center'
  }
});

const getMetaData = ({
  joinDateText,
  joinDate
}) => {
  const base = `${joinDateText} ${joinDate}`;
  return base;
};

const Author = props => {
  const {
    image,
    name,
    socialButtons,
    bio,
    articles,
    paddingFactors,
    oldSocialButtons
  } = props;
  const {
    titleColor,
    metaDataColor,
    bioColor,
    baseUnit
  } = useTheme(componentConfigThemeKey$B);
  const headerHeights = useHeaderHeights();
  const styles = getStyles$p(titleColor, metaDataColor, bioColor, baseUnit);
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const metaData = getMetaData(props);

  const getHorizontalSocialButtonsWrapperComponent = () => {
    if (socialButtons) {
      return /*#__PURE__*/React.createElement(HorizontalSocialButtonsWrapper, {
        buttons: socialButtons
      });
    }

    if (oldSocialButtons) {
      return /*#__PURE__*/React.createElement(OldHorizontalSocialButtonsWrapper, {
        buttons: oldSocialButtons
      });
    }

    return null;
  };

  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle)
  }, /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(AuthorTopGradient, {
    headerHeights: headerHeights
  })), /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(AuthorImage, {
    image: image
  })), /*#__PURE__*/React.createElement(H1, {
    styles: semanticCSS(styles.title)
  }, name), /*#__PURE__*/React.createElement(ErrorBoundary, null, getHorizontalSocialButtonsWrapperComponent()), /*#__PURE__*/React.createElement(H4, {
    styles: semanticCSS(styles.metaData)
  }, metaData), bio ? /*#__PURE__*/React.createElement(P, {
    styles: semanticCSS(styles.description)
  }, bio) : null, /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(AuthorPageFeed, {
    articles: articles
  }))));
};

const componentConfigurationKey$6 = 'HoverAuthorsWithRoundImage';
const largeScreenImageSize = 80;
const smallScreenImageSize = 50;

const getStyles$o = (baseUnit, marginTopFactor) => {
  return StyleSheet.create({
    wrapper: {
      display: 'grid',
      [MEDIA_BREAKPOINTS.large]: {
        width: '160px',
        position: 'absolute',
        left: `${baseUnit}px`,
        gridRowGap: `${baseUnit * 2}px`,
        marginTop: marginTopFactor ? `${marginTopFactor * baseUnit}px` : 'unset'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        width: 'unset',
        position: 'relative',
        left: 'unset',
        transform: 'unset',
        gridTemplateColumns: '1fr 1fr',
        justifyItems: 'center',
        gridRowGap: `${baseUnit}px`,
        maxWidth: '360px',
        margin: 'auto',
        marginTop: `${baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        width: 'unset',
        position: 'relative',
        left: 'unset',
        transform: 'unset',
        gridTemplateColumns: '1fr 1fr',
        justifyItems: 'center',
        gridRowGap: `${baseUnit}px`,
        maxWidth: '260px',
        margin: 'auto',
        marginTop: `${baseUnit}px`
      }
    }
  });
};

const getImageAdditionalStyle$1 = () => {
  return StyleSheet.create({
    style: {
      borderRadius: '100%',
      display: 'block',
      overflow: 'hidden',
      [MEDIA_BREAKPOINTS.large]: {
        width: `${largeScreenImageSize}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        width: `${smallScreenImageSize}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        width: `${smallScreenImageSize}px`
      }
    }
  });
};

const getImageStyle$1 = () => {
  return StyleSheet.create({
    oddLink: {
      [MEDIA_BREAKPOINTS.medium]: {
        gridColumn: '1 / 3'
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridColumn: '1 / 3'
      }
    },
    link: {
      display: 'grid',
      justifyItems: 'center',
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateRows: `${largeScreenImageSize}px auto`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateRows: `${smallScreenImageSize}px auto`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateRows: `${smallScreenImageSize}px auto`
      }
    }
  });
};

const getTextsStyle = (baseUnit, authorColor, dateColor, bylineColor, separatorColor) => StyleSheet.create({
  authorText: {
    textAlign: 'center',
    color: authorColor,
    [MEDIA_BREAKPOINTS.large]: {
      marginTop: `${baseUnit / 2}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      marginTop: `${baseUnit / 2}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      marginTop: `${baseUnit / 4}px`
    }
  },
  date: {
    display: 'block',
    textAlign: 'center',
    color: dateColor
  },
  byline: {
    textAlign: 'center',
    color: bylineColor
  },
  separator: {
    height: '1px',
    width: '100%',
    backgroundColor: separatorColor,
    margin: `${baseUnit / 4}px auto ${baseUnit / 4}px`
  }
});

const getAuthorTexts = (name, byline, updatedText, createdDate, createdAtISO, updatedDate, updatedAtISO, showUpdatedAt, showDate, themeProps) => {
  const {
    baseUnit,
    authorColor,
    dateColor,
    bylineColor,
    separatorColor,
    authorFontSizeLarge,
    authorFontSizeSmall,
    authorFontSizeMedium,
    dateFontSizeSmall,
    dateFontSizeMedium,
    dateFontSizeLarge,
    bylineFontSizeLarge,
    bylineFontSizeMedium,
    bylineFontSizeSmall,
    fontSizesStyles
  } = themeProps;
  const hasByline = typeof byline === 'string' && byline.trim().length > 0;
  const hasSeparator = hasByline && showDate;
  const styles = getTextsStyle(baseUnit, authorColor, dateColor, bylineColor, separatorColor);
  const fontSizes = {
    fontSizeLarge: dateFontSizeLarge,
    fontSizeMedium: dateFontSizeMedium,
    fontSizeSmall: dateFontSizeSmall
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(P, {
    styles: semanticCSS(styles.authorText),
    fontSizeLarge: authorFontSizeLarge,
    fontSizeMedium: authorFontSizeMedium,
    fontSizeSmall: authorFontSizeSmall
  }, name), hasByline && /*#__PURE__*/React.createElement(P, {
    styles: semanticCSS(styles.byline),
    fontSizeLarge: bylineFontSizeLarge,
    fontSizeMedium: bylineFontSizeMedium,
    fontSizeSmall: bylineFontSizeSmall
  }, byline), hasSeparator && /*#__PURE__*/React.createElement("div", {
    className: css(styles.separator)
  }), showDate ? /*#__PURE__*/React.createElement("time", {
    dateTime: createdAtISO,
    className: css(styles.date, getStyleBySize(fontSizesStyles, fontSizes))
  }, createdDate) : null, showDate && showUpdatedAt ? /*#__PURE__*/React.createElement("time", {
    dateTime: updatedAtISO,
    className: css(styles.date, getStyleBySize(fontSizesStyles, fontSizes))
  }, ` | ${updatedText} ${updatedDate}`) : null);
};

const getAuthors$1 = (authors, createdDate, createdAtISO, updatedDate, updatedAtISO, updatedText, showUpdatedAt, themeProps) => {
  const isOddList = authors.length % 2 !== 0;
  const styles = getImageStyle$1();
  const additionalStyle = getImageAdditionalStyle$1();
  const imageWidths = createImageWidths(50, 50, 80);

  const getLinkClass = index => {
    return isOddList && index === 0 ? css(styles.link, styles.oddLink) : css(styles.link);
  };

  return authors.map((author, index) => {
    const isFirstAuthor = index === 0;
    const showTimestampForAuthor = themeProps.showTimestamp && isFirstAuthor;
    return /*#__PURE__*/React.createElement(Link, {
      key: index,
      href: author.link,
      className: getLinkClass(index)
    }, author.image && /*#__PURE__*/React.createElement(Image, _extends$1({}, author.image, {
      imageWidths: imageWidths,
      additionalStyle: additionalStyle,
      aspectRatio: {
        x: 1,
        y: 1
      }
    })), getAuthorTexts(author.name, author.byline, updatedText, createdDate, createdAtISO, updatedDate, updatedAtISO, showUpdatedAt, showTimestampForAuthor, themeProps));
  });
};

const HoverAuthorsWithRoundImage = props => {
  const {
    authors,
    updatedText,
    showUpdatedAt,
    createdDateFormatted,
    createdTimeAndDateFormatted,
    createdAtISO,
    updatedDateFormatted,
    updatedTimeAndDateFormatted,
    updatedAtISO,
    marginTopFactor
  } = props;
  const themeProps = useTheme(componentConfigurationKey$6);
  const {
    baseUnit,
    showTime
  } = themeProps;
  const styles = getStyles$o(baseUnit, marginTopFactor);
  const updatedAtFormatted = showTime ? updatedTimeAndDateFormatted : updatedDateFormatted;
  const createdAtFormatted = showTime ? createdTimeAndDateFormatted : createdDateFormatted;
  return /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapper)
  }, authors && getAuthors$1(authors, createdAtFormatted, createdAtISO, updatedAtFormatted, updatedAtISO, updatedText, showUpdatedAt, themeProps));
};

const componentConfigurationKey$5 = 'list';

const createStyles$5 = (backgroundColor, borderWidth, borderRadius, borderColor) => StyleSheet.create({
  listWrapper: { ...LIST_WRAPPER_STYLE,
    backgroundColor,
    border: `${borderWidth}px solid ${borderColor}`,
    borderRadius: `${borderRadius}px`,
    overflow: 'hidden'
  },
  list: { ...LIST_STYLE,
    [MEDIA_BREAKPOINTS.small]: {
      position: 'relative'
    }
  }
});

const List = ({
  listProps
}) => {
  const {
    backgroundColor,
    borderWidth,
    borderRadius,
    borderColor,
    boxShadowTypeNormal,
    boxShadowTypeHover,
    boxShadowTypeActive
  } = useTheme(componentConfigurationKey$5);
  const styles = createStyles$5(backgroundColor, borderWidth, borderRadius, borderColor);
  const boxShadowStyle = createStyleForBoxShadow({
    boxShadowTypeNormal,
    boxShadowTypeHover,
    boxShadowTypeActive
  });
  return /*#__PURE__*/React.createElement("div", {
    className: css(boxShadowStyle.style, styles.listWrapper)
  }, /*#__PURE__*/React.createElement(DecorationLine, null), /*#__PURE__*/React.createElement("div", {
    className: css(styles.list)
  }, listProps.map((listItemProps, index) => /*#__PURE__*/React.createElement(ListItem, _extends$1({}, listItemProps, {
    key: index
  })))));
};

const createStyles$4 = baseUnit => StyleSheet.create({
  container: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    gridGap: `${baseUnit / 2}px`,
    [MEDIA_BREAKPOINTS.large]: {
      gridGap: `${baseUnit / 2}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      gridTemplateColumns: '1fr 1fr',
      gridGap: `${baseUnit / 2}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto auto',
      gridGap: `${baseUnit / 2}px`
    }
  }
});

const imageWidths$c = createImageWidths(360, 720, 720);
const HighlightsArticleList = ({
  cardsProps,
  paddingFactors
}) => {
  const {
    baseUnit
  } = useTheme();
  const styles = createStyles$4(baseUnit);
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const [onTopCardProps, ...listProps] = cardsProps || [];
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cardsProps && cardsProps.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle, styles.container)
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, onTopCardProps, {
    imageWidths: imageWidths$c
  })), /*#__PURE__*/React.createElement(List, {
    listProps: listProps
  })));
};

const componentConfigThemeKey$A = 'scrollableArticleList';

const createStyles$3 = (baseUnit, columnGap, verticalCardBorderWidthTypeNormal) => StyleSheet.create({
  listWrapper: {
    display: 'grid',
    maxWidth: `${LARGE_SCREEN_SIZE}px`
  },
  scrollContainer: {
    '-webkit-overflow-scrolling': 'touch',
    display: 'flex',
    justifyContent: 'space-between',
    overflowX: 'scroll',
    overflowY: 'visible',
    [MEDIA_BREAKPOINTS.large]: {
      overflow: 'visible',
      justifyContent: 'center',
      gridTemplateColumns: '1fr 1fr 1fr 1fr',
      gridColumnGap: `${baseUnit * columnGap}px`,
      display: 'grid'
    },
    [MEDIA_BREAKPOINTS.medium]: {
      padding: `${verticalCardBorderWidthTypeNormal}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      padding: `${verticalCardBorderWidthTypeNormal}px`
    },
    '::-webkit-scrollbar': {
      display: 'none'
    }
  },
  scrollItem: {
    flex: '0 0 auto',
    flexBasis: `${300 - baseUnit / 2}px`,
    [MEDIA_BREAKPOINTS.medium]: {
      margin: `0 ${baseUnit / 4}px`,
      ':first-child': {
        marginLeft: 0
      },
      ':last-child': {
        marginRight: 0
      }
    },
    [MEDIA_BREAKPOINTS.small]: {
      margin: `0 ${baseUnit / 4}px`,
      ':first-child': {
        marginLeft: 0
      },
      ':last-child': {
        marginRight: 0
      }
    },
    position: 'relative',
    boxSizing: 'border-box',
    '@media (max-width: 330px)': {
      flexBasis: 'min(85%, 255px)'
    }
  }
});

const imageWidths$b = createImageWidths(360, 360, 360);
const ScrollableArticleList = ({
  cardsProps,
  paddingFactors
}) => {
  const {
    baseUnit,
    showDateInLargeScreen,
    showDateInMediumScreen,
    showDateInSmallScreen,
    columnGap,
    showAuthorInLargeScreen,
    showAuthorInMediumScreen,
    showAuthorInSmallScreen,
    showDescriptionInLargeScreen,
    showDescriptionInMediumScreen,
    showDescriptionInSmallScreen
  } = useTheme(componentConfigThemeKey$A);
  const {
    borderWidthTypeNormal
  } = useTheme(componentConfigThemeKey$M);
  const styles = createStyles$3(baseUnit, columnGap, borderWidthTypeNormal);
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const themeData = {
    showDateInLargeScreen,
    showDateInMediumScreen,
    showDateInSmallScreen,
    showAuthorInLargeScreen,
    showAuthorInMediumScreen,
    showAuthorInSmallScreen,
    showDescriptionInLargeScreen,
    showDescriptionInMediumScreen,
    showDescriptionInSmallScreen
  };
  const themeContext = useThemeOverride(themeData, componentConfigThemeKey$M);

  const createCard = props => {
    const {
      id
    } = props;
    return /*#__PURE__*/React.createElement("div", {
      className: css(styles.scrollItem),
      key: id
    }, /*#__PURE__*/React.createElement(VerticalCard, _extends$1({}, props, {
      imageWidths: imageWidths$b
    })));
  };

  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cardsProps && cardsProps.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle, styles.listWrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(styles.scrollContainer)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContext
  }, cardsProps.map(createCard)))));
};

const createStyle$p = baseUnit => StyleSheet.create({
  container: {
    display: 'grid',
    gridColumnGap: `${baseUnit / 2}px`,
    gridTemplateRows: '1fr',
    gridTemplateColumns: '1fr 1fr',
    [MEDIA_BREAKPOINTS.small]: {
      gridColumnGap: '0',
      gridRowGap: `${baseUnit / 2}px`,
      gridTemplateRows: 'auto',
      gridTemplateColumns: '1fr'
    }
  },
  horizontalCardsWrapper: {
    position: 'relative'
  },
  horizontalCardsContainer: {
    maxHeight: '100%',
    height: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridTemplateRows: '1fr 1fr 1fr',
    gridRowGap: `${baseUnit / 2}px`
  },
  horizontalCardWrapper: {
    minWidth: '0',
    minHeight: '0',
    boxSizing: 'border-box',
    padding: '0.1px',
    position: 'relative',
    ':last-child': {
      marginBottom: '0'
    }
  }
});

const imageWidthsHorizontalCard$3 = createImageWidths(180, 180, 180);
const imageWidthsVerticalCard = createImageWidths(360, 720, 540);
const OneThreeArticleList = ({
  cardsProps = [],
  paddingFactors
}) => {
  const [highlight, ...moreCards] = cardsProps;
  const {
    baseUnit
  } = useTheme();
  const style = createStyle$p(baseUnit);
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const themeContextHorizontalCards = useThemeOverride({
    aspectRatioLarge: {
      x: 4,
      y: 3
    },
    aspectRatioMedium: {
      x: 4,
      y: 3
    },
    aspectRatioSmall: {
      x: 1,
      y: 1
    }
  }, componentConfigThemeKey$K);

  const createCard = (cardProps, i) => /*#__PURE__*/React.createElement("div", {
    className: css(style.horizontalCardWrapper),
    key: i
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextHorizontalCards
  }, /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({}, cardProps, {
    imageWidths: imageWidthsHorizontalCard$3
  }))));

  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cardsProps && cardsProps.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle, style.container)
  }, /*#__PURE__*/React.createElement(VerticalCard, _extends$1({}, highlight, {
    imageWidths: imageWidthsVerticalCard
  })), /*#__PURE__*/React.createElement("div", {
    className: css(style.horizontalCardsWrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(style.horizontalCardsContainer)
  }, moreCards.map(createCard)))));
};

const componentConfigThemeKey$z = 'oneTwoOnTopFullWidth';

const getStyles$n = theme => {
  const {
    largeHorizontalGap,
    largeVerticalGap,
    mediumHorizontalGap,
    mediumVerticalGap,
    smallHorizontalGap
  } = theme;
  return StyleSheet.create({
    container: {
      [MEDIA_BREAKPOINTS.large]: {
        display: 'grid',
        gridTemplateColumns: '2fr 1fr',
        gridColumnGap: `${largeVerticalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'grid',
        gridTemplateRows: '1fr auto',
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'block'
      }
    },
    lastCardsContainer: {
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gridColumnGap: `${mediumVerticalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'block'
      }
    },
    secondAndThirdCards: {
      [MEDIA_BREAKPOINTS.large]: {
        height: '50%',
        boxSizing: 'border-box'
      },
      [MEDIA_BREAKPOINTS.small]: {
        marginTop: `${smallHorizontalGap * baseUnit}px`
      }
    },
    secondChild: {
      [MEDIA_BREAKPOINTS.large]: {
        paddingBottom: `${largeHorizontalGap * baseUnit / 2}px`
      }
    },
    thirdChild: {
      [MEDIA_BREAKPOINTS.large]: {
        paddingTop: `${largeHorizontalGap * baseUnit / 2}px`
      }
    }
  });
};

const secondAndThirdImageHeightCalculationMethods$1 = createImageHeightCalculationMethods('ASPECT_RATIO', 'ASPECT_RATIO', '100%_HEIGHT');

const addImageHeightCalculationMethodsProp$2 = cardProps => ({ ...cardProps,
  imageHeightCalculationMethods: secondAndThirdImageHeightCalculationMethods$1
});

const imageWidthsMainCard$2 = createImageWidths(360, 720, 720);
const imageWidthsMinorCards$1 = createImageWidths(360, 360, 360);
const OneTwoOnTopFullWidth = props => {
  const {
    paddingFactors
  } = props;
  const themeProps = useTheme(componentConfigThemeKey$z);
  const {
    mainCardTitleFontSizeLarge,
    mainCardTitleFontSizeMedium,
    mainCardTitleFontSizeSmall,
    secondaryCardsTitleFontSizeLarge,
    secondaryCardsTitleFontSizeMedium,
    secondaryCardsTitleFontSizeSmall,
    secondaryCardsMetadataFontSizeLarge,
    secondaryCardsMetadataFontSizeMedium,
    secondaryCardsMetadataFontSizeSmall,
    insideCardSmallHorizontalGap,
    insideCardMediumHorizontalGap,
    insideCardLargeHorizontalGap,
    aspectRatioSmall,
    titleSemanticTag,
    showMainCategoryInLargeScreen,
    showMainCategoryInMediumScreen,
    showMainCategoryInSmallScreen
  } = themeProps;
  const {
    authorColor
  } = themeProps;
  const styles = getStyles$n(themeProps);
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const {
    cards
  } = props;
  const topCard = cards && cards[0];
  const secondCard = cards && addImageHeightCalculationMethodsProp$2(cards[1]);
  const thirdCard = cards && addImageHeightCalculationMethodsProp$2(cards[2]);
  const themeContextFirstCard = useThemeOverride({
    titleFontSizeLarge: mainCardTitleFontSizeLarge,
    titleFontSizeMedium: mainCardTitleFontSizeMedium,
    titleFontSizeSmall: mainCardTitleFontSizeSmall,
    horizontalGapSmall: insideCardSmallHorizontalGap,
    horizontalGapMedium: insideCardMediumHorizontalGap,
    horizontalGapLarge: insideCardLargeHorizontalGap,
    titleSemanticTag,
    aspectRatioSmall,
    authorColor,
    showMainCategoryInLargeScreen,
    showMainCategoryInMediumScreen,
    showMainCategoryInSmallScreen
  }, componentConfigThemeKey$O);
  const themeContextSecondAndThirdCards = useThemeOverride({
    titleFontSizeLarge: secondaryCardsTitleFontSizeLarge,
    titleFontSizeMedium: secondaryCardsTitleFontSizeMedium,
    titleFontSizeSmall: secondaryCardsTitleFontSizeSmall,
    metadataFontSizeLarge: secondaryCardsMetadataFontSizeLarge,
    metadataFontSizeMedium: secondaryCardsMetadataFontSizeMedium,
    metadataFontSizeSmall: secondaryCardsMetadataFontSizeSmall,
    horizontalGapSmall: insideCardSmallHorizontalGap,
    horizontalGapMedium: insideCardMediumHorizontalGap,
    horizontalGapLarge: insideCardLargeHorizontalGap,
    authorColor,
    showMainCategoryInLargeScreen,
    showMainCategoryInMediumScreen,
    showMainCategoryInSmallScreen
  }, componentConfigThemeKey$O);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle, styles.container)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextFirstCard
  }, topCard && /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, topCard, {
    imageWidths: imageWidthsMainCard$2
  }))), /*#__PURE__*/React.createElement("div", {
    className: css(styles.lastCardsContainer)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextSecondAndThirdCards
  }, /*#__PURE__*/React.createElement("div", {
    className: css(styles.secondAndThirdCards, styles.secondChild)
  }, secondCard && /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, secondCard, {
    imageWidths: imageWidthsMinorCards$1
  }))), /*#__PURE__*/React.createElement("div", {
    className: css(styles.secondAndThirdCards, styles.thirdChild)
  }, thirdCard && /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, thirdCard, {
    imageWidths: imageWidthsMinorCards$1
  })))))));
};

const componentConfigThemeKey$y = 'twoOneTwoArticleList';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const createStyle$o = ({
  largeHorizontalGap,
  largeVerticalGap,
  mediumHorizontalGap,
  mediumVerticalGap,
  smallHorizontalGap,
  minorCardsRatioLarge,
  minorCardsRatioMedium
}) => StyleSheet.create({
  wrapper: {
    display: 'grid',
    [MEDIA_BREAKPOINTS.large]: {
      gridTemplateColumns: '1fr 2fr 1fr',
      gridTemplateRows: `${minorCardsRatioLarge.x}fr ${minorCardsRatioLarge.y}fr`,
      gridColumnGap: `${largeVerticalGap * baseUnit}px`,
      gridRowGap: `${largeHorizontalGap * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      gridTemplateColumns: `${minorCardsRatioMedium.x}fr ${minorCardsRatioMedium.y}fr`,
      gridTemplateRows: 'auto auto auto',
      gridColumnGap: `${mediumVerticalGap * baseUnit}px`,
      gridRowGap: `${mediumHorizontalGap * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      gridTemplateColumns: '1fr',
      gridRowGap: `${smallHorizontalGap * baseUnit}px`
    }
  },
  secondCard: {
    [MEDIA_BREAKPOINTS.large]: {
      gridRowStart: '2',
      gridRowEnd: '3',
      gridColumnStart: '1'
    },
    [MEDIA_BREAKPOINTS.small]: {
      gridRowStart: 'unset',
      gridRowEnd: 'unset',
      gridColumnStart: 'unset'
    }
  },
  mainCard: {
    [MEDIA_BREAKPOINTS.large]: {
      gridRowStart: '1',
      gridRowEnd: '3',
      gridColumnStart: '2'
    },
    [MEDIA_BREAKPOINTS.medium]: {
      gridRowStart: '2',
      gridRowEnd: '3',
      gridColumnStart: '1',
      gridColumnEnd: '3'
    },
    [MEDIA_BREAKPOINTS.small]: {
      order: '-1',
      gridRowStart: 'unset',
      gridRowEnd: 'unset',
      gridColumnStart: 'unset',
      gridColumnEnd: 'unset'
    }
  },
  fourthCard: {
    [MEDIA_BREAKPOINTS.medium]: {
      gridRowStart: '3',
      gridRowEnd: '4',
      gridColumnStart: '1',
      gridColumnEnd: '2'
    },
    [MEDIA_BREAKPOINTS.small]: {
      gridRowStart: 'unset',
      gridRowEnd: 'unset',
      gridColumnStart: 'unset',
      gridColumnEnd: 'unset'
    }
  },
  fifthCard: {
    [MEDIA_BREAKPOINTS.large]: {
      gridColumnStart: '3'
    },
    [MEDIA_BREAKPOINTS.medium]: {
      gridRowStart: '3',
      gridRowEnd: '4',
      gridColumnStart: '2',
      gridColumnEnd: '3'
    },
    [MEDIA_BREAKPOINTS.small]: {
      gridRowStart: 'unset',
      gridRowEnd: 'unset',
      gridColumnStart: 'unset',
      gridColumnEnd: 'unset'
    }
  }
});

const addImageHeightCalculationMethodsProp$1 = (cardProps, imageHeightCalculationMethods) => ({ ...cardProps,
  imageHeightCalculationMethods
});

const imageWidthsMainCard$1 = createImageWidths(360, 720, 540);
const imageWidthsMinorCard = createImageWidths(360, 360, 360);
const TwoOneTwoArticleList = props => {
  const {
    cards,
    paddingFactors
  } = props;
  const themeProps = useTheme(componentConfigThemeKey$y);
  const firstCard = addImageHeightCalculationMethodsProp$1(cards[1], createImageHeightCalculationMethods('ASPECT_RATIO', 'ASPECT_RATIO', '100%_HEIGHT'));
  const secondCard = addImageHeightCalculationMethodsProp$1(cards[2], createImageHeightCalculationMethods('ASPECT_RATIO', '100%_HEIGHT', '100%_HEIGHT'));
  const mainCard = addImageHeightCalculationMethodsProp$1(cards[0], createImageHeightCalculationMethods('ASPECT_RATIO', 'ASPECT_RATIO', 'ASPECT_RATIO'));
  const fourthCard = addImageHeightCalculationMethodsProp$1(cards[3], createImageHeightCalculationMethods('ASPECT_RATIO', 'ASPECT_RATIO', '100%_HEIGHT'));
  const fifthCard = addImageHeightCalculationMethodsProp$1(cards[4], createImageHeightCalculationMethods('ASPECT_RATIO', '100%_HEIGHT', '100%_HEIGHT'));
  const style = createStyle$o(themeProps);
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const themeContextMainCard = useThemeOverride({
    titleFontSizeMedium: 'large',
    titleFontSizeLarge: 'large',
    titleFontSizeSmall: 'bigger',
    horizontalGapSmall: 0.25,
    horizontalGapMedium: 0.5,
    horizontalGapLarge: 0.5,
    aspectRatioSmall: {
      x: 4,
      y: 3
    }
  }, componentConfigThemeKey$O);
  const themeContextMinorCards = useThemeOverride({
    titleFontSizeMedium: 'bigger',
    titleFontSizeLarge: 'bigger',
    titleFontSizeSmall: 'bigger',
    horizontalGapSmall: 0.25,
    horizontalGapMedium: 0.25,
    horizontalGapLarge: 0.25
  }, componentConfigThemeKey$O);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle, style.wrapper)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextMinorCards
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, firstCard, {
    imageWidths: imageWidthsMinorCard
  })), /*#__PURE__*/React.createElement("div", {
    className: css(style.secondCard)
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, secondCard, {
    imageWidths: imageWidthsMinorCard
  })))), /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextMainCard
  }, /*#__PURE__*/React.createElement("div", {
    className: css(style.mainCard)
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, mainCard, {
    imageWidths: imageWidthsMainCard$1
  })))), /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextMinorCards
  }, /*#__PURE__*/React.createElement("div", {
    className: css(style.fourthCard)
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, fourthCard, {
    imageWidths: imageWidthsMinorCard
  }))), /*#__PURE__*/React.createElement("div", {
    className: css(style.fifthCard)
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, fifthCard, {
    imageWidths: imageWidthsMinorCard
  }))))));
};

const componentConfigThemeKey$x = 'oneThreeOTC';
const imageWidthsFirstCard = createImageWidths(360, 720, 1080);
const imageWidthsSecondAndThirdCards = createImageWidths(360, 360, 360);
const imageWidthsFourthCard = createImageWidths(360, 720, 360);

const getStyle$2 = theme => {
  const {
    largeHorizontalGap,
    largeVerticalGap,
    mediumHorizontalGap,
    mediumVerticalGap,
    smallHorizontalGap,
    minorCardsSmallHorizontalCard
  } = theme;
  const firstCardArea = 'first-card';
  const adArea = 'ad';
  const minorCardsArea = 'minor-cards';
  return StyleSheet.create({
    wrapper: {
      [MEDIA_BREAKPOINTS.large]: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'auto',
        gridColumnGap: `${largeVerticalGap * baseUnit}px`,
        gridRowGap: `${largeHorizontalGap * baseUnit}px`,
        gridTemplateAreas: `'${firstCardArea}' '${adArea}' '${minorCardsArea}'`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'auto',
        gridColumnGap: `${mediumVerticalGap * baseUnit}px`,
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`,
        gridTemplateAreas: `'${firstCardArea}' '${adArea}' '${minorCardsArea}'`
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'auto',
        gridRowGap: `${smallHorizontalGap * baseUnit}px`,
        gridTemplateAreas: `'${firstCardArea}' '${adArea}' '${minorCardsArea}'`
      }
    },
    minorCardsWrapper: {
      [MEDIA_BREAKPOINTS.large]: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gridTemplateRows: 'auto',
        gridColumnGap: `${largeVerticalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gridTemplateRows: 'auto',
        gridColumnGap: `${mediumVerticalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'auto',
        gridRowGap: `${minorCardsSmallHorizontalCard * baseUnit}px`
      }
    },
    firstCard: {
      gridArea: firstCardArea
    },
    ad: {
      gridArea: adArea
    },
    minorCards: {
      gridArea: minorCardsArea
    }
  });
};

const OneThreeOTC = props => {
  const {
    cards,
    children
  } = props;
  const themeProps = useTheme(componentConfigThemeKey$x);
  const style = getStyle$2(themeProps);
  const themeContextFirstCard = useThemeOverride({
    titleFontSizeLarge: 'gigantic',
    titleFontSizeMedium: 'large',
    titleFontSizeSmall: 'gigantic',
    metadataFontSizeLarge: 'big',
    metadataFontSizeMedium: 'big',
    metadataFontSizeSmall: 'big',
    aspectRatioLarge: {
      x: 2,
      y: 1
    },
    aspectRatioSmall: {
      x: 4,
      y: 5
    },
    titleAlignment: 'CENTER',
    metadataAlignment: 'CENTER',
    verticalGapLarge: 1,
    verticalGapMedium: 1,
    verticalGapSmall: 1,
    horizontalGapLarge: 2,
    horizontalGapMedium: 0.75,
    horizontalGapSmall: 0.75
  }, componentConfigThemeKey$O);
  const themeContextMinorCards = useThemeOverride({
    titleFontSizeLarge: 'gigantic',
    titleFontSizeMedium: 'large',
    titleFontSizeSmall: 'gigantic',
    metadataFontSizeLarge: 'big',
    metadataFontSizeMedium: 'big',
    metadataFontSizeSmall: 'big',
    aspectRatioLarge: {
      x: 4,
      y: 5
    },
    aspectRatioMedium: {
      x: 4,
      y: 5
    },
    aspectRatioSmall: {
      x: 4,
      y: 5
    },
    titleAlignment: 'CENTER',
    metadataAlignment: 'CENTER',
    verticalGapLarge: 1,
    verticalGapMedium: 1,
    verticalGapSmall: 1,
    horizontalGapLarge: 2,
    horizontalGapMedium: 0.75,
    horizontalGapSmall: 0.75
  }, componentConfigThemeKey$O);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(style.wrapper)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextFirstCard
  }, /*#__PURE__*/React.createElement("div", {
    className: css(style.firstCard)
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, cards[0], {
    imageWidths: imageWidthsFirstCard
  })))), /*#__PURE__*/React.createElement("div", {
    className: css(style.ad)
  }, children), /*#__PURE__*/React.createElement("div", {
    className: css(style.minorCards, style.minorCardsWrapper)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextMinorCards
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, cards[1], {
    imageWidths: imageWidthsSecondAndThirdCards
  })), /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, cards[2], {
    imageWidths: imageWidthsSecondAndThirdCards
  })), /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, cards[3], {
    imageWidths: imageWidthsFourthCard
  }))))));
};

const componentConfigThemeKey$w = 'oneOTCThreeHC';
const imageWidthsOnTopCard$2 = createImageWidths(360, 720, 540);
const imageWidthsHorizontalCard$2 = createImageWidths(180, 180, 180);

const getStyles$m = baseUnit => {
  return StyleSheet.create({
    section: {
      [MEDIA_BREAKPOINTS.large]: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gridColumnGap: `${0.5 * baseUnit}px`
      }
    },
    horizontalCards: {
      display: 'grid',
      gridTemplateRows: '1fr 1fr 1fr',
      gridRowGap: `${0.5 * baseUnit}px`,
      [MEDIA_BREAKPOINTS.large]: {
        marginTop: 0
      },
      [MEDIA_BREAKPOINTS.medium]: {
        marginTop: `${0.5 * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        marginTop: `${0.5 * baseUnit}px`,
        paddingLeft: `${0.5 * baseUnit}px`,
        paddingRight: `${0.5 * baseUnit}px`
      }
    }
  });
};

const OneOnTopThreeHorizontalArticleList = props => {
  const {
    cards,
    paddingFactors = {
      large: 0.5,
      medium: 0.5,
      small: 0
    }
  } = props;
  const {
    baseUnit
  } = useTheme();
  const styles = getStyles$m(baseUnit);
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const onTopCardHeightCalculation = createImageHeightCalculationMethods('ASPECT_RATIO', 'ASPECT_RATIO', '100%_HEIGHT');
  const themeProps = useTheme(componentConfigThemeKey$w);
  const {
    titleFontSizeLarge,
    titleFontSizeMedium,
    titleFontSizeSmall,
    OTCTitleFontSizeSmall,
    metadataFontSizeLarge,
    metadataFontSizeMedium,
    metadataFontSizeSmall,
    authorColor,
    showDescriptionInLargeScreen,
    showDescriptionInMediumScreen,
    insideCardSmallHorizontalGap,
    aspectRatioSmallForHC,
    aspectRatioLargeForHC
  } = themeProps;
  const themeContextHC = useThemeOverride({
    titleFontSizeLarge,
    titleFontSizeMedium,
    titleFontSizeSmall,
    metadataFontSizeLarge,
    metadataFontSizeMedium,
    metadataFontSizeSmall,
    showDescriptionInMediumScreen,
    showDescriptionInLargeScreen,
    aspectRatioSmall: aspectRatioSmallForHC,
    aspectRatioLarge: aspectRatioLargeForHC
  }, componentConfigThemeKey$K);
  const themeContextOTC = useThemeOverride({
    titleFontSizeSmall: OTCTitleFontSizeSmall,
    horizontalGapSmall: insideCardSmallHorizontalGap,
    authorColor
  }, componentConfigThemeKey$O);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(styles.section, paddingStyle)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextOTC
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, cards[0], {
    imageWidths: imageWidthsOnTopCard$2,
    imageHeightCalculationMethods: onTopCardHeightCalculation,
    lazyLoad: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: css(styles.horizontalCards)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextHC
  }, /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({}, cards[1], {
    imageWidths: imageWidthsHorizontalCard$2
  })), /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({}, cards[2], {
    imageWidths: imageWidthsHorizontalCard$2
  })), /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({}, cards[3], {
    imageWidths: imageWidthsHorizontalCard$2
  }))))));
};

const componentConfigThemeKey$v = 'section';

const getMaxWidth = (theme, themeConfigurationPropKey) => {
  if (typeof themeConfigurationPropKey === 'string' && themeConfigurationPropKey in theme) {
    return theme[themeConfigurationPropKey];
  }

  return LARGE_SCREEN_SIZE;
};

const Section = props => {
  const {
    children,
    themeConfigurationPropKey
  } = props;
  const theme = useTheme(componentConfigThemeKey$v);
  const sectionStyle = getSectionStyle$1(getMaxWidth(theme, themeConfigurationPropKey));
  const additionalStyle = getBackgroundColorStyle(theme.backgroundColor);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("section", {
    className: css(sectionStyle, additionalStyle)
  }, children));
};

const SectionWithTitle = props => {
  const {
    maxWidth,
    children,
    additionalStyle
  } = props;
  const sectionStyle = getSectionStyle$1(maxWidth);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, additionalStyle ? /*#__PURE__*/React.createElement("section", {
    className: css(sectionStyle, additionalStyle.style)
  }, children) : /*#__PURE__*/React.createElement("section", {
    className: css(sectionStyle)
  }, children));
};

const componentConfigThemeKey$u = 'sixHCForTwoThirds';
const imageWidths$a = createImageWidths(180, 360, 360);
const SixHCForTwoThirds = props => {
  const {
    cards
  } = props;
  const themeProps = useTheme(componentConfigThemeKey$u);
  const themeContextHC = useThemeOverride(themeProps, componentConfigThemeKey$K);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextHC
  }, /*#__PURE__*/React.createElement(SixHC, {
    cards: cards,
    paddingFactors: {
      large: 0,
      medium: 0,
      small: 0
    },
    imageWidths: imageWidths$a
  })));
};

const componentConfigThemeKey$t = 'fourVCForOneThird';

const createStyle$n = themeProps => {
  const {
    largeHorizontalGap,
    mediumHorizontalGap,
    mediumVerticalGap,
    smallHorizontalGap
  } = themeProps;
  return StyleSheet.create({
    wrapper: {
      display: 'grid',
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'auto',
        gridRowGap: `${largeHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: 'auto',
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`,
        gridColumnGap: `${mediumVerticalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'auto',
        gridRowGap: `${smallHorizontalGap * baseUnit}px`
      }
    }
  });
};

const imageWidths$9 = createImageWidths(360, 360, 360);
const FourVCForOneThird = props => {
  const {
    cards
  } = props;
  const themeProps = useTheme(componentConfigThemeKey$t);
  const style = createStyle$n(themeProps);
  const themeContextVC = useThemeOverride({
    titleFontSizeLarge: 'bigger',
    titleFontSizeMedium: 'bigger',
    titleFontSizeSmall: 'bigger',
    titleSemanticTag: 'h4',
    metadataSemanticTag: 'h5',
    metadataFontSizeLarge: 'big',
    metadataFontSizeMedium: 'big',
    metadataFontSizeSmall: 'big',
    showAuthorInLargeScreen: false,
    showDateInLargeScreen: false
  }, componentConfigThemeKey$M);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(style.wrapper)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextVC
  }, /*#__PURE__*/React.createElement(VerticalCard, _extends$1({}, cards[0], {
    imageWidths: imageWidths$9
  })), /*#__PURE__*/React.createElement(VerticalCard, _extends$1({}, cards[1], {
    imageWidths: imageWidths$9
  })), /*#__PURE__*/React.createElement(VerticalCard, _extends$1({}, cards[2], {
    imageWidths: imageWidths$9
  })), /*#__PURE__*/React.createElement(VerticalCard, _extends$1({}, cards[3], {
    imageWidths: imageWidths$9
  })))));
};

const createStyle$m = () => StyleSheet.create({
  wrapper: {
    display: 'grid',
    boxSizing: 'border-box',
    [MEDIA_BREAKPOINTS.large]: {
      gridTemplateColumns: '2fr 1fr',
      gridColumnGap: `${baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      gridTemplateColumns: '1fr',
      gridRowGap: `${baseUnit * 1.5}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      gridTemplateColumns: '1fr',
      gridRowGap: `${baseUnit * 1.5}px`
    }
  }
});

const TwoThirdsOneThirdWrapper = props => {
  const {
    children,
    maxWidth,
    paddingFactors
  } = props;
  const style = createStyle$m();
  const sectionStyle = getSectionStyle$1(maxWidth);
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  return /*#__PURE__*/React.createElement("div", {
    className: css(style.wrapper, sectionStyle, paddingStyle)
  }, children);
};

const componentConfigThemeKey$s = 'oneTwoTwoOTC';

const createStyle$l = themeProps => {
  const {
    largeHorizontalGap,
    largeVerticalGap,
    mediumHorizontalGap,
    mediumVerticalGap,
    smallHorizontalGap,
    baseUnit
  } = themeProps;
  const firstCardArea = 'first_card_area';
  const secondCardArea = 'second_card_area';
  const thirdCardArea = 'third_card_area';
  const fourthCardArea = 'fourth_card_area';
  const fifthCardArea = 'fifth_card_area';
  return StyleSheet.create({
    wrapper: {
      display: 'grid',
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: '2fr 1fr 1fr',
        gridTemplateRows: '1fr 1fr',
        gridColumnGap: `${largeVerticalGap * baseUnit}px`,
        gridRowGap: `${largeHorizontalGap * baseUnit}px`,
        gridTemplateAreas: `'${firstCardArea} ${secondCardArea} ${thirdCardArea}' '${firstCardArea} ${fourthCardArea} ${fifthCardArea}'`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: 'auto auto auto',
        gridColumnGap: `${mediumVerticalGap * baseUnit}px`,
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`,
        gridTemplateAreas: `'${firstCardArea} ${firstCardArea}' '${secondCardArea} ${thirdCardArea}' '${fourthCardArea} ${fifthCardArea}'`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateColumns: '1fr',
        gridRowGap: `${smallHorizontalGap * baseUnit}px`,
        gridTemplateAreas: `'${firstCardArea}' '${secondCardArea}' '${thirdCardArea}' '${fourthCardArea}' '${fifthCardArea}'`
      }
    },
    firstCard: {
      gridArea: firstCardArea
    },
    secondCard: {
      gridArea: secondCardArea
    },
    thirdCard: {
      gridArea: thirdCardArea
    },
    fourthCard: {
      gridArea: fourthCardArea
    },
    fifthCard: {
      gridArea: fifthCardArea
    }
  });
};

const imageWidthsForMainCard$4 = createImageWidths(360, 720, 540);
const imageWidthsForMinorCard$2 = createImageWidths(360, 360, 360);
const minorCardsImageHeightCalculationMethods = createImageHeightCalculationMethods('ASPECT_RATIO', 'ASPECT_RATIO', '100%_HEIGHT');
const OneTwoTwoOTC = props => {
  const {
    cards,
    paddingFactors
  } = props;
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const themeProps = useTheme(componentConfigThemeKey$s);
  const styles = createStyle$l(themeProps);
  const themeContextFirstCard = useThemeOverride({
    titleFontSizeSmall: 'large',
    titleFontSizeMedium: 'large',
    titleFontSizeLarge: 'large',
    metadataFontSizeSmall: 'big',
    metadataFontSizeMedium: 'bigger',
    metadataFontSizeLarge: 'bigger',
    horizontalGapSmall: 0.25,
    horizontalGapMedium: 0.5,
    horizontalGapLarge: 0.5,
    aspectRatioSmall: {
      x: 4,
      y: 3
    }
  }, componentConfigThemeKey$O);
  const themeContextMinorCard = useThemeOverride({
    titleFontSizeSmall: 'large',
    titleFontSizeMedium: 'big',
    titleFontSizeLarge: 'big',
    metadataFontSizeSmall: 'big',
    metadataFontSizeMedium: 'big',
    metadataFontSizeLarge: 'big',
    horizontalGapSmall: 0.25,
    horizontalGapMedium: 0.25,
    horizontalGapLarge: 0.25
  }, componentConfigThemeKey$O);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle, styles.wrapper)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextFirstCard
  }, /*#__PURE__*/React.createElement("div", {
    className: css(styles.firstCard)
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, cards[0], {
    imageWidths: imageWidthsForMainCard$4
  })))), /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextMinorCard
  }, /*#__PURE__*/React.createElement("div", {
    className: css(styles.secondCard)
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, cards[1], {
    imageWidths: imageWidthsForMinorCard$2,
    imageHeightCalculationMethods: minorCardsImageHeightCalculationMethods
  }))), /*#__PURE__*/React.createElement("div", {
    className: css(styles.thirdCard)
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, cards[2], {
    imageWidths: imageWidthsForMinorCard$2,
    imageHeightCalculationMethods: minorCardsImageHeightCalculationMethods
  }))), /*#__PURE__*/React.createElement("div", {
    className: css(styles.fourthCard)
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, cards[3], {
    imageWidths: imageWidthsForMinorCard$2,
    imageHeightCalculationMethods: minorCardsImageHeightCalculationMethods
  }))), /*#__PURE__*/React.createElement("div", {
    className: css(styles.fifthCard)
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, cards[4], {
    imageWidths: imageWidthsForMinorCard$2,
    imageHeightCalculationMethods: minorCardsImageHeightCalculationMethods
  }))))));
};

const componentConfigThemeKey$r = 'announcementCard';
const numberOfLinesForTitle = 1;
const numberOfLinesForSubHeadlineLargeAndMedium = 1;
const numberOfLinesForSubHeadlineSmall = 2;

const createStyle$k = ({
  titleColor,
  subHeadlineColor,
  wrapperGapLarge,
  wrapperGapMedium,
  wrapperGapSmall,
  horizontalGapLarge,
  horizontalGapMedium,
  horizontalGapSmall
}, maxWidth = LARGE_SCREEN_SIZE) => StyleSheet.create({
  wrapper: {
    display: 'grid',
    overflow: 'hidden',
    background: 'transparent',
    justifyItems: 'center',
    maxWidth: `${maxWidth}px`,
    margin: 'auto'
  },
  link: {
    position: 'relative',
    textDecoration: 'none',
    display: 'block',
    gridTemplateRows: 'max-content auto',
    maxWidth: `${maxWidth}px`,
    width: '-webkit-fill-available',
    paddingLeft: '10px',
    paddingRight: '10px',
    [MEDIA_BREAKPOINTS.large]: {
      height: '80px'
    },
    [MEDIA_BREAKPOINTS.medium]: {
      height: '80px'
    },
    [MEDIA_BREAKPOINTS.small]: {
      height: '80px'
    }
  },
  innerWrapper: {
    overflow: 'hidden',
    display: 'grid',
    background: 'transparent',
    position: 'relative',
    [MEDIA_BREAKPOINTS.large]: {
      padding: `${wrapperGapLarge * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      padding: `${wrapperGapMedium * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      padding: `${wrapperGapSmall * baseUnit}px`
    }
  },
  title: {
    color: titleColor,
    height: 'fit-content',
    ...ellipsify(numberOfLinesForTitle).style,
    [MEDIA_BREAKPOINTS.large]: {
      paddingBottom: `${horizontalGapLarge * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      paddingBottom: `${horizontalGapMedium * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      paddingBottom: `${horizontalGapSmall * baseUnit}px`
    }
  },
  seoDescription: {
    color: subHeadlineColor,
    height: 'fit-content',
    [MEDIA_BREAKPOINTS.large]: { ...ellipsify(numberOfLinesForSubHeadlineLargeAndMedium).style
    },
    [MEDIA_BREAKPOINTS.medium]: { ...ellipsify(numberOfLinesForSubHeadlineLargeAndMedium).style
    },
    [MEDIA_BREAKPOINTS.small]: { ...ellipsify(numberOfLinesForSubHeadlineSmall).style
    }
  }
});

const AnnouncementCard = props => {
  const {
    title,
    seoDescription,
    path,
    image,
    lazyLoad = false,
    maxWidth
  } = props;
  const themeProps = useTheme(componentConfigThemeKey$r);
  const {
    titleFontSizeLarge,
    titleFontSizeMedium,
    titleFontSizeSmall,
    titleSemanticTag,
    subHeadlineFontSizeLarge,
    subHeadlineFontSizeMedium,
    subHeadlineFontSizeSmall,
    subHeadlineSemanticTag,
    boxShadowTypeActive,
    boxShadowTypeHover,
    boxShadowTypeNormal,
    borderColorTypeActive,
    borderColorTypeHover,
    borderColorTypeNormal,
    borderWidthTypeActive,
    borderWidthTypeHover,
    borderWidthTypeNormal,
    aspectRatioLarge,
    aspectRatioMedium,
    aspectRatioSmall
  } = themeProps;
  const borderBoxShadow = {
    borderColorTypeActive,
    borderColorTypeHover,
    borderColorTypeNormal,
    borderWidthTypeActive,
    borderWidthTypeHover,
    borderWidthTypeNormal
  };
  const boxShadowStyle = createStyleForBoxShadow({
    boxShadowTypeNormal,
    boxShadowTypeHover,
    boxShadowTypeActive,
    borderBoxShadow
  });
  const style = createStyle$k(themeProps, maxWidth);
  const imageWidths = createImageWidths(360, 720, 1080);

  const createImageAdditionalStyle = () => StyleSheet.create({
    style: {
      position: 'absolute',
      top: '0',
      bottom: '0',
      margin: '0',
      [MEDIA_BREAKPOINTS.large]: {
        left: '10px',
        right: '10px'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        left: '10px',
        right: '10px'
      },
      [MEDIA_BREAKPOINTS.small]: {
        left: '10px',
        right: '10px'
      }
    }
  });

  return /*#__PURE__*/React.createElement("div", {
    className: css(style.wrapper, boxShadowStyle.style)
  }, /*#__PURE__*/React.createElement(Link, {
    className: css(style.link),
    href: path
  }, /*#__PURE__*/React.createElement(Image, _extends$1({}, image, {
    lazyLoad: lazyLoad,
    imageAspectRatios: createImageAspectRatios(aspectRatioSmall, aspectRatioMedium, aspectRatioLarge),
    imageWidths: imageWidths,
    additionalStyle: createImageAdditionalStyle()
  })), /*#__PURE__*/React.createElement("div", {
    className: css(style.innerWrapper)
  }, /*#__PURE__*/React.createElement(DynamicSemanticTag, {
    semanticTag: titleSemanticTag,
    fontSizeLarge: titleFontSizeLarge,
    fontSizeMedium: titleFontSizeMedium,
    fontSizeSmall: titleFontSizeSmall,
    styles: semanticCSS(style.title)
  }, title), /*#__PURE__*/React.createElement(DynamicSemanticTag, {
    semanticTag: subHeadlineSemanticTag,
    fontSizeLarge: subHeadlineFontSizeLarge,
    fontSizeMedium: subHeadlineFontSizeMedium,
    fontSizeSmall: subHeadlineFontSizeSmall,
    styles: semanticCSS(style.seoDescription)
  }, seoDescription))));
};

const componentConfigThemeKey$q = 'fourVCOneOTC';

const createStyle$j = themeProps => {
  const {
    largeHorizontalGap,
    largeVerticalGap,
    mediumHorizontalGap,
    mediumVerticalGap,
    smallHorizontalGap,
    baseUnit
  } = themeProps;
  const mainCardArea = 'main_card_area';
  const firstCardArea = 'first_card_area';
  const secondCardArea = 'second_card_area';
  const thirdCardArea = 'third_card_area';
  const fourthCardArea = 'fourth_card_area';
  return StyleSheet.create({
    wrapper: {
      display: 'grid',
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: '1fr 1fr 2fr',
        gridTemplateRows: '1fr 1fr',
        gridColumnGap: `${largeVerticalGap * baseUnit}px`,
        gridRowGap: `${largeHorizontalGap * baseUnit}px`,
        gridTemplateAreas: `'${firstCardArea} ${secondCardArea} ${mainCardArea}' '${thirdCardArea} ${fourthCardArea} ${mainCardArea}'`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: 'auto auto auto',
        gridColumnGap: `${mediumVerticalGap * baseUnit}px`,
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`,
        gridTemplateAreas: `'${mainCardArea} ${mainCardArea}' '${firstCardArea} ${secondCardArea}' '${thirdCardArea} ${fourthCardArea}'`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateColumns: '1fr',
        gridRowGap: `${smallHorizontalGap * baseUnit}px`,
        gridTemplateAreas: `'${mainCardArea}' '${firstCardArea}' '${secondCardArea}' '${thirdCardArea}' '${fourthCardArea}'`
      }
    },
    mainCard: {
      gridArea: mainCardArea
    },
    firstCard: {
      gridArea: firstCardArea
    },
    secondCard: {
      gridArea: secondCardArea
    },
    thirdCard: {
      gridArea: thirdCardArea
    },
    fourthCard: {
      gridArea: fourthCardArea
    },
    minorCard: {
      [MEDIA_BREAKPOINTS.small]: {
        paddingLeft: `${0.5 * baseUnit}px`,
        paddingRight: `${0.5 * baseUnit}px`
      }
    }
  });
};

const imageWidthsForMainCard$3 = createImageWidths(360, 720, 540);
const imageWidthsForMinorCard$1 = createImageWidths(360, 360, 360);
const onTopCardImageHeightCalculationMethods$2 = createImageHeightCalculationMethods('ASPECT_RATIO', 'ASPECT_RATIO', '100%_HEIGHT');
const FourVCOneOTC = props => {
  const {
    cards,
    paddingFactors = {
      large: 0.5,
      medium: 0.5,
      small: 0
    }
  } = props;
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const themeProps = useTheme(componentConfigThemeKey$q);
  const styles = createStyle$j(themeProps);
  const {
    authorColor,
    primaryTitleFontSizeSmall,
    primaryTitleFontSizeMedium,
    primaryTitleFontSizeLarge,
    primaryMetadataFontSizeSmall,
    primaryMetadataFontSizeMedium,
    primaryMetadataFontSizeLarge,
    primaryHorizontalGapSmall,
    primaryHorizontalGapMedium,
    primaryHorizontalGapLarge,
    aspectRatioSmall,
    secondaryTitleFontSizeSmall,
    secondaryTitleFontSizeMedium,
    secondaryTitleFontSizeLarge,
    secondaryMetadataFontSizeSmall,
    secondaryMetadataFontSizeMedium,
    secondaryMetadataFontSizeLarge,
    secondaryHorizontalGapSmall,
    secondaryHorizontalGapMedium,
    secondaryHorizontalGapLarge,
    showMainCategoryInLargeScreen,
    showMainCategoryInMediumScreen,
    showMainCategoryInSmallScreen
  } = themeProps;
  const themeContextFirstCard = useThemeOverride({
    titleFontSizeLarge: primaryTitleFontSizeLarge,
    titleFontSizeMedium: primaryTitleFontSizeMedium,
    titleFontSizeSmall: primaryTitleFontSizeSmall,
    metadataFontSizeLarge: primaryMetadataFontSizeLarge,
    metadataFontSizeMedium: primaryMetadataFontSizeMedium,
    metadataFontSizeSmall: primaryMetadataFontSizeSmall,
    horizontalGapLarge: primaryHorizontalGapLarge,
    horizontalGapMedium: primaryHorizontalGapMedium,
    horizontalGapSmall: primaryHorizontalGapSmall,
    aspectRatioLarge: {
      x: 3,
      y: 4
    },
    aspectRatioSmall,
    authorColor,
    showMainCategoryInLargeScreen,
    showMainCategoryInMediumScreen,
    showMainCategoryInSmallScreen
  }, componentConfigThemeKey$O);
  const themeContextMinorCard = useThemeOverride({
    titleFontSizeLarge: secondaryTitleFontSizeLarge,
    titleFontSizeMedium: secondaryTitleFontSizeMedium,
    titleFontSizeSmall: secondaryTitleFontSizeSmall,
    metadataFontSizeLarge: secondaryMetadataFontSizeLarge,
    metadataFontSizeMedium: secondaryMetadataFontSizeMedium,
    metadataFontSizeSmall: secondaryMetadataFontSizeSmall,
    horizontalGapLarge: secondaryHorizontalGapLarge,
    horizontalGapMedium: secondaryHorizontalGapMedium,
    horizontalGapSmall: secondaryHorizontalGapSmall,
    showMainCategoryInLargeScreen,
    showMainCategoryInMediumScreen,
    showMainCategoryInSmallScreen
  }, componentConfigThemeKey$M);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle, styles.wrapper)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextMinorCard
  }, /*#__PURE__*/React.createElement("div", {
    className: css(styles.firstCard, styles.minorCard)
  }, /*#__PURE__*/React.createElement(VerticalCard, _extends$1({}, cards[1], {
    imageWidths: imageWidthsForMinorCard$1
  }))), /*#__PURE__*/React.createElement("div", {
    className: css(styles.secondCard, styles.minorCard)
  }, /*#__PURE__*/React.createElement(VerticalCard, _extends$1({}, cards[2], {
    imageWidths: imageWidthsForMinorCard$1
  }))), /*#__PURE__*/React.createElement("div", {
    className: css(styles.thirdCard, styles.minorCard)
  }, /*#__PURE__*/React.createElement(VerticalCard, _extends$1({}, cards[3], {
    imageWidths: imageWidthsForMinorCard$1
  }))), /*#__PURE__*/React.createElement("div", {
    className: css(styles.fourthCard, styles.minorCard)
  }, /*#__PURE__*/React.createElement(VerticalCard, _extends$1({}, cards[4], {
    imageWidths: imageWidthsForMinorCard$1
  })))), /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextFirstCard
  }, /*#__PURE__*/React.createElement("div", {
    className: css(styles.mainCard)
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, cards[0], {
    imageWidths: imageWidthsForMainCard$3,
    imageHeightCalculationMethods: onTopCardImageHeightCalculationMethods$2,
    lazyLoad: true
  }))))));
};

const componentConfigThemeKey$p = 'oneOTCFourVC';

const createStyle$i = themeProps => {
  const {
    largeHorizontalGap,
    largeVerticalGap,
    mediumHorizontalGap,
    mediumVerticalGap,
    smallHorizontalGap,
    baseUnit
  } = themeProps;
  const firstCardArea = 'first_card_area';
  const secondCardArea = 'second_card_area';
  const thirdCardArea = 'third_card_area';
  const fourthCardArea = 'fourth_card_area';
  const fifthCardArea = 'fifth_card_area';
  return StyleSheet.create({
    wrapper: {
      display: 'grid',
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: '2fr 1fr 1fr',
        gridTemplateRows: '1fr 1fr',
        gridColumnGap: `${largeVerticalGap * baseUnit}px`,
        gridRowGap: `${largeHorizontalGap * baseUnit}px`,
        gridTemplateAreas: `'${firstCardArea} ${secondCardArea} ${thirdCardArea}' '${firstCardArea} ${fourthCardArea} ${fifthCardArea}'`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: 'auto auto auto',
        gridColumnGap: `${mediumVerticalGap * baseUnit}px`,
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`,
        gridTemplateAreas: `'${firstCardArea} ${firstCardArea}' '${secondCardArea} ${thirdCardArea}' '${fourthCardArea} ${fifthCardArea}'`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateColumns: '1fr',
        gridRowGap: `${smallHorizontalGap * baseUnit}px`,
        gridTemplateAreas: `'${firstCardArea}' '${secondCardArea}' '${thirdCardArea}' '${fourthCardArea}' '${fifthCardArea}'`
      }
    },
    firstCard: {
      gridArea: firstCardArea
    },
    secondCard: {
      gridArea: secondCardArea
    },
    thirdCard: {
      gridArea: thirdCardArea
    },
    fourthCard: {
      gridArea: fourthCardArea
    },
    fifthCard: {
      gridArea: fifthCardArea
    },
    minorCard: {
      [MEDIA_BREAKPOINTS.small]: {
        paddingLeft: `${0.5 * baseUnit}px`,
        paddingRight: `${0.5 * baseUnit}px`
      }
    }
  });
};

const imageWidthsForMainCard$2 = createImageWidths(360, 720, 540);
const imageWidthsForMinorCard = createImageWidths(360, 360, 360);
const onTopCardImageHeightCalculationMethods$1 = createImageHeightCalculationMethods('ASPECT_RATIO', 'ASPECT_RATIO', '100%_HEIGHT');
const OneOTCFourVC = props => {
  const {
    cards,
    paddingFactors = {
      large: 0.5,
      medium: 0.5,
      small: 0
    }
  } = props;
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const themeProps = useTheme(componentConfigThemeKey$p);
  const styles = createStyle$i(themeProps);
  const {
    authorColor
  } = themeProps;
  const themeContextFirstCard = useThemeOverride({
    titleFontSizeLarge: 'large',
    titleFontSizeMedium: 'large',
    titleFontSizeSmall: 'bigger',
    metadataFontSizeLarge: 'bigger',
    metadataFontSizeMedium: 'bigger',
    metadataFontSizeSmall: 'big',
    horizontalGapSmall: 0.5,
    horizontalGapMedium: 0.5,
    horizontalGapLarge: 0.5,
    aspectRatioSmall: {
      x: 4,
      y: 3
    },
    aspectRatioLarge: {
      x: 3,
      y: 4
    },
    authorColor
  }, componentConfigThemeKey$O);
  const themeContextMinorCard = useThemeOverride({
    titleFontSizeLarge: 'bigger',
    titleFontSizeMedium: 'bigger',
    titleFontSizeSmall: 'bigger',
    metadataFontSizeLarge: 'big',
    metadataFontSizeMedium: 'big',
    metadataFontSizeSmall: 'big',
    horizontalGapSmall: 0.5,
    horizontalGapMedium: 0.5,
    horizontalGapLarge: 0.5
  }, componentConfigThemeKey$M);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle, styles.wrapper)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextFirstCard
  }, /*#__PURE__*/React.createElement("div", {
    className: css(styles.firstCard)
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, cards[0], {
    imageWidths: imageWidthsForMainCard$2,
    imageHeightCalculationMethods: onTopCardImageHeightCalculationMethods$1,
    lazyLoad: true
  })))), /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextMinorCard
  }, /*#__PURE__*/React.createElement("div", {
    className: css(styles.secondCard, styles.minorCard)
  }, /*#__PURE__*/React.createElement(VerticalCard, _extends$1({}, cards[1], {
    imageWidths: imageWidthsForMinorCard
  }))), /*#__PURE__*/React.createElement("div", {
    className: css(styles.thirdCard, styles.minorCard)
  }, /*#__PURE__*/React.createElement(VerticalCard, _extends$1({}, cards[2], {
    imageWidths: imageWidthsForMinorCard
  }))), /*#__PURE__*/React.createElement("div", {
    className: css(styles.fourthCard, styles.minorCard)
  }, /*#__PURE__*/React.createElement(VerticalCard, _extends$1({}, cards[3], {
    imageWidths: imageWidthsForMinorCard
  }))), /*#__PURE__*/React.createElement("div", {
    className: css(styles.fifthCard, styles.minorCard)
  }, /*#__PURE__*/React.createElement(VerticalCard, _extends$1({}, cards[4], {
    imageWidths: imageWidthsForMinorCard
  }))))));
};

const componentConfigThemeKey$o = 'nineHC';
const maximumNumberOfCards$1 = 9;

const getStyle$1 = themeProps => {
  const {
    largeHorizontalGap,
    mediumHorizontalGap,
    smallHorizontalGap
  } = themeProps;
  return StyleSheet.create({
    wrapper: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto',
      height: 'fit-content',
      [MEDIA_BREAKPOINTS.large]: {
        gridRowGap: `${baseUnit * largeHorizontalGap}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridRowGap: `${baseUnit * mediumHorizontalGap}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridRowGap: `${baseUnit * smallHorizontalGap}px`
      }
    }
  });
};

const defaultImageWidths = createImageWidths(180, 180, 360);
const NineHC = props => {
  const {
    cards,
    paddingFactors,
    imageWidths = defaultImageWidths
  } = props;
  const themeProps = useTheme(componentConfigThemeKey$o);
  const style = getStyle$1(themeProps);
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle, style.wrapper)
  }, cards.map(card => /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({
    key: card.id
  }, card, {
    imageWidths: imageWidths
  }))).slice(0, maximumNumberOfCards$1)));
};

const componentConfigThemeKey$n = 'nineHCForOneThird';
const imageWidths$8 = createImageWidths(180, 180, 180);
const NineHCForOneThird = props => {
  const {
    cards
  } = props;
  const themeProps = useTheme(componentConfigThemeKey$n);
  const themeContextHC = useThemeOverride(themeProps, componentConfigThemeKey$K);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextHC
  }, /*#__PURE__*/React.createElement(NineHC, {
    cards: cards,
    paddingFactors: {
      large: 0,
      medium: 0,
      small: 0
    },
    imageWidths: imageWidths$8
  })));
};

const componentConfigThemeKey$m = 'threeHCOneOTC';
const imageWidthsOnTopCard$1 = createImageWidths(360, 720, 540);
const imageWidthsHorizontalCard$1 = createImageWidths(360, 360, 360);

const getStyles$l = themeProps => {
  const {
    largeHorizontalGap,
    largeVerticalGap,
    mediumHorizontalGap,
    smallHorizontalGap,
    showDividers,
    dividersColor
  } = themeProps;
  const mainCardArea = 'main_card_area';
  const firstCardArea = 'first_card_area';
  const secondCardArea = 'second_card_area';
  const thirdCardArea = 'third_card_area';
  const dividerStyle = {
    ':after': {
      content: '""',
      display: 'block',
      borderBottom: `1px solid ${dividersColor}`,
      [MEDIA_BREAKPOINTS.large]: {
        paddingTop: `${largeHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        paddingTop: `${mediumHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        paddingTop: `${smallHorizontalGap * baseUnit}px`
      }
    },
    [MEDIA_BREAKPOINTS.large]: {
      paddingBottom: `${largeHorizontalGap * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      paddingBottom: `${mediumHorizontalGap * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      paddingBottom: `${smallHorizontalGap * baseUnit}px`
    }
  };
  return StyleSheet.create({
    section: {
      display: 'grid',
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: '1fr 1fr 1fr',
        gridRowGap: `${largeHorizontalGap * baseUnit}px`,
        gridColumnGap: `${largeVerticalGap * baseUnit}px`,
        gridTemplateAreas: `'${firstCardArea} ${mainCardArea}' '${secondCardArea} ${mainCardArea}' '${thirdCardArea} ${mainCardArea}'`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateRows: 'auto auto auto auto',
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`,
        gridTemplateAreas: `'${mainCardArea}' '${firstCardArea}' '${secondCardArea}' '${thirdCardArea}'`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateRows: 'auto auto auto auto',
        gridRowGap: `${smallHorizontalGap * baseUnit}px`,
        gridTemplateAreas: `'${mainCardArea}' '${firstCardArea}' '${secondCardArea}' '${thirdCardArea}'`
      }
    },
    minorCard: {
      [MEDIA_BREAKPOINTS.small]: {
        paddingLeft: `${0.5 * baseUnit}px`,
        paddingRight: `${0.5 * baseUnit}px`
      }
    },
    mainCard: {
      gridArea: mainCardArea
    },
    firstCard: {
      gridArea: firstCardArea,
      ...(showDividers ? dividerStyle : {})
    },
    secondCard: {
      gridArea: secondCardArea,
      ...(showDividers ? dividerStyle : {})
    },
    thirdCard: {
      gridArea: thirdCardArea
    }
  });
};

const ThreeHCOneOTC = props => {
  const {
    cards,
    paddingFactors = {
      large: 0.5,
      medium: 0.5,
      small: 0
    }
  } = props;
  const themeProps = useTheme(componentConfigThemeKey$m);
  const styles = getStyles$l(themeProps);
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const onTopCardHeightCalculation = createImageHeightCalculationMethods('ASPECT_RATIO', 'ASPECT_RATIO', '100%_HEIGHT');
  const {
    titleFontSizeSmall,
    titleFontSizeMedium,
    titleFontSizeLarge,
    aspectRatioLarge,
    aspectRatioSmall,
    aspectRatioMedium,
    showDescriptionInLargeScreen,
    showDescriptionInMediumScreen,
    metadataFontSizeLarge,
    metadataFontSizeMedium,
    metadataFontSizeSmall,
    authorColor,
    insideCardSmallHorizontalGap,
    showAuthorInSmallScreenForHC,
    showAuthorInLargeScreenForHC,
    showAuthorInMediumScreenForHC
  } = themeProps;
  const themeContextHorizontalCard = useThemeOverride({
    titleFontSizeSmall,
    titleFontSizeMedium,
    titleFontSizeLarge,
    aspectRatioLarge,
    aspectRatioSmall,
    aspectRatioMedium,
    showDescriptionInLargeScreen,
    showDescriptionInMediumScreen,
    metadataFontSizeLarge,
    metadataFontSizeMedium,
    metadataFontSizeSmall,
    showAuthorInSmallScreen: showAuthorInSmallScreenForHC,
    showAuthorInLargeScreen: showAuthorInLargeScreenForHC,
    showAuthorInMediumScreen: showAuthorInMediumScreenForHC
  }, componentConfigThemeKey$K);
  const themeContextOnTopCard = useThemeOverride({
    horizontalGapSmall: insideCardSmallHorizontalGap,
    titleFontSizeSmall,
    authorColor
  }, componentConfigThemeKey$O);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(styles.section, paddingStyle)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextHorizontalCard
  }, /*#__PURE__*/React.createElement("div", {
    className: css(styles.firstCard, styles.minorCard)
  }, /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({}, cards[1], {
    imageWidths: imageWidthsHorizontalCard$1
  }))), /*#__PURE__*/React.createElement("div", {
    className: css(styles.secondCard, styles.minorCard)
  }, /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({}, cards[2], {
    imageWidths: imageWidthsHorizontalCard$1
  }))), /*#__PURE__*/React.createElement("div", {
    className: css(styles.thirdCard, styles.minorCard)
  }, /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({}, cards[3], {
    imageWidths: imageWidthsHorizontalCard$1
  })))), /*#__PURE__*/React.createElement("div", {
    className: css(styles.mainCard)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextOnTopCard
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, cards[0], {
    imageWidths: imageWidthsOnTopCard$1,
    imageHeightCalculationMethods: onTopCardHeightCalculation,
    lazyLoad: true
  }))))));
};

const componentConfigThemeKey$l = 'oneTwoOTCHorizontal';

const getStyles$k = theme => {
  const {
    largeVerticalGap,
    mediumHorizontalGap,
    mediumVerticalGap,
    smallHorizontalGap
  } = theme;
  return StyleSheet.create({
    container: {
      [MEDIA_BREAKPOINTS.large]: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gridColumnGap: `${largeVerticalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'grid',
        gridTemplateRows: '1fr auto',
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'block'
      }
    },
    lastCardsContainer: {
      [MEDIA_BREAKPOINTS.large]: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gridColumnGap: `${largeVerticalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gridColumnGap: `${mediumVerticalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'block'
      }
    },
    secondAndThirdCards: {
      [MEDIA_BREAKPOINTS.large]: {
        height: '100%'
      },
      [MEDIA_BREAKPOINTS.small]: {
        marginTop: `${smallHorizontalGap * baseUnit}px`
      }
    }
  });
};

const secondAndThirdImageHeightCalculationMethods = createImageHeightCalculationMethods('ASPECT_RATIO', 'ASPECT_RATIO', '100%_HEIGHT');

const addImageHeightCalculationMethodsProp = cardProps => ({ ...cardProps,
  imageHeightCalculationMethods: secondAndThirdImageHeightCalculationMethods
});

const imageWidthsMainCard = createImageWidths(360, 720, 720);
const imageWidthsMinorCards = createImageWidths(360, 360, 720);
const OneTwoOTCHorizontal = props => {
  const {
    paddingFactors
  } = props;
  const themeProps = useTheme(componentConfigThemeKey$l);
  const {
    mainCardTitleFontSizeLarge,
    mainCardTitleFontSizeMedium,
    mainCardTitleFontSizeSmall,
    secondaryCardsTitleFontSizeLarge,
    secondaryCardsTitleFontSizeMedium,
    secondaryCardsTitleFontSizeSmall,
    aspectRatioSmall,
    aspectRatioLarge,
    titleSemanticTag,
    showMainCategoryInLargeScreen,
    showMainCategoryInMediumScreen,
    showMainCategoryInSmallScreen
  } = themeProps;
  const styles = getStyles$k(themeProps);
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const {
    cards
  } = props;
  const topCard = cards && cards[0];
  const secondCard = cards && addImageHeightCalculationMethodsProp(cards[1]);
  const thirdCard = cards && addImageHeightCalculationMethodsProp(cards[2]);
  const themeContextFirstCard = useThemeOverride({
    titleFontSizeLarge: mainCardTitleFontSizeLarge,
    titleFontSizeMedium: mainCardTitleFontSizeMedium,
    titleFontSizeSmall: mainCardTitleFontSizeSmall,
    titleSemanticTag,
    aspectRatioSmall,
    aspectRatioLarge,
    showMainCategoryInLargeScreen,
    showMainCategoryInMediumScreen,
    showMainCategoryInSmallScreen
  }, componentConfigThemeKey$O);
  const themeContextSecondAndThirdCards = useThemeOverride({
    titleFontSizeLarge: secondaryCardsTitleFontSizeLarge,
    titleFontSizeMedium: secondaryCardsTitleFontSizeMedium,
    titleFontSizeSmall: secondaryCardsTitleFontSizeSmall,
    showMainCategoryInLargeScreen,
    showMainCategoryInMediumScreen,
    showMainCategoryInSmallScreen
  }, componentConfigThemeKey$O);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle, styles.container)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextFirstCard
  }, topCard && /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, topCard, {
    imageWidths: imageWidthsMainCard
  }))), /*#__PURE__*/React.createElement("div", {
    className: css(styles.lastCardsContainer)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextSecondAndThirdCards
  }, /*#__PURE__*/React.createElement("div", {
    className: css(styles.secondAndThirdCards)
  }, secondCard && /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, secondCard, {
    imageWidths: imageWidthsMinorCards
  }))), /*#__PURE__*/React.createElement("div", {
    className: css(styles.secondAndThirdCards)
  }, thirdCard && /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, thirdCard, {
    imageWidths: imageWidthsMinorCards
  })))))));
};

let Directions;

(function (Directions) {
  Directions["UP"] = "180deg";
  Directions["DOWN"] = "0deg";
  Directions["LEFT"] = "90deg";
  Directions["RIGHT"] = "270deg";
})(Directions || (Directions = {}));

const getStyle = (direction, baseUnit) => StyleSheet.create({
  caret: {
    width: '10px',
    transform: `rotate(${direction})`,
    transition: 'transform 400ms',
    marginLeft: `${baseUnit * 0.25}px`
  }
});

const getFillColor = (color, hoverColor = '', isHovering = false) => {
  return isHovering ? hoverColor : color;
};

const TriangleIcon = props => {
  const {
    direction = Directions.DOWN,
    color = '#FFF',
    hoverColor,
    isHovering
  } = props;
  const {
    baseUnit
  } = useTheme();
  const fillColor = getFillColor(color, hoverColor, isHovering);
  return /*#__PURE__*/React__default.createElement("svg", {
    className: css(getStyle(direction, baseUnit).caret),
    width: "64",
    height: "10px",
    viewBox: "0 0 64 64",
    version: "1.1"
  }, /*#__PURE__*/React__default.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("polygon", {
    fill: fillColor,
    points: "0 16 32 48 64 16"
  })));
};

const getLinkColorsStyle = (activeStateColor, hoverStateColor, idleColor, currentLinkColor, isActive) => {
  return StyleSheet.create({
    link: {
      color: isActive ? currentLinkColor : idleColor,
      textDecoration: 'none',
      '@media (hover: hover)': {
        ':hover': {
          color: hoverStateColor
        }
      },
      ':active': {
        color: activeStateColor
      }
    }
  });
};

const getStyles$j = isInvisibleLink => StyleSheet.create({
  span: {
    visibility: isInvisibleLink ? 'hidden' : 'visible',
    whiteSpace: 'nowrap',
    position: 'relative',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center'
  },
  menu: {
    position: 'absolute'
  }
});

const FolderWrapper = ({
  children,
  fontStyle,
  spanStyle,
  labelColorStyle,
  onHover,
  onLeave,
  onClick,
  refObject
}) => /*#__PURE__*/React.createElement(Span, {
  styles: semanticCSS(fontStyle, spanStyle, labelColorStyle),
  onMouseEnter: onHover,
  onMouseLeave: onLeave,
  onClick: onClick,
  reference: refObject
}, children);

const LinkWrapper = ({
  children,
  fontStyle,
  spanStyle,
  labelColorStyle,
  onHover,
  onLeave,
  onClick,
  refObject,
  href
}) => /*#__PURE__*/React.createElement("a", {
  className: css(fontStyle, spanStyle, labelColorStyle),
  onMouseEnter: onHover,
  onMouseLeave: onLeave,
  onClick: onClick,
  ref: refObject,
  href: href
}, children);

const LinkWithSubMenu = props => {
  const {
    title,
    hoverStateColor,
    idleColor,
    index,
    linkDropdownIconColor,
    linkFontSizeLarge,
    linkFontSizeMedium,
    linkFontSizeSmall,
    isInvisibleLink = false,
    isOpen = false,
    currentLinkColor,
    activeStateColor,
    registerLinkWithSubMenu,
    toggleMenu,
    href
  } = props;
  const [isHovering, setIsHovering] = React.useState(false);
  const {
    fontSizesStyles
  } = useTheme();
  const styles = getStyles$j(isInvisibleLink);
  const linkOrFolderRef = React.useRef(null);
  const fontStyle = getStyleBySize(fontSizesStyles, {
    fontSizeSmall: linkFontSizeSmall,
    fontSizeMedium: linkFontSizeMedium,
    fontSizeLarge: linkFontSizeLarge
  });
  const linkColorsStyle = getLinkColorsStyle(activeStateColor, hoverStateColor, idleColor, currentLinkColor, false);
  React.useEffect(() => {
    if (typeof registerLinkWithSubMenu === 'function') {
      registerLinkWithSubMenu(linkOrFolderRef, index);
    }
  }, [registerLinkWithSubMenu, index]);

  const onHover = () => {
    setIsHovering(true);
  };

  const onLeave = () => {
    setIsHovering(false);
  };

  const onClick = () => {
    if (linkOrFolderRef.current !== null && typeof toggleMenu === 'function') {
      toggleMenu(linkOrFolderRef.current, index);
    }
  };

  const triangleDirection = isOpen ? Directions$1.UP : Directions$1.DOWN;
  const isFolder = href === '-';
  const WrapperComponent = isFolder ? FolderWrapper : LinkWrapper;
  return /*#__PURE__*/React.createElement(WrapperComponent, {
    fontStyle: fontStyle,
    spanStyle: styles.span,
    labelColorStyle: linkColorsStyle.link,
    onHover: onHover,
    onLeave: onLeave,
    onClick: onClick,
    refObject: linkOrFolderRef,
    href: href
  }, title, /*#__PURE__*/React.createElement(TriangleIcon, {
    hoverColor: hoverStateColor,
    color: linkDropdownIconColor,
    isHovering: isHovering,
    direction: triangleDirection
  }));
};

const getVisibilityStyle = isInvisibleLink => StyleSheet.create({
  spanWrapper: {
    visibility: isInvisibleLink ? 'hidden' : 'visible'
  },
  span: {
    display: 'flex',
    alignItems: 'center'
  }
});

const RegularHeaderLink = props => {
  const {
    href,
    text,
    activeStateColor,
    hoverStateColor,
    idleColor,
    isActive,
    linkFontSizeLarge,
    linkFontSizeMedium,
    linkFontSizeSmall,
    isInvisibleLink = false,
    currentLinkColor
  } = props;
  const {
    fontSizesStyles
  } = useTheme();
  const linkColorsStyle = getLinkColorsStyle(activeStateColor, hoverStateColor, idleColor, currentLinkColor, isActive);
  const fontStyle = getStyleBySize(fontSizesStyles, {
    fontSizeSmall: linkFontSizeSmall,
    fontSizeMedium: linkFontSizeMedium,
    fontSizeLarge: linkFontSizeLarge
  });
  const visibilityStyle = getVisibilityStyle(isInvisibleLink);
  return /*#__PURE__*/React.createElement(Link, {
    href: href,
    className: css(visibilityStyle.spanWrapper)
  }, /*#__PURE__*/React.createElement(Span, {
    className: css(visibilityStyle.span, fontStyle, linkColorsStyle.link)
  }, text));
};

const getStyles$i = (secondRowBackgroundColor, baseUnit, secondRowHeightInMediumScreen, secondRowHeightInSmallScreen, boxShadow, verticalGapInMediumScreen, verticalGapInSmallScreen, logo) => {
  return StyleSheet.create({
    scrollableNavWrapper: {
      boxShadow,
      backgroundColor: secondRowBackgroundColor,
      alignItems: 'center',
      zIndex: 50,
      [MEDIA_BREAKPOINTS.large]: {
        display: 'none'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        height: `${secondRowHeightInMediumScreen * baseUnit}px`,
        display: 'grid',
        gridTemplateRows: '1fr',
        gridTemplateColumns: logo ? 'max-content auto' : 'auto',
        gridColumnGap: `${baseUnit * verticalGapInMediumScreen}px`,
        paddingLeft: `${baseUnit * verticalGapInMediumScreen}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        height: `${secondRowHeightInSmallScreen * baseUnit}px`,
        display: 'grid',
        gridTemplateRows: '1fr',
        gridTemplateColumns: logo ? 'max-content auto' : 'auto',
        gridColumnGap: `${baseUnit * verticalGapInMediumScreen}px`,
        paddingLeft: `${baseUnit * verticalGapInSmallScreen}px`
      }
    },
    scrollableUl: {
      display: 'flex',
      padding: 0,
      overflowX: 'auto'
    }
  });
};

const getLinksStyle$1 = (baseUnit, verticalGapInLargeScreen, verticalGapInMediumScreen, verticalGapInSmallScreen) => StyleSheet.create({
  li: {
    display: 'inline-block',
    whiteSpace: 'nowrap',
    ':not(:first-child)': {
      [MEDIA_BREAKPOINTS.large]: {
        marginLeft: `${baseUnit * verticalGapInLargeScreen}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        marginLeft: `${baseUnit * verticalGapInMediumScreen}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        marginLeft: `${baseUnit * verticalGapInSmallScreen}px`
      }
    },
    ':last-child': {
      [MEDIA_BREAKPOINTS.medium]: {
        paddingRight: `${baseUnit * verticalGapInMediumScreen}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        paddingRight: `${baseUnit * verticalGapInSmallScreen}px`
      }
    }
  }
});

const getLinks = (links, activeStateColor, hoverStateColor, idleColor, currentLinkColor, pagePath, baseUnit, linkFontSizeLarge, linkFontSizeMedium, linkFontSizeSmall, verticalGapInLargeScreen, verticalGapInMediumScreen, verticalGapInSmallScreen, linkDropdownIconColor, onMenuToggle, openLinkIndex) => {
  return links.map((navigationLink, index) => {
    const isActive = pagePath === navigationLink.link.href;
    const style = getLinksStyle$1(baseUnit, verticalGapInLargeScreen, verticalGapInMediumScreen, verticalGapInSmallScreen);
    const hasSubMenu = (navigationLink.children || []).length > 0;
    const {
      href
    } = navigationLink.link;
    const fontStyles = {
      linkFontSizeLarge,
      linkFontSizeMedium,
      linkFontSizeSmall
    };
    return /*#__PURE__*/React.createElement("li", {
      key: index,
      className: css(style.li)
    }, hasSubMenu ? /*#__PURE__*/React.createElement(LinkWithSubMenu, _extends$1({
      currentLinkColor: currentLinkColor,
      activeStateColor: activeStateColor,
      title: navigationLink.link.text,
      hoverStateColor: hoverStateColor,
      toggleMenu: onMenuToggle,
      idleColor: openLinkIndex === index ? hoverStateColor : idleColor,
      index: index,
      linkDropdownIconColor: linkDropdownIconColor
    }, fontStyles, {
      isOpen: openLinkIndex === index,
      href: "-"
    })) : /*#__PURE__*/React.createElement(RegularHeaderLink, _extends$1({
      currentLinkColor: currentLinkColor,
      activeStateColor: activeStateColor,
      hoverStateColor: hoverStateColor,
      idleColor: idleColor,
      isActive: isActive,
      href: href,
      text: navigationLink.link.text
    }, fontStyles)));
  });
};

const createHeaderSecondRowStyleWithAnimation = animationDuration => {
  return StyleSheet.create({
    foldingUp: {
      [MEDIA_BREAKPOINTS.medium]: {
        transition: `${animationDuration}ms`,
        transform: 'translateY(-100%)'
      },
      [MEDIA_BREAKPOINTS.small]: {
        transition: `${animationDuration}ms`,
        transform: 'translateY(-100%)'
      }
    },
    foldingDown: {
      [MEDIA_BREAKPOINTS.medium]: {
        transition: `${animationDuration}ms`,
        transform: 'translateY(0)',
        transitionDelay: `${animationDuration}ms`
      },
      [MEDIA_BREAKPOINTS.small]: {
        transition: `${animationDuration}ms`,
        transform: 'translateY(0)',
        transitionDelay: `${animationDuration}ms`
      }
    }
  });
};

const getHeaderSecondRowStyleWithAnimation = (menuFoldState, animationDuration) => {
  const style = createHeaderSecondRowStyleWithAnimation(animationDuration);
  return menuFoldState === AnimationDirection.UP ? style.foldingUp : style.foldingDown;
};

const ScrollableNav = props => {
  const {
    menuFoldState,
    animationDuration,
    links,
    linkColorTypeActive,
    linkColorTypeHover,
    linkColorTypeNormal,
    currentLinkColor,
    pagePath,
    baseUnit,
    linkFontSizeLarge,
    linkFontSizeMedium,
    linkFontSizeSmall,
    verticalGapInLargeScreen,
    verticalGapInMediumScreen,
    verticalGapInSmallScreen,
    secondRowBackgroundColor,
    secondRowHeightInMediumScreen,
    secondRowHeightInSmallScreen,
    linkDropdownIconColor,
    onMenuToggle,
    openLinkIndex,
    boxShadow,
    logo
  } = props;
  const {
    secondRowLogoHeightInSmallScreen,
    secondRowLogoHeightInMediumScreen,
    secondRowLogoHeightInLargeScreen
  } = useTheme(componentConfigThemeKey$G);
  const styles = getStyles$i(secondRowBackgroundColor, baseUnit, secondRowHeightInMediumScreen, secondRowHeightInSmallScreen, boxShadow, verticalGapInMediumScreen, verticalGapInSmallScreen, logo);
  return /*#__PURE__*/React.createElement("nav", {
    className: css(getHeaderSecondRowStyleWithAnimation(menuFoldState, animationDuration), styles.scrollableNavWrapper)
  }, logo ? /*#__PURE__*/React.createElement(Logo$1, _extends$1({}, logo, {
    logoHeightInLargeScreen: secondRowLogoHeightInLargeScreen,
    logoHeightInMediumScreen: secondRowLogoHeightInMediumScreen,
    logoHeightInSmallScreen: secondRowLogoHeightInSmallScreen,
    menuAnimation: menuFoldState,
    reduceHeightAnimationDuration: animationDuration
  })) : null, /*#__PURE__*/React.createElement("ul", {
    className: css(styles.scrollableUl)
  }, getLinks(links || [], linkColorTypeActive, linkColorTypeHover, linkColorTypeNormal, currentLinkColor, pagePath, baseUnit, linkFontSizeLarge, linkFontSizeMedium, linkFontSizeSmall, verticalGapInLargeScreen, verticalGapInMediumScreen, verticalGapInSmallScreen, linkDropdownIconColor, onMenuToggle, openLinkIndex)));
};

const getStyles$h = (baseUnit, firstRowHeightInMediumScreen, firstRowHeightInSmallScreen, secondRowHeightInMediumScreen, secondRowHeightInSmallScreen, backgroundColor) => {
  return StyleSheet.create({
    menuWrapper: {
      zIndex: 1000,
      position: 'fixed',
      backgroundColor,
      left: 0,
      right: 0,
      bottom: 0,
      padding: `${baseUnit}px`,
      [MEDIA_BREAKPOINTS.large]: {
        display: 'none'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        top: `${(firstRowHeightInMediumScreen + secondRowHeightInMediumScreen) * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        top: `${(firstRowHeightInSmallScreen + secondRowHeightInSmallScreen) * baseUnit}px`,
        gridTemplateColumns: 'repeat(2, 1fr)'
      }
    },
    ul: {
      listStyle: 'none',
      display: 'grid',
      gridRowGap: `${baseUnit}px`,
      gridColumnGap: `${baseUnit}px`,
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateColumns: 'repeat(4, 1fr)'
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateColumns: 'repeat(2, 1fr)'
      }
    }
  });
};

const ScrollableNavDropdown = props => {
  const {
    firstRowHeightInMediumScreen,
    firstRowHeightInSmallScreen,
    secondRowHeightInMediumScreen,
    secondRowHeightInSmallScreen,
    linkColorTypeActive,
    linkColorTypeHover,
    linkColorTypeNormal,
    currentLinkColor,
    backgroundColor,
    links,
    pagePath,
    linkFontSize
  } = props;
  const {
    baseUnit
  } = useTheme();
  const styles = getStyles$h(baseUnit, firstRowHeightInMediumScreen, firstRowHeightInSmallScreen, secondRowHeightInMediumScreen, secondRowHeightInSmallScreen, backgroundColor);
  const fontStyles = {
    linkFontSizeLarge: linkFontSize,
    linkFontSizeMedium: linkFontSize,
    linkFontSizeSmall: linkFontSize
  };
  return /*#__PURE__*/React.createElement("div", {
    className: css(styles.menuWrapper)
  }, /*#__PURE__*/React.createElement("ul", {
    className: css(styles.ul)
  }, links.map((navigationLink, index) => {
    const isActive = pagePath === navigationLink.link.href;
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, /*#__PURE__*/React.createElement(RegularHeaderLink, _extends$1({
      currentLinkColor: currentLinkColor,
      activeStateColor: linkColorTypeActive,
      hoverStateColor: linkColorTypeHover,
      idleColor: linkColorTypeNormal,
      isActive: isActive,
      href: navigationLink.link.href,
      text: navigationLink.link.text
    }, fontStyles)));
  })));
};

const getMenuLinksStyle = (backgroundColor, baseUnit, headerHeights) => StyleSheet.create({
  style: {
    padding: 0,
    margin: 0,
    backgroundColor,
    position: 'fixed',
    width: '100%',
    zIndex: 2,
    left: 0,
    overflowY: 'auto',
    [MEDIA_BREAKPOINTS.medium]: {
      top: `${headerHeights.medium * baseUnit}px`,
      height: `calc(100vh - ${headerHeights.medium * baseUnit}px)`
    },
    [MEDIA_BREAKPOINTS.small]: {
      top: `${headerHeights.small * baseUnit}px`,
      height: `calc(100vh - ${headerHeights.small * baseUnit}px)`
    }
  },
  enter: {
    opacity: 0,
    transform: 'translate(-100%)'
  },
  enterActive: {
    opacity: 1,
    transform: 'translate(0)',
    transition: `transform ${menuEnterDuration}ms, opacity ${menuEnterDuration}ms`,
    transitionTimingFunction: 'ease-out'
  },
  exit: {
    opacity: 1,
    transform: 'translate(0)'
  },
  exitActive: {
    opacity: 0,
    transform: 'translate(-100%)',
    transition: `transform ${menuExitDuration}ms ease-in , opacity ${menuExitDuration}ms ease-in`,
    transitionDelay: `${menuExitDelay}ms`
  }
});

const getMenuLinkStyle = () => StyleSheet.create({
  enter: {
    opacity: 0.5,
    transform: 'translate(-100%)'
  },
  enterActive: {
    opacity: 1,
    transform: 'translate(0)',
    transition: `transform ${linkEnterDuration}ms ease-out, opacity ${linkEnterDuration}ms ease-in`,
    transitionDelay: `${linkEnterDelay}ms`
  },
  exit: {
    transform: 'translate(0)',
    opacity: 1
  },
  exitActive: {
    opacity: 0.5,
    transform: 'translate(-100%)',
    transition: `transform ${linkExitDuration}ms ease-in, opacity ${linkExitDuration}ms ease-in`,
    transitionDelay: `${linkExitDelay}ms`
  }
});

const MenuLinkAnimationWrapper = props => {
  const {
    children,
    shouldAppear
  } = props;
  const style = getMenuLinkStyle();
  return /*#__PURE__*/React.createElement(CSSTransition, {
    unmountOnExit: true,
    mountOnEnter: true,
    in: shouldAppear,
    timeout: {
      enter: linkEnterTimeOut,
      exit: linkExitTimeOut
    },
    classNames: {
      enter: css(style.enter),
      enterActive: css(style.enterActive),
      exit: css(style.exit),
      exitActive: css(style.exitActive)
    }
  }, children);
};

const createMenuLink = (onClick, currentOpenLink, shouldAppear, startIndex = 0) => (menuLink, index) => {
  return /*#__PURE__*/React.createElement(MenuLinkAnimationWrapper, {
    shouldAppear: shouldAppear,
    key: index
  }, state => /*#__PURE__*/React.createElement(MenuLink, {
    key: index,
    link: menuLink.link,
    childrenLinks: menuLink.childrenLinks,
    index: startIndex + index,
    onClick: onClick,
    isLinkOpen: currentOpenLink !== -1 && currentOpenLink === startIndex + index,
    startChevronIconAnimation: state === 'entering' || state === 'entered'
  }));
};

const createMenuButton = shouldAppear => ({
  text,
  onClick
}, key) => /*#__PURE__*/React.createElement(MenuLinkAnimationWrapper, {
  shouldAppear: shouldAppear,
  key: key
}, /*#__PURE__*/React.createElement(MenuButton, {
  text: text,
  onClick: onClick
}));
const MenuLinks = props => {
  const {
    menuLinks,
    isMenuOpen,
    onClick,
    currentOpenLink,
    buttons = [],
    children
  } = props;
  const {
    hamburgerMenuLinksBackgroundColor,
    baseUnit
  } = useTheme(componentConfigThemeKey$G);
  const headerHeights = useFirstRowHeaderHeights();
  const style = getMenuLinksStyle(hamburgerMenuLinksBackgroundColor, baseUnit, headerHeights);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(CSSTransition, {
    in: isMenuOpen,
    unmountOnExit: true,
    mountOnEnter: true,
    timeout: {
      enter: menuEnterTimeOut,
      exit: menuExitTimeOut
    },
    classNames: {
      enter: css(style.enter),
      enterActive: css(style.enterActive),
      exit: css(style.exit),
      exitActive: css(style.exitActive)
    }
  }, state => /*#__PURE__*/React.createElement("ul", {
    className: css(style.style)
  }, menuLinks.map(createMenuLink(onClick, currentOpenLink, state === 'entering' || state === 'entered')), buttons.map(createMenuButton(state === 'entering' || state === 'entered')), children)));
};

const getStyles$g = (titleColor, baseUnit, socialLinksColor, socialLinksHoverColor) => StyleSheet.create({
  wrapper: {
    padding: `${baseUnit / 2}px ${baseUnit}px`
  },
  title: {
    color: titleColor,
    marginBottom: `${baseUnit}px`
  },
  ul: {
    listStyle: 'none',
    display: 'inline-grid',
    gridAutoFlow: 'column',
    gridGap: `${baseUnit}px`
  },
  svg: {
    height: '16px',
    fill: socialLinksColor,
    ':hover': {
      fill: socialLinksHoverColor
    }
  }
});

const MenuSocialLinks = props => {
  const {
    socialSection,
    oldSocialSection
  } = props;
  const {
    hamburgerMenuSocialLinksTitleColor,
    baseUnit,
    hamburgerMenuSocialLinksColor,
    hamburgerMenuSocialLinksHoverColor,
    hamburgerMenuSocialLinksTitleFontSizeLarge,
    hamburgerMenuSocialLinksTitleFontSizeMedium,
    hamburgerMenuSocialLinksTitleFontSizeSmall
  } = useTheme(componentConfigThemeKey$G);
  const styles = getStyles$g(hamburgerMenuSocialLinksTitleColor, baseUnit, hamburgerMenuSocialLinksColor, hamburgerMenuSocialLinksHoverColor);
  return socialSection ? /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapper)
  }, /*#__PURE__*/React.createElement(H4, {
    styles: semanticCSS(styles.title),
    fontSizeLarge: hamburgerMenuSocialLinksTitleFontSizeLarge,
    fontSizeMedium: hamburgerMenuSocialLinksTitleFontSizeMedium,
    fontSizeSmall: hamburgerMenuSocialLinksTitleFontSizeSmall
  }, socialSection.title), /*#__PURE__*/React.createElement("ul", {
    className: css(styles.ul)
  }, socialSection.imageLinks.map((link, index) => {
    const svg = link.src.replace(/<svg/g, `<svg class="${css(styles.svg)}"`);
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, /*#__PURE__*/React.createElement(Link, {
      href: link.href,
      rel: "noopener",
      dangerouslySetInnerHTML: {
        __html: svg
      },
      alt: link.alt
    }));
  }))) : /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapper)
  }, /*#__PURE__*/React.createElement(H4, {
    styles: semanticCSS(styles.title)
  }, oldSocialSection.title), /*#__PURE__*/React.createElement("ul", {
    className: css(styles.ul)
  }, oldSocialSection.imageLinks.map((link, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, /*#__PURE__*/React.createElement(Link, {
    href: link.href
  }, /*#__PURE__*/React.createElement("img", {
    alt: link.alt,
    src: link.src,
    height: "16"
  }))))));
};

const getStyles$f = (dividerColor, baseUnit) => StyleSheet.create({
  divider: {
    backgroundColor: dividerColor,
    height: '1px',
    [MEDIA_BREAKPOINTS.medium]: {
      margin: `${baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      margin: `${baseUnit}px`
    }
  }
});

const Menu = props => {
  const {
    links,
    buttons,
    additionalStyle,
    socialSection,
    oldSocialSection
  } = props;
  const shouldShowSocialSection = socialSection && socialSection.imageLinks.length > 0;
  const shouldShowSocial = shouldShowSocialSection || oldSocialSection && oldSocialSection.imageLinks.length > 0;
  const {
    baseUnit,
    hamburgerMenuDividerColor
  } = useTheme(componentConfigThemeKey$G);
  const [state, setState] = useState({
    isMenuOpen: false,
    currentOpenLink: -1
  });
  const {
    isMenuOpen,
    currentOpenLink
  } = state;

  const clickOnMenuIcon = () => {
    setState({
      isMenuOpen: !isMenuOpen,
      currentOpenLink: isMenuOpen ? currentOpenLink : -1
    });
  };

  const clickOnLinkDropDown = index => {
    setState({
      isMenuOpen,
      currentOpenLink: currentOpenLink === index ? -1 : index
    });
  };

  const style = getStyles$f(hamburgerMenuDividerColor, baseUnit);
  return /*#__PURE__*/React__default.createElement("div", {
    className: css(additionalStyle && additionalStyle.style)
  }, /*#__PURE__*/React__default.createElement(MenuIcon, {
    isMenuOpen: isMenuOpen,
    onClick: clickOnMenuIcon
  }), /*#__PURE__*/React__default.createElement(MenuLinks, {
    menuLinks: links,
    buttons: buttons,
    isMenuOpen: isMenuOpen,
    onClick: clickOnLinkDropDown,
    currentOpenLink: currentOpenLink
  }, shouldShowSocial && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: css(style.divider)
  }), /*#__PURE__*/React__default.createElement(MenuSocialLinks, {
    socialSection: socialSection,
    oldSocialSection: oldSocialSection
  }))));
};

const getInjectedVideoLogoStyle = (reduceHeightAnimationDuration, menuAnimation, baseUnit, firstRowHeightInMediumScreen, firstRowHeightInSmallScreen, largeLogoHeightsAndWidths) => {
  return StyleSheet.create({
    wrapper: {
      [MEDIA_BREAKPOINTS.large]: {
        height: menuAnimation === AnimationDirection.UP ? `${largeLogoHeightsAndWidths.reducedHeight}px` : `${largeLogoHeightsAndWidths.height}px`,
        minWidth: menuAnimation === AnimationDirection.UP ? `${largeLogoHeightsAndWidths.reducedWidth}px` : `${largeLogoHeightsAndWidths.width}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        height: `${baseUnit * firstRowHeightInMediumScreen}px`,
        width: 'auto'
      },
      [MEDIA_BREAKPOINTS.small]: {
        height: `${baseUnit * firstRowHeightInSmallScreen}px`,
        width: 'auto'
      },
      transition: `${reduceHeightAnimationDuration}ms`
    },
    video: {
      height: '100%',
      alignItems: 'center',
      display: 'inline-flex'
    },
    source: {
      height: '100%'
    }
  });
};

const VideoLogo = props => {
  const {
    baseUnit
  } = useTheme();
  const {
    videoPath,
    href,
    reduceHeightAnimationDuration = 0,
    menuAnimation = AnimationDirection.NONE,
    firstRowHeightInLargeScreen,
    firstRowHeightInMediumScreen,
    firstRowHeightInSmallScreen
  } = props;
  React__default.useEffect(() => {
    setEventEmitter(injectVideoLogoSuccessfully, callback => callback());
  }, [videoPath]);
  const [ref, largeLogoHeightsAndWidths] = useAnimationLogoHeightsAndWidths(firstRowHeightInLargeScreen);
  const style = getInjectedVideoLogoStyle(reduceHeightAnimationDuration, menuAnimation, baseUnit, firstRowHeightInMediumScreen, firstRowHeightInSmallScreen, largeLogoHeightsAndWidths);
  return /*#__PURE__*/React__default.createElement(Link, {
    className: css(style.wrapper),
    href: href
  }, /*#__PURE__*/React__default.createElement("video", {
    ref: ref,
    className: css(style.video),
    loop: true,
    autoPlay: true,
    muted: "true",
    playsinline: "true"
  }, /*#__PURE__*/React__default.createElement("source", {
    className: css(style.source),
    src: videoPath,
    type: "video/mp4"
  })));
};

const getStyles$e = (colorTypeHover, colorTypeNormal, colorTypeActive) => {
  return StyleSheet.create({
    button: {
      color: colorTypeNormal,
      border: 'none',
      backgroundColor: 'transparent',
      alignItems: 'center',
      cursor: 'pointer',
      ':hover': {
        color: colorTypeHover
      },
      ':active': {
        color: colorTypeActive
      }
    }
  });
};

const MoreButton = props => {
  const {
    fontSizesStyles
  } = useTheme();
  const {
    moreButtonText,
    additionalStyle,
    refObject,
    fontSizeLarge,
    fontSizeMedium,
    fontSizeSmall,
    colorTypeHover,
    colorTypeNormal,
    dropdownIconColor,
    colorTypeActive,
    registerLinkWithSubMenu,
    index,
    isMenuOpen = false
  } = props;
  const styles = getStyles$e(colorTypeHover, colorTypeNormal, colorTypeActive);
  const fontStyle = getStyleBySize(fontSizesStyles, {
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge
  });
  const triangleDirection = isMenuOpen ? Directions.UP : Directions.DOWN;
  React.useEffect(() => {
    if (typeof registerLinkWithSubMenu === 'function') {
      registerLinkWithSubMenu(refObject, index, true);
    }
  }, [registerLinkWithSubMenu, index, refObject]);
  return /*#__PURE__*/React.createElement("button", {
    ref: refObject,
    type: "button",
    className: css(styles.button, additionalStyle && additionalStyle.style, fontStyle)
  }, moreButtonText, /*#__PURE__*/React.createElement(TriangleIcon, {
    color: dropdownIconColor,
    direction: triangleDirection
  }));
};

const getLinkBackgroundOffset = subMenuState => {
  if (subMenuState.element && subMenuState.index >= 0) {
    const offset = subMenuState.element.getBoundingClientRect().left;
    return offset;
  }

  return 0;
};

const getStyles$d = (navHeightLarge, baseUnit, linkBackgroundColor, rowHeight, subMenuState) => {
  const backgroundWidth = subMenuState.element ? subMenuState.element.getBoundingClientRect().width : 0;
  const elementOffset = getLinkBackgroundOffset(subMenuState);
  return StyleSheet.create({
    fixedNav: {
      height: `${navHeightLarge}px`,
      [MEDIA_BREAKPOINTS.large]: {
        display: 'block'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'none'
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'none'
      }
    },
    navHiddenLayer: {
      overflow: 'hidden',
      height: `${navHeightLarge}px`
    },
    menuContainer: {
      position: 'relative'
    },
    fixedUl: {
      display: 'inline',
      padding: 0
    },
    menuWrapper: {
      position: 'relative'
    },
    linkBackground: {
      position: 'absolute',
      display: elementOffset === 0 ? 'none' : 'block',
      backgroundColor: linkBackgroundColor,
      height: `${rowHeight * baseUnit}px`,
      top: 0,
      left: `${elementOffset - baseUnit / 2}px`,
      width: `${backgroundWidth + baseUnit}px`,
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'none'
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'none'
      }
    }
  });
};

const getLinksStyle = baseUnit => StyleSheet.create({
  li: {
    display: 'inline-block',
    position: 'relative',
    whiteSpace: 'nowrap',
    ':not(:first-child)': {
      marginLeft: `${baseUnit}px`
    },
    ':last-child': {
      [MEDIA_BREAKPOINTS.medium]: {
        marginRight: `${baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        marginRight: `${baseUnit}px`
      }
    },
    ':first-child': {
      [MEDIA_BREAKPOINTS.medium]: {
        marginLeft: `${baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        marginLeft: `${baseUnit}px`
      }
    }
  }
});

const showMoreButtonStyle = (buttonOffset, shouldShowMoreButton) => {
  return StyleSheet.create({
    style: {
      [MEDIA_BREAKPOINTS.large]: {
        display: shouldShowMoreButton ? 'flex' : 'none',
        transform: `translateX(-${buttonOffset}px)`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'none'
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'none'
      }
    }
  });
};

const getMoreButton = (ref, text, style, fontSizeSmall, fontSizeMedium, fontSizeLarge, hoverColor, normalColor, activeColor, iconColor, registerLinkWithSubMenu) => (isMenuOpen, index) => {
  return /*#__PURE__*/React.createElement(MoreButton, {
    refObject: ref,
    moreButtonText: text,
    additionalStyle: style,
    fontSizeSmall: fontSizeSmall,
    fontSizeMedium: fontSizeMedium,
    fontSizeLarge: fontSizeLarge,
    colorTypeHover: hoverColor,
    colorTypeNormal: normalColor,
    colorTypeActive: activeColor,
    dropdownIconColor: iconColor,
    registerLinkWithSubMenu: registerLinkWithSubMenu,
    index: index,
    isMenuOpen: isMenuOpen
  });
};

const getLink = (hasSubMenu, currentLinkColor, activeStateColor, hoverStateColor, idleColor, linkDropdownIconColor, isActive, href, title, openLinkIndex, index, indexOfFirstInvisibleLink, linkFontSizeSmall, linkFontSizeMedium, linkFontSizeLarge, registerLinkWithSubMenu) => {
  const fontStyles = {
    linkFontSizeSmall,
    linkFontSizeMedium,
    linkFontSizeLarge
  };
  return hasSubMenu ? /*#__PURE__*/React.createElement(LinkWithSubMenu, _extends$1({
    currentLinkColor: currentLinkColor,
    activeStateColor: activeStateColor,
    title: title,
    hoverStateColor: hoverStateColor,
    idleColor: openLinkIndex === index ? hoverStateColor : idleColor,
    index: index,
    linkDropdownIconColor: linkDropdownIconColor
  }, fontStyles, {
    isInvisibleLink: indexOfFirstInvisibleLink < index || indexOfFirstInvisibleLink === index,
    isOpen: index === openLinkIndex,
    registerLinkWithSubMenu: registerLinkWithSubMenu,
    href: href
  })) : /*#__PURE__*/React.createElement(RegularHeaderLink, _extends$1({
    currentLinkColor: currentLinkColor,
    activeStateColor: activeStateColor,
    hoverStateColor: hoverStateColor,
    idleColor: idleColor,
    isActive: isActive,
    href: href,
    text: title
  }, fontStyles, {
    isInvisibleLink: indexOfFirstInvisibleLink < index || indexOfFirstInvisibleLink === index
  }));
};

const getLinkList = (props, baseUnit, buttonRef, moreButtonCreateMethod) => {
  const {
    links,
    pagePath,
    currentLinkColor,
    activeStateColor,
    hoverStateColor,
    idleColor,
    linkDropdownIconColor,
    linkFontSizeSmall,
    linkFontSizeMedium,
    linkFontSizeLarge,
    indexOfFirstInvisibleLink,
    subMenuState,
    registerLinkWithSubMenu
  } = props;
  if (!links) return [];
  const openLinkIndex = subMenuState.index;
  const isMoreLinksOpen = subMenuState.element === buttonRef.current;
  return links.map((link, index) => {
    const isActive = pagePath === link.link.href;
    const style = getLinksStyle(baseUnit);
    const hasSubMenu = (link.children || []).length > 0;
    const showMenu = index === indexOfFirstInvisibleLink;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, showMenu && /*#__PURE__*/React.createElement("li", {
      className: css(style.li)
    }, moreButtonCreateMethod(isMoreLinksOpen, index)), /*#__PURE__*/React.createElement("li", {
      className: css(style.li)
    }, getLink(hasSubMenu, currentLinkColor, activeStateColor, hoverStateColor, idleColor, linkDropdownIconColor, isActive, link.link.href, link.link.text, openLinkIndex, index, indexOfFirstInvisibleLink, linkFontSizeSmall, linkFontSizeMedium, linkFontSizeLarge, registerLinkWithSubMenu)));
  });
};

const FixedNav = props => {
  const {
    baseUnit
  } = useTheme();
  const {
    navHeightLarge,
    ulRef,
    rowHeight,
    subMenuState,
    linkBackgroundColor,
    linkFontSizeSmall,
    linkFontSizeMedium,
    linkFontSizeLarge,
    hoverStateColor,
    idleColor,
    activeStateColor,
    linkDropdownIconColor,
    moreButtonText,
    registerLinkWithSubMenu
  } = props;
  const buttonRef = React.useRef(null);
  const buttonStyle = showMoreButtonStyle(0, true);
  const moreButtonMethod = getMoreButton(buttonRef, moreButtonText, buttonStyle, linkFontSizeSmall, linkFontSizeMedium, linkFontSizeLarge, hoverStateColor, idleColor, activeStateColor, linkDropdownIconColor, registerLinkWithSubMenu);
  const styles = getStyles$d(navHeightLarge, baseUnit, linkBackgroundColor, rowHeight, subMenuState);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(styles.linkBackground)
  }), /*#__PURE__*/React.createElement("nav", {
    className: css(styles.fixedNav)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(styles.navHiddenLayer)
  }, /*#__PURE__*/React.createElement("ul", {
    className: css(styles.fixedUl),
    ref: ulRef
  }, getLinkList(props, baseUnit, buttonRef, moreButtonMethod)))));
};

const getStyles$c = (numSocialLinks, verticalGapInLargeScreen, verticalGapInMediumScreen, reduceHeightAnimationDuration, menuAnimation, socialLinksColor, socialLinksHoverColor) => StyleSheet.create({
  wrapper: {
    gridTemplateColumns: `repeat(${numSocialLinks}, 1fr)`,
    alignItems: 'center',
    textAlign: 'center',
    [MEDIA_BREAKPOINTS.large]: {
      display: 'grid',
      paddingLeft: `${baseUnit * verticalGapInLargeScreen}px`,
      gridColumnGap: `${baseUnit * verticalGapInLargeScreen}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      display: 'grid',
      paddingLeft: `${baseUnit * verticalGapInMediumScreen}px`,
      gridColumnGap: `${baseUnit * verticalGapInMediumScreen}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      display: 'none'
    }
  },
  img: {
    height: menuAnimation === AnimationDirection.UP ? `${baseUnit * 0.5}px` : `${baseUnit * 0.75}px`,
    transition: `${reduceHeightAnimationDuration}ms`
  },
  svg: {
    height: menuAnimation === AnimationDirection.UP ? `${baseUnit * 0.5}px` : `${baseUnit * 0.75}px`,
    transition: `${reduceHeightAnimationDuration}ms`,
    fill: socialLinksColor,
    ':hover': {
      fill: socialLinksHoverColor
    }
  }
});

const SocialLinks = props => {
  const {
    socialLinks,
    oldSocialSection,
    verticalGapInLargeScreen,
    verticalGapInMediumScreen,
    reduceHeightAnimationDuration,
    menuAnimation,
    socialLinksColor,
    socialLinksHoverColor
  } = props; // eslint-disable-next-line no-nested-ternary

  const socialLinksLength = socialLinks ? socialLinks.length : oldSocialSection ? oldSocialSection.imageLinks.length : 0;
  const styles = getStyles$c(socialLinksLength, verticalGapInLargeScreen, verticalGapInMediumScreen, reduceHeightAnimationDuration, menuAnimation, socialLinksColor, socialLinksHoverColor);
  return socialLinks ? /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapper)
  }, socialLinks.map((link, index) => {
    const svg = link.src.replace(/<svg/g, `<svg class="${css(styles.svg)}"`);
    return /*#__PURE__*/React.createElement(Link, {
      href: link.href,
      key: index,
      rel: "noopener",
      target: "_blank",
      dangerouslySetInnerHTML: {
        __html: svg
      },
      alt: link.alt
    });
  })) : /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapper)
  }, oldSocialSection && oldSocialSection.imageLinks.map((link, index) => /*#__PURE__*/React.createElement(Link, {
    href: link.href,
    key: index,
    rel: "noopener",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("img", {
    className: css(styles.img),
    src: link.src,
    alt: link.alt
  }))));
};

const createStyle$h = (editionsIconHoverColor, editionsIconNormalColor, baseUnit, menuAnimation) => {
  return StyleSheet.create({
    colors: {
      fill: editionsIconNormalColor,
      ':hover': {
        fill: editionsIconHoverColor
      }
    },
    svg: {
      height: menuAnimation === AnimationDirection.UP ? `${baseUnit * 0.5}px` : `${baseUnit * 0.75}px`,
      width: 'auto'
    },
    wrapper: {
      display: 'flex'
    }
  });
};

const EditionsIcon = props => {
  const {
    src,
    alt,
    editionsIconHoverColor,
    editionsIconNormalColor,
    menuAnimation
  } = props;
  const {
    baseUnit
  } = useTheme();
  const style = createStyle$h(editionsIconHoverColor, editionsIconNormalColor, baseUnit, menuAnimation);
  const svg = src.replace(/<svg/g, `<svg class="${css(style.svg, style.colors)}"`);
  return /*#__PURE__*/React.createElement("div", {
    className: css(style.wrapper),
    "aria-label": alt,
    dangerouslySetInnerHTML: {
      __html: svg
    }
  });
};

const createStyles$2 = ({
  editionsMenuWidthInSmallScreen,
  editionsMenuWidthInMediumScreen,
  editionsMenuWidthInLargeScreen,
  colorTypeActive,
  colorTypeNormal,
  colorTypeHover,
  editionsMenuBackgroundColor
}, baseUnit, editionsMenuToggle) => StyleSheet.create({
  button: {
    display: 'flex',
    color: colorTypeNormal,
    alignItems: 'center',
    cursor: 'pointer',
    ':hover': {
      color: colorTypeHover
    },
    ':active': {
      color: colorTypeActive
    }
  },
  link: {
    color: colorTypeNormal,
    ':hover': {
      color: colorTypeHover
    },
    ':active': {
      color: colorTypeActive
    }
  },
  ul: {
    backgroundColor: editionsMenuBackgroundColor,
    position: 'absolute',
    top: '100%',
    right: 0,
    boxSizing: 'border-box',
    listStyle: 'none',
    padding: '0 10px',
    margin: 0,
    display: editionsMenuToggle ? 'flex' : 'none',
    flexDirection: 'column',
    zIndex: 100,
    [MEDIA_BREAKPOINTS.large]: {
      width: `${editionsMenuWidthInLargeScreen * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      width: `${editionsMenuWidthInMediumScreen * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      width: `${editionsMenuWidthInSmallScreen * baseUnit}px`
    }
  },
  li: {
    textAlign: 'center',
    marginBottom: `${baseUnit}px`,
    ':first-child': {
      marginTop: `${baseUnit}px`
    }
  }
});

const Editions = props => {
  const {
    baseUnit,
    fontSizesStyles
  } = useTheme();
  const {
    editions,
    editionEndpoint,
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge,
    dropdownIconColor,
    colorTypeHover,
    editionsIcon,
    editionsIconNormalColor,
    editionsIconHoverColor,
    menuAnimation
  } = props;
  const [editionsMenuToggle, setEditionsMenuToggle] = React.useState(false);
  const styles = createStyles$2(props, baseUnit, editionsMenuToggle);
  const activeEdition = getActiveEdition(editions, editionEndpoint);
  const fontStyle = getStyleBySize(fontSizesStyles, {
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge
  });

  const scrollHandler = () => {
    if (editionsMenuToggle) {
      setEditionsMenuToggle(false);
    }
  };

  React.useEffect(() => {
    window.addEventListener('scroll', scrollHandler);
    return () => window.removeEventListener('scroll', scrollHandler);
  });

  const createEditionLink = (edition, index) => /*#__PURE__*/React.createElement("li", {
    className: css(styles.li),
    key: index
  }, /*#__PURE__*/React.createElement(Link, {
    href: edition.link.href,
    className: css(styles.link, fontStyle)
  }, edition.link.text));

  const EditionsMenu = () => /*#__PURE__*/React.createElement("ul", {
    className: css(styles.ul)
  }, editions.map(createEditionLink));

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: css(styles.button, fontStyle),
    onClick: () => setEditionsMenuToggle(!editionsMenuToggle)
  }, editionsIcon ? /*#__PURE__*/React.createElement(EditionsIcon, _extends$1({}, editionsIcon, {
    editionsIconNormalColor: editionsIconNormalColor,
    editionsIconHoverColor: editionsIconHoverColor,
    menuAnimation: menuAnimation
  })) : activeEdition.link.text, /*#__PURE__*/React.createElement(TriangleIcon, {
    direction: editionsMenuToggle ? Directions.UP : Directions.DOWN,
    color: dropdownIconColor,
    hoverColor: colorTypeHover
  })), /*#__PURE__*/React.createElement(EditionsMenu, null));
};

const subMenuReducerInitialState = {
  links: null,
  element: null,
  index: -1,
  linkFontSize: null,
  backgroundColor: ''
};
const subMenuReducer = (state, action) => {
  if (action.data.element === state.element) {
    return {
      links: null,
      element: null,
      index: -1,
      linkFontSize: null,
      backgroundColor: ''
    };
  }

  return action.data;
};
const useSubMenu = () => {
  return React__default.useReducer(subMenuReducer, subMenuReducerInitialState);
};

const MAX_NUM_ROWS = 7;

const getPaddingForUlLinks = baseUnit => baseUnit / 2;

const getStyles$b = (backgroundColor, baseUnit, offset, numMenuRows, minWidth, shouldOffsetLeft, animationDuration, rowFinalHeightInLargeScreen, isParentLinkVisibleOnTheRow) => {
  return StyleSheet.create({
    ul: {
      position: 'absolute',
      left: shouldOffsetLeft ? 0 : `${offset - getPaddingForUlLinks(baseUnit)}px`,
      transition: `top ${animationDuration}ms ease 0s`,
      top: isParentLinkVisibleOnTheRow ? `${rowFinalHeightInLargeScreen / 2}px` : `-${getPaddingForUlLinks(baseUnit)}px`,
      backgroundColor,
      listStyle: 'none',
      padding: `${getPaddingForUlLinks(baseUnit)}px`,
      display: 'grid',
      gridRowGap: `${baseUnit / 2}px`,
      gridColumnGap: `${baseUnit * 4}px`,
      gridAutoFlow: 'column',
      gridTemplateRows: `repeat(${numMenuRows}, 1fr)`,
      minWidth: `${minWidth}px`,
      transform: shouldOffsetLeft ? 'translateX(-100%)' : ''
    },
    li: {
      padding: 0,
      position: 'relative'
    },
    link: {
      whiteSpace: 'nowrap',
      cursor: 'pointer'
    }
  });
};

const getOpenListItemStyle = (isSubMenuOpen, activeMenuBackgroundColor, baseUnit) => {
  if (!isSubMenuOpen) return null;
  return StyleSheet.create({
    li: {
      position: 'relative',
      ':before': {
        content: isSubMenuOpen ? "''" : '',
        backgroundColor: activeMenuBackgroundColor,
        position: 'absolute',
        top: `-${getPaddingForUlLinks(baseUnit)}px`,
        left: `-${getPaddingForUlLinks(baseUnit)}px`,
        bottom: `-${getPaddingForUlLinks(baseUnit)}px`,
        right: `-${getPaddingForUlLinks(baseUnit)}px`,
        zIndex: 0
      }
    }
  }).li;
};

const getMenuOffset = parentElement => {
  const offset = parentElement.getBoundingClientRect().left;
  return offset;
};

const getMenuMinWidth = parentElement => {
  return parentElement.getBoundingClientRect().width;
};

const SubMenu = props => {
  const {
    links,
    parentElement,
    activeStateColor,
    hoverStateColor,
    idleColor,
    currentLinkColor,
    linkFontSize,
    backgroundColor,
    pagePath,
    shouldOffsetLeft,
    animationDuration,
    rowFinalHeightInLargeScreen,
    openLinkIndex,
    innerLinkFontSize,
    innerLinksBackgroundColor,
    linkDropdownIconColor,
    isParentLinkVisibleOnTheRow
  } = props;
  const {
    baseUnit,
    fontSizesStyles
  } = useTheme();
  const [subMenuState, dispatch] = useSubMenu();
  const offset = getMenuOffset(parentElement);
  const numMenuRows = Math.min(links.length, MAX_NUM_ROWS);
  const minWidth = getMenuMinWidth(parentElement);
  const styles = getStyles$b(backgroundColor, baseUnit, offset, numMenuRows, minWidth, shouldOffsetLeft, animationDuration, rowFinalHeightInLargeScreen, isParentLinkVisibleOnTheRow);
  const fontStyle = getStyleBySize(fontSizesStyles, {
    fontSizeSmall: linkFontSize,
    fontSizeMedium: linkFontSize,
    fontSizeLarge: linkFontSize
  });
  const isMenuOpen = subMenuState.links && subMenuState.links.length > 0;
  const ulRef = React.useRef(null);

  const onHoverLink = (element, index) => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const menuLinks = links[index].children;
    dispatch({
      data: {
        links: menuLinks,
        element,
        index,
        linkFontSize: innerLinkFontSize || linkFontSize,
        backgroundColor: innerLinksBackgroundColor || backgroundColor
      }
    });
  };

  const onLeaveLink = () => {
    dispatch({
      data: {
        links: null,
        element: null,
        index: -1,
        linkFontSize: innerLinkFontSize || linkFontSize,
        backgroundColor: innerLinksBackgroundColor || backgroundColor
      }
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", {
    className: css(styles.ul),
    ref: ulRef
  }, links.map((navigationLink, index) => {
    const isLinkActive = pagePath === navigationLink.link.href;
    const isLinkWithSubMenu = navigationLink.children !== null && navigationLink.children.length > 0;
    const {
      href
    } = navigationLink.link;
    return /*#__PURE__*/React.createElement("li", {
      key: index,
      className: css(getOpenListItemStyle(subMenuState.index === index, innerLinksBackgroundColor || backgroundColor, baseUnit)),
      onMouseEnter: e => isLinkWithSubMenu && onHoverLink(e.target, index),
      onMouseLeave: onLeaveLink
    }, isLinkWithSubMenu ? /*#__PURE__*/React.createElement(React.Fragment, null, isMenuOpen && subMenuState.index === index && /*#__PURE__*/React.createElement(SubMenu, {
      activeStateColor: activeStateColor,
      hoverStateColor: hoverStateColor,
      idleColor: idleColor,
      backgroundColor: innerLinksBackgroundColor || backgroundColor,
      linkFontSize: innerLinkFontSize || linkFontSize,
      pagePath: pagePath // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ,
      links: subMenuState.links // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ,
      parentElement: subMenuState.element,
      rowFinalHeightInLargeScreen: rowFinalHeightInLargeScreen,
      animationDuration: animationDuration,
      shouldOffsetLeft: true,
      currentLinkColor: currentLinkColor,
      openLinkIndex: subMenuState.index,
      linkDropdownIconColor: linkDropdownIconColor,
      isParentLinkVisibleOnTheRow: false
    }), /*#__PURE__*/React.createElement(LinkWithSubMenu, {
      title: navigationLink.link.text,
      hoverStateColor: hoverStateColor,
      idleColor: openLinkIndex === index ? hoverStateColor : idleColor,
      index: index,
      linkDropdownIconColor: linkDropdownIconColor,
      linkFontSizeLarge: linkFontSize,
      linkFontSizeMedium: linkFontSize,
      linkFontSizeSmall: linkFontSize,
      isOpen: subMenuState.index === index,
      activeStateColor: activeStateColor,
      currentLinkColor: currentLinkColor,
      href: href
    })) : /*#__PURE__*/React.createElement(Link, {
      href: href,
      className: css(styles.link)
    }, /*#__PURE__*/React.createElement(Span, {
      className: css(fontStyle, getLinkColorsStyle(activeStateColor, hoverStateColor, idleColor, currentLinkColor, isLinkActive).link)
    }, navigationLink.link.text)));
  })));
};

const getLinkType = type => {
  return type === 'button' ? 'button' : 'link';
};

const initialState = [];

const reducer = (state, action) => {
  if (action) {
    switch (action.type) {
      case 'addLink':
        return [...state, action.data];

      case 'addButton':
        {
          const buttonIndex = state.findIndex(link => link.ref.current === action.data.ref.current);

          if (buttonIndex < 0) {
            return [...state, action.data];
          }

          if (state[buttonIndex].index !== action.data.index) {
            return [...state.slice(0, buttonIndex), action.data, ...state.slice(buttonIndex + 1)];
          }

          return state;
        }

      default:
        return state;
    }
  }

  return state;
};

const useLinksWithSubMenuHover = (onHoverLink, ulRef, firstRowFinalHeightInLargeScreen, baseUnit) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  const registerLinkWithSubMenu = (ref, index, isButton = false) => {
    if (ref.current === null) return;
    const data = {
      ref,
      index,
      type: isButton ? getLinkType('button') : getLinkType('link')
    };

    if (!isButton) {
      if (!state.find(element => element.ref.current === ref.current)) {
        dispatch({
          data,
          type: 'addLink'
        });
      }
    } else {
      dispatch({
        data,
        type: 'addButton'
      });
    }
  };

  const getHoverPlaceholders = () => {
    return state.filter(trigger => {
      const {
        ref
      } = trigger;
      if (!ref.current || !ulRef.current) return false;
      const visibleArea = ulRef.current.getBoundingClientRect().top + 5;
      if (trigger.type !== 'button' && ref.current.getBoundingClientRect().top > visibleArea) return false;
      return true;
    }).map((trigger, index) => {
      const {
        ref
      } = trigger; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

      const rect = ref.current.getBoundingClientRect();
      const {
        style
      } = StyleSheet.create({
        style: {
          position: 'absolute',
          width: `${rect.width + baseUnit}px`,
          height: `${firstRowFinalHeightInLargeScreen}px`,
          top: `-${firstRowFinalHeightInLargeScreen / 2}px`,
          left: `${rect.left - baseUnit / 2}px`,
          cursor: 'pointer'
        }
      }); // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

      const linkActualIndex = state.find(element => element.ref === ref).index; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

      return /*#__PURE__*/React.createElement("div", {
        className: css(style),
        key: index,
        onMouseEnter: () => onHoverLink(ref.current, linkActualIndex, trigger.type),
        onClick: () => ref.current ? ref.current.click() : null
      });
    });
  };

  return [registerLinkWithSubMenu, getHoverPlaceholders];
};

const createStyle$g = (accessibilityIconHoverColor, accessibilityIconNormalColor, baseUnit, menuAnimation) => {
  return StyleSheet.create({
    svg: {
      fill: accessibilityIconNormalColor,
      ':hover': {
        fill: accessibilityIconHoverColor
      },
      height: menuAnimation === AnimationDirection.UP ? `${baseUnit * 0.5}px` : `${baseUnit * 0.75}px`,
      width: 'auto'
    },
    button: {
      cursor: 'pointer',
      display: 'flex'
    }
  });
};

const AccessibilityIcon = props => {
  const {
    accessibilityIconNormalColor,
    menuAnimation,
    accessibilityIconHoverColor
  } = props;
  const {
    baseUnit
  } = useTheme();
  const style = createStyle$g(accessibilityIconHoverColor, accessibilityIconNormalColor, baseUnit, menuAnimation);

  const onClick = () => {
    try {
      // @ts-ignore TS2339
      if (window.interdeal) {
        // @ts-ignore TS2339
        window.interdeal.a11y.openMenu();
      }
    } catch (e) {
      console.error('Error when clicking on accessibilityIcon', e);
    }
  };

  return /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: onClick,
    "aria-label": "accessibility",
    className: css(style.button)
  }, /*#__PURE__*/React__default.createElement("svg", {
    className: css(style.svg, style.button),
    version: "1.1",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(50 50) scale(-.69 .69) translate(-50 -50)"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "m99 39.8-1.9-7.7c-2.8 6.9-9.5 11.9-17.4 11.9-10.3 0.1-18.7-8.3-18.7-18.7 0-7.3 4.2-13.6 10.4-16.7l-1.1-6c-8.9 3.8-15.2 12.5-15.2 22.7 0 13.6 11.1 24.7 24.7 24.7 7.9 0 15-3.8 19.5-9.6-0.2-0.2-0.3-0.4-0.3-0.6z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "m112.7 32.4-4 1-4.5-18.1c-0.4-1.8-2-3-3.9-3h-17.2l-0.9-4.5h11.4c2.2 0 3.9-1.8 3.9-3.9s-1.8-3.9-3.9-3.9h-12.9l-1.7-8.5c2.5-1.2 4.2-3.7 4.2-6.6 0-4-3.3-7.3-7.3-7.3s-7.3 3.3-7.3 7.3c0 1.9 0.7 3.6 1.8 4.8l5.3 27.4c0.4 1.9 2 3.3 3.9 3.3h17.4l4.7 18.9c0.5 1.8 2.1 3 3.9 3 0.3 0 0.6 0 0.9-0.1l7.9-1.9c2.1-0.5 3.5-2.7 2.9-4.7-0.4-2.4-2.6-3.7-4.6-3.2z"
  }))));
};

const createStyles$1 = (verticalGapInSmallScreen, verticalGapInMediumScreen, verticalGapInLargeScreen, separatorColor, numberOfItems) => StyleSheet.create({
  wrapper: {
    position: 'relative',
    height: '100%',
    display: 'grid',
    alignItems: 'center',
    [MEDIA_BREAKPOINTS.large]: {
      marginLeft: `${verticalGapInLargeScreen * baseUnit}px`,
      gridColumnGap: `${verticalGapInLargeScreen * baseUnit}px`,
      gridTemplateColumns: `repeat(${numberOfItems + 1}, auto)`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      marginLeft: `${verticalGapInMediumScreen * baseUnit}px`,
      gridColumnGap: `${verticalGapInMediumScreen * baseUnit}px`,
      gridTemplateColumns: `repeat(${numberOfItems + 1}, auto)`
    },
    [MEDIA_BREAKPOINTS.small]: {
      marginLeft: `${verticalGapInSmallScreen * baseUnit}px`,
      gridColumnGap: `${verticalGapInSmallScreen * baseUnit}px`,
      gridTemplateColumns: `repeat(${numberOfItems}, auto)`
    }
  },
  separator: {
    backgroundColor: separatorColor,
    height: '50%',
    width: '1px',
    [MEDIA_BREAKPOINTS.small]: {
      display: 'none'
    }
  }
});

const ItemsWithSeparator = props => {
  const {
    verticalGapInSmallScreen,
    verticalGapInMediumScreen,
    verticalGapInLargeScreen,
    separatorColor,
    numberOfItems,
    children
  } = props;
  const styles = createStyles$1(verticalGapInSmallScreen, verticalGapInMediumScreen, verticalGapInLargeScreen, separatorColor, numberOfItems);
  return /*#__PURE__*/React__default.createElement("div", {
    className: css(styles.wrapper)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css(styles.separator)
  }), children);
};

const getStyles$a = (themeProps, menuFoldState, animationDuration, hideInSmallAndMediumScreens, zIndex, rowBackgroundColor, rowFinalHeightInLargeScreen, rowHeightInMediumScreen, rowHeightInSmallScreen, rowBoxShadow, linkFontSizeLarge) => {
  const {
    baseUnit,
    verticalGapInLargeScreen,
    verticalGapInMediumScreen,
    verticalGapInSmallScreen,
    fontSizesStyles
  } = themeProps;
  return StyleSheet.create({
    headerFirstRow: {
      boxShadow: rowBoxShadow,
      backgroundColor: rowBackgroundColor,
      alignItems: 'center',
      justifyContent: 'space-between',
      zIndex,
      position: 'relative',
      transition: `height ${animationDuration}ms ease 0s`,
      [MEDIA_BREAKPOINTS.large]: {
        display: 'flex',
        height: `${rowFinalHeightInLargeScreen}px`,
        padding: `0 max(${baseUnit * verticalGapInLargeScreen}px, calc((100% - ${HUGE_SCREEN_SIZE}px) / 2))`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: hideInSmallAndMediumScreens ? 'none' : 'flex',
        height: `${rowHeightInMediumScreen * baseUnit}px`,
        padding: `0 ${baseUnit * verticalGapInMediumScreen}px`,
        justifyContent: 'space-between'
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: hideInSmallAndMediumScreens ? 'none' : 'flex',
        height: `${rowHeightInSmallScreen * baseUnit}px`,
        padding: `0 ${baseUnit * verticalGapInSmallScreen}px`,
        justifyContent: 'space-between'
      }
    },
    headerFirstRowItemsContainer: {
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      gap: `${baseUnit}px`
    },
    fixedNav: {
      [MEDIA_BREAKPOINTS.large]: {
        height: `${getLineHeightBySize(fontSizesStyles, linkFontSizeLarge, 'large')}px`,
        overflow: 'hidden',
        display: 'block'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'none'
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'none'
      }
    },
    subMenuWrapper: {
      position: 'absolute',
      left: 0,
      top: `${rowFinalHeightInLargeScreen / 2}px`,
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'none'
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'none'
      }
    },
    ctaWrapper: {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      display: 'grid',
      gridAutoFlow: 'column',
      height: '100%',
      width: 'max-content',
      alignItems: 'center',
      gridColumnGap: `${baseUnit}px`
    }
  });
};

const createMenuStyle = (baseUnit, verticalGapInMediumScreen, verticalGapInSmallScreen) => {
  return StyleSheet.create({
    style: {
      [MEDIA_BREAKPOINTS.large]: {
        display: 'none'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'inline-flex',
        marginRight: `${baseUnit * verticalGapInMediumScreen}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'inline-flex',
        marginRight: `${baseUnit * verticalGapInSmallScreen}px`
      }
    }
  });
};

const getMoreMenuLinks = (invisibleLinks, links) => {
  const numLinks = invisibleLinks.length;
  return links.slice(links.length - numLinks);
};

const isSubMenuOpen = subMenuState => {
  return subMenuState.element !== null;
};

const getInvisibleLinks = parent => {
  if (!parent) return [];
  const safetyBuffer = 5;
  const baseline = parent.getBoundingClientRect().top + safetyBuffer;
  return Array.from(parent.childNodes).filter(child => {
    return child.getBoundingClientRect().top > baseline;
  });
};

const RowWithFixedNav = props => {
  const {
    videoLogo,
    logo,
    links,
    moreButtonText,
    socialSection,
    oldSocialSection,
    pagePath,
    menu,
    editions,
    editionEndpoint,
    editionsIcon,
    hideInSmallAndMediumScreens,
    zIndex,
    logoHeightInLargeScreen,
    logoHeightInMediumScreen,
    logoHeightInSmallScreen,
    linkFontSizeLarge,
    linkDropdownIconColor,
    linkFontSizeMedium,
    linkFontSizeSmall,
    linkColorTypeActive,
    rowBackgroundColor,
    linkColorTypeHover,
    linkColorTypeNormal,
    rowHeightInLargeScreen,
    linkCurrentColor,
    rowHeightInMediumScreen,
    rowHeightInSmallScreen,
    subMenuBackgroundColor,
    subMenuLinksFontSize,
    rowBoxShadow,
    socialLinksColor,
    socialLinksHoverColor,
    cta,
    showAccessibilityIcon,
    reducedHeaderHeightFactors
  } = props;
  const themeProps = useTheme(componentConfigThemeKey$G);
  const {
    menuFoldState,
    animationDuration
  } = React__default.useContext(HeaderAnimationContext);
  const {
    baseUnit,
    verticalGapInLargeScreen,
    verticalGapInMediumScreen,
    verticalGapInSmallScreen,
    editionsSeparatorColor,
    editionsMenuBackgroundColor,
    editionsIconHoverColor,
    editionsIconNormalColor,
    editionsMenuWidthInLargeScreen,
    editionsMenuWidthInMediumScreen,
    editionsMenuWidthInSmallScreen,
    fontSizesStyles
  } = themeProps;
  const navHeightLarge = getLineHeightBySize(fontSizesStyles, linkFontSizeLarge, 'large');
  const rowFinalHeightInLargeScreen = menuFoldState === AnimationDirection.UP ? rowHeightInLargeScreen * reducedHeaderHeightFactors.large * baseUnit : rowHeightInLargeScreen * baseUnit;
  const styles = getStyles$a(themeProps, menuFoldState, animationDuration, hideInSmallAndMediumScreens, zIndex, rowBackgroundColor, rowFinalHeightInLargeScreen, rowHeightInMediumScreen, rowHeightInSmallScreen, rowBoxShadow, linkFontSizeLarge);
  const menuStyle = createMenuStyle(baseUnit, verticalGapInMediumScreen, verticalGapInSmallScreen);
  const ulRef = React__default.useRef(null);
  const [subMenuState, dispatchMenuState] = useSubMenu();
  const [invisibleLinks, setInvisibleLinks] = React__default.useState([]);
  const [invisibleLinksRecheckHappened, setInvisibleLinksRecheckHappened] = React__default.useState(false);
  const [invisibleLinksRecheckIsRequiredBecauseOfFontDisplaySwap, setInvisibleLinksRecheckIsRequiredBecauseOfFontDisplaySwap] = React__default.useState(false);
  const webFontsContext = React__default.useContext(WebFontsLoadingFlagContext);

  const closeSubMenu = () => {
    dispatchMenuState({
      data: {
        element: null,
        links: null,
        index: -1,
        linkFontSize: null,
        backgroundColor: ''
      }
    });
  };

  React__default.useEffect(() => {
    if (ulRef.current !== null) {
      if (menuFoldState === AnimationDirection.NONE) {
        const newInvisibleLinksList = getInvisibleLinks(ulRef.current);

        if (newInvisibleLinksList.length !== invisibleLinks.length) {
          setInvisibleLinks(newInvisibleLinksList);
        }
      }

      if (!invisibleLinksRecheckHappened) {
        setInvisibleLinksRecheckIsRequiredBecauseOfFontDisplaySwap(true);
      }
    }
  }, [ulRef, webFontsContext, baseUnit, verticalGapInLargeScreen, menuFoldState, invisibleLinks, invisibleLinksRecheckHappened]);
  React__default.useEffect(() => {
    if (invisibleLinksRecheckIsRequiredBecauseOfFontDisplaySwap && !invisibleLinksRecheckHappened) {
      setTimeout(() => {
        if (menuFoldState === AnimationDirection.NONE) {
          const newInvisibleLinksList = getInvisibleLinks(ulRef.current);

          if (newInvisibleLinksList.length !== invisibleLinks.length) {
            setInvisibleLinks(newInvisibleLinksList);
          }
        }
      }, 0.5);
      setInvisibleLinksRecheckHappened(true);
    }
  }, [invisibleLinks.length, invisibleLinksRecheckHappened, invisibleLinksRecheckIsRequiredBecauseOfFontDisplaySwap, menuFoldState]);
  React__default.useEffect(() => {
    window.addEventListener('scroll', closeSubMenu);
    return () => window.removeEventListener('scroll', closeSubMenu);
  });
  const shouldEditions = editions && editions.length > 0;
  const shouldShowSocialSection = socialSection && socialSection.length > 0;
  const shouldShowSocial = shouldShowSocialSection || oldSocialSection && oldSocialSection.imageLinks.length > 0;

  const toggleSubMenu = (element, navigationLinks, index, linkFontSize, backgroundColor) => {
    if (navigationLinks) {
      dispatchMenuState({
        data: {
          element,
          links: navigationLinks,
          index,
          linkFontSize,
          backgroundColor
        }
      });
    }
  };

  const onToggleFixedNavMenu = (element, index, type) => {
    if (type === 'button') {
      const moreButtonLinks = getMoreMenuLinks(invisibleLinks, links);
      toggleSubMenu(element, moreButtonLinks, -1, linkFontSizeLarge, rowBackgroundColor);
    } else {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const fixedNavLinks = links[index].children;
      toggleSubMenu(element, fixedNavLinks, index, subMenuLinksFontSize, subMenuBackgroundColor);
    }
  };

  const [registerLinkWithSubMenu, getHoverPlaceholders] = useLinksWithSubMenuHover(onToggleFixedNavMenu, ulRef, rowFinalHeightInLargeScreen, baseUnit);
  const indexOfFirstInvisibleLink = links ? links.length - invisibleLinks.length : 0;
  const numberOfItemsWithSeparator = [showAccessibilityIcon, shouldEditions].reduce((numberOfItems, itemData) => {
    if (itemData) {
      return numberOfItems + 1;
    }

    return numberOfItems;
  }, 0);
  return /*#__PURE__*/React__default.createElement("div", {
    className: css(styles.headerFirstRow)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css(styles.headerFirstRowItemsContainer)
  }, menu ? /*#__PURE__*/React__default.createElement(Menu, {
    links: menu.links,
    buttons: menu.buttons,
    additionalStyle: menuStyle,
    oldSocialSection: menu.oldSocialSection,
    socialSection: menu.socialSection
  }) : null, videoLogo && logo ? /*#__PURE__*/React__default.createElement(VideoLogo, _extends$1({}, videoLogo, {
    href: logo.href,
    firstRowHeightInSmallScreen: rowHeightInSmallScreen,
    firstRowHeightInMediumScreen: rowHeightInMediumScreen,
    firstRowHeightInLargeScreen: rowHeightInLargeScreen,
    menuAnimation: menuFoldState,
    reduceHeightAnimationDuration: animationDuration
  })) : logo && /*#__PURE__*/React__default.createElement(Logo$1, _extends$1({}, logo, {
    logoHeightInLargeScreen: logoHeightInLargeScreen,
    logoHeightInMediumScreen: logoHeightInMediumScreen,
    logoHeightInSmallScreen: logoHeightInSmallScreen,
    menuAnimation: menuFoldState,
    reduceHeightAnimationDuration: animationDuration
  })), /*#__PURE__*/React__default.createElement(FixedNav, {
    rowHeight: rowHeightInLargeScreen,
    navHeightLarge: navHeightLarge,
    ulRef: ulRef,
    links: links,
    pagePath: pagePath,
    activeStateColor: linkColorTypeActive,
    hoverStateColor: linkColorTypeHover,
    idleColor: linkColorTypeNormal,
    linkFontSizeLarge: linkFontSizeLarge,
    linkFontSizeMedium: linkFontSizeMedium,
    linkFontSizeSmall: linkFontSizeSmall,
    currentLinkColor: linkCurrentColor,
    linkDropdownIconColor: linkDropdownIconColor,
    subMenuState: subMenuState,
    indexOfFirstInvisibleLink: indexOfFirstInvisibleLink,
    linkBackgroundColor: subMenuState.backgroundColor,
    moreButtonText: moreButtonText,
    registerLinkWithSubMenu: registerLinkWithSubMenu
  })), /*#__PURE__*/React__default.createElement("div", {
    className: css(styles.headerFirstRowItemsContainer)
  }, cta && cta.href && cta.text ? /*#__PURE__*/React__default.createElement("div", {
    className: css(styles.ctaWrapper)
  }, /*#__PURE__*/React__default.createElement(CtaButton, cta)) : null, shouldShowSocial && /*#__PURE__*/React__default.createElement(SocialLinks, {
    socialLinks: socialSection,
    oldSocialSection: oldSocialSection,
    verticalGapInLargeScreen: verticalGapInLargeScreen,
    verticalGapInMediumScreen: verticalGapInMediumScreen,
    menuAnimation: menuFoldState,
    reduceHeightAnimationDuration: animationDuration,
    socialLinksColor: socialLinksColor,
    socialLinksHoverColor: socialLinksHoverColor
  }), numberOfItemsWithSeparator > 0 ? /*#__PURE__*/React__default.createElement(ItemsWithSeparator, {
    verticalGapInSmallScreen: verticalGapInSmallScreen,
    verticalGapInMediumScreen: verticalGapInMediumScreen,
    verticalGapInLargeScreen: verticalGapInLargeScreen,
    separatorColor: editionsSeparatorColor,
    numberOfItems: numberOfItemsWithSeparator
  }, showAccessibilityIcon && /*#__PURE__*/React__default.createElement(AccessibilityIcon, {
    accessibilityIconHoverColor: editionsIconHoverColor,
    accessibilityIconNormalColor: editionsIconNormalColor,
    menuAnimation: menuFoldState
  }), shouldEditions && /*#__PURE__*/React__default.createElement(Editions // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  , {
    editions: editions,
    editionEndpoint: editionEndpoint,
    editionsMenuWidthInLargeScreen: editionsMenuWidthInLargeScreen,
    editionsMenuWidthInMediumScreen: editionsMenuWidthInMediumScreen,
    editionsMenuWidthInSmallScreen: editionsMenuWidthInSmallScreen,
    fontSizeSmall: linkFontSizeSmall,
    fontSizeMedium: linkFontSizeMedium,
    fontSizeLarge: linkFontSizeLarge,
    colorTypeHover: linkColorTypeHover,
    colorTypeNormal: linkColorTypeNormal,
    colorTypeActive: linkColorTypeActive,
    dropdownIconColor: linkDropdownIconColor,
    editionsMenuBackgroundColor: editionsMenuBackgroundColor,
    editionsIcon: editionsIcon,
    editionsIconHoverColor: editionsIconHoverColor,
    editionsIconNormalColor: editionsIconNormalColor,
    menuAnimation: menuFoldState
  })) : null), /*#__PURE__*/React__default.createElement("div", {
    className: css(styles.subMenuWrapper),
    onMouseLeave: closeSubMenu
  }, getHoverPlaceholders(), isSubMenuOpen(subMenuState) && /*#__PURE__*/React__default.createElement(SubMenu, {
    rowFinalHeightInLargeScreen: rowFinalHeightInLargeScreen,
    animationDuration: animationDuration // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ,
    links: subMenuState.links // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ,
    parentElement: subMenuState.element,
    activeStateColor: linkColorTypeActive,
    hoverStateColor: linkColorTypeHover,
    idleColor: linkColorTypeNormal,
    currentLinkColor: linkCurrentColor,
    pagePath: pagePath // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ,
    linkFontSize: subMenuState.linkFontSize,
    innerLinkFontSize: subMenuLinksFontSize,
    backgroundColor: subMenuState.backgroundColor,
    innerLinksBackgroundColor: subMenuBackgroundColor,
    shouldOffsetLeft: false,
    openLinkIndex: subMenuState.index,
    linkDropdownIconColor: linkDropdownIconColor,
    isParentLinkVisibleOnTheRow: true
  })));
};

const reducedHeaderFirstRowHeightFactors = {
  large: 0.75,
  medium: 2 / 3,
  small: 2 / 3
};
const reducedHeaderSecondRowHeightFactors = {
  large: 0.5,
  medium: 2 / 3,
  small: 2 / 3
};

const zIndexForFirstRow = 200;
const zIndexForSecondRow = 100;

const getHeaderStyles = () => {
  return StyleSheet.create({
    style: {
      position: 'fixed',
      width: '100%',
      zIndex: 1500,
      top: 0
    }
  }).style;
};

const createHeaderStyleWithAnimation = animationDuration => {
  return StyleSheet.create({
    foldingUp: {
      [MEDIA_BREAKPOINTS.medium]: {
        transition: `${animationDuration}ms`,
        transform: 'translateY(-100%)',
        transitionDelay: `${animationDuration}ms`
      },
      [MEDIA_BREAKPOINTS.small]: {
        transition: `${animationDuration}ms`,
        transform: 'translateY(-100%)',
        transitionDelay: `${animationDuration}ms`
      }
    },
    foldingDown: {
      [MEDIA_BREAKPOINTS.medium]: {
        transform: 'translateY(0)'
      },
      [MEDIA_BREAKPOINTS.small]: {
        transform: 'translateY(0)'
      }
    }
  });
};

const getHeaderAnimationStyle = (menuFoldState, animationDuration) => {
  const style = createHeaderStyleWithAnimation(animationDuration);
  return menuFoldState === AnimationDirection.UP ? style.foldingUp : style.foldingDown;
};

const getChildrenByIndex = (links, index) => {
  if (!links || !links[index] || !links[index].children) return [];
  return links[index].children || [];
};

const HeaderComponent = props => {
  const {
    links,
    pagePath,
    subHeader,
    logo,
    moreButtonText,
    editionsIcon,
    editionEndpoint,
    editions,
    menu,
    oldSocialSection,
    socialSection,
    videoLogo,
    cta,
    showAccessibilityIcon
  } = props;
  const {
    menuFoldState,
    animationDuration
  } = React.useContext(HeaderAnimationContext);
  const themeProps = useTheme(componentConfigThemeKey$G);
  const {
    secondRowLinkColorTypeActive,
    secondRowLinkColorTypeHover,
    secondRowLinkColorTypeNormal,
    secondRowLinkCurrentColor,
    baseUnit,
    firstRowLinkFontSizeLarge,
    firstRowLinkFontSizeMedium,
    firstRowLinkFontSizeSmall,
    secondRowLinkFontSizeLarge,
    secondRowLinkFontSizeMedium,
    secondRowLinkFontSizeSmall,
    verticalGapInLargeScreen,
    verticalGapInMediumScreen,
    verticalGapInSmallScreen,
    firstRowLinkDropdownIconColor,
    secondRowLinkDropdownIconColor,
    firstRowSubMenuBackgroundColor,
    secondRowSubMenuBackgroundColor,
    secondRowBackgroundColor,
    secondRowHeightInMediumScreen,
    secondRowHeightInSmallScreen,
    secondRowHeightInLargeScreen,
    firstRowSubMenuLinksFontSize,
    secondRowSubMenuLinksFontSize,
    firstRowLinkCurrentColor,
    firstRowLinkColorTypeNormal,
    firstRowLinkColorTypeHover,
    firstRowLinkColorTypeActive,
    firstRowLogoHeightInSmallScreen,
    firstRowLogoHeightInMediumScreen,
    firstRowLogoHeightInLargeScreen,
    firstRowHeightInSmallScreen,
    firstRowHeightInMediumScreen,
    firstRowHeightInLargeScreen,
    firstRowBackgroundColor,
    secondRowLogoHeightInSmallScreen,
    secondRowLogoHeightInMediumScreen,
    secondRowLogoHeightInLargeScreen,
    firstRowBoxShadow,
    secondRowBoxShadow,
    firstRowSocialLinksColor,
    firstRowSocialLinksHoverColor,
    secondRowSocialLinksColor,
    secondRowSocialLinksHoverColor
  } = themeProps;
  const [scrollableMenuIndex, setScrollableMenuIndex] = React.useState(-1);
  const headerStyle = getHeaderStyles();

  const closeSubMenu = () => {
    setScrollableMenuIndex(-1);
  };

  React.useEffect(() => {
    window.addEventListener('scroll', closeSubMenu);
    return () => window.removeEventListener('scroll', closeSubMenu);
  });
  const scrollableLinks = subHeader ? subHeader.links : links;

  const onScrollableNavMenuToggle = (element, index) => {
    if (!scrollableLinks) return;

    if (index !== scrollableMenuIndex) {
      setScrollableMenuIndex(index);
    } else {
      setScrollableMenuIndex(-1);
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("header", {
    className: css(getHeaderAnimationStyle(menuFoldState, animationDuration), headerStyle)
  }, /*#__PURE__*/React.createElement(RowWithFixedNav, {
    cta,
    logo,
    moreButtonText,
    editionsIcon,
    editionEndpoint,
    editions,
    menu,
    oldSocialSection,
    socialSection,
    videoLogo,
    links,
    pagePath,
    linkFontSizeLarge: firstRowLinkFontSizeLarge,
    linkFontSizeMedium: firstRowLinkFontSizeMedium,
    linkFontSizeSmall: firstRowLinkFontSizeSmall,
    subMenuLinksFontSize: firstRowSubMenuLinksFontSize,
    subMenuBackgroundColor: firstRowSubMenuBackgroundColor,
    linkDropdownIconColor: firstRowLinkDropdownIconColor,
    linkCurrentColor: firstRowLinkCurrentColor,
    linkColorTypeNormal: firstRowLinkColorTypeNormal,
    linkColorTypeHover: firstRowLinkColorTypeHover,
    linkColorTypeActive: firstRowLinkColorTypeActive,
    logoHeightInSmallScreen: firstRowLogoHeightInSmallScreen,
    logoHeightInMediumScreen: firstRowLogoHeightInMediumScreen,
    logoHeightInLargeScreen: firstRowLogoHeightInLargeScreen,
    rowHeightInSmallScreen: firstRowHeightInSmallScreen,
    rowHeightInMediumScreen: firstRowHeightInMediumScreen,
    rowHeightInLargeScreen: firstRowHeightInLargeScreen,
    rowBackgroundColor: firstRowBackgroundColor,
    rowBoxShadow: firstRowBoxShadow,
    socialLinksColor: firstRowSocialLinksColor,
    socialLinksHoverColor: firstRowSocialLinksHoverColor,
    hideInSmallAndMediumScreens: false,
    zIndex: zIndexForFirstRow,
    showAccessibilityIcon,
    reducedHeaderHeightFactors: reducedHeaderFirstRowHeightFactors
  }), subHeader ? /*#__PURE__*/React.createElement(RowWithFixedNav, {
    cta: null,
    logo: subHeader.logoForLargeScreen,
    moreButtonText: subHeader.moreButtonText,
    editionsIcon: null,
    editionEndpoint,
    editions: null,
    menu: null,
    socialSection: subHeader.socialSection,
    links: subHeader.links,
    pagePath,
    linkFontSizeLarge: secondRowLinkFontSizeLarge,
    linkFontSizeMedium: secondRowLinkFontSizeMedium,
    linkFontSizeSmall: secondRowLinkFontSizeSmall,
    subMenuLinksFontSize: secondRowSubMenuLinksFontSize,
    subMenuBackgroundColor: secondRowSubMenuBackgroundColor,
    linkDropdownIconColor: secondRowLinkDropdownIconColor,
    linkCurrentColor: secondRowLinkCurrentColor,
    linkColorTypeNormal: secondRowLinkColorTypeNormal,
    linkColorTypeHover: secondRowLinkColorTypeHover,
    linkColorTypeActive: secondRowLinkColorTypeActive,
    logoHeightInSmallScreen: secondRowLogoHeightInSmallScreen,
    logoHeightInMediumScreen: secondRowLogoHeightInMediumScreen,
    logoHeightInLargeScreen: secondRowLogoHeightInLargeScreen,
    rowHeightInSmallScreen: secondRowHeightInSmallScreen,
    rowHeightInMediumScreen: secondRowHeightInMediumScreen,
    rowHeightInLargeScreen: secondRowHeightInLargeScreen,
    rowBackgroundColor: secondRowBackgroundColor,
    rowBoxShadow: secondRowBoxShadow,
    socialLinksColor: secondRowSocialLinksColor,
    socialLinksHoverColor: secondRowSocialLinksHoverColor,
    hideInSmallAndMediumScreens: true,
    zIndex: zIndexForSecondRow,
    reducedHeaderHeightFactors: reducedHeaderSecondRowHeightFactors
  }) : null, /*#__PURE__*/React.createElement(ScrollableNav, {
    menuFoldState: menuFoldState,
    animationDuration: animationDuration,
    links: scrollableLinks,
    linkColorTypeActive: secondRowLinkColorTypeActive,
    linkColorTypeHover: secondRowLinkColorTypeHover,
    linkColorTypeNormal: secondRowLinkColorTypeNormal,
    currentLinkColor: secondRowLinkCurrentColor,
    pagePath: pagePath,
    baseUnit: baseUnit,
    linkFontSizeLarge: secondRowLinkFontSizeLarge,
    linkFontSizeMedium: secondRowLinkFontSizeMedium,
    linkFontSizeSmall: secondRowLinkFontSizeSmall,
    verticalGapInLargeScreen: verticalGapInLargeScreen,
    verticalGapInMediumScreen: verticalGapInMediumScreen,
    verticalGapInSmallScreen: verticalGapInSmallScreen,
    secondRowBackgroundColor: secondRowBackgroundColor,
    secondRowHeightInMediumScreen: secondRowHeightInMediumScreen,
    secondRowHeightInSmallScreen: secondRowHeightInSmallScreen,
    linkDropdownIconColor: secondRowLinkDropdownIconColor,
    openLinkIndex: scrollableMenuIndex,
    onMenuToggle: onScrollableNavMenuToggle,
    boxShadow: secondRowBoxShadow,
    logo: subHeader ? subHeader.logoForSmallScreen : null
  })), scrollableMenuIndex >= 0 && /*#__PURE__*/React.createElement(ScrollableNavDropdown, {
    firstRowHeightInMediumScreen: firstRowHeightInMediumScreen,
    firstRowHeightInSmallScreen: firstRowHeightInSmallScreen,
    secondRowHeightInMediumScreen: secondRowHeightInMediumScreen,
    secondRowHeightInSmallScreen: secondRowHeightInSmallScreen,
    backgroundColor: secondRowSubMenuBackgroundColor,
    links: getChildrenByIndex(scrollableLinks, scrollableMenuIndex),
    pagePath: pagePath,
    linkColorTypeActive: secondRowLinkColorTypeActive,
    linkColorTypeHover: secondRowLinkColorTypeHover,
    linkColorTypeNormal: secondRowLinkColorTypeNormal,
    currentLinkColor: secondRowLinkCurrentColor,
    linkFontSize: secondRowSubMenuLinksFontSize
  }));
};
const Header = props => {
  const headerHeights = useHeaderHeights();
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(HeaderAnimation, {
    headerHeights: headerHeights
  }, /*#__PURE__*/React.createElement(HeaderComponent, props)));
};

const RecommendationsAdvertisement = props => {
  const {
    revcontentWidgetID,
    disableDefaultStyle
  } = props;

  const createStyle = baseUnit => {
    return StyleSheet.create({
      style: {
        paddingTop: `${baseUnit * 2}px`,
        paddingLeft: `${baseUnit}px`,
        paddingRight: `${baseUnit}px`,
        [MEDIA_BREAKPOINTS.large]: {
          paddingLeft: `${baseUnit + 80}px`
        }
      }
    });
  };

  const {
    baseUnit
  } = useTheme();
  const ref = React__default.useRef(null);
  React__default.useEffect(() => {
    // @ts-ignore TS2339
    if (ref && ref.current && typeof window.renderRCWidget === 'function') {
      // @ts-ignore TS2339
      window.renderRCWidget(ref.current);
    }
  }, []);
  const style = createStyle(baseUnit);
  const wrapperProps = disableDefaultStyle ? {} : {
    className: css(style.style)
  };
  return /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement("div", wrapperProps, /*#__PURE__*/React__default.createElement("div", {
    ref: ref,
    "data-rc-widget": true,
    "data-widget-host": "habitat",
    "data-endpoint": "//trends.revcontent.com",
    "data-widget-id": revcontentWidgetID
  })));
};

const componentConfigThemeKey$k = 'primarySectionTitle';
const PrimarySectionTitle = props => {
  const {
    children
  } = props;
  const theme = useTheme(componentConfigThemeKey$k);
  return /*#__PURE__*/React.createElement(H1, theme, children);
};

const componentConfigThemeKey$j = 'secondarySectionTitle';
const SecondarySectionTitle = props => {
  const {
    children
  } = props;
  const theme = useTheme(componentConfigThemeKey$j);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(H2, theme, children));
};

const componentConfigThemeKey$i = 'fourVC';

const createStyle$f = themeProps => {
  const {
    largeHorizontalGap,
    largeVerticalGap,
    mediumHorizontalGap,
    mediumVerticalGap,
    smallHorizontalGap,
    baseUnit
  } = themeProps;
  return StyleSheet.create({
    wrapper: {
      display: 'grid',
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: 'auto',
        gridRowGap: `${largeHorizontalGap * baseUnit}px`,
        gridColumnGap: `${largeVerticalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: 'auto',
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`,
        gridColumnGap: `${mediumVerticalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'auto',
        gridRowGap: `${smallHorizontalGap * baseUnit}px`
      }
    }
  });
};

const imageWidths$7 = createImageWidths(360, 360, 540);
const FourVC = props => {
  const {
    cards,
    paddingFactors
  } = props;
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const themeProps = useTheme(componentConfigThemeKey$i);
  const style = createStyle$f(themeProps);
  const themeContextVC = useThemeOverride({
    titleFontSizeLarge: 'large',
    titleFontSizeMedium: 'bigger',
    titleFontSizeSmall: 'large',
    metadataFontSizeLarge: 'bigger',
    metadataFontSizeMedium: 'big',
    metadataFontSizeSmall: 'bigger'
  }, componentConfigThemeKey$M);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle, style.wrapper)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextVC
  }, /*#__PURE__*/React.createElement(VerticalCard, _extends$1({}, cards[0], {
    imageWidths: imageWidths$7
  })), /*#__PURE__*/React.createElement(VerticalCard, _extends$1({}, cards[1], {
    imageWidths: imageWidths$7
  })), /*#__PURE__*/React.createElement(VerticalCard, _extends$1({}, cards[2], {
    imageWidths: imageWidths$7
  })), /*#__PURE__*/React.createElement(VerticalCard, _extends$1({}, cards[3], {
    imageWidths: imageWidths$7
  })))));
};

const componentConfigurationKey$4 = 'sectionDivider';
const getTrianglesSvg = color => `<?xml version="1.0" encoding="utf-8"?>
<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.31514 12.5L15.9999 25.8165L25.6847 12.5H6.31514Z" stroke="${color}"/>
<path d="M6.31514 6.49996L15.9999 19.8165L25.6847 6.49996H6.31514Z" stroke="${color}"/>
</svg>`;

const getStyles$9 = lineColor => {
  return StyleSheet.create({
    wrapper: {
      display: 'flex',
      alignItems: 'center',
      width: '-webkit-fill-available'
    },
    line: {
      height: '1px',
      width: '100%',
      border: 0,
      margin: 0,
      backgroundColor: lineColor
    }
  });
};

const SectionDividerWithIcon = props => {
  const {
    dividerLineColor,
    dividerShowIcon
  } = useTheme(componentConfigurationKey$4);
  const {
    iconComponent
  } = props;
  const styles = getStyles$9(dividerLineColor);
  const IconComponent = iconComponent;
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapper)
  }, dividerShowIcon && !!IconComponent ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("hr", {
    className: css(styles.line)
  }), /*#__PURE__*/React.createElement(IconComponent, null), /*#__PURE__*/React.createElement("hr", {
    className: css(styles.line)
  })) : /*#__PURE__*/React.createElement("hr", {
    className: css(styles.line)
  })));
};

const componentConfigThemeKey$h = 'fourHC';

const createStyle$e = themeProps => {
  const {
    largeHorizontalGap,
    mediumHorizontalGap,
    smallHorizontalGap
  } = themeProps;
  return StyleSheet.create({
    wrapper: {
      display: 'grid',
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'auto',
        gridRowGap: `${largeHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'auto',
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'auto',
        gridRowGap: `${smallHorizontalGap * baseUnit}px`
      }
    }
  });
};

const imageWidths$6 = createImageWidths(180, 360, 540);
const FourHC = props => {
  const {
    cards,
    paddingFactors,
    showDivider,
    dividerIcon
  } = props;
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const themeProps = useTheme(componentConfigThemeKey$h);
  const {
    titleFontSizeLarge,
    titleFontSizeMedium,
    titleFontSizeSmall,
    metadataFontSizeLarge,
    metadataFontSizeMedium,
    metadataFontSizeSmall,
    descriptionFontSizeLarge,
    descriptionFontSizeMedium,
    descriptionFontSizeSmall,
    cardProportionsLarge,
    cardProportionsMedium
  } = themeProps;
  const style = createStyle$e(themeProps);
  const themeContextVC = useThemeOverride({
    titleFontSizeLarge,
    titleFontSizeMedium,
    titleFontSizeSmall,
    metadataFontSizeLarge,
    metadataFontSizeMedium,
    metadataFontSizeSmall,
    descriptionFontSizeLarge,
    descriptionFontSizeMedium,
    descriptionFontSizeSmall,
    cardProportionsLarge,
    cardProportionsMedium
  }, componentConfigThemeKey$K);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle, style.wrapper)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextVC
  }, showDivider ? /*#__PURE__*/React.createElement(SectionDividerWithIcon, {
    iconComponent: dividerIcon
  }) : null, /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({}, cards[0], {
    imageWidths: imageWidths$6
  })), showDivider ? /*#__PURE__*/React.createElement(SectionDividerWithIcon, {
    iconComponent: dividerIcon
  }) : null, /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({}, cards[1], {
    imageWidths: imageWidths$6
  })), showDivider ? /*#__PURE__*/React.createElement(SectionDividerWithIcon, {
    iconComponent: dividerIcon
  }) : null, /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({}, cards[2], {
    imageWidths: imageWidths$6
  })), showDivider ? /*#__PURE__*/React.createElement(SectionDividerWithIcon, {
    iconComponent: dividerIcon
  }) : null, /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({}, cards[3], {
    imageWidths: imageWidths$6
  })))));
};

const componentConfigThemeKey$g = 'headlineCard';

const createStyle$d = ({
  horizontalGapLarge,
  horizontalGapMedium,
  horizontalGapSmall,
  cardTitleColorTypeNormal,
  cardTitleColorTypeHover,
  cardTitleColorTypeActive,
  authorColor,
  showAuthorInLargeScreen,
  showAuthorInMediumScreen,
  showAuthorInSmallScreen,
  showDateInLargeScreen,
  showDateInMediumScreen,
  showDateInSmallScreen,
  pipeColor,
  dateColor,
  numberOfLinesForTitle,
  numberOfLinesForAuthors,
  cardBackgroundColor,
  wrapperGapLarge,
  wrapperGapMedium,
  wrapperGapSmall
}) => StyleSheet.create({
  wrapper: {
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    backgroundColor: cardBackgroundColor,
    [MEDIA_BREAKPOINTS.large]: {
      padding: `${baseUnit * wrapperGapLarge}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      padding: `${baseUnit * wrapperGapMedium}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      padding: `${baseUnit * wrapperGapSmall}px`
    }
  },
  innerWrapper: {
    overflow: 'hidden',
    width: '-webkit-fill-available',
    height: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr',
    textDecoration: 'none',
    color: cardTitleColorTypeNormal,
    ':hover': {
      color: cardTitleColorTypeHover
    },
    ':active': {
      color: cardTitleColorTypeActive
    },
    [MEDIA_BREAKPOINTS.large]: {
      gridRowGap: `${baseUnit * horizontalGapLarge}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      gridRowGap: `${baseUnit * horizontalGapMedium}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      gridRowGap: `${baseUnit * horizontalGapSmall}px`
    }
  },
  title: {
    height: 'fit-content',
    ...ellipsify(numberOfLinesForTitle).style
  },
  metadata: {
    gridTemplateColumns: 'auto auto max-content',
    width: 'fit-content',
    [MEDIA_BREAKPOINTS.large]: {
      display: showMetadataInLargeScreenSize(showAuthorInLargeScreen, showDateInLargeScreen) ? 'inline-grid' : 'none'
    },
    [MEDIA_BREAKPOINTS.medium]: {
      display: showMetadataInMediumScreenSize(showAuthorInMediumScreen, showDateInMediumScreen) ? 'inline-grid' : 'none'
    },
    [MEDIA_BREAKPOINTS.small]: {
      display: showMetadataInSmallScreenSize(showAuthorInSmallScreen, showDateInSmallScreen) ? 'inline-grid' : 'none'
    }
  },
  authors: {
    color: authorColor,
    height: 'fit-content',
    [MEDIA_BREAKPOINTS.large]: {
      marginRight: `${baseUnit * 0.25}px`,
      ...(showAuthorInLargeScreen ? ellipsify(numberOfLinesForAuthors).style : {
        display: 'none'
      })
    },
    [MEDIA_BREAKPOINTS.medium]: {
      marginRight: `${baseUnit * 0.25}px`,
      ...(showAuthorInMediumScreen ? ellipsify(numberOfLinesForAuthors).style : {
        display: 'none'
      })
    },
    [MEDIA_BREAKPOINTS.small]: {
      marginRight: `${baseUnit * 0.25}px`,
      ...(showAuthorInSmallScreen ? ellipsify(numberOfLinesForAuthors).style : {
        display: 'none'
      })
    }
  },
  pipe: {
    color: pipeColor,
    [MEDIA_BREAKPOINTS.large]: {
      display: showDateInLargeScreen && showAuthorInLargeScreen ? 'block' : 'none',
      marginRight: `${baseUnit * 0.25}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      display: showDateInMediumScreen && showAuthorInMediumScreen ? 'block' : 'none',
      marginRight: `${baseUnit * 0.25}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      display: showDateInSmallScreen && showAuthorInSmallScreen ? 'block' : 'none',
      marginRight: `${baseUnit * 0.25}px`
    }
  },
  date: {
    color: dateColor,
    overflow: 'hidden',
    [MEDIA_BREAKPOINTS.large]: {
      display: showDateInLargeScreen ? 'inline-block' : 'none'
    },
    [MEDIA_BREAKPOINTS.medium]: {
      display: showDateInMediumScreen ? 'inline-block' : 'none'
    },
    [MEDIA_BREAKPOINTS.small]: {
      display: showDateInSmallScreen ? 'inline-block' : 'none'
    }
  },
  footer: {
    alignSelf: 'flex-end'
  }
});

const createMainCategoryStyle = (showMainCategoryInLargeScreen, showMainCategoryInMediumScreen, showMainCategoryInSmallScreen, mainCategoryHorizontalGapLarge, mainCategoryHorizontalGapMedium, mainCategoryHorizontalGapSmall, mainCategoryVerticalGapLarge, mainCategoryVerticalGapMedium, mainCategoryVerticalGapSmall, mainCategoryBackgroundColor, mainCategoryTextColor, horizontalGapLarge, horizontalGapMedium, horizontalGapSmall) => StyleSheet.create({
  style: {
    backgroundColor: mainCategoryBackgroundColor,
    color: mainCategoryTextColor,
    width: 'fit-content',
    [MEDIA_BREAKPOINTS.large]: {
      display: showMainCategoryInLargeScreen ? 'block' : 'none',
      padding: `${mainCategoryHorizontalGapLarge * baseUnit}px ${mainCategoryVerticalGapLarge * baseUnit}px`,
      marginBottom: `${horizontalGapLarge * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      display: showMainCategoryInMediumScreen ? 'block' : 'none',
      padding: `${mainCategoryHorizontalGapMedium * baseUnit}px ${mainCategoryVerticalGapMedium * baseUnit}px`,
      marginBottom: `${horizontalGapMedium * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      display: showMainCategoryInSmallScreen ? 'block' : 'none',
      padding: `${mainCategoryHorizontalGapSmall * baseUnit}px ${mainCategoryVerticalGapSmall * baseUnit}px`,
      marginBottom: `${horizontalGapSmall * baseUnit}px`
    }
  }
}).style;

const HeadlineCard = props => {
  const {
    title,
    authors,
    articleUrl,
    updatedAt,
    updatedAtISO,
    mainCategory,
    createdAt,
    createdAtISO
  } = props;
  const themeProps = useTheme(componentConfigThemeKey$g);
  const {
    titleFontSizeLarge,
    titleFontSizeMedium,
    titleFontSizeSmall,
    titleSemanticTag,
    metadataSemanticTag,
    metadataFontSizeSmall,
    metadataFontSizeMedium,
    metadataFontSizeLarge,
    showDateInSmallScreen,
    showDateInMediumScreen,
    showDateInLargeScreen,
    showAuthorInSmallScreen,
    showAuthorInMediumScreen,
    showAuthorInLargeScreen,
    showMainCategoryInLargeScreen,
    showMainCategoryInMediumScreen,
    showMainCategoryInSmallScreen,
    mainCategoryHorizontalGapLarge,
    mainCategoryHorizontalGapMedium,
    mainCategoryHorizontalGapSmall,
    mainCategoryVerticalGapLarge,
    mainCategoryVerticalGapMedium,
    mainCategoryVerticalGapSmall,
    mainCategoryBackgroundColor,
    mainCategoryFontSizeLarge,
    mainCategoryFontSizeMedium,
    mainCategoryFontSizeSmall,
    mainCategorySemanticTag,
    mainCategoryTextColor,
    horizontalGapLarge,
    horizontalGapMedium,
    horizontalGapSmall,
    isUpdatedAtTimestamp,
    isMainCategoryEnabled
  } = themeProps;
  const style = createStyle$d(themeProps);
  const showAuthor = showAuthorInAnyScreenSize(authors, showAuthorInLargeScreen, showAuthorInMediumScreen, showAuthorInSmallScreen);
  const showDate = showDateInAnyScreenSize(showDateInLargeScreen, showDateInMediumScreen, showDateInSmallScreen);
  const timestamp = isUpdatedAtTimestamp ? updatedAt : createdAt;
  const timestampISO = isUpdatedAtTimestamp ? updatedAtISO : createdAtISO;
  const showMainCategory = isMainCategoryEnabled && mainCategory && (showMainCategoryInSmallScreen || showMainCategoryInMediumScreen || showMainCategoryInLargeScreen);

  const MainCategory = () => {
    const mainCategoryStyle = createMainCategoryStyle(showMainCategoryInLargeScreen, showMainCategoryInMediumScreen, showMainCategoryInSmallScreen, mainCategoryHorizontalGapLarge, mainCategoryHorizontalGapMedium, mainCategoryHorizontalGapSmall, mainCategoryVerticalGapLarge, mainCategoryVerticalGapMedium, mainCategoryVerticalGapSmall, mainCategoryBackgroundColor, mainCategoryTextColor, horizontalGapLarge, horizontalGapMedium, horizontalGapSmall);
    return /*#__PURE__*/React.createElement(DynamicSemanticTag, {
      semanticTag: mainCategorySemanticTag,
      fontSizeLarge: mainCategoryFontSizeLarge,
      fontSizeMedium: mainCategoryFontSizeMedium,
      fontSizeSmall: mainCategoryFontSizeSmall,
      styles: semanticCSS(mainCategoryStyle)
    }, mainCategory);
  };

  return /*#__PURE__*/React.createElement("article", {
    className: css(style.wrapper)
  }, /*#__PURE__*/React.createElement(Link, {
    className: css(style.innerWrapper),
    href: articleUrl
  }, /*#__PURE__*/React.createElement("header", null, showMainCategory ? /*#__PURE__*/React.createElement(MainCategory, null) : null, /*#__PURE__*/React.createElement(DynamicSemanticTag, {
    semanticTag: titleSemanticTag,
    fontSizeLarge: titleFontSizeLarge,
    fontSizeMedium: titleFontSizeMedium,
    fontSizeSmall: titleFontSizeSmall,
    styles: semanticCSS(style.title)
  }, title)), showMetadataInAnyScreenSize(showAuthor, showDate) ? /*#__PURE__*/React.createElement("footer", {
    className: css(style.footer)
  }, /*#__PURE__*/React.createElement(DynamicSemanticTag, {
    semanticTag: metadataSemanticTag,
    fontSizeLarge: metadataFontSizeLarge,
    fontSizeMedium: metadataFontSizeMedium,
    fontSizeSmall: metadataFontSizeSmall,
    styles: semanticCSS(style.metadata)
  }, showAuthor ? /*#__PURE__*/React.createElement("div", {
    className: css(style.authors)
  }, listAuthors(authors)) : null, showPipeInAnyScreenSize(showAuthor, showDate) ? /*#__PURE__*/React.createElement("div", {
    className: css(style.pipe)
  }, "|") : null, showDate ? /*#__PURE__*/React.createElement("time", {
    dateTime: timestampISO,
    className: css(style.date)
  }, timestamp) : null)) : null));
};

const componentConfigThemeKey$f = 'fourHeadlineCards';

const createStyle$c = themeProps => {
  const {
    dividerWidth,
    baseUnit,
    dividerGapInSmallScreen,
    dividerGapInMediumScreen,
    dividerGapInLargeScreen,
    diverColor,
    showDivider,
    backgroundColor,
    borderRadius,
    wrapperGapLarge,
    wrapperGapMedium,
    wrapperGapSmall
  } = themeProps;
  return StyleSheet.create({
    wrapper: {
      display: 'grid',
      gridTemplateRows: 'auto',
      backgroundColor,
      borderRadius: `${borderRadius}px`,
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: showDivider ? '1fr auto 1fr auto 1fr auto 1fr' : '1fr 1fr 1fr 1fr',
        gridColumnGap: `${dividerGapInLargeScreen * baseUnit}px`,
        padding: `${wrapperGapLarge * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateColumns: showDivider ? '1fr auto 1fr' : '1fr 1fr',
        gridColumnGap: `${dividerGapInMediumScreen * baseUnit}px`,
        gridRowGap: `${dividerGapInMediumScreen * baseUnit}px`,
        padding: `${wrapperGapMedium * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateColumns: '1fr',
        gridRowGap: `${dividerGapInSmallScreen * baseUnit}px`,
        padding: `${wrapperGapSmall * baseUnit}px`
      }
    },
    dividerBetweenTwoCards: {
      backgroundColor: diverColor,
      [MEDIA_BREAKPOINTS.large]: {
        display: 'block',
        width: `${dividerWidth}px`,
        height: '100%'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'none'
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'block',
        width: '100%',
        height: `${dividerWidth}px`
      }
    },
    dividerBetweenFourCards: {
      [MEDIA_BREAKPOINTS.large]: {
        display: 'none'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        backgroundColor: diverColor,
        display: 'block',
        width: `${dividerWidth}px`,
        height: '100%',
        margin: `0 ${dividerGapInMediumScreen * baseUnit}px`,
        gridRowEnd: '3',
        gridRowStart: '1',
        gridColumnStart: '2'
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'none'
      }
    }
  });
};

const FourHeadlineCards = props => {
  const {
    cards
  } = props;
  const themeProps = useTheme(componentConfigThemeKey$f);
  const {
    borderColorTypeActive,
    borderColorTypeHover,
    borderColorTypeNormal,
    boxShadowTypeActive,
    boxShadowTypeHover,
    boxShadowTypeNormal,
    borderWidthTypeActive,
    borderWidthTypeHover,
    borderWidthTypeNormal
  } = themeProps;
  const borderBoxShadow = {
    borderColorTypeActive,
    borderColorTypeHover,
    borderColorTypeNormal,
    borderWidthTypeActive,
    borderWidthTypeHover,
    borderWidthTypeNormal
  };
  const boxShadowStyle = createStyleForBoxShadow({
    boxShadowTypeNormal,
    boxShadowTypeHover,
    boxShadowTypeActive,
    borderBoxShadow
  });
  const {
    showDivider
  } = themeProps;
  const style = createStyle$c(themeProps);
  const themeContextHeadlineCard = useThemeOverride({
    horizontalGapMedium: 0
  }, componentConfigThemeKey$g);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(style.wrapper, boxShadowStyle.style)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextHeadlineCard
  }, /*#__PURE__*/React.createElement(HeadlineCard, cards[0]), showDivider ? /*#__PURE__*/React.createElement("div", {
    className: css(style.dividerBetweenTwoCards)
  }) : null, showDivider ? /*#__PURE__*/React.createElement("div", {
    className: css(style.dividerBetweenFourCards)
  }) : null, /*#__PURE__*/React.createElement(HeadlineCard, cards[1]), showDivider ? /*#__PURE__*/React.createElement("div", {
    className: css(style.dividerBetweenTwoCards)
  }) : null, /*#__PURE__*/React.createElement(HeadlineCard, cards[2]), showDivider ? /*#__PURE__*/React.createElement("div", {
    className: css(style.dividerBetweenTwoCards)
  }) : null, /*#__PURE__*/React.createElement(HeadlineCard, cards[3]))));
};

const componentConfigThemeKey$e = 'twoOTCFourHLC';

const createStyle$b = (largeVerticalGap, largeHorizontalGap, mediumVerticalGap, mediumHorizontalGap, smallHorizontalGap) => {
  const firstOnTopCardArea = 'first_on_top_card_area';
  const secondOnTopCardArea = 'second_on_top_card_area';
  return StyleSheet.create({
    wrapper: {
      [MEDIA_BREAKPOINTS.large]: {
        display: 'grid',
        gridTemplateRows: '1fr auto',
        gridRowGap: `${largeHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'grid',
        gridTemplateRows: '1fr auto',
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'grid',
        gridTemplateRows: '1fr',
        gridRowGap: `${smallHorizontalGap * baseUnit}px`
      }
    },
    onTopCardsWrapper: {
      [MEDIA_BREAKPOINTS.large]: {
        display: 'inline-grid',
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: '1fr',
        gridColumnGap: `${largeVerticalGap * baseUnit}px`,
        gridTemplateAreas: `'${firstOnTopCardArea} ${secondOnTopCardArea}'`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'inline-grid',
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: '1fr',
        gridColumnGap: `${mediumVerticalGap * baseUnit}px`,
        gridTemplateAreas: `'${firstOnTopCardArea} ${secondOnTopCardArea}'`
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gridRowGap: `${smallHorizontalGap * baseUnit}px`,
        gridTemplateAreas: `'${firstOnTopCardArea}' '${secondOnTopCardArea}'`
      }
    },
    firstOnTopCard: {
      gridArea: firstOnTopCardArea
    },
    secondOnTopCard: {
      gridArea: secondOnTopCardArea
    },
    minorCard: {
      [MEDIA_BREAKPOINTS.small]: {
        paddingLeft: `${0.5 * baseUnit}px`,
        paddingRight: `${0.5 * baseUnit}px`
      }
    }
  });
};

const imageWidthsForMainCard$1 = createImageWidths(360, 360, 540);
const TwoOTCFourHLC = props => {
  const {
    cards,
    paddingFactors
  } = props;
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const themeProps = useTheme(componentConfigThemeKey$e);
  const headlineCards = {
    cards: [cards[2], cards[3], cards[4], cards[5]]
  };
  const {
    largeVerticalGap,
    largeHorizontalGap,
    mediumVerticalGap,
    mediumHorizontalGap,
    smallHorizontalGap
  } = themeProps;
  const styles = createStyle$b(largeVerticalGap, largeHorizontalGap, mediumVerticalGap, mediumHorizontalGap, smallHorizontalGap);
  const themeContextOnTopCards = useThemeOverride({
    aspectRatioSmall: {
      x: 4,
      y: 3
    },
    titleFontSizeLarge: 'large',
    titleFontSizeMedium: 'bigger',
    titleFontSizeSmall: 'large',
    metadataFontSizeMedium: 'big',
    metadataFontSizeSmall: 'bigger',
    horizontalGapSmall: 0.5
  }, componentConfigThemeKey$O);
  const themeContextHeadlineCards = useThemeOverride({
    horizontalGapLarge: 0.5,
    horizontalGapMedium: 0,
    horizontalGapSmall: 0.25,
    titleFontSizeSmall: 'large',
    metadataFontSizeSmall: 'bigger'
  }, componentConfigThemeKey$g);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle, styles.wrapper)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextOnTopCards
  }, /*#__PURE__*/React.createElement("div", {
    className: css(styles.onTopCardsWrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(styles.firstOnTopCard)
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, cards[0], {
    imageWidths: imageWidthsForMainCard$1
  }))), /*#__PURE__*/React.createElement("div", {
    className: css(styles.secondOnTopCard)
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, cards[1], {
    imageWidths: imageWidthsForMainCard$1
  }))))), /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextHeadlineCards
  }, /*#__PURE__*/React.createElement(FourHeadlineCards, headlineCards))));
};

const getStylesForTrianglesIcon = baseUnit => {
  return StyleSheet.create({
    triangles: {
      width: `${baseUnit * 1.2}px`
    }
  });
};
const TrianglesIconForDivider = () => {
  const {
    baseUnit,
    dividerLogoColor
  } = useTheme(componentConfigurationKey$4);
  const styles = getStylesForTrianglesIcon(baseUnit);
  const svg = getTrianglesSvg(dividerLogoColor);
  const imgSrc = `data:image/svg+xml,${encodeURIComponent(svg)}`;
  return /*#__PURE__*/React.createElement("img", {
    className: css(styles.triangles),
    src: imgSrc,
    alt: ""
  });
};

const getStylesForDotsBackImage = () => {
  return StyleSheet.create({
    background: {
      position: 'absolute',
      top: 0,
      zIndex: -1,
      height: '75%'
    },
    rect: {
      fill: '#fff'
    }
  });
};
const TitleDotsBackgroundImage = () => {
  const styles = getStylesForDotsBackImage();
  return /*#__PURE__*/React.createElement("svg", {
    className: css(styles.background),
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 50"
  }, /*#__PURE__*/React.createElement("rect", {
    className: css(styles.rect),
    width: "320",
    height: "50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.64,0c0,.79,0,1.59,0,2.37.1,1.26-.71,2.38-1.64,2.25A2,2,0,0,1,126.67,2a14,14,0,0,1,1-2Zm49.82,0a14,14,0,0,0-1,2,2,2,0,0,0,1.35,2.64c.92.13,1.73-1,1.63-2.25-.06-.78,0-1.58,0-2.37ZM75.83,0a13,13,0,0,0-1,2A2,2,0,0,0,76.2,4.66c.92.13,1.73-1,1.63-2.25-.06-.78,0-1.58,0-2.37ZM24,0a14,14,0,0,0-1,2,2,2,0,0,0,1.35,2.64c.92.13,1.73-1,1.63-2.25C26,1.63,26,.83,26,0ZM283.09,0a14,14,0,0,0-1,2,2,2,0,0,0,1.35,2.64c.92.13,1.73-1,1.63-2.25-.06-.78,0-1.58,0-2.37ZM231.28,0a14,14,0,0,0-1,2,2,2,0,0,0,1.35,2.64c.92.13,1.73-1,1.63-2.25-.06-.78,0-1.58,0-2.37ZM12.05,0c.17.91-.52,2.23.36,2.66a6.22,6.22,0,0,0,3.25.11c.57-.07.46-.83.35-1.24C15.85,1,14.91.84,15,0ZM63.87,0c.16.91-.53,2.23.36,2.66a6.22,6.22,0,0,0,3.25.11c.56-.07.46-.83.34-1.24-.16-.58-1.1-.73-1-1.53Zm51.82,0c.16.91-.53,2.23.36,2.66a6.18,6.18,0,0,0,3.24.11c.57-.07.47-.83.35-1.24-.16-.58-1.1-.73-1-1.53ZM167.5,0c.17.91-.52,2.23.37,2.66a6.18,6.18,0,0,0,3.24.11c.57-.07.46-.83.35-1.24-.16-.58-1.1-.73-1-1.53Zm51.82,0c.16.91-.53,2.23.36,2.66a6.22,6.22,0,0,0,3.25.11c.56-.07.46-.83.34-1.24-.16-.58-1.09-.73-1-1.53Zm51.82,0c.16.91-.53,2.23.36,2.66a6.22,6.22,0,0,0,3.25.11c.56-.07.46-.83.34-1.24-.16-.58-1.1-.73-1-1.53ZM.09,20.58c.33,0,.66,0,1,0,1.76-.14,2.65-1.3,1.85-2.56A2.51,2.51,0,0,0,.09,16.67ZM.09,46c1.49.26,2.81-.49,2.88-1.72.09-1.52-1.16-2.4-2.88-2.19ZM187.43,0c.32,1.13-1.08,3.2,1.74,3,2.41-.22.82-2,1.25-2.95ZM.09,10.8c2.26.82,2.53-1.53,2.64-2.29C2.9,7.27,1.47,6.72.09,6.89ZM291.07,0c.32,1.13-1.08,3.2,1.74,3,2.41-.22.82-2,1.25-2.95ZM32,0c.43,1-1.16,2.73,1.25,3C36.05,3.24,34.65,1.17,35,0ZM83.8,0c.32,1.13-1.08,3.2,1.74,3C88,2.77,86.36,1,86.79,0ZM239.25,0c.32,1.13-1.08,3.2,1.74,3,2.41-.22.82-2,1.25-2.95ZM135.61,0c.32,1.13-1.08,3.2,1.75,3,2.4-.22.81-2,1.24-2.95Zm69.76,0c.08.86-.43,1.92,1.25,2s1.92-.7,1.74-2ZM101.73,0c.08.86-.42,1.92,1.25,2s1.92-.7,1.74-2Zm51.82,0c.08.86-.42,1.92,1.25,2s1.92-.7,1.74-2ZM49.92,0C50,.9,49.49,2,51.16,2s1.93-.7,1.75-2ZM257.19,0c.08.86-.43,1.92,1.24,2s1.92-.7,1.75-2ZM212.34,0c1.67,2.45,1.33,2.45,3,0ZM108.71,0c1.66,2.45,1.32,2.45,3,0ZM93.76,0c1.67,2.45,1.33,2.45,3,0ZM249.21,0c1.67,2.45,1.33,2.45,3,0ZM145.58,0c1.66,2.45,1.32,2.45,3,0ZM42,0c1.66,2.45,1.32,2.45,3,0ZM5.08,0c1.66,2.45,1.32,2.45,3,0ZM264.16,0c1.67,2.45,1.33,2.45,3,0ZM160.53,0c1.66,2.45,1.32,2.45,3,0ZM197.4,0c1.66,2.45,1.32,2.45,3,0ZM56.89,0c1.67,2.45,1.33,2.45,3,0ZM.09,38.19a.77.77,0,0,0,1-.74c.07-.66,0-1.29-1-1.22ZM.09,2c1.49-.09.85-1.22,1-2C-.88-.11.5,1.38.09,2ZM245.16,42.12c-1,0-2,1.59-1.95,2.84,0,1,.81,1.4,1.41,1.83.4.3,2.64-2.26,2.6-3C246.72,43.05,246.26,42.14,245.16,42.12Zm-91.34-7.56a2.35,2.35,0,0,0-1.29,2.38c.19,1.27.86,2.16,2.09,2.17,1,0,1.6-.89,1.92-1.79C156.49,36.48,154.29,34.23,153.82,34.56ZM48.92,37.42c.28,1,1.86,2.16,2.51,1.66s2-1.18,1.41-2.25a10.92,10.92,0,0,0-2.26-2.41A2.94,2.94,0,0,0,48.92,37.42ZM283.09,10.31c-1.09-.94-1.25.42-1.71.78-.7.53-1.83,1.17-1.08,2.28.4.59.91,1.56,1.87,1.31a2.19,2.19,0,0,0,1.92-2.42C284.36,11.37,283.71,10.84,283.09,10.31ZM194,42.24c-.53-.43-1.15-.06-1.67.44-1.07,1-1.45,2.09-.38,3.32a11.85,11.85,0,0,0,1,1c.76-1,2.1-1.55,2.47-2.77C195.4,43.1,194.55,42.7,194,42.24Zm37.1-32.09c-.83-.62-.89.52-1.37.77a5.25,5.25,0,0,0-1.06,1,1,1,0,0,0,0,1.66c.56.53,1.07,1.5,2,1.09s1.94-1.23,1.65-2.6C232.46,11.08,231.67,10.6,231.07,10.15Zm-50.59,1.64c-.07-1-.86-1.38-1.46-1.81-.4-.28-2.79,2.5-2.51,3,.43.81.94,1.68,2,1.71S180.57,13,180.48,11.79ZM143.55,43.73a5.07,5.07,0,0,0-1.7-1.59c-.66-.33-1.19.31-1.6.8-.91,1.12-1.05,2.24.09,3.31l.7.69C141.63,46.88,143.84,44.15,143.55,43.73ZM124.69,13.22c.49.59,1.18,1.37,1.82,1.41,1.25.08,1.93-.83,2.15-2.08s-.48-1.78-1.21-2.43c-.11-.09-.24-.17-.35-.25C126.43,10,124.35,12.81,124.69,13.22Zm-51.8-.35a4.23,4.23,0,0,0,1.47,1.81c.59.41,2.23-.85,2.46-1.78s-.64-2.77-1.29-2.88S72.65,12.21,72.89,12.87ZM23.78,10.14c-.8-.59-.88.53-1.36.79a5,5,0,0,0-1.06,1,1,1,0,0,0,0,1.66c.57.53,1.08,1.5,2,1.07S25.29,13.43,25,12C25.22,11,24.38,10.59,23.78,10.14Zm68,33.46c-.49-.59-1.18-1.38-1.82-1.42-1.25-.08-1.93.83-2.16,2.08S88.24,46,89,46.69c.11.1.23.17.35.26C90,46.82,92.07,44,91.74,43.6Zm10.64-9.13a1.65,1.65,0,0,0-1,.7,2.21,2.21,0,0,0,.17,3.33c.51.48,1,.89,1.69.64a8.15,8.15,0,0,0,1.52-.8C104.72,36.9,102.86,34.44,102.38,34.47Zm102,2.26a2.33,2.33,0,0,0,1.91,2.38c1.08.23,1.67-.82,2.08-1.64.28-.54-1.93-3.07-2.56-3.09C205.16,35.08,204.28,35.53,204.33,36.73Zm53.26-2.33c-.25,0-.47.42-.7.66a2.16,2.16,0,0,0,0,3.32c.44.49,1,1.07,1.62.75a8,8,0,0,0,1.64-1.38C260.26,36.89,258.2,34.33,257.59,34.4ZM37.81,42.11c-1,0-2,1.69-1.87,2.92.08,1,.87,1.39,1.46,1.8.42.29,2.64-2.41,2.55-3.07C39.36,43.06,39,42.06,37.81,42.11Zm8.52,2.94c1.47-.17,2.71-1.15,2.59-2.15s-1.69-1.9-3-1.78c-1.63.14-.81,1.37-1,2.1C44.89,44.24,44.77,45.23,46.33,45.05Zm207.3,0c1.46-.2,2.71-1.18,2.56-2.17s-1.71-1.89-3-1.76c-1.61.17-.77,1.4-1,2.16C252.16,44.27,252,45.27,253.63,45.05Zm-53.22-1.93c0,.86-.43,2,1.23,1.93,1.39-.09,2.75-1,2.73-2s-1.43-1.94-2.71-1.92C199.88,41.05,200.43,42.29,200.41,43.12Zm-50.66,1.93c1.37,0,2.79-1,2.81-1.93s-1.35-1.92-2.74-2c-1.67-.1-1.19,1.07-1.25,2C148.7,43.86,148.05,45.08,149.75,45.05Zm-52,0c1.21.16,2.83-.77,3-1.73s-1.08-2-2.54-2.2-1.52.72-1.45,1.74C96.71,44.74,96.79,44.91,97.74,45Zm137.52-1.26c-.19,1,1.05,2.09,2.46,2.23.87.09,1.57,0,1.54-1.15,0-1.34-.94-2.71-1.94-2.76A3.33,3.33,0,0,0,235.26,43.78ZM29.8,42.14A2.21,2.21,0,0,0,28,44c-.08,1.14,1.82,2.25,3.18,2,.88-.18.82-.79.75-1.76S30.76,41.86,29.8,42.14ZM310,18.35c-.19,1,1,2.09,2.46,2.23.87.08,1.57,0,1.54-1.15,0-1.35-.95-2.71-1.94-2.76A3.31,3.31,0,0,0,310,18.35ZM264.59,37.17a1.36,1.36,0,0,0-2.37.55c-.1.72-.48,1.66.31,2.26.43.32.93,1.43,1.3.84.61-1,2.07-.17,2.34-1.44S265.2,37.86,264.59,37.17Zm-2.4-17.55c.1-1.53-1.06-3.24-2.22-2.91a2.22,2.22,0,0,0-1.77,1.92c-.06.94,1.37,1.92,2.85,1.95C261.58,20.56,262.14,20.54,262.19,19.62Zm-55.82-1.27c-.19,1,1,2.09,2.46,2.23.86.08,1.57,0,1.53-1.15,0-1.35-.94-2.71-1.94-2.76A3.29,3.29,0,0,0,206.37,18.35Zm7.84,20.75c.07-1.33-1.56-1.88-2.4-2.84-.23-.27-1.51,2-1.47,2.76.06,1.08.85,1.52,1.72,2C212.82,40.4,214.17,39.78,214.21,39.1ZM156.74,16.67c-.81-.12-2.37,1.23-2.16,2a2.22,2.22,0,0,0,2.29,1.9c.76,0,1.68.2,1.68-1.14A2.65,2.65,0,0,0,156.74,16.67Zm5.65,22.43c.07-1.33-1.56-1.88-2.4-2.84-.23-.27-1.51,2-1.47,2.76.06,1.08.85,1.52,1.72,2C161,40.4,162.36,39.78,162.39,39.1ZM26,31.36C26,32.45,28,33.6,29.24,33.3c.86-.2.8-.83.74-1.45-.13-1.42-1.21-2.61-2.24-2.46C27,29.87,26.08,30.33,26,31.36Zm83.17,5.88c-.39-.26-.53-1.42-1.37-.6-.43.43-1.13.7-1.11,1.49a2.74,2.74,0,0,0,.62,2.2c.77.78,1.1.54,1.82,0,.52-.41,1.68,0,1.51-1.65A11.31,11.31,0,0,0,109.19,37.24Zm-6.42-18.87c-.37.89,1,2.07,2.42,2.21.87.08,1.57,0,1.54-1.15,0-1.35-1-2.71-2-2.76A2.47,2.47,0,0,0,102.77,18.37Zm-24.93,13c-.07,1.09,1.93,2.24,3.22,1.94.86-.2.8-.83.74-1.45-.14-1.42-1.22-2.61-2.25-2.46C78.79,29.87,77.9,30.33,77.84,31.36Zm182.6,10.78c-.91-.37-2.11,1-2.26,2.38-.08.85,0,1.54,1.18,1.51,1.37,0,2.75-.93,2.81-2A2.43,2.43,0,0,0,260.44,42.14ZM52.89,16.69A2.19,2.19,0,0,0,51,18.44c-.32,1.15,1.44,2.28,3,2.16.93-.06,1-.61,1-1.16C54.85,18,53.87,16.62,52.89,16.69Zm76.77,14.67c-.07,1.09,1.93,2.24,3.22,1.94.86-.2.8-.83.74-1.45-.14-1.42-1.22-2.61-2.25-2.46C130.61,29.87,129.72,30.33,129.66,31.36Zm55.8,1c.1-1.53-1.06-3.24-2.22-2.91a2.22,2.22,0,0,0-1.77,1.92c-.06.93,1.37,1.91,2.85,1.95C184.85,33.28,185.41,33.26,185.46,32.34Zm49.78-2.94a2.23,2.23,0,0,0-1.93,1.76c-.3,1.15,1.45,2.28,3,2.16.93-.07.94-.62,1-1.17C237.21,30.7,236.22,29.33,235.24,29.4Zm53.86,2.94c.09-1.53-1.07-3.24-2.23-2.91a2.23,2.23,0,0,0-1.77,1.92c-.06.93,1.38,1.91,2.85,1.95C288.49,33.28,289,33.26,289.1,32.34ZM299,13.46c-.19,1,1,2.09,2.46,2.23.87.08,1.57,0,1.54-1.16,0-1.34-1-2.7-1.94-2.75A3.31,3.31,0,0,0,299,13.46Zm-10,.29C289,14.84,291,16,292.31,15.69c.87-.19.8-.83.74-1.45-.13-1.42-1.21-2.6-2.24-2.46C290.05,12.26,289.16,12.72,289.09,13.75Zm-37.86,1c.1-1.53-1.06-3.24-2.22-2.91a2.22,2.22,0,0,0-1.77,1.92c-.06.94,1.37,1.92,2.85,1.95C250.62,15.67,251.17,15.65,251.23,14.73Zm-14-1.27c-.19,1,1,2.09,2.46,2.23.86.08,1.57,0,1.53-1.16,0-1.34-.94-2.7-1.93-2.75A3.28,3.28,0,0,0,237.26,13.46ZM197.38,11.8a2.19,2.19,0,0,0-1.93,1.75c-.31,1.15,1.45,2.28,3,2.16.93-.07.94-.62.95-1.17C199.34,13.09,198.36,11.72,197.38,11.8Zm-11.9,1.71c-.33.92,1,2,2.46,2.18.91.1,1.55-.07,1.5-1.19-.06-1.35-1-2.69-2.05-2.72A2.47,2.47,0,0,0,185.48,13.51ZM145.6,11.79a2.23,2.23,0,0,0-2,1.73c-.35,1.13,1.39,2.29,3,2.19.92-.05,1-.57,1-1.07C147.55,13.14,146.56,11.74,145.6,11.79Zm-9.79,0c-.8-.12-2.36,1.23-2.16,2a2.22,2.22,0,0,0,2.3,1.9c.75,0,1.67.2,1.67-1.14A2.63,2.63,0,0,0,135.81,11.78ZM32,8.06c.11-1-1.08-2-2.54-2.15-1-.11-1.52.15-1.46,1.24.09,1.35,1,2.65,2,2.67A3.31,3.31,0,0,0,32,8.06Zm59.83,5.45c-.33.92,1,2,2.46,2.18.91.1,1.55-.07,1.5-1.19-.06-1.35-1-2.69-2-2.72A2.47,2.47,0,0,0,91.81,13.51Zm-8.2-1.69a2.21,2.21,0,0,0-1.78,1.9c-.07,1.14,1.82,2.25,3.18,2,.88-.18.82-.8.75-1.77S84.57,11.53,83.61,11.82ZM81.08,5.9c-1.1-.07-1.37.48-1.27,1.42C80,8.75,81,10.06,82,9.78A2.52,2.52,0,0,0,83.8,8C83.78,6.92,82.46,6,81.08,5.9ZM42,11.79a2.23,2.23,0,0,0-2,1.73c-.36,1.13,1.38,2.29,3,2.19.92-.05,1-.57,1-1.07C43.91,13.14,42.93,11.74,42,11.79ZM30,13.51c-.34.92,1,2,2.45,2.18.92.1,1.55-.07,1.5-1.19-.06-1.35-1-2.69-2-2.72A2.45,2.45,0,0,0,30,13.51Zm103.06-7.6c-.63-.06-1.28-.11-1.47.74-.29,1.31.87,3.22,2,3.15s1.52-.93,2-1.69C135.75,7.09,134.55,6.05,133.09,5.91Zm75.5,36.23c-.94-.33-2.07,1-2.23,2.41-.09.9.08,1.52,1.22,1.48,1.38-.06,2.74-1,2.77-2A2.48,2.48,0,0,0,208.59,42.14Zm-23.13,0a2.23,2.23,0,0,0-2,1.72c-.35,1.14,1.38,2.29,2.95,2.2.92-.06,1-.58,1-1.07C187.41,43.46,186.42,42.06,185.46,42.12Zm2-34.28c0-1.1-2-2.24-3.25-1.93-.85.2-.79.84-.73,1.45.14,1.42,1.23,2.61,2.23,2.46A3.29,3.29,0,0,0,187.43,7.84Zm-30.62,34.3c-.91-.37-2.12,1-2.26,2.38-.09.85,0,1.54,1.18,1.51,1.36,0,2.75-.93,2.81-2A2.46,2.46,0,0,0,156.81,42.14Zm-23.38,0a2.21,2.21,0,0,0-1.78,1.9c-.07,1.14,1.83,2.25,3.19,2,.87-.18.81-.79.74-1.76S134.4,41.86,133.43,42.14ZM235.26,6.68c-.28,1.35.85,3.2,2,3.12A2.23,2.23,0,0,0,239.21,8c.28-.95-1.05-2-2.2-2.1C236.06,5.87,235.43,5.82,235.26,6.68ZM105,42.14c-.93-.33-2.06,1-2.22,2.41-.1.9.08,1.52,1.22,1.48,1.37-.06,2.74-1,2.77-2A2.47,2.47,0,0,0,105,42.14ZM83.8,45.27c.29-1.3-.86-3.21-2-3.15a2.26,2.26,0,0,0-2,1.74c-.31.93,1,2,2,2.1C83,46.06,83.61,46.12,83.8,45.27ZM291.07,8.1c.15-1-1.06-2-2.51-2.19-.92-.1-1.54.08-1.49,1.2.06,1.34,1,2.69,2,2.71A3.31,3.31,0,0,0,291.07,8.1ZM58.76,39.16c.16-1.37-1.61-1.83-2.32-2.88-.65.64-1.49,1-1.58,2.19-.11,1.36.72,1.94,1.62,2.55C57.29,40.4,58.68,39.85,58.76,39.16Zm-5.62,3c-.94-.33-2.07,1-2.23,2.41-.1.9.08,1.52,1.22,1.48,1.38-.06,2.74-1,2.77-2A2.48,2.48,0,0,0,53.14,42.14Zm-46.2-3c.17-1.37-1.6-1.83-2.32-2.88-.64.64-1.49,1-1.58,2.19-.11,1.36.72,1.94,1.62,2.55C5.47,40.4,6.86,39.85,6.94,39.16Zm7.6-3c-1.48,0-1.59.71-1.49,1.78s-.54,2.29,1.49,2.25c1.5,0,1.6-.69,1.46-2.17C15.88,37.47,16.6,36.12,14.54,36.17ZM267.13,7.41a2,2,0,0,0,1.73,2.2c.22-1.25,2.41-.12,2.28-1.81-.08-1-1.44-1.91-2.81-1.89C267.16,5.82,267.15,6.56,267.13,7.41ZM253.45,5.9c-1.12-.06-1.27.52-1.27,1.44a2.31,2.31,0,0,0,1.68,2.32c.21-1.31,2.41-.13,2.33-1.8C256.17,6.91,254.8,6,253.45,5.9ZM215.31,7.37A2.19,2.19,0,0,0,217,9.64c.23-1.27,2.4-.13,2.31-1.8,0-1-1.38-1.92-2.77-1.93C215.41,5.81,215.32,6.48,215.31,7.37ZM201.63,5.9c-1.12-.06-1.26.52-1.27,1.44a2.31,2.31,0,0,0,1.69,2.32c.2-1.31,2.4-.13,2.32-1.8C204.35,6.91,203,6,201.63,5.9ZM163.47,7.11c-.16,1.37.82,1.93,1.54,2.71.39-1.18,2.17-.5,2.48-1.73.24-1-1-2-2.77-2.21C164.05,5.78,163.6,6,163.47,7.11ZM149.61,5.9c-1.62.12-1.09,1.37-1,2.1s1,2,1.62,1.42,2.57,0,2.29-1.75A2.84,2.84,0,0,0,149.61,5.9ZM279.38,30.32c-1.67.07-1.18,1.11-1.27,2-.14,1.27,0,2.1,1.73,2s1.2-1.11,1.26-2.07C281.28,31.05,281.09,30.24,279.38,30.32Zm-51.84,4c1.08,0,2.06,0,1.72-1.48-.2-.88.9-2.43-1.22-2.46-1.09,0-2,0-1.74,1.51C226.61,32.69,225.42,34.26,227.54,34.29Zm-51.82,0c1.08,0,2.07,0,1.73-1.48-.21-.88.89-2.43-1.22-2.46-1.09,0-2,0-1.75,1.51C174.79,32.69,173.61,34.26,175.72,34.29Zm-51.82,0c1.09,0,2.07,0,1.73-1.48-.21-.88.89-2.43-1.22-2.46-1.09,0-2,0-1.74,1.51C123,32.69,121.79,34.26,123.9,34.29Zm-51.32-4c-1.7-.08-1.89.71-1.74,2,.1.86-.41,1.92,1.26,2s1.92-.7,1.74-1.89C73.76,31.45,74.27,30.39,72.58,30.32Zm39.1-22.94a2.16,2.16,0,0,0,1.7,2.26c.23-1.27,2.41-.13,2.31-1.81-.06-1-1.4-1.91-2.89-1.92C111.75,5.8,111.69,6.5,111.68,7.38ZM98,5.9c-1.12-.06-1.26.52-1.26,1.44a2.31,2.31,0,0,0,1.68,2.32c.21-1.31,2.41-.13,2.33-1.8C100.72,6.91,99.35,6,98,5.9Zm-37.06,0C59.31,6,59.83,7.27,60,8s1,2,1.63,1.42,2.56,0,2.29-1.75A2.86,2.86,0,0,0,60.93,5.9Zm-12,2c-.08-1-1.36-1.9-2.74-2-1.1-.07-1.27.49-1.28,1.43,0,1.23.65,1.88,2,2.49C46.4,7.87,49.1,9.73,48.93,7.88ZM9.11,5.9C7.49,6,8,7.27,8.13,8s1,2,1.63,1.42,2.56,0,2.29-1.75A2.86,2.86,0,0,0,9.11,5.9ZM296.59,9.8c.92.35,1.48-.39,2-1A2.72,2.72,0,0,0,299,7.59c.13-.77-1.18-2.84-1.47-2.58-.66.58-1.69,1-1.51,2.2a6,6,0,0,1,0,1C296.05,8.77,295.88,9.52,296.59,9.8Zm-16.5-2.91A2.29,2.29,0,0,0,278.23,5c-.86-.21-2.4,1.39-2.07,2.15a2.42,2.42,0,0,0,2,1.74C278.86,8.8,280.17,7.49,280.09,6.89ZM245,9.8a2.08,2.08,0,0,0,2.16-1.51,2.2,2.2,0,0,0-.92-2.87c-.22-.12-.6-.34-.66-.28-.63.65-1.64,1.11-1.33,2.29a3,3,0,0,1,0,.52C244.38,8.58,243.78,9.6,245,9.8Zm-20.63-3c-.11,1.07.85,1.68,1.75,2s2.41-1.25,2.15-2.08a2.5,2.5,0,0,0-2-1.82A2.41,2.41,0,0,0,224.35,6.81Zm-31.19,3a2.08,2.08,0,0,0,2.16-1.51,2.2,2.2,0,0,0-.92-2.87c-.21-.12-.6-.34-.66-.28-.63.65-1.63,1.11-1.33,2.29a2.24,2.24,0,0,1,0,.52C192.56,8.58,192,9.6,193.16,9.8ZM174.4,5a2.13,2.13,0,0,0-1.89,1.87c-.14.86,1.57,2.34,2.27,2s1.77-.93,1.69-2.13C176,5.88,175.5,4.87,174.4,5Zm-33.17.79c-1,.68-.53,1.7-.63,2.59-.06.61-.13,1.28.72,1.46s1.18-.33,1.59-.81c1.1-1.29.71-3.59-.8-3.95C141.86,5.26,141.57,5.54,141.23,5.77ZM6.57,16.73c2,0,1.4-1.26,1.49-2.26s0-1.74-1.49-1.77c-2,0-1.4,1.26-1.49,2.25S5.07,16.7,6.57,16.73Zm51.56-.05c1.09,0,2.07,0,1.73-1.47-.21-.89.89-2.44-1.22-2.47-1.09,0-2,0-1.74,1.51C57.21,15.09,56,16.66,58.13,16.68Zm52.09.05c1.5,0,1.56-.74,1.48-1.79s.5-2.27-1.51-2.24c-1.52,0-1.57.73-1.44,2.23C108.82,15.47,108.19,16.77,110.22,16.73Zm51.82,0c1.5,0,1.55-.74,1.48-1.79S164,12.67,162,12.7c-1.52,0-1.57.73-1.44,2.23C160.64,15.47,160,16.77,162,16.73Zm51.55-.05c1.08,0,2.06,0,1.72-1.47-.2-.89.9-2.44-1.22-2.47-1.09,0-2,0-1.74,1.51C212.66,15.09,211.47,16.66,213.59,16.68Zm52.07.05c1.48,0,1.59-.71,1.49-1.78s.53-2.29-1.49-2.25c-1.5,0-1.6.7-1.46,2.17C264.31,15.43,263.6,16.78,265.66,16.73ZM20.53,34.33c1.51,0,1.56-.74,1.48-1.78s.5-2.27-1.5-2.25c-1.52,0-1.57.74-1.48,1.79S18.53,34.37,20.53,34.33ZM122.66,5a2.13,2.13,0,0,0-2,1.8c-.22.84,1.41,2.36,2.19,2a2.39,2.39,0,0,0,1.77-2.05C124.26,5.88,123.7,5,122.66,5Zm148.42,24.9a2.13,2.13,0,0,0-1.18-.46c-.71,0-1.65-.36-1.77.91-.14,1.56.92,3.17,2.19,2.92.68-.14,1.24-.89,1.87-1.37C271.54,31.31,271,30.81,271.08,29.87ZM90.08,5.13c-1.11.35-1.83,3.7-.94,4.52A1,1,0,0,0,90,9.8c.81-.44,1.63-.91,1.76-2a2.23,2.23,0,0,0-1-2.44,2.12,2.12,0,0,1-.34-.33A1.86,1.86,0,0,0,90.08,5.13Zm126.23,25.5a2.32,2.32,0,0,0,2,2.64c1,.16,1.33-.8,1.79-1.35.33-.39-1.73-2.52-2.48-2.54S216.31,29.56,216.31,30.63ZM68.9,6.81c-.11,1.07.85,1.68,1.75,2s2.41-1.25,2.15-2.08a2.5,2.5,0,0,0-2-1.82A2.4,2.4,0,0,0,68.9,6.81Zm96.65,22.55c-1.27.09-1.09.94-1,1.66.16,1.37,1.47,2.62,2.38,2.24a5.63,5.63,0,0,0,1.46-1.3A3,3,0,0,0,165.55,29.36ZM37.46,9.78c.9.37,1.49-.32,2-.94a3,3,0,0,0,.51-1.21c.14-.73-1.18-2.9-1.44-2.66-.66.6-1.68,1-1.54,2.19,0,.32,0,.64,0,.95C37,8.72,36.76,9.49,37.46,9.78ZM112.7,30.85c.15,1.4,1.23,2.69,2.22,2.39a3.29,3.29,0,0,0,1.68-1.47c.29-.52-2-2.43-2.69-2.38C112.82,29.46,112.58,29.75,112.7,30.85ZM36.94,16.67c-1.64,0-.58,1.9-1.77,2.41-.36.15,1.56,1.61,2.83,1.52.93-.06.94-.62,1-1.17C38.91,18,37.93,16.68,36.94,16.67ZM19,5a2.12,2.12,0,0,0-1.95,1.8c-.22.84,1.41,2.36,2.19,2A2.41,2.41,0,0,0,21,6.75C20.62,5.88,20.07,5,19,5ZM66.36,40.2c1.48,0,1.59-.71,1.49-1.77s.54-2.29-1.49-2.26c-1.5,0-1.6.7-1.46,2.18C65,38.91,64.3,40.26,66.36,40.2Zm-5.48-9.32c.14,1.38,1.29,2.69,2.25,2.36a2.94,2.94,0,0,0,1.61-1.49c.29-.68-1.85-2.44-2.68-2.37C60.89,29.3,60.79,30,60.88,30.88Zm29.9-11.52c-.07-1.33-1-2.66-2-2.69-1.69-.07-.5,2.07-1.83,2.28a2.24,2.24,0,0,0,2.42,1.63C90.27,20.72,90.84,20.45,90.78,19.36Zm27.39,16.81c-1.48,0-1.58.71-1.49,1.78s-.53,2.29,1.5,2.25c1.49,0,1.59-.69,1.45-2.17C119.52,37.47,120.23,36.12,118.17,36.17ZM9.06,30.88c.14,1.38,1.29,2.69,2.26,2.36a3,3,0,0,0,1.61-1.49c.28-.68-1.86-2.44-2.69-2.37C9.07,29.3,9,30,9.06,30.88ZM140.81,16.72c-1.73-.49-1.17,1.46-1.75,2.17-.44.55.54,1.77,1.84,1.69.73,0,1.68.25,1.71-1.1A2.33,2.33,0,0,0,140.81,16.72Zm29,19.47c-1.67.07-1.18,1.11-1.28,2-.13,1.27,0,2.09,1.73,2s1.21-1.11,1.27-2.06C171.66,36.92,171.48,36.11,169.77,36.19ZM275.86,24.45c-1.69-.08-1.89.71-1.74,2,.1.86-.41,1.92,1.26,2s1.93-.7,1.74-1.89C277.05,25.58,277.55,24.52,275.86,24.45Zm-51.83,4c1.67-.07,1.18-1.11,1.27-2,.14-1.27,0-2.1-1.72-2s-1.21,1.1-1.27,2.06C222.13,27.72,222.32,28.53,224,28.45Zm-29.61-9.09c-.07-1.33-1-2.66-2-2.69-1.7-.07-.51,2.07-1.83,2.28A2.22,2.22,0,0,0,193,20.58C193.91,20.72,194.47,20.45,194.42,19.36ZM172,24.44c-2,0-1.43,1.23-1.51,2.24s0,1.76,1.48,1.78c2,0,1.43-1.23,1.51-2.24S173.52,24.46,172,24.44Zm-51.59,0c-1.69-.08-1.89.71-1.74,2,.1.86-.41,1.92,1.26,2s1.93-.7,1.74-1.89C121.59,25.58,122.1,24.52,120.41,24.45Zm121.91-5.28c-.26.15,2.13,1.61,3.12,1.42s.84-.8.78-1.42c-.13-1.44-1.18-2.63-2.28-2.49C242.8,17,243.37,18.58,242.32,19.17ZM222,36.18c-1.72-.07-1.87.75-1.73,2,.09.87-.4,1.91,1.27,2s1.9-.73,1.73-1.94C223.25,37.29,223.72,36.25,222,36.18ZM68.6,24.48c-1.08,0-2.06,0-1.72,1.48.21.89-.9,2.43,1.22,2.46,1.09,0,2,0,1.74-1.51C69.53,26.08,70.72,24.51,68.6,24.48Zm-52,0c-2,0-1.43,1.23-1.51,2.24s0,1.76,1.48,1.78c2,0,1.43-1.23,1.51-2.24S18.07,24.46,16.55,24.44Zm279.52-7.77c-1.71-.08-.53,2.06-1.84,2.27a2.26,2.26,0,0,0,2.34,1.66c.92,0,1.58-.11,1.47-1.23C298,18,297,16.71,296.07,16.67ZM273.63,40.2c2,0,1.4-1.26,1.49-2.25s0-1.75-1.49-1.77c-2,0-1.4,1.26-1.5,2.25S272.13,40.18,273.63,40.2ZM11.81,23.5A2.09,2.09,0,0,0,14,22a1.93,1.93,0,0,0-.57-2.54c-.34-.21-.92-.66-1-.59-.66.62-1.64,1.1-1.34,2.28a3.18,3.18,0,0,1,0,.63C11.26,22.25,10.57,23.3,11.81,23.5Zm51.76,0c.73.17,1.18-.3,1.6-.79.29-.33.65-.56.73-1.13.18-1.27-.37-2.49-1.37-2.66s-1.76.92-1.66,2.15c0,.31,0,.63,0,1.07S62.75,23.31,63.57,23.51Zm51.82,0c.72.18,1.18-.3,1.59-.78s.65-.57.73-1.13c.18-1.27-.36-2.5-1.36-2.67s-1.76.91-1.67,2.14c0,.31,0,.63,0,1.18A.94.94,0,0,0,115.39,23.51Zm51.83,0c1,.2,1.49-.55,1.9-1.15a2,2,0,0,0-.27-2.89c-.31-.26-.92-.7-1-.64-.63.63-1.66,1.07-1.37,2.26a5.32,5.32,0,0,1,0,1.07C166.47,22.66,166.38,23.33,167.22,23.51Zm52,0a2.67,2.67,0,0,0,2.09-2.62c.06-1.18-1-1.53-1.5-2.25-.78.73-1.83,1.31-1.52,2.65a2.46,2.46,0,0,1,0,.47C218.29,23.25,218.45,23.56,219.25,23.52Zm51.63,0A2.09,2.09,0,0,0,273.05,22a2.2,2.2,0,0,0-.92-2.87c-.21-.13-.6-.35-.66-.29-.62.65-1.64,1.1-1.33,2.29a3,3,0,0,1,0,.52C270.29,22.27,269.69,23.28,270.88,23.5ZM50.21,21.57c-1-.27-2.09,1-2.3,2.43s.65,1.46,1.74,1.5c1.68.06,1.21-1.07,1.26-2C50.77,22.86,51.34,21.89,50.21,21.57Zm51.77,0c-1.17-.19-1.8.8-2.16,1.55-.26.55-.52,1.67.31,2.17a3,3,0,0,0,1.87.14c1.18-.23.58-1.24.76-2C102.51,22.84,103.22,21.78,102,21.58Zm52.09,0c-.91-.4-1.41.38-2,.89s-.49,1.11-.49,1.73,0,1.33,1,1.22c.72-.08,1.71.44,2-.71a6.19,6.19,0,0,0,0-1.43C154.51,22.72,154.78,21.93,154.07,21.62Zm51.56-.05c-1-.23-2.09,1-2.26,2.47-.11.95.17,1.38,1.27,1.47,1.69.13,1.91-.7,1.67-2.29C206.22,22.83,206.82,21.84,205.63,21.57Zm52,0c-.92-.37-1.41.45-2,1s-.44,1.13-.46,1.74.13,1.28,1,1.17c.7-.08,1.71.46,1.94-.75a8.65,8.65,0,0,0,0-1.44C258.17,22.66,258.38,21.87,257.67,21.59Zm51.61,0c-1-.25-2.1,1-2.27,2.46-.11.94.14,1.39,1.25,1.48,1.66.13,1.94-.66,1.67-2.35C309.85,22.84,310.44,21.86,309.28,21.57ZM8.06,24.72c.18-1-.68-1.37-1.22-1.89a2.31,2.31,0,0,0-2.28-.2c-.72.19-.45,1.06-.48,1.67C4,26,5.26,25.36,6.23,25.49,6.77,25.25,7.83,26,8.06,24.72ZM271.11,45c0-.58.41-1.46-.33-1.73a3.11,3.11,0,0,0-2.25,0c-.6.31-1.43.81-1.38,1.78.06,1.3,1.08.81,1.76.94C269.71,45.78,271,46.61,271.11,45ZM44.9,25c.38-.9-.45-1.39-1-2s-1.14-.44-1.76-.46-1.32.12-1.21,1c.09.69-.47,1.68.76,1.91a7.9,7.9,0,0,0,1.46,0C43.81,25.46,44.61,25.67,44.9,25Zm14.92,0c.41-.89-.39-1.39-.91-2s-1.13-.48-1.76-.48-1.36,0-1.24,1c.08.71-.45,1.68.72,1.95a6.46,6.46,0,0,0,1.46,0C58.7,25.43,59.5,25.7,59.82,25ZM218.36,46c1.32,0,.88-1,.95-1.74.13-1.14-.62-1.12-1.5-1.23-1.26-.16-1.74.76-2.32,1.43a.94.94,0,0,0,.44,1.52,4.39,4.39,0,0,0,1.45,0C217.71,46,218,46,218.36,46ZM96.74,24.78c.28-.93-1-2.05-2.48-2.25s-1.48.63-1.52,1.7c-.06,1.65,1.09,1.19,2,1.24C95.43,25.33,96.41,25.89,96.74,24.78Zm14.91.21c.39-.9-.42-1.39-.94-2s-1.14-.46-1.76-.47-1.34.08-1.23,1c.09.69-.46,1.67.75,1.93a7.89,7.89,0,0,0,1.46,0C110.55,25.44,111.35,25.69,111.65,25Zm55.83,20.06c0-.59.39-1.46-.32-1.74a3,3,0,0,0-2.24,0c-.6.32-1.43.8-1.41,1.77,0,1.32,1.06.85,1.93,1C166,45.6,167.41,46.74,167.48,45.05ZM148.56,24.72c.19-1-.67-1.37-1.22-1.89a2.3,2.3,0,0,0-2.28-.2c-.72.19-.44,1.06-.48,1.67-.09,1.67,1.19,1.06,2.06,1.18C147.3,25.32,148.32,25.93,148.56,24.72Zm14.91.27c.39-.9-.42-1.39-.94-2s-1.14-.46-1.76-.47-1.34.08-1.23,1c.09.69-.46,1.67.74,1.93a7.91,7.91,0,0,0,1.46,0C162.36,25.44,163.16,25.69,163.47,25ZM115.72,44.36c-.09-1-.47-1.39-1.46-1.29-1.49.16-2.73,1.16-2.55,2.19.22,1.22,1.26.6,1.77.73C114.91,46.15,115.88,46.08,115.72,44.36Zm84.66-19.6c.25-1-1-2.06-2.5-2.23-1-.1-1.43.15-1.52,1.24-.13,1.63.67,1.9,2.4,1.63C199.08,25.33,200.08,25.91,200.38,24.76Zm14.94,0c.23-1-1-2.05-2.51-2.22-1-.1-1.41.17-1.5,1.25-.14,1.65.71,1.88,2.33,1.64C214,25.33,215.05,25.92,215.32,24.75ZM63.89,44.33c0-1.1-.52-1.36-1.48-1.25-1.49.16-2.75,1.22-2.52,2.21.28,1.17,1.29.58,1.93.72C63.81,46,63.91,45.87,63.89,44.33Zm188.3-19.57c.25-1-1-2.06-2.5-2.23-1-.1-1.42.15-1.51,1.24-.13,1.63.67,1.9,2.4,1.63C250.9,25.33,251.9,25.91,252.19,24.76Zm14.95,0c.25-1-1-2.06-2.5-2.23-1-.1-1.43.15-1.51,1.24-.13,1.63.67,1.9,2.39,1.63C265.85,25.33,266.84,25.91,267.14,24.76Zm-255,19.56c-.09-1.08-.53-1.35-1.5-1.24-1.49.16-2.74,1.22-2.51,2.21.27,1.17,1.28.58,1.68.67C11.38,46.2,12.23,46,12.09,44.32ZM304,24.73c.2-1.14-.82-1.76-1.58-2.11-.56-.26-1.7-.51-2.21.3a2.77,2.77,0,0,0-.15,1.83c.24,1.17,1.28.58,2,.74C302.74,25.32,303.79,25.93,304,24.73Zm15,0c.27-.94-1-2.07-2.49-2.23-.94-.11-1.44.11-1.53,1.22-.12,1.6.64,1.93,2.5,1.62C317.65,25.33,318.64,25.9,319,24.77ZM227,44.82a2.54,2.54,0,0,0-.78-3.35c-.37-.27-.39-.29-.74-.06a2.73,2.73,0,0,0-.92,3.36c.26.56.56,1.1.85,1.65A10.44,10.44,0,0,0,227,44.82ZM174,46c.56-.73,1.63-1.09,1.52-2.32-.09-1-1.16-2.73-1.67-2.36-.74.55-1.69,1.14-1.34,2.36C172.25,44.92,173.43,45.27,174,46ZM285.79,20.57c.95.27,2.09-1,2.3-2.43s-.65-1.46-1.74-1.5c-1.68-.06-1.21,1.07-1.26,2C285.23,19.28,284.66,20.25,285.79,20.57ZM280,18.22c-.55-.52-1-1.25-1.68-1.5-.83-.31-2.41,1.18-2.19,2a2.55,2.55,0,0,0,2,1.86C279.72,20.55,278.72,18.49,280,18.22Zm-46.71-.07c0,.82-.69,2,.72,2.41,1,.27,2.07-1,2.23-2.47.11-1-.17-1.55-1.24-1.42C233.52,16.57,233.25,16.73,233.31,18.15Zm-9,.48c0,1,.89,1.62,1.83,1.93.48.16,2.23-2.14,1.89-2.56-.46-.59-.9-1.41-1.92-1.34C225.26,17.06,224.36,17.6,224.35,18.63Zm-42.87.24c0,.69-.35,1.85,1,1.67s2.06-1.22,2-2.68c0-1.14-.64-1.3-1.51-1.19C180.89,16.41,181.51,17.9,181.48,18.87Zm-5.07-.79c-.66-.43-.91-1.42-1.89-1.4s-2.39,1.56-2,2.25.94,1.73,2.2,1.65C175.91,20.18,175.38,18.61,176.41,18.08Zm-54.19,23.1c-.68.62-1.61,1-1.57,2.19,0,.93,1.18,2.8,1.6,2.49.73-.55,1.68-1.13,1.41-2.33C123.88,42.33,122.81,41.9,122.22,41.18Zm-52,.13a2.65,2.65,0,0,0-1.44,2.34c0,1.22,1,1.6,1.53,2.34.61-.69,1.7-1.06,1.52-2.26C71.89,42.69,70.72,41,70.23,41.31Zm-51.7-.19c-.56.74-1.63,1.1-1.52,2.33.09,1,1.16,2.72,1.66,2.35.75-.55,1.7-1.14,1.35-2.35C20.26,42.22,19.07,41.87,18.53,41.12Zm264,0c.92.39,1.42-.4,2-.91s.48-1.11.49-1.73-.07-1.32-1-1.21c-.71.08-1.71-.45-2,.72a6.29,6.29,0,0,0,0,1.44C282.13,40,281.87,40.77,282.58,41.07Zm-51.57,0c1,.25,2.09-1,2.26-2.45.11-.94-.14-1.4-1.25-1.49-1.66-.13-1.94.66-1.67,2.36C230.43,39.84,229.84,40.82,231,41.11Zm-52,0c.91.38,1.41-.41,2-.93s.47-1.11.48-1.72-.08-1.32-1-1.21c-.71.09-1.71-.45-2,.73a6.82,6.82,0,0,0,0,1.43C178.49,40,178.25,40.78,179,41.08Zm-51.58,0c1,.23,2.09-1,2.26-2.47.11-.94-.17-1.38-1.27-1.47-1.69-.13-1.91.7-1.67,2.29C126.79,39.85,126.2,40.84,127.38,41.11Zm-51.83,0c1,.25,2.1-1,2.27-2.45.11-.94-.14-1.4-1.26-1.49-1.66-.13-1.93.66-1.66,2.36C75,39.84,74.39,40.82,75.55,41.11Zm-52.06,0c.91.4,1.41-.38,2-.89s.49-1.11.49-1.72,0-1.34-1-1.23c-.72.08-1.71-.44-2,.71a6.19,6.19,0,0,0,0,1.43C23.05,40,22.78,40.75,23.49,41.06ZM51,9c.32.88.93,1.79,2,1.74,1.45-.07.63-2,1.88-2.39L53.43,6.9C52.12,6.86,50.66,8.24,51,9Zm55.71-.73c-.66-.43-.92-1.42-1.89-1.41s-2.39,1.57-2,2.25,1,1.74,2.2,1.66C106.16,10.4,105.62,8.82,106.66,8.3Zm23,10.57c0,.69-.35,1.85,1,1.67s2-1.22,2-2.68c0-1.14-.63-1.3-1.5-1.19C129.07,16.41,129.7,17.9,129.66,18.87Zm-9-.05c.33.88.93,1.78,2,1.73,1.45-.07.63-2.05,1.88-2.38l-1.44-1.49C121.88,16.64,120.41,18,120.7,18.82ZM47.47,29.36c-.86.07-1.53,0-1.56,1.19a2.33,2.33,0,0,0,2,2.71c1.3.2.91-.95,1-1.62C48.77,30.66,49.51,29.2,47.47,29.36ZM77.83,18.17c.18.82-.68,2,.76,2.39,1,.24,2.07-1,2.22-2.49.1-1-.21-1.53-1.28-1.4C78.34,16.52,77.53,16.81,77.83,18.17Zm-7-1.5c-1,0-2.36,1.62-2,2.3s1,1.82,2.19,1.57.71-1.9,1.71-2.5C72.06,17.66,71.86,16.61,70.84,16.67Zm29.9,13.68c0-1.31-1-.88-1.76-1-1.14-.12-1.2.56-1.27,1.46a2.1,2.1,0,0,0,1.07,2,2.06,2.06,0,0,0,1.25.45.8.8,0,0,0,.72-1,6.14,6.14,0,0,1,0-1ZM26.48,20.52c.91.4,1.41-.38,2-.89S29,18.52,29,17.9s0-1.33-1-1.22c-.72.08-1.71-.44-2,.71a6.19,6.19,0,0,0,0,1.43C26,19.43,25.77,20.21,26.48,20.52ZM19,16.67c-1,0-2.37,1.62-2,2.3s1.05,1.82,2.2,1.57S20,18.64,21,18C20.24,17.66,20,16.61,19,16.67ZM150.87,29.35c-1.07.09-1.41.46-1.31,1.44.16,1.45,1.18,2.67,2.22,2.49,1.25-.2.62-1.23.75-1.73C152.69,30.14,152.62,29.19,150.87,29.35ZM305.05,15.61c-.19.85,1.42,2.32,2.23,2,.64-.26,1.08-1,1.61-1.53-1.35-.21-.2-2.41-1.94-2.34A2.56,2.56,0,0,0,305.05,15.61ZM203.34,29.41c-.59,0-1.48-.4-1.75.33a2.91,2.91,0,0,0,0,2.21,2,2,0,0,0,1.81,1.35c1.33-.08.82-1.08.95-1.74C204.14,30.77,205,29.47,203.34,29.41Zm49.9-14c-.36.71,1.1,2.23,2,2.21s1.22-1,1.88-1.43c-1.11-.47-.56-2.1-1.76-2.48C254.18,13.72,253.65,14.62,253.24,15.43Zm-49.9-1.59c-.91-.29-1.68.8-1.92,1.74s1.34,2.31,2.19,2a6.87,6.87,0,0,0,1.76-1.37C204.64,15.31,204.15,14.11,203.34,13.84Zm51.12,15.51c-1.11.08-1.37.53-1.26,1.48.17,1.46,1.25,2.69,2.26,2.46,1.18-.28.58-1.27.66-1.62C256.39,30,256.13,29.22,254.46,29.35ZM151.64,13.77c-1.11-.07-1.72.85-2,1.73s1.23,2.35,2.11,2.09a7.08,7.08,0,0,0,1.93-1.41C152.29,15.8,153.06,13.85,151.64,13.77Zm-51.7,0c-1.13-.2-1.72.81-2.15,1.61s1,2.24,2,2.26,1.21-1,1.93-1.39C100.63,15.72,101.22,14,99.94,13.77ZM308,30.35c0-1.31-1-.88-1.75-1-1.14-.12-1.18.55-1.29,1.45-.14,1.23.72,1.79,1.44,2.28s1.57.34,1.6-.85V30.35ZM48.2,13.77c-1.15-.3-1.72.8-2.23,1.54s1,2.26,1.91,2.33,1.24-.94,2-1.34C48.94,15.64,49.38,14.09,48.2,13.77ZM156.93,6.93c-.74-.37-2.43,1-2.37,1.87a2.19,2.19,0,0,0,1.82,2c1.82.39.57-2.06,2-2.21A2.31,2.31,0,0,0,156.93,6.93Zm51.82,0c-.75-.37-2.43,1-2.37,1.87a2.18,2.18,0,0,0,1.82,2c1.82.39.57-2.06,2-2.21A2.31,2.31,0,0,0,208.75,6.93ZM258.2,8.84a2.4,2.4,0,0,0,1.86,1.94c.48.16,2.23-2.14,1.89-2.57-.46-.58-.9-1.4-1.73-1.34S258.12,8.23,258.2,8.84Zm-141,1.94c-.88,0-1.44.06-1.57,1.18-.15,1.37.78,1.95,1.52,2.73.77-.74,1.85-1.32,1.49-2.75C118.83,10.87,118.14,10.77,117.21,10.78Zm-50.33,1c-.08-1.25-.95-1-1.69-1-1.61-.16-1.32,1-1.32,1.85,0,1.06.86,1.48,1.48,1.89A2.54,2.54,0,0,0,66.88,11.82ZM32,37c.05.65.06,1.37,1,1.2A2.19,2.19,0,0,0,35,36a3.54,3.54,0,0,0-.18-1.34c-.07-.19-.52-.24-.82-.37A2.42,2.42,0,0,0,32,37ZM15.08,12c-.1-1.07-.53-1.28-1.49-1.25S12.13,10.81,12,12c-.15,1.35.76,2,1.51,2.73C14.31,14,15.22,13.39,15.08,12ZM86,34.3a2.09,2.09,0,0,0-2.2,2c-.09.65-.49,1.69.71,1.9s1.62-.85,2.2-1.52c.24-.28,0-.92,0-1.41A.74.74,0,0,0,86,34.3ZM24.74,22.54c-.71.08-1.6-.32-1.76,1s.4,2.51,1.38,2.66,1.75-1,1.64-2.25C26.15,23,25.84,22.43,24.74,22.54ZM138.08,34.33a1.66,1.66,0,0,0-1.28.28,2.47,2.47,0,0,0-1,3.23.9.9,0,0,0,.79.33c1.43-.32,2.11-1.22,2-3C138.51,35.05,138.4,34.46,138.08,34.33ZM169,10.78c-.88,0-1.45.06-1.57,1.18-.16,1.37.78,1.95,1.52,2.73.77-.74,1.84-1.32,1.49-2.75C170.65,10.87,170,10.77,169,10.78Zm18.41,26c-.07.62-.14,1.33.75,1.43,1.16.13,1.7-.83,2.18-1.55.29-.44.11-1.24,0-1.86,0-.2-.48-.33-.73-.49C188.58,34.2,187.6,35.28,187.44,36.75ZM219.28,12c-.14,1.36.8,2.53,1.56,2.49s1.67-1.22,1.51-2.57c-.12-1.13-.7-1.23-1.6-1.14C219.8,10.66,219.39,11,219.28,12Zm20,24.94c0,.65.06,1.37,1,1.2a2.19,2.19,0,0,0,2-2.2,3.54,3.54,0,0,0-.18-1.34c-.08-.19-.52-.24-.82-.37A2.42,2.42,0,0,0,239.24,37ZM274.17,12c-.1-1.07-.54-1.28-1.5-1.25s-1.45,0-1.58,1.17c-.15,1.35.76,2,1.51,2.73C273.4,14,274.3,13.39,274.17,12ZM294,36.24c.12-.66.48-1.69-.66-1.94s-1.7.8-2.23,1.49c-.31.4-.11,1.23,0,1.85,0,.21.44.37.68.56A2.16,2.16,0,0,0,294,36.24ZM76.3,22.52c-1,0-1.41.16-1.52,1.24-.13,1.36.78,1.94,1.56,2.67.74-.78,1.83-1.38,1.48-2.7C77.91,22.56,77.17,22.54,76.3,22.52Zm51.81,0c-1,0-1.4.16-1.51,1.24-.13,1.36.77,1.94,1.56,2.67.74-.78,1.83-1.38,1.48-2.7C129.73,22.56,129,22.54,128.11,22.52ZM314,32.29c1.07,0,1.64-.87,2-1.71s-1.09-2.16-2-2.16c-1.31,0-.83,1-1,1.69C313.24,30.89,312.36,32.22,314,32.29Zm-15.42-3.88c-.72.78-1.7,1.34-1.54,2.72.13,1.1.63,1.21,1.54,1.21s1.6-.09,1.47-1.46C300.61,29.65,299.16,29.25,298.54,28.41ZM180,22.52c-.88,0-1.45.06-1.57,1.18-.15,1.36.78,1.95,1.52,2.73.77-.74,1.84-1.32,1.49-2.75C181.61,22.61,180.92,22.51,180,22.52Zm53.31,1c-.26-1.58-1.44-1-2.21-1-1.24.06-.78,1.15-.79,1.83,0,1,.82,1.47,1.6,1.91C232.8,25.58,233.52,24.85,233.3,23.53ZM261.19,29c-.42,1.21.07,3.27.74,3.33,1.17.1,1.67-.85,2.19-1.55s-.83-2.12-1.74-2.35A1,1,0,0,0,261.19,29Zm23.93-5.46c-.26-1.58-1.44-1-2.22-1-1.23.06-.77,1.15-.78,1.83,0,1,.82,1.47,1.59,1.91C284.61,25.58,285.33,24.85,285.12,23.53ZM33.94,23.48c-1.36-.17-2.57.48-2.69,1.4s1,1.67,2.33,1.6c1,0,1.52-.27,1.42-1.05C34.92,24.43,35.2,23.63,33.94,23.48Zm52.11,0c-.91-.23-3.48.95-3.19,1.43a3.06,3.06,0,0,0,1.76,1.42c.72.14,2,.64,2.2-1.07C87,24.46,86.7,23.68,86.05,23.52ZM138.62,25c0-.86-.05-1.41-1.2-1.54-1.39-.15-2,.77-2.78,1.49.75.76,1.35,1.82,2.8,1.47C138.53,26.6,138.64,25.92,138.62,25ZM245.18,31.1c.14,1.07.57,1.27,1.52,1.24s1.44-.06,1.56-1.18c.16-1.37-.78-1.95-1.56-2.78C246.07,29.22,245,29.7,245.18,31.1Zm32.27,10.33c-1,.17-1.53,1.4-1.36,2.67s1.08.86,1.79.93c1.12.12,1.36-.52,1.22-1.39C279.21,42.35,278.45,41.25,277.45,41.43Zm-67.39-9.11c.76.18,2.28-1.11,2.28-1.94s-1.46-2.15-2.25-2c-1.18.27-.59,1.25-.74,1.88C209.36,31.86,209.47,32.18,210.06,32.32ZM43,38.2c-.26-1.57-1.44-1-2.21-.94-1.24.05-.78,1.14-.79,1.82,0,1,.82,1.48,1.6,1.92C42.47,40.25,43.19,39.53,43,38.2Zm152-9.6c-.76,0-1.7,1.13-1.56,2.49.1,1.07.54,1.28,1.49,1.25s1.63,0,1.54-1.2A2.05,2.05,0,0,0,194.93,28.6ZM94.78,38.18c-.26-1.57-1.45-1-2.22-.92-1.23.06-.77,1.15-.77,1.84,0,1,.81,1.47,1.6,1.89C94.31,40.25,95,39.5,94.78,38.18ZM158,32.25c.89.4,1.42-.33,2-.86s.8-1.12.36-1.61-.83-1.43-1.81-1.36c-.29,0-.75.14-.8.31a9.81,9.81,0,0,0-.24,1.56C157.59,31.15,157.29,31.92,158,32.25Zm-12.95,4.94c-1,0-1.4.16-1.51,1.24-.13,1.36.77,1.94,1.56,2.67.74-.78,1.83-1.37,1.48-2.7C146.67,37.23,145.93,37.21,145.05,37.19Zm-1.87-8.61c-.53-.37-1.72,1.76-1.6,2.85.15,1.26,1.11.81,1.82.88,1.15.12,1.28-.61,1.1-2.09A6,6,0,0,0,143.18,28.58Zm52.18,9.65c-.16,1.32.49,2.51,1.43,2.63s1.7-1,1.64-2.28c-.05-1-.28-1.5-1.37-1.38C196.35,37.29,195.52,37,195.36,38.23Zm-89.48-9.46a28.63,28.63,0,0,0,0,3.21c0,.13.52.33.79.32.93,0,2.29-1.48,2-2.18a2.53,2.53,0,0,0-2-1.72C106.39,28.53,105.89,28.64,105.88,28.77Zm144.36,9.41c-.26-1.57-1.46-1-2.23-.92-1.23.06-.76,1.15-.76,1.84,0,1,.8,1.47,1.59,1.89A2.82,2.82,0,0,0,250.24,38.18ZM92.8,31.1c.17-1.36-.76-1.94-1.55-2.67-.74.78-1.68,1.36-1.52,2.73.13,1.11.68,1.25,1.69,1.13C92.33,32.54,92.68,32.13,92.8,31.1ZM190.44,25c0-.89-.11-1.39-1.23-1.51-1.4-.16-2,.8-2.77,1.51.79.72,1.38,1.82,2.76,1.47C190.35,26.55,190.44,25.88,190.44,25ZM54.91,32.29c1.06,0,1.65-.88,2-1.75s-1.17-2.16-2-2.12c-1.29,0-.78,1.08-.92,1.73C54.13,30.94,53.31,32.27,54.91,32.29ZM241,23.47c-1.38-.13-2.57.79-2.53,1.53s1.24,1.64,2.62,1.49c1.15-.12,1.25-.69,1.16-1.57C242.38,24,242.06,23.58,241,23.47ZM39.58,28.68c-.92-.13-1.67,1-1.65,2.24,0,1,.24,1.5,1.32,1.4.73-.07,1.69.25,1.72-1.07A2,2,0,0,0,39.58,28.68ZM294.08,25c0-.86-.06-1.41-1.21-1.54-1.39-.15-2,.77-2.78,1.49.76.76,1.35,1.82,2.8,1.47C294,26.6,294.09,25.92,294.08,25ZM2.82,32.31c.79.19,2.26-1.12,2.26-2S3.54,28.2,2.79,28.41c-1.13.33-.57,1.28-.72,2C2.23,31.06,1.64,32,2.82,32.31Zm298,4.89c-1.06,0-2,0-1.76,1.46.09.6-.12,1.31.74,1.47s2.15-1,2.3-2.2C302.05,37.3,301.46,37.23,300.78,37.2ZM176.5,48.2c0,.88.81.69,1.44.77,1.41.18,1.62-.57,1.53-1.68-.05-.64,0-1.29-1-1.28C177.35,46.3,176.45,46.9,176.5,48.2ZM24,47.5c-.09-.6.12-1.31-.74-1.47S21.12,47,21,48s.59,1,1.45,1S24.24,49,24,47.5Zm48.83.7c0,.88.82.69,1.44.77,1.42.18,1.62-.57,1.54-1.68-.06-.64,0-1.29-1-1.28C73.71,46.3,72.82,46.9,72.86,48.2Zm238-12.3a.33.33,0,0,0,0-.32,3.91,3.91,0,0,0-1-1c-1-.48-1.08.72-1.64,1.07-.18.11,0,.81,0,1.23,0,.11.21.19.47.42C308.82,35.94,310.19,36.55,310.83,35.9ZM304,7.89c-.06.79.66,1,1,1.45.69.86.95-.1,1.33-.37.56-.41.95-1-.16-1.07A2.35,2.35,0,0,1,304.66,7C304.09,7.06,304,7.42,304,7.89Z"
  }));
};

const componentConfigThemeKey$d = 'threeVC';

const createStyle$a = themeProps => {
  const {
    largeVerticalGap,
    mediumVerticalGap,
    smallHorizontalGap,
    baseUnit
  } = themeProps;
  return StyleSheet.create({
    wrapper: {
      [MEDIA_BREAKPOINTS.large]: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gridTemplateRows: 'auto',
        gridColumnGap: `${largeVerticalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gridTemplateRows: 'auto',
        gridColumnGap: `${mediumVerticalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'grid',
        gridTemplateColumns: 'auto',
        gridTemplateRows: 'min-content',
        gridRowGap: `${smallHorizontalGap * baseUnit}px`
      }
    }
  });
};

const imagesWidths$1 = createImageWidths(360, 360, 360);
const ThreeVC = props => {
  const {
    cards,
    paddingFactors
  } = props;
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const themeProps = useTheme(componentConfigThemeKey$d);
  const {
    titleFontSizeLarge,
    titleFontSizeMedium,
    titleFontSizeSmall,
    innerHorizontalGapLarge,
    innerHorizontalGapMedium,
    innerHorizontalGapSmall,
    innerVerticalGapLarge,
    innerVerticalGapMedium,
    innerVerticalGapSmall,
    metadataFontSizeLarge,
    metadataFontSizeMedium,
    metadataFontSizeSmall
  } = themeProps;
  const style = createStyle$a(themeProps);
  const themeContextVC = useThemeOverride({
    titleFontSizeLarge,
    titleFontSizeMedium,
    titleFontSizeSmall,
    metadataFontSizeLarge,
    metadataFontSizeMedium,
    metadataFontSizeSmall,
    verticalGapLarge: innerVerticalGapLarge,
    verticalGapMedium: innerVerticalGapMedium,
    verticalGapSmall: innerVerticalGapSmall,
    horizontalGapLarge: innerHorizontalGapLarge,
    horizontalGapMedium: innerHorizontalGapMedium,
    horizontalGapSmall: innerHorizontalGapSmall
  }, componentConfigThemeKey$M);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle, style.wrapper)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextVC
  }, /*#__PURE__*/React.createElement(VerticalCard, _extends$1({}, cards[0], {
    imageWidths: imagesWidths$1
  })), /*#__PURE__*/React.createElement(VerticalCard, _extends$1({}, cards[1], {
    imageWidths: imagesWidths$1
  })), /*#__PURE__*/React.createElement(VerticalCard, _extends$1({}, cards[2], {
    imageWidths: imagesWidths$1
  })))));
};

const componentConfigThemeKey$c = 'threeHC';

const createStyle$9 = themeProps => {
  const {
    largeHorizontalGap,
    mediumHorizontalGap,
    smallHorizontalGap
  } = themeProps;
  return StyleSheet.create({
    wrapper: {
      display: 'grid',
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'auto',
        gridRowGap: `${largeHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateColumns: '1fr',
        gridTemplateRows: '1fr 1fr 1fr',
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'auto',
        gridRowGap: `${smallHorizontalGap * baseUnit}px`
      }
    }
  });
};

const imageWidths$5 = createImageWidths(180, 360, 540);
const ThreeHC = props => {
  const {
    cards,
    paddingFactors
  } = props;
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const themeProps = useTheme(componentConfigThemeKey$c);
  const {
    descriptionFontSizeLarge,
    descriptionFontSizeMedium,
    descriptionFontSizeSmall
  } = themeProps;
  const style = createStyle$9(themeProps);
  const themeContextVC = useThemeOverride({
    descriptionFontSizeLarge,
    descriptionFontSizeMedium,
    descriptionFontSizeSmall,
    titleFontSizeLarge: 'large',
    titleFontSizeMedium: 'large',
    titleFontSizeSmall: 'large',
    metadataFontSizeLarge: 'big',
    metadataFontSizeMedium: 'big',
    metadataFontSizeSmall: 'big',
    cardProportionsLarge: {
      x: 2,
      y: 1
    },
    cardProportionsMedium: {
      x: 1,
      y: 1
    },
    shouldReverseImageAlignment: true,
    verticalGapLarge: 1,
    verticalGapMedium: 1,
    verticalGapSmall: 1,
    horizontalGapLarge: 0.75,
    horizontalGapMedium: 0.75,
    horizontalGapSmall: 0.75
  }, componentConfigThemeKey$K);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle, style.wrapper)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextVC
  }, /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({}, cards[0], {
    imageWidths: imageWidths$5
  })), /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({}, cards[1], {
    imageWidths: imageWidths$5
  })), /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({}, cards[2], {
    imageWidths: imageWidths$5
  })))));
};

const componentConfigThemeKey$b = 'oneHCThreeVC';

const createStyle$8 = themeProps => {
  const {
    largeHorizontalGap,
    mediumHorizontalGap,
    smallHorizontalGap,
    baseUnit
  } = themeProps;
  return StyleSheet.create({
    wrapper: {
      display: 'grid',
      [MEDIA_BREAKPOINTS.large]: {
        gridRowGap: `${largeHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridRowGap: `${smallHorizontalGap * baseUnit}px`
      }
    }
  });
};

const imageWidthsHC$2 = createImageWidths(360, 540, 720);
const OneHCThreeVC = props => {
  const {
    cards,
    paddingFactors
  } = props;
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const themeProps = useTheme(componentConfigThemeKey$b);
  const style = createStyle$8(themeProps);
  const [firstCard, ...rest] = cards;
  const themeContextHC = useThemeOverride({
    titleFontSizeLarge: 'large',
    titleFontSizeMedium: 'large',
    titleFontSizeSmall: 'large',
    metadataFontSizeLarge: 'big',
    metadataFontSizeMedium: 'big',
    metadataFontSizeSmall: 'big',
    shouldReverseImageAlignment: true,
    cardProportionsLarge: {
      x: 2,
      y: 1
    },
    cardProportionsMedium: {
      x: 2,
      y: 1
    },
    verticalGapLarge: 1,
    verticalGapMedium: 1,
    verticalGapSmall: 1,
    horizontalGapLarge: 0.75,
    horizontalGapMedium: 0.75,
    horizontalGapSmall: 0.75
  }, componentConfigThemeKey$K);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle, style.wrapper)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextHC
  }, /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({}, firstCard, {
    imageWidths: imageWidthsHC$2
  }))), /*#__PURE__*/React.createElement(ThreeVC, {
    cards: rest,
    paddingFactors: {
      large: 0,
      medium: 0,
      small: 0
    }
  })));
};

const imageWidths$4 = createImageWidths(540, 1080, 1080);
const FullWidthOTC = props => {
  const {
    cards
  } = props;
  const themeContext = useThemeOverride({
    titleFontSizeLarge: 'gigantic',
    titleFontSizeMedium: 'gigantic',
    titleFontSizeSmall: 'gigantic',
    metadataFontSizeLarge: 'big',
    metadataFontSizeMedium: 'big',
    metadataFontSizeSmall: 'big',
    titleAlignment: 'CENTER',
    metadataAlignment: 'CENTER',
    aspectRatioLarge: {
      x: 2,
      y: 1
    },
    aspectRatioMedium: {
      x: 2,
      y: 1
    },
    aspectRatioSmall: {
      x: 4,
      y: 3
    },
    verticalGapLarge: 1,
    verticalGapMedium: 1,
    verticalGapSmall: 1,
    horizontalGapLarge: 2,
    horizontalGapMedium: 0.75,
    horizontalGapSmall: 0.75
  }, componentConfigThemeKey$O);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContext
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, cards[0], {
    imageWidths: imageWidths$4,
    lazyLoad: true
  }))));
};

const AuthorsWithRoundImageClipMAsk = ({
  clipPathLarge,
  clipPathSmall
}) => /*#__PURE__*/React.createElement("svg", {
  width: "0",
  height: "0",
  style: {
    position: 'absolute'
  }
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: clipPathLarge
}, /*#__PURE__*/React.createElement("path", {
  d: "M34.5,0C25,0,16.4,3.7,10,9.6c5.8,6.9,9.2,15.8,9.2,25.4S15.8,53.5,10,60.4c6.4,6,15,9.6,24.5,9.6C54.1,70,70,54.3,70,35 S54.1,0,34.5,0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: clipPathSmall
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.6,0C17.8,0,11.6,2.6,7,6.9c4.2,4.9,6.6,11.3,6.6,18.1S11.2,38.2,7,43.1c4.6,4.3,10.8,6.9,17.6,6.9 C38.6,50,50,38.8,50,25S38.6,0,24.6,0z"
}))));

const getTextStyle$1 = textColor => StyleSheet.create({
  textWithColor: {
    color: textColor
  }
});

const getAuthors = (authors, style) => authors && authors.map((author, index) => {
  const prefix = index >= 1 ? ', ' : '';
  const authorText = `${prefix}${author.name}`;
  return typeof author.link === 'string' ? /*#__PURE__*/React.createElement(Link, {
    key: index,
    href: author.link
  }, /*#__PURE__*/React.createElement(Span, {
    styles: semanticCSS(style.textWithColor)
  }, authorText)) : /*#__PURE__*/React.createElement(Span, {
    key: index,
    styles: semanticCSS(style.textWithColor)
  }, authorText);
});

const AuthorsWithRoundImageList = props => {
  const {
    authors,
    by,
    textColor
  } = props;
  const textStyle = getTextStyle$1(textColor);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Span, {
    styles: semanticCSS(textStyle.textWithColor)
  }, `${by} `), getAuthors(authors, textStyle)));
};

const componentConfigurationKey$3 = 'authorsWithRoundImage';
const CLIP_PATH_SMALL = 'clipPathSmall';
const CLIP_PATH_LARGE = 'clipPathLarge';

const getImageAdditionalStyle = () => {
  return StyleSheet.create({
    style: {
      borderRadius: '100%',
      display: 'block',
      overflow: 'hidden',
      [MEDIA_BREAKPOINTS.large]: {
        width: '70px',
        ':not(:first-child)': {
          clipPath: `url(#${CLIP_PATH_LARGE})`,
          marginLeft: '-10px'
        }
      },
      [MEDIA_BREAKPOINTS.medium]: {
        width: '70px',
        ':not(:first-child)': {
          clipPath: `url(#${CLIP_PATH_LARGE})`,
          marginLeft: '-10px'
        }
      },
      [MEDIA_BREAKPOINTS.small]: {
        width: '50px',
        ':not(:first-child)': {
          clipPath: `url(#${CLIP_PATH_SMALL})`,
          marginLeft: '-8px'
        }
      }
    }
  });
};

const getImageStyle = () => StyleSheet.create({
  wrapper: {
    whiteSpace: 'nowrap',
    display: 'flex'
  },
  image: {
    borderRadius: '100%',
    display: 'block',
    overflow: 'hidden',
    [MEDIA_BREAKPOINTS.large]: {
      width: '70px',
      ':not(:first-child)': {
        clipPath: `url(#${CLIP_PATH_LARGE})`,
        marginLeft: '-10px'
      }
    },
    [MEDIA_BREAKPOINTS.medium]: {
      width: '70px',
      ':not(:first-child)': {
        clipPath: `url(#${CLIP_PATH_LARGE})`,
        marginLeft: '-10px'
      }
    },
    [MEDIA_BREAKPOINTS.small]: {
      width: '50px',
      ':not(:first-child)': {
        clipPath: `url(#${CLIP_PATH_SMALL})`,
        marginLeft: '-8px'
      }
    }
  }
});

const getTextStyle = (baseUnit, textColor, smallVerticalMarginFactor, mediumVerticalMarginFactor, largeVerticalMarginFactor, smallHorizontalMarginFactor, mediumHorizontalMarginFactor, largeHorizontalMarginFactor) => StyleSheet.create({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    [MEDIA_BREAKPOINTS.large]: {
      margin: `${baseUnit * largeVerticalMarginFactor}px ${baseUnit * largeHorizontalMarginFactor}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      margin: `${baseUnit * mediumVerticalMarginFactor}px ${baseUnit * mediumHorizontalMarginFactor}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      margin: `${baseUnit * smallVerticalMarginFactor}px ${baseUnit * smallHorizontalMarginFactor}px`
    }
  },
  text: {
    [MEDIA_BREAKPOINTS.large]: {
      marginLeft: `${baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      marginLeft: `${baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      marginLeft: `${baseUnit / 2}px`
    }
  },
  textWithColor: {
    color: textColor
  }
});

const getAuthorsImages = authors => {
  const imageWidths = createImageWidths(50, 50, 80);
  const additionalStyle = getImageAdditionalStyle();
  return authors && authors.filter(({
    image
  }) => typeof image === 'object').map((author, index) => {
    return author.image && /*#__PURE__*/React.createElement(Image, _extends$1({}, author.image, {
      imageWidths: imageWidths,
      key: index,
      additionalStyle: additionalStyle,
      aspectRatio: {
        x: 1,
        y: 1
      }
    }));
  });
};

const shouldDisplayAuthors = authors => {
  return authors && authors.length > 0;
};

const AuthorsWithRoundImage = props => {
  const {
    authors,
    by,
    updatedText,
    updatedAt,
    updatedAtISO,
    createdAt,
    createdAtISO,
    showUpdatedAt
  } = props;
  const {
    baseUnit,
    textColor,
    smallVerticalMarginFactor,
    mediumVerticalMarginFactor,
    largeVerticalMarginFactor,
    smallHorizontalMarginFactor,
    mediumHorizontalMarginFactor,
    largeHorizontalMarginFactor,
    showTimestamp,
    fontSizesStyles
  } = useTheme(componentConfigurationKey$3);
  const imageStyle = getImageStyle();
  const textStyle = getTextStyle(baseUnit, textColor, smallVerticalMarginFactor, mediumVerticalMarginFactor, largeVerticalMarginFactor, smallHorizontalMarginFactor, mediumHorizontalMarginFactor, largeHorizontalMarginFactor);
  const hasAuthors = shouldDisplayAuthors(authors);
  const fontSizes = {
    fontSizeLarge: consts.TYPOGRAPHY_SIZE.NORMAL,
    fontSizeMedium: consts.TYPOGRAPHY_SIZE.NORMAL,
    fontSizeSmall: consts.TYPOGRAPHY_SIZE.NORMAL
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AuthorsWithRoundImageClipMAsk, {
    clipPathLarge: CLIP_PATH_LARGE,
    clipPathSmall: CLIP_PATH_SMALL
  }), /*#__PURE__*/React.createElement("div", {
    className: css(textStyle.wrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(imageStyle.wrapper)
  }, getAuthorsImages(authors)), /*#__PURE__*/React.createElement("div", {
    className: css(textStyle.text)
  }, /*#__PURE__*/React.createElement("div", null, hasAuthors ? /*#__PURE__*/React.createElement(AuthorsWithRoundImageList, {
    by: by,
    authors: authors,
    textColor: textColor
  }) : null), showTimestamp ? /*#__PURE__*/React.createElement("time", {
    dateTime: createdAtISO,
    className: css(textStyle.textWithColor, getStyleBySize(fontSizesStyles, fontSizes))
  }, createdAt) : null, showTimestamp && showUpdatedAt ? /*#__PURE__*/React.createElement("time", {
    dateTime: updatedAtISO,
    className: css(textStyle.textWithColor, getStyleBySize(fontSizesStyles, fontSizes))
  }, ` | ${updatedText} ${updatedAt}`) : null)));
};

const componentConfigThemeKey$a = 'threeVCExpandable';

const createStyle$7 = themeProps => {
  const {
    largeVerticalGap,
    mediumVerticalGap,
    smallHorizontalGap,
    largeHorizontalGap,
    mediumHorizontalGap,
    baseUnit
  } = themeProps;
  return StyleSheet.create({
    wrapper: {
      [MEDIA_BREAKPOINTS.large]: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gridTemplateRows: 'auto',
        gridColumnGap: `${largeVerticalGap * baseUnit}px`,
        gridRowGap: `${largeHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: 'auto',
        gridColumnGap: `${mediumVerticalGap * baseUnit}px`,
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'grid',
        gridTemplateColumns: 'auto',
        gridTemplateRows: 'auto',
        gridRowGap: `${smallHorizontalGap * baseUnit}px`
      }
    }
  });
};

const imagesWidths = createImageWidths(360, 360, 360);
const ThreeVCExpandable = props => {
  const {
    cards,
    paddingFactors
  } = props;
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const themeProps = useTheme(componentConfigThemeKey$a);
  const style = createStyle$7(themeProps);
  const {
    innerCardLargeVerticalGap,
    innerCardMediumVerticalGap,
    innerCardSmallVerticalGap,
    innerCardLargeHorizontalGap,
    innerCardMediumHorizontalGap,
    innerCardSmallHorizontalGap,
    titleFontSizeLarge,
    titleFontSizeMedium,
    titleFontSizeSmall,
    metadataFontSizeLarge,
    metadataFontSizeMedium,
    metadataFontSizeSmall,
    descriptionFontSizeInLargeScreen,
    descriptionFontSizeInMediumScreen,
    descriptionFontSizeInSmallScreen
  } = themeProps;
  const themeContextVC = useThemeOverride({
    titleFontSizeLarge,
    titleFontSizeMedium,
    titleFontSizeSmall,
    metadataFontSizeLarge,
    metadataFontSizeMedium,
    metadataFontSizeSmall,
    descriptionFontSizeInLargeScreen,
    descriptionFontSizeInMediumScreen,
    descriptionFontSizeInSmallScreen,
    verticalGapLarge: innerCardLargeVerticalGap,
    verticalGapMedium: innerCardMediumVerticalGap,
    verticalGapSmall: innerCardSmallVerticalGap,
    horizontalGapLarge: innerCardLargeHorizontalGap,
    horizontalGapMedium: innerCardMediumHorizontalGap,
    horizontalGapSmall: innerCardSmallHorizontalGap
  }, componentConfigThemeKey$M);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle, style.wrapper)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextVC
  }, cards.map((cardDataProps, index) => {
    return /*#__PURE__*/React.createElement(VerticalCard, _extends$1({}, cardDataProps, {
      imageWidths: imagesWidths,
      key: index
    }));
  }))));
};

const componentConfigThemeKey$9 = 'sectionOnTopTitle';

const createWrapperStyle = theme => StyleSheet.create({
  style: {
    display: 'flex',
    width: '100%',
    height: '100%',
    borderRadius: `${theme.borderRadius}px`,
    boxSizing: 'border-box',
    background: 'transparent',
    [MEDIA_BREAKPOINTS.large]: {
      padding: `${theme.wrapperGapLarge * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      padding: `${theme.wrapperGapMedium * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      padding: `${theme.wrapperGapSmall * baseUnit}px`
    }
  }
}).style;

const createInnerWrapperStyle = theme => StyleSheet.create({
  style: {
    width: '100%',
    height: '100%',
    position: 'relative',
    textDecoration: 'none',
    color: theme.titleColorTypeNormal,
    display: 'block',
    '-webkit-mask-image': '-webkit-radial-gradient(white, black)',
    borderRadius: `${theme.borderRadius}px`
  }
}).style;

const createAdditionalInnerWrapperForLinkStyle = theme => StyleSheet.create({
  style: {
    ':hover': {
      color: theme.titleColorTypeHover
    },
    ':active': {
      color: theme.titleColorTypeActive
    }
  }
}).style;

const SectionOnTopTitleWrapper = props => {
  const {
    link,
    children,
    isSponsoredLink = false
  } = props;
  const theme = useTheme(componentConfigThemeKey$9);
  const {
    boxShadowTypeNormal,
    boxShadowTypeHover,
    boxShadowTypeActive,
    borderColorTypeActive,
    borderColorTypeHover,
    borderColorTypeNormal,
    borderWidthTypeActive,
    borderWidthTypeNormal,
    borderWidthTypeHover
  } = theme;
  const borderBoxShadowForLink = {
    borderColorTypeActive,
    borderColorTypeHover,
    borderColorTypeNormal,
    borderWidthTypeActive,
    borderWidthTypeHover,
    borderWidthTypeNormal
  };
  const boxShadowForLinkStyle = createStyleForBoxShadow({
    boxShadowTypeNormal,
    boxShadowTypeHover,
    boxShadowTypeActive,
    borderBoxShadow: borderBoxShadowForLink
  });
  const borderBoxShadowForNotLink = {
    borderColorTypeActive: borderColorTypeNormal,
    borderColorTypeHover: borderColorTypeNormal,
    borderColorTypeNormal,
    borderWidthTypeActive: borderWidthTypeNormal,
    borderWidthTypeHover: borderWidthTypeNormal,
    borderWidthTypeNormal
  };
  const boxShadowForNotLinkStyle = createStyleForBoxShadow({
    boxShadowTypeNormal,
    boxShadowTypeHover: boxShadowTypeNormal,
    boxShadowTypeActive: boxShadowTypeNormal,
    borderBoxShadow: borderBoxShadowForNotLink
  });
  const wrapperStyle = createWrapperStyle(theme);
  const innerWrapperStyle = createInnerWrapperStyle(theme);
  const additionalInnerWrapperForLinkStyle = createAdditionalInnerWrapperForLinkStyle(theme);
  const boxShadowStyle = link ? boxShadowForLinkStyle.style : boxShadowForNotLinkStyle.style;
  const relForSponsoredLink = isSponsoredLink ? {
    rel: 'nofollow sponsored'
  } : {};
  return /*#__PURE__*/React.createElement("div", {
    className: css(boxShadowStyle, wrapperStyle)
  }, link ? /*#__PURE__*/React.createElement(Link, _extends$1({
    className: css(innerWrapperStyle, additionalInnerWrapperForLinkStyle, boxShadowStyle),
    href: link
  }, relForSponsoredLink), children) : /*#__PURE__*/React.createElement("div", {
    className: css(innerWrapperStyle, boxShadowStyle)
  }, children));
};

const imageWidths$3 = createImageWidths(360, 1080, 1080);

const createContentWrapperStyle = theme => {
  const {
    horizontalGapLarge,
    verticalGapLarge,
    horizontalGapMedium,
    verticalGapMedium,
    horizontalGapSmall,
    verticalGapSmall
  } = theme;
  const actualHorizontalGapLarge = baseUnit * horizontalGapLarge;
  const actualVerticalGapLarge = baseUnit * verticalGapLarge;
  const actualHorizontalGapMedium = baseUnit * horizontalGapMedium;
  const actualVerticalGapMedium = baseUnit * verticalGapMedium;
  const actualHorizontalGapSmall = baseUnit * horizontalGapSmall;
  const actualVerticalGapSmall = baseUnit * verticalGapSmall;
  const largeWidthForCentering = `calc(100% - ${actualVerticalGapLarge * 2}px)`;
  const mediumWidthForCentering = `calc(100% - ${actualVerticalGapMedium * 2}px)`;
  const smallWidthForCentering = `calc(100% - ${actualVerticalGapSmall * 2}px)`;
  return StyleSheet.create({
    style: {
      overflow: 'hidden',
      display: 'grid',
      background: 'transparent',
      position: 'absolute',
      bottom: 0,
      justifyContent: 'center',
      textAlign: 'center',
      justifyItems: 'center',
      [MEDIA_BREAKPOINTS.large]: {
        width: largeWidthForCentering,
        margin: `${actualHorizontalGapLarge}px ${actualVerticalGapLarge}px`,
        gridRowGap: `${actualHorizontalGapLarge}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        width: mediumWidthForCentering,
        margin: `${actualHorizontalGapMedium}px ${actualVerticalGapMedium}px`,
        gridRowGap: `${actualHorizontalGapMedium}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        width: smallWidthForCentering,
        margin: `${actualHorizontalGapSmall}px ${actualVerticalGapSmall}px`,
        gridRowGap: `${actualHorizontalGapSmall}px`
      }
    }
  }).style;
};

const createLogoStyle = () => StyleSheet.create({
  style: {
    display: 'inline-flex',
    width: 'auto',
    [MEDIA_BREAKPOINTS.large]: {
      height: `${4 * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      height: `${3 * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      height: `${3 * baseUnit}px`
    }
  }
}).style;

const SectionOnTopTitle = props => {
  const {
    title,
    subtitle,
    logo,
    link,
    image,
    isSponsoredLink = false
  } = props;
  const theme = useTheme(componentConfigThemeKey$9);
  const {
    aspectRatioSmall,
    aspectRatioMedium,
    aspectRatioLarge,
    overlayColor,
    titleSemanticTag,
    titleFontSizeLarge,
    titleFontSizeMedium,
    titleFontSizeSmall,
    subtitleSemanticTag,
    subtitleFontSizeLarge,
    subtitleFontSizeMedium,
    subtitleFontSizeSmall
  } = theme;
  const contentWrapperStyle = createContentWrapperStyle(theme);
  const logoStyle = createLogoStyle();
  return /*#__PURE__*/React.createElement(SectionOnTopTitleWrapper, {
    link: link,
    isSponsoredLink: isSponsoredLink
  }, /*#__PURE__*/React.createElement(Image, _extends$1({}, image, {
    lazyLoad: false,
    imageAspectRatios: createImageAspectRatios(aspectRatioSmall, aspectRatioMedium, aspectRatioLarge),
    imageWidths: imageWidths$3
  })), /*#__PURE__*/React.createElement(CardOverlay, {
    overlayColor: overlayColor
  }), /*#__PURE__*/React.createElement("div", {
    className: css(contentWrapperStyle)
  }, logo ? /*#__PURE__*/React.createElement("img", {
    className: css(logoStyle),
    alt: logo.alt,
    src: `data:image/svg+xml,${encodeURIComponent(logo.src)}`
  }) : null, /*#__PURE__*/React.createElement(DynamicSemanticTag, {
    semanticTag: titleSemanticTag,
    fontSizeLarge: titleFontSizeLarge,
    fontSizeMedium: titleFontSizeMedium,
    fontSizeSmall: titleFontSizeSmall
  }, title), /*#__PURE__*/React.createElement(DynamicSemanticTag, {
    semanticTag: subtitleSemanticTag,
    fontSizeLarge: subtitleFontSizeLarge,
    fontSizeMedium: subtitleFontSizeMedium,
    fontSizeSmall: subtitleFontSizeSmall
  }, subtitle)));
};

const componentConfigThemeKey$8 = 'oneOTCThreeVC';

const createStyle$6 = themeProps => {
  const {
    largeHorizontalGap,
    mediumHorizontalGap,
    smallHorizontalGap,
    baseUnit
  } = themeProps;
  return StyleSheet.create({
    wrapper: {
      display: 'grid',
      [MEDIA_BREAKPOINTS.large]: {
        gridRowGap: `${largeHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridRowGap: `${smallHorizontalGap * baseUnit}px`
      }
    }
  });
};

const imageWidthsHC$1 = createImageWidths(360, 720, 720);
const OneOTCThreeVC = props => {
  const {
    cards,
    paddingFactors
  } = props;
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const themeProps = useTheme(componentConfigThemeKey$8);
  const style = createStyle$6(themeProps);
  const [firstCard, ...rest] = cards || [];
  const themeContextOTC = useThemeOverride({
    titleFontSizeLarge: 'gigantic',
    titleFontSizeMedium: 'bigger',
    titleFontSizeSmall: 'bigger',
    metadataFontSizeLarge: 'big',
    metadataFontSizeMedium: 'big',
    metadataFontSizeSmall: 'big',
    verticalGapLarge: 1,
    verticalGapMedium: 1,
    verticalGapSmall: 1,
    horizontalGapLarge: 2,
    horizontalGapMedium: 0.75,
    horizontalGapSmall: 0.75,
    aspectRatioSmall: {
      x: 4,
      y: 3
    },
    titleAlignment: 'CENTER',
    metadataAlignment: 'CENTER'
  }, componentConfigThemeKey$O);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle, style.wrapper)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextOTC
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, firstCard, {
    imageWidths: imageWidthsHC$1
  }))), /*#__PURE__*/React.createElement(ThreeVC, {
    cards: rest,
    paddingFactors: {
      large: 0,
      medium: 0,
      small: 0
    }
  })));
};

const TRANSITION_LENGTH = 500;

const getShareIconStyles = (fillColor, isOpen) => {
  return StyleSheet.create({
    base: {
      fill: fillColor,
      opacity: 1,
      width: '100%',
      transition: `${TRANSITION_LENGTH}ms`,
      ...(isOpen && {
        transform: 'translateY(-30px)',
        opacity: 0
      })
    }
  });
};

const getCloseIconStyles = (fillColor, baseUnit, isOpen) => {
  return StyleSheet.create({
    base: {
      position: 'absolute',
      width: '100%',
      height: 0
    },
    line: {
      position: 'absolute',
      bottom: 0,
      height: '1px',
      backgroundColor: fillColor,
      opacity: 0,
      transition: `${TRANSITION_LENGTH}ms`,
      width: '100%'
    },
    leftLine: {
      left: 0,
      transformOrigin: 'left bottom',
      ...(isOpen && {
        opacity: 1,
        transform: 'rotate(-45deg)',
        width: '130%'
      })
    },
    rightLine: {
      right: 0,
      transformOrigin: 'right bottom',
      ...(isOpen && {
        opacity: 1,
        transform: 'rotate(45deg)',
        width: '130%'
      })
    }
  });
};

const SquareShareButton = ({
  shareIconColor,
  additionalStyle,
  onClick,
  isOpen
}) => {
  const {
    baseUnit
  } = useTheme();
  const shareIconStyles = getShareIconStyles(shareIconColor, isOpen);
  const closeIconStyles = getCloseIconStyles(shareIconColor, baseUnit, isOpen);
  return /*#__PURE__*/React.createElement("div", {
    className: css(additionalStyle.style),
    onClick: onClick
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: css(shareIconStyles.base),
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 0L8.125 10.709 9.658 12.247 17.655 4.229 17.655 31.25 19.846 31.25 19.846 4.229 27.841 12.247 29.375 10.709 18.751 0z",
    transform: "translate(1.25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.357 20L35.357 37.778 2.143 37.778 2.143 20 0 20 0 40 37.5 40 37.5 20z",
    transform: "translate(1.25)"
  }))), /*#__PURE__*/React.createElement("div", {
    className: css(closeIconStyles.base)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(closeIconStyles.line, closeIconStyles.leftLine)
  }), /*#__PURE__*/React.createElement("div", {
    className: css(closeIconStyles.line, closeIconStyles.rightLine)
  })));
};

const componentConfigurationKey$2 = 'copyLinkButton';

const getStyles$8 = () => {
  return StyleSheet.create({
    button: {
      position: 'relative',
      overflow: 'hidden',
      [MEDIA_BREAKPOINTS.large]: {
        width: '30px',
        height: '30px'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        width: '30px',
        height: '30px'
      },
      [MEDIA_BREAKPOINTS.small]: {
        width: '20px',
        height: '20px'
      }
    },
    copyLinkIcon: {
      position: 'absolute',
      bottom: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      transition: '200ms ease-in-out',
      [MEDIA_BREAKPOINTS.large]: {
        width: '30px'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        width: '30px'
      },
      [MEDIA_BREAKPOINTS.small]: {
        width: '20px'
      }
    },
    copyLinkIconAction: {
      left: '-150%'
    },
    successIcon: {
      left: '150%'
    },
    successIconAction: {
      left: '50%'
    }
  });
};

const copyToClipboard = text => {
  const el = document.createElement('textarea');
  el.value = text;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.opacity = '0';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};

const CopyLinkButton = props => {
  const {
    canonical,
    buttonClass
  } = props;
  const {
    color
  } = useTheme(componentConfigurationKey$2);
  const styles = getStyles$8();
  let timeout;
  const [wasCopied, setWasCopied] = React.useState(false);

  const onClickCopy = () => {
    copyToClipboard(canonical);
    clearTimeout(timeout);
    setWasCopied(true);
    timeout = setTimeout(() => {
      setWasCopied(false);
    }, 1000);
  };

  const copyIconAction = wasCopied ? styles.copyLinkIconAction : styles.copyLinkIcon;
  const succcessIconAction = wasCopied ? styles.successIconAction : styles.successIcon;
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: css(styles.button, buttonClass),
    onClick: onClickCopy
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    className: css(styles.copyLinkIcon, copyIconAction),
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.906 30H0V5.625h5.625V0H30v24.375h-1.875v-.001h-4.219V30zM5.625 24.375V7.5h-3.75v20.624h20.156v-3.75H7.5v.001H5.625zm22.5-22.501H7.5v20.625h20.625V1.874z"
  })), /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    className: css(styles.copyLinkIcon, succcessIconAction)
  }, /*#__PURE__*/React.createElement("g", {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5,10.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1,56L1,32.9c-1.4-1.4-1.3-3.7,0.1-5.1c1.4-1.4,3.7-1.4,5,0.1l17,17.8L57.9,9.1c1.4-1.4,3.6-1.5,5-0.1 c1.4,1.4,1.4,3.7,0.1,5.1L23.1,56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4,43.4"
  })))));
};

const getAnimationDelayClass = index => {
  return StyleSheet.create({
    animationModifier: {
      animationDelay: `${index * 50}ms`
    }
  });
};

const socialButtonAnimation = {
  '0%': {
    opacity: 0
  },
  '100%': {
    opacity: 1
  }
};

const getStyles$7 = (baseUnit, paddingBottomForShareIconsWrapper) => {
  return StyleSheet.create({
    wrapper: {
      display: 'flex',
      flexDirection: 'column-reverse',
      position: 'absolute',
      alignItems: 'center',
      zIndex: 1000,
      [MEDIA_BREAKPOINTS.large]: {
        bottom: `${baseUnit * 3.5}px`,
        right: `${baseUnit}px`,
        width: '30px',
        paddingBottom: `${paddingBottomForShareIconsWrapper.large}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        bottom: `${baseUnit * 3.5}px`,
        right: `${baseUnit / 2}px`,
        width: '30px',
        paddingBottom: `${paddingBottomForShareIconsWrapper.medium}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        bottom: `${baseUnit * 2}px`,
        right: '5px',
        width: '20px',
        paddingBottom: `${paddingBottomForShareIconsWrapper.small}px`
      }
    },
    socialButton: {
      opacity: 0,
      animationName: [socialButtonAnimation],
      animationDuration: '500ms',
      animationFillMode: 'forwards',
      cursor: 'pointer',
      textAlign: 'center',
      [MEDIA_BREAKPOINTS.large]: {
        height: `${baseUnit * 1.5}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        height: `${baseUnit * 1.5}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        height: `${baseUnit}px`
      },
      ':not(:first-child):not(:last-child)': {
        [MEDIA_BREAKPOINTS.large]: {
          margin: `${baseUnit * 0.75}px 0`
        },
        [MEDIA_BREAKPOINTS.medium]: {
          margin: `${baseUnit * 0.75}px 0`
        },
        [MEDIA_BREAKPOINTS.small]: {
          margin: `${baseUnit * 0.5}px 0`
        }
      },
      ':first-child': {
        [MEDIA_BREAKPOINTS.large]: {
          margin: `${baseUnit * 0.75}px 0`
        },
        [MEDIA_BREAKPOINTS.medium]: {
          margin: `${baseUnit * 0.75}px 0`
        },
        [MEDIA_BREAKPOINTS.small]: {
          margin: `${baseUnit * 0.5}px 0`
        }
      },
      ':last-child': {
        [MEDIA_BREAKPOINTS.large]: {
          margin: `${baseUnit * 0.75}px 0`
        },
        [MEDIA_BREAKPOINTS.medium]: {
          margin: `${baseUnit * 0.75}px 0`
        },
        [MEDIA_BREAKPOINTS.small]: {
          margin: `${baseUnit * 0.5}px 0`
        }
      }
    }
  });
};

const getShareButtons = (buttons, styles) => buttons.map((button, index) => {
  const {
    shareURL,
    src,
    type
  } = button;
  const animationDurationClass = getAnimationDelayClass(index);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    React.createElement(Link, {
      className: css(styles.socialButton, animationDurationClass.animationModifier),
      key: index,
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: () => {
        window.open(shareURL, '_blank', 'noopener');
        return false;
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: src,
      alt: type,
      className: css(styles.socialIcon),
      height: "100%"
    }))
  );
});

const useToggleSocialMenu = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  const onToggle = () => {
    setIsOpen(prev => !prev);
  };

  return [onToggle, isOpen];
};

const ArticleOnTopTitleShareButton = ({
  shareConfig,
  shareIconColor,
  shareIconStyle,
  canonical,
  paddingBottomForShareIconsWrapper = {
    large: 0,
    medium: 0,
    small: 0
  }
}) => {
  const [onToggle, isOpen] = useToggleSocialMenu();
  const {
    baseUnit
  } = useTheme();
  const styles = getStyles$7(baseUnit, paddingBottomForShareIconsWrapper);
  const copyLinkAnimationClass = getAnimationDelayClass(shareConfig.length);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isOpen && /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapper)
  }, getShareButtons(shareConfig, styles), /*#__PURE__*/React.createElement(CopyLinkButton, {
    canonical: canonical,
    buttonClass: [styles.socialButton, copyLinkAnimationClass.animationModifier]
  })), /*#__PURE__*/React.createElement(SquareShareButton, {
    shareConfig: shareConfig,
    shareIconColor: shareIconColor,
    additionalStyle: shareIconStyle,
    onClick: onToggle,
    isOpen: isOpen
  }));
};

const createSponsorStyle = (baseUnit, textColor, sponsorBackgroundColor) => StyleSheet.create({
  logo: {
    [MEDIA_BREAKPOINTS.large]: {
      height: `${2 * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      height: `${2 * baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      height: `${baseUnit}px`
    }
  },
  text: {
    color: textColor
  },
  wrapper: {
    backgroundColor: sponsorBackgroundColor,
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    justifyItems: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    [MEDIA_BREAKPOINTS.large]: {
      height: `${4.25 * baseUnit}px`,
      columnGap: `${baseUnit * 0.5}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      height: `${4.25 * baseUnit}px`,
      columnGap: `${baseUnit * 0.5}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      height: `${2.25 * baseUnit}px`,
      columnGap: `${baseUnit * 0.25}px`
    }
  },
  link: {
    display: 'flex'
  }
});

const SponsorWithBackground = props => {
  const {
    text,
    logo,
    brandName,
    href
  } = props;
  const {
    sponsorWithBackgroundTextColor,
    sponsorBackgroundColor,
    baseUnit
  } = useTheme(componentConfigurationKey$o);
  const style = createSponsorStyle(baseUnit, sponsorWithBackgroundTextColor, sponsorBackgroundColor);
  return /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement("div", {
    className: css(style.wrapper)
  }, /*#__PURE__*/React__default.createElement(H5, {
    styles: semanticCSS(style.text)
  }, text), /*#__PURE__*/React__default.createElement(Link, {
    href: href,
    rel: "nofollow sponsored",
    className: css(style.link)
  }, logo ? /*#__PURE__*/React__default.createElement("img", {
    className: css(style.logo),
    alt: brandName,
    src: `data:image/svg+xml,${encodeURIComponent(logo)}`
  }) : null)));
};

const componentConfigurationKey$1 = 'articleOnTopTitle';

const getBlockStyle = () => {
  return StyleSheet.create({
    style: {
      position: 'absolute',
      top: '0',
      left: '0',
      width: '100%',
      margin: 0
    }
  });
};

const getMedia = (media, siteName, templateName) => {
  const additionalStyle = getBlockStyle();
  const {
    type
  } = media;

  switch (type) {
    case 'jw':
      {
        const {
          html,
          videoId
        } = media;
        return /*#__PURE__*/React.createElement(Jw, {
          html: html,
          additionalStyle: additionalStyle,
          videoId: videoId,
          siteName: siteName,
          templateName: templateName
        });
      }

    case 'youtube':
      {
        const {
          html
        } = media;
        return /*#__PURE__*/React.createElement(Iframe, {
          html: html,
          additionalStyle: additionalStyle
        });
      }

    case 'mmPlayer':
      {
        const {
          html
        } = media;
        return /*#__PURE__*/React.createElement(MMPlayer, {
          html: html,
          additionalStyle: additionalStyle
        });
      }

    default:
      return null;
  }
};

const imageWidths$2 = createImageWidths(540, 720, 1440);

const getStyles$6 = ({
  baseUnit,
  creditColor,
  titleColor,
  titleWithMediaColor
}) => {
  return StyleSheet.create({
    relativeElement: {
      position: 'relative'
    },
    creditWrapper: {
      position: 'absolute',
      textAlign: 'left',
      display: 'flex',
      alignItems: 'center',
      [MEDIA_BREAKPOINTS.large]: {
        bottom: `${baseUnit}px`,
        left: `${baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        bottom: `${baseUnit / 2}px`,
        left: `${baseUnit / 2}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        bottom: `${baseUnit / 4}px`,
        left: `${baseUnit / 4}px`
      }
    },
    credit: {
      color: creditColor,
      marginLeft: `${baseUnit / 2}px`
    },
    title: {
      color: titleColor,
      position: 'absolute',
      width: '100%',
      textAlign: 'center',
      boxSizing: 'border-box',
      [MEDIA_BREAKPOINTS.large]: {
        padding: `0 ${baseUnit * 2}px`,
        bottom: `${baseUnit * 4}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        padding: `0 ${baseUnit * 2}px`,
        bottom: `${baseUnit * 4}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        padding: `0 ${baseUnit}px`,
        bottom: `${baseUnit * 2.5}px`
      }
    },
    titleWithMedia: {
      color: titleWithMediaColor,
      textAlign: 'center',
      [MEDIA_BREAKPOINTS.large]: {
        margin: `${baseUnit * 2}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        margin: `${baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        margin: `${baseUnit}px`
      }
    },
    wrapperOfSponsorForMMMediaCover: {
      marginTop: '16px'
    }
  });
};

const getShareIconStyle = baseUnit => {
  return StyleSheet.create({
    style: {
      cursor: 'pointer',
      position: 'absolute',
      [MEDIA_BREAKPOINTS.large]: {
        bottom: `${baseUnit}px`,
        right: `${baseUnit}px`,
        height: '30px',
        maxWidth: '30px'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        bottom: `${baseUnit / 2}px`,
        right: `${baseUnit / 2}px`,
        height: '30px',
        maxWidth: '30px'
      },
      [MEDIA_BREAKPOINTS.small]: {
        bottom: '9px',
        right: `${baseUnit / 4}px`,
        height: '20px',
        maxWidth: '20px'
      }
    }
  });
};

const ArticleOnTopTitle = props => {
  const {
    image,
    title,
    shareConfig,
    canonical,
    media,
    siteName,
    templateName,
    sponsor
  } = props;
  const themeProps = useTheme(componentConfigurationKey$1);
  const {
    creditColor,
    fontSizesStyles
  } = themeProps;
  const {
    creditFontSizeLarge,
    creditFontSizeSmall,
    titleFontSizeLarge,
    titleFontSizeSmall,
    baseUnit,
    shareIconColor,
    shareIconColorForMediaCover,
    overlayColor,
    numberOfLinesForTitle
  } = themeProps;
  const hasCredit = typeof image.credit === 'string';
  const creditHTML = useTransformCreditHTML(image.credit);
  const styles = getStyles$6(themeProps);
  const shareIconStyle = getShareIconStyle(baseUnit);
  const {
    style
  } = StyleSheet.create(ellipsify(numberOfLinesForTitle));
  const creditFontsStyleBySize = getStyleBySize(fontSizesStyles, {
    fontSizeSmall: creditFontSizeSmall,
    fontSizeMedium: creditFontSizeLarge,
    fontSizeLarge: creditFontSizeLarge
  });
  const aspectRatios = {
    large: {
      x: 16,
      y: 9
    },
    medium: {
      x: 16,
      y: 9
    },
    small: media ? {
      x: 16,
      y: 9
    } : {
      x: 4,
      y: 3
    }
  };

  const getPaddingBottomForShareIconsWrapperWithMediaCover = () => {
    const addingBottomForShareIconsWrapperWithMediaCover = {
      large: 60,
      medium: 0,
      small: 45
    };

    const addSponsorPadding = basePadding => ({
      large: basePadding.large + 4.25 * baseUnit,
      medium: basePadding.medium + 4.25 * baseUnit,
      small: basePadding.small + 2.25 * baseUnit
    });

    return sponsor ? addSponsorPadding(addingBottomForShareIconsWrapperWithMediaCover) : addingBottomForShareIconsWrapperWithMediaCover;
  };

  return media ? /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement("div", {
    className: css(styles.relativeElement)
  }, /*#__PURE__*/React.createElement(Image, _extends$1({}, image, {
    imageWidths: imageWidths$2,
    imageAspectRatios: aspectRatios
  })), getMedia(media, siteName, templateName)), /*#__PURE__*/React.createElement("div", media.type === 'mmPlayer' ? {
    className: css(styles.wrapperOfSponsorForMMMediaCover)
  } : {}, sponsor ? /*#__PURE__*/React.createElement(SponsorWithBackground, sponsor) : null), /*#__PURE__*/React.createElement("div", {
    className: css(styles.relativeElement)
  }, /*#__PURE__*/React.createElement(H1, {
    styles: semanticCSS(styles.titleWithMedia, style),
    fontSizeLarge: titleFontSizeLarge,
    fontSizeMedium: titleFontSizeLarge,
    fontSizeSmall: titleFontSizeSmall
  }, title), shareConfig.length > 0 && /*#__PURE__*/React.createElement(ArticleOnTopTitleShareButton, {
    canonical: canonical,
    shareConfig: shareConfig,
    shareIconColor: media ? shareIconColorForMediaCover : shareIconColor,
    shareIconStyle: shareIconStyle,
    paddingBottomForShareIconsWrapper: getPaddingBottomForShareIconsWrapperWithMediaCover()
  }))) : /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement("div", {
    className: css(styles.relativeElement)
  }, /*#__PURE__*/React.createElement(Image, _extends$1({}, image, {
    imageWidths: imageWidths$2,
    imageAspectRatios: aspectRatios
  })), /*#__PURE__*/React.createElement(CardOverlay, {
    overlayColor: overlayColor
  }), /*#__PURE__*/React.createElement(H1, {
    styles: semanticCSS(styles.title, style),
    fontSizeLarge: titleFontSizeLarge,
    fontSizeMedium: titleFontSizeLarge,
    fontSizeSmall: titleFontSizeSmall
  }, title), hasCredit && /*#__PURE__*/React.createElement("div", {
    className: css(styles.creditWrapper)
  }, /*#__PURE__*/React.createElement(CameraIcon, {
    color: creditColor
  }), /*#__PURE__*/React.createElement("figcaption", {
    className: css(creditFontsStyleBySize, styles.credit),
    dangerouslySetInnerHTML: {
      __html: creditHTML
    }
  })), shareConfig.length > 0 && /*#__PURE__*/React.createElement(ArticleOnTopTitleShareButton, {
    canonical: canonical,
    shareConfig: shareConfig,
    shareIconColor: media ? shareIconColorForMediaCover : shareIconColor,
    shareIconStyle: shareIconStyle
  })), sponsor ? /*#__PURE__*/React.createElement(SponsorWithBackground, sponsor) : null);
};

const createImageAdditionalStyle = () => {
  return StyleSheet.create({
    style: {
      overflow: 'hidden',
      borderRadius: '100%',
      [MEDIA_BREAKPOINTS.large]: {
        height: '200px',
        width: '200px'
      },
      [MEDIA_BREAKPOINTS.medium]: {
        height: '160px',
        width: '160px'
      },
      [MEDIA_BREAKPOINTS.small]: {
        height: '80px',
        width: '80px'
      }
    }
  });
};

const AuthorPremiumImage = props => {
  const {
    image
  } = props;
  const aspectRatio = {
    x: 1,
    y: 1
  };
  const imageWidths = createImageWidths(360, 360, 360);
  const imageAdditionalStyle = createImageAdditionalStyle();
  return /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement(Image, _extends$1({}, image, {
    aspectRatio: aspectRatio,
    imageWidths: imageWidths,
    additionalStyle: imageAdditionalStyle
  })));
};

const componentConfigThemeKey$7 = 'premiumAuthorPage';

const createAuthorPremiumTitleStyle = titleColor => {
  return StyleSheet.create({
    style: {
      color: titleColor
    }
  }).style;
};

const AuthorPremiumTitle = props => {
  const {
    name
  } = props;
  const themeProps = useTheme(componentConfigThemeKey$7);
  const {
    titleFontSizeLarge,
    titleFontSizeSmall,
    titleFontSizeMedium,
    titleColor
  } = themeProps;
  const authorPremiumTitleStyle = createAuthorPremiumTitleStyle(titleColor);
  return /*#__PURE__*/React__default.createElement(H1, {
    fontSizeLarge: titleFontSizeLarge,
    fontSizeSmall: titleFontSizeSmall,
    fontSizeMedium: titleFontSizeMedium,
    styles: semanticCSS(authorPremiumTitleStyle)
  }, name);
};

const createSocialButtonStyle = (socialIconsHoverColor, socialIconsNormalColor) => {
  return StyleSheet.create({
    style: {
      height: `${baseUnit * 1}px`,
      fill: socialIconsNormalColor,
      ':hover': {
        fill: socialIconsHoverColor
      }
    }
  }).style;
};

const createSocialButtonsWrapperStyle = numSocialLinks => {
  return StyleSheet.create({
    style: {
      marginTop: `${baseUnit * 1.5}px`,
      display: 'grid',
      gridColumnGap: `${baseUnit * 1.5}px`,
      gridTemplateColumns: `repeat(${numSocialLinks}, auto)`
    }
  }).style;
};

const AuthorPremiumSocialLinks = props => {
  const {
    socialButtons
  } = props;
  const {
    socialIconsHoverColor,
    socialIconsNormalColor
  } = useTheme(componentConfigThemeKey$7);
  const socialButtonStyle = createSocialButtonStyle(socialIconsHoverColor, socialIconsNormalColor);
  const socialButtonsWrapperStyle = createSocialButtonsWrapperStyle(socialButtons.length);
  return /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement("div", {
    className: css(socialButtonsWrapperStyle)
  }, socialButtons.map((link, index) => {
    const svg = link.src.replace(/<svg/g, `<svg class="${css(socialButtonStyle)}"`);
    return /*#__PURE__*/React__default.createElement(Link, {
      href: link.href,
      key: index,
      rel: "noopener",
      target: "_blank",
      dangerouslySetInnerHTML: {
        __html: svg
      },
      alt: link.alt
    });
  })));
};

const getStyles$5 = (color, baseUnit) => StyleSheet.create({
  p: {
    color,
    marginTop: `${baseUnit / 2}px`
  }
});

const AuthorPremiumByline = ({
  byline
}) => {
  const {
    baseUnit,
    bylineTextColor,
    bylineFontSizeLarge,
    bylineFontSizeMedium,
    bylineFontSizeSmall
  } = useTheme(componentConfigThemeKey$7);
  const styles = getStyles$5(bylineTextColor, baseUnit);
  return /*#__PURE__*/React.createElement(P, {
    styles: semanticCSS(styles.p),
    fontSizeLarge: bylineFontSizeLarge,
    fontSizeMedium: bylineFontSizeMedium,
    fontSizeSmall: bylineFontSizeSmall
  }, byline);
};

const backgroundHeightForLargeScreen = 220;
const backgroundHeightForMediumScreen = 160;
const backgroundHeightForSmallScreen = 80;

const createBackgroundWrapperStyle = (backgroundColor, maxWidth, headerHeights) => {
  return StyleSheet.create({
    style: {
      backgroundColor,
      position: 'absolute',
      top: 0,
      margin: 0,
      maxWidth: `${maxWidth}px`,
      width: '-webkit-fill-available',
      [MEDIA_BREAKPOINTS.large]: {
        paddingTop: `${headerHeights.large * baseUnit}px`,
        height: `${backgroundHeightForLargeScreen}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        paddingTop: `${headerHeights.medium * baseUnit}px`,
        height: `${backgroundHeightForMediumScreen}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        paddingTop: `${headerHeights.small * baseUnit}px`,
        height: `${backgroundHeightForSmallScreen}px`
      }
    }
  }).style;
};

const createAuthorPremiumInfoWrapperStyle = () => {
  return StyleSheet.create({
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      justifyItems: 'center',
      marginBottom: `${baseUnit * 2}px`,
      [MEDIA_BREAKPOINTS.large]: {
        marginTop: `${backgroundHeightForLargeScreen * 0.5}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        marginTop: `${backgroundHeightForMediumScreen * 0.5}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        marginTop: `${backgroundHeightForSmallScreen * 0.5}px`
      }
    }
  }).style;
};

const AuthorPremium = props => {
  const {
    image,
    name,
    byline,
    socialButtons
  } = props;
  const headerHeights = useHeaderHeights();
  const {
    backgroundColor,
    maxWidth
  } = useTheme(componentConfigThemeKey$7);
  const backgroundStyle = createBackgroundWrapperStyle(backgroundColor, maxWidth, headerHeights);
  const authorPremiumInfoWrapperStyle = createAuthorPremiumInfoWrapperStyle();
  return /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement("div", {
    className: css(backgroundStyle)
  }), /*#__PURE__*/React__default.createElement("div", {
    className: css(authorPremiumInfoWrapperStyle)
  }, /*#__PURE__*/React__default.createElement(AuthorPremiumImage, {
    image: image
  }), /*#__PURE__*/React__default.createElement(AuthorPremiumTitle, {
    name: name
  }), byline ? /*#__PURE__*/React__default.createElement(AuthorPremiumByline, {
    byline: byline
  }) : null, socialButtons ? /*#__PURE__*/React__default.createElement(AuthorPremiumSocialLinks, {
    socialButtons: socialButtons
  }) : null));
};

const componentConfigThemeKey$6 = 'twoTwoOTC';

const createStyle$5 = themeProps => {
  const {
    largeHorizontalGap,
    largeVerticalGap,
    mediumHorizontalGap,
    mediumVerticalGap,
    smallHorizontalGap,
    baseUnit
  } = themeProps;
  return StyleSheet.create({
    wrapper: {
      display: 'grid',
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: 'auto',
        gridRowGap: `${largeHorizontalGap * baseUnit}px`,
        gridColumnGap: `${largeVerticalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: 'auto',
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`,
        gridColumnGap: `${mediumVerticalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'auto',
        gridRowGap: `${smallHorizontalGap * baseUnit}px`
      }
    }
  });
};

const imageWidths$1 = createImageWidths(360, 360, 540);
const TwoTwoOTC = props => {
  const {
    cards,
    paddingFactors
  } = props;
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const themeProps = useTheme(componentConfigThemeKey$6);
  const style = createStyle$5(themeProps);
  const themeContextOTC = useThemeOverride({
    titleFontSizeLarge: 'large',
    titleFontSizeMedium: 'bigger',
    titleFontSizeSmall: 'bigger',
    metadataFontSizeLarge: 'big',
    metadataFontSizeMedium: 'big',
    metadataFontSizeSmall: 'big',
    verticalGapLarge: 1,
    verticalGapMedium: 1,
    verticalGapSmall: 0.75,
    horizontalGapLarge: 0.75,
    horizontalGapMedium: 0.75,
    horizontalGapSmall: 0.5
  }, componentConfigThemeKey$O);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle, style.wrapper)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextOTC
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, cards[0], {
    imageWidths: imageWidths$1
  })), /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, cards[1], {
    imageWidths: imageWidths$1
  })), /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, cards[2], {
    imageWidths: imageWidths$1
  })), /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, cards[3], {
    imageWidths: imageWidths$1
  })))));
};

const componentConfigThemeKey$5 = 'fourHCFourVC';
const maximumNumberOfCards = 4;

const createStyle$4 = themeProps => {
  const {
    largeHorizontalGap,
    largeVerticalGap,
    mediumHorizontalGap,
    mediumVerticalGap,
    smallHorizontalGap
  } = themeProps;
  return StyleSheet.create({
    wrapperHC: {
      display: 'grid',
      marginTop: `${baseUnit}px`,
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'auto',
        gridRowGap: `${largeHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'auto',
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'auto',
        gridRowGap: `${smallHorizontalGap * baseUnit}px`
      }
    },
    wrapperVC: {
      display: 'grid',
      marginTop: `${baseUnit}px`,
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: 'auto',
        gridRowGap: `${largeHorizontalGap * baseUnit}px`,
        gridColumnGap: `${largeVerticalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: 'auto',
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`,
        gridColumnGap: `${mediumVerticalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'auto',
        gridRowGap: `${smallHorizontalGap * baseUnit}px`
      }
    }
  });
};

const imageWidthsHC = createImageWidths(180, 360, 540);
const imageWidthsVC = createImageWidths(360, 360, 540);
const FourHCFourVC = props => {
  const {
    cards,
    paddingFactors
  } = props;
  const themeProps = useTheme(componentConfigThemeKey$5);
  const style = createStyle$4(themeProps);
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const themeContextHC = useThemeOverride({
    titleFontSizeLarge: 'large',
    titleFontSizeMedium: 'bigger',
    titleFontSizeSmall: 'bigger',
    metadataFontSizeLarge: 'big',
    metadataFontSizeMedium: 'big',
    metadataFontSizeSmall: 'big',
    descriptionFontSizeLarge: 'normal',
    descriptionFontSizeMedium: 'normal',
    descriptionFontSizeSmall: 'normal',
    showDescriptionInLargeScreen: true,
    showDescriptionInMediumScreen: true,
    verticalGapLarge: 1,
    verticalGapMedium: 1,
    verticalGapSmall: 0.75,
    horizontalGapLarge: 0.75,
    horizontalGapMedium: 0.75,
    horizontalGapSmall: 0.5,
    cardProportionsLarge: {
      x: 1,
      y: 1
    },
    cardProportionsMedium: {
      x: 1,
      y: 1
    },
    cardProportionsSmall: {
      x: 1,
      y: 1
    }
  }, componentConfigThemeKey$K);
  const themeContextVC = useThemeOverride({
    titleFontSizeLarge: 'large',
    titleFontSizeMedium: 'bigger',
    titleFontSizeSmall: 'bigger',
    metadataFontSizeLarge: 'big',
    metadataFontSizeMedium: 'big',
    metadataFontSizeSmall: 'big',
    verticalGapLarge: 1,
    verticalGapMedium: 1,
    verticalGapSmall: 0.75,
    horizontalGapLarge: 0.75,
    horizontalGapMedium: 0.75,
    horizontalGapSmall: 0.5,
    showDescriptionInLargeScreen: true,
    showDescriptionInMediumScreen: true
  }, componentConfigThemeKey$M);

  const createGrids = (cardsProps, index) => {
    return index % 2 === 0 ? /*#__PURE__*/React.createElement("div", {
      className: css(style.wrapperHC, paddingStyle),
      key: index
    }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
      value: themeContextHC
    }, cardsProps && cardsProps.map(card => /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({
      key: card.id
    }, card, {
      imageWidths: imageWidthsHC
    }))).slice(0, maximumNumberOfCards))) : /*#__PURE__*/React.createElement("div", {
      className: css(style.wrapperVC, paddingStyle),
      key: index
    }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
      value: themeContextVC
    }, cardsProps && cardsProps.map(card => /*#__PURE__*/React.createElement(VerticalCard, _extends$1({
      key: card.id
    }, card, {
      imageWidths: imageWidthsVC
    }))).slice(0, maximumNumberOfCards)));
  };

  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && getArticlesInChunks(cards, 4).map(createGrids));
};

const componentConfigThemeKey$4 = 'fiveHLCNumberedList';

const createStyle$3 = themeProps => {
  const {
    dividerWidth,
    baseUnit,
    dividerGapInSmallScreen,
    dividerGapInMediumScreen,
    dividerGapInLargeScreen,
    dividerColor,
    showDivider,
    borderRadius,
    wrapperGapLarge,
    wrapperGapMedium,
    wrapperGapSmall,
    numberColor,
    fontSizesStyles,
    numberFontSizeSmall,
    numberFontSizeMedium,
    numberFontSizeLarge
  } = themeProps;
  return StyleSheet.create({
    wrapper: {
      display: 'grid',
      gridTemplateRows: showDivider ? 'repeat(5, auto 1fr)' : 'repeat(5, 1fr)',
      alignItems: 'center',
      backgroundColor: 'transparent',
      borderRadius: `${borderRadius}px`,
      gridTemplateColumns: '1fr',
      [MEDIA_BREAKPOINTS.large]: {
        gridRowGap: `${dividerGapInLargeScreen * baseUnit}px`,
        padding: `${wrapperGapLarge * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridRowGap: `${dividerGapInMediumScreen * baseUnit}px`,
        padding: `${wrapperGapMedium * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridRowGap: `${dividerGapInSmallScreen * baseUnit}px`,
        padding: `${wrapperGapSmall * baseUnit}px`
      }
    },
    dividerBetweenCards: {
      backgroundColor: dividerColor,
      display: 'block',
      width: '100%',
      height: `${dividerWidth}px`
    },
    numberColor: {
      color: numberColor
    },
    numberTextStyle: { ...getStyleBySize(fontSizesStyles, {
        fontSizeSmall: numberFontSizeSmall,
        fontSizeMedium: numberFontSizeMedium,
        fontSizeLarge: numberFontSizeLarge
      })
    },
    numberAndCardWrapper: {
      flex: '1 1',
      display: 'inline-flex',
      height: 'fit-content',
      alignItems: 'center',
      gap: `${baseUnit}px`,
      padding: `${baseUnit * 0.5}px`
    }
  });
};

const FiveHLCNumberedList = props => {
  const {
    cards
  } = props;
  const themeProps = useTheme(componentConfigThemeKey$4);
  const {
    borderColorTypeActive,
    borderColorTypeHover,
    borderColorTypeNormal,
    boxShadowTypeActive,
    boxShadowTypeHover,
    boxShadowTypeNormal,
    borderWidthTypeActive,
    borderWidthTypeHover,
    borderWidthTypeNormal,
    titleFontSizeLarge,
    titleFontSizeMedium,
    titleFontSizeSmall,
    titleSemanticTag,
    showAuthor,
    showDate,
    fontSizesStyles,
    numberFontSizeSmall,
    numberFontSizeMedium,
    numberFontSizeLarge
  } = themeProps;
  const borderBoxShadow = {
    borderColorTypeActive,
    borderColorTypeHover,
    borderColorTypeNormal,
    borderWidthTypeActive,
    borderWidthTypeHover,
    borderWidthTypeNormal
  };
  const boxShadowStyle = createStyleForBoxShadow({
    boxShadowTypeNormal,
    boxShadowTypeHover,
    boxShadowTypeActive,
    borderBoxShadow
  });
  const {
    showDivider
  } = themeProps;
  const style = createStyle$3(themeProps);
  const numberTextStyle = getStyleBySize(fontSizesStyles, {
    fontSizeSmall: numberFontSizeSmall,
    fontSizeMedium: numberFontSizeMedium,
    fontSizeLarge: numberFontSizeLarge
  });
  const themeContextHeadlineCard = useThemeOverride({
    titleFontSizeLarge,
    titleFontSizeMedium,
    titleFontSizeSmall,
    titleSemanticTag,
    numberOfLinesForTitle: 2,
    showAuthorInLargeScreen: showAuthor,
    showAuthorInMediumScreen: showAuthor,
    showAuthorInSmallScreen: showAuthor,
    showDateInLargeScreen: showDate,
    showDateInMediumScreen: showDate,
    showDateInSmallScreen: showDate
  }, componentConfigThemeKey$g);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(style.wrapper, boxShadowStyle.style)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextHeadlineCard
  }, showDivider ? /*#__PURE__*/React.createElement("div", {
    className: css(style.dividerBetweenCards)
  }) : null, /*#__PURE__*/React.createElement(NumberedHeadlineCard, {
    cardNumber: 1,
    cardProps: cards[0],
    style: style,
    numberStyle: numberTextStyle
  }), showDivider ? /*#__PURE__*/React.createElement("div", {
    className: css(style.dividerBetweenCards)
  }) : null, /*#__PURE__*/React.createElement(NumberedHeadlineCard, {
    cardNumber: 2,
    cardProps: cards[1],
    style: style,
    numberStyle: numberTextStyle
  }), showDivider ? /*#__PURE__*/React.createElement("div", {
    className: css(style.dividerBetweenCards)
  }) : null, /*#__PURE__*/React.createElement(NumberedHeadlineCard, {
    cardNumber: 3,
    cardProps: cards[2],
    style: style,
    numberStyle: numberTextStyle
  }), showDivider ? /*#__PURE__*/React.createElement("div", {
    className: css(style.dividerBetweenCards)
  }) : null, /*#__PURE__*/React.createElement(NumberedHeadlineCard, {
    cardNumber: 4,
    cardProps: cards[3],
    style: style,
    numberStyle: numberTextStyle
  }), showDivider ? /*#__PURE__*/React.createElement("div", {
    className: css(style.dividerBetweenCards)
  }) : null, /*#__PURE__*/React.createElement(NumberedHeadlineCard, {
    cardNumber: 5,
    cardProps: cards[4],
    style: style,
    numberStyle: numberTextStyle
  }))));
};
const NumberedHeadlineCard = props => {
  const {
    cardNumber,
    cardProps,
    style,
    numberStyle
  } = props;
  return /*#__PURE__*/React.createElement("li", {
    className: css(style.numberAndCardWrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: css(style.numberColor, numberStyle)
  }, cardNumber), /*#__PURE__*/React.createElement(HeadlineCard, cardProps));
};

const componentConfigThemeKey$3 = 'oneHC';
const imageWidths = createImageWidths(180, 360, 540);
const OneHC = props => {
  const {
    cards,
    paddingFactors
  } = props;
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const {
    titleFontSizeLarge,
    titleFontSizeMedium,
    titleFontSizeSmall,
    metadataFontSizeLarge,
    metadataFontSizeMedium,
    metadataFontSizeSmall,
    shouldReverseImageAlignment,
    cardProportionsLarge,
    cardProportionsMedium,
    cardProportionsSmall,
    verticalGapLarge,
    verticalGapMedium,
    verticalGapSmall,
    cardBackgroundColor,
    cardTitleColorTypeNormal,
    cardTitleColorTypeHover,
    cardTitleColorTypeActive,
    descriptionColor,
    mainCategoryTextColor,
    mainCategoryBackgroundColor,
    authorColor,
    dateColor,
    pipeColor,
    showDateInLargeScreen,
    showDateInMediumScreen,
    showDateInSmallScreen,
    mainCategoryVerticalGapLarge,
    mainCategoryVerticalGapMedium,
    mainCategoryVerticalGapSmall,
    showMainCategoryInLargeScreen,
    showMainCategoryInMediumScreen,
    showMainCategoryInSmallScreen
  } = useTheme(componentConfigThemeKey$3);
  const themeContextVC = useThemeOverride({
    titleFontSizeLarge,
    titleFontSizeMedium,
    titleFontSizeSmall,
    metadataFontSizeLarge,
    metadataFontSizeMedium,
    metadataFontSizeSmall,
    shouldReverseImageAlignment,
    cardProportionsLarge,
    cardProportionsMedium,
    cardProportionsSmall,
    verticalGapLarge,
    verticalGapMedium,
    verticalGapSmall,
    horizontalGapLarge: 0.75,
    horizontalGapMedium: 0.75,
    horizontalGapSmall: 0.75,
    cardBackgroundColor,
    cardTitleColorTypeNormal,
    cardTitleColorTypeHover,
    cardTitleColorTypeActive,
    descriptionColor,
    mainCategoryTextColor,
    mainCategoryBackgroundColor,
    authorColor,
    dateColor,
    pipeColor,
    showDateInLargeScreen,
    showDateInMediumScreen,
    showDateInSmallScreen,
    showMainCategoryInLargeScreen,
    showMainCategoryInMediumScreen,
    showMainCategoryInSmallScreen,
    mainCategoryVerticalGapLarge,
    mainCategoryVerticalGapMedium,
    mainCategoryVerticalGapSmall
  }, componentConfigThemeKey$K);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextVC
  }, /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({}, cards[0], {
    imageWidths: imageWidths
  })))));
};

const componentConfigThemeKey$2 = 'oneOTCThreeHLC';

const createStyle$2 = themeProps => {
  const {
    largeHorizontalGap,
    largeVerticalGap,
    mediumHorizontalGap,
    mediumVerticalGap,
    smallHorizontalGap,
    showDivider,
    dividerColor,
    dividerWidth
  } = themeProps;
  return StyleSheet.create({
    wrapper: {
      display: 'grid',
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: '2fr 1fr',
        gridColumnGap: `${largeVerticalGap * baseUnit}px`,
        gridRowGap: `${largeHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateColumns: '1fr',
        gridColumnGap: `${mediumVerticalGap * baseUnit}px`,
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateColumns: '1fr',
        gridRowGap: `${smallHorizontalGap * baseUnit}px`
      }
    },
    minorCardsWrapper: {
      display: 'grid',
      gridTemplateRows: showDivider ? 'repeat(3, 1fr auto)' : 'repeat(3, 1fr)',
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: '1fr',
        gridColumnGap: `${largeVerticalGap * baseUnit}px`,
        gridRowGap: `${largeHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateColumns: '1fr',
        gridColumnGap: `${mediumVerticalGap * baseUnit}px`,
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateColumns: '1fr',
        gridRowGap: `${smallHorizontalGap * baseUnit}px`
      }
    },
    dividerBetweenCards: {
      backgroundColor: dividerColor,
      display: 'block',
      width: '100%',
      height: `${dividerWidth}px`
    }
  });
};

const imageWidthsForMainCard = createImageWidths(360, 720, 720);
const onTopCardImageHeightCalculationMethods = createImageHeightCalculationMethods('ASPECT_RATIO', 'ASPECT_RATIO', '100%_HEIGHT');
const OneOTCThreeHLC = props => {
  const {
    cards,
    paddingFactors = {
      large: 0.5,
      medium: 0.5,
      small: 0
    }
  } = props;
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const themeProps = useTheme(componentConfigThemeKey$2);
  const {
    showMainCategoryInLargeScreen,
    showMainCategoryInMediumScreen,
    showMainCategoryInSmallScreen,
    titleFontSizeLargeForHeadlineCard,
    titleFontSizeMediumForHeadlineCard,
    titleFontSizeSmallForHeadlineCard,
    mainCategoryFontSizeLarge,
    mainCategoryFontSizeMedium,
    mainCategoryFontSizeSmall,
    showDivider
  } = themeProps;
  const styles = createStyle$2(themeProps);
  const themeContextFirstCard = useThemeOverride({
    titleFontSizeLarge: 'huge',
    titleFontSizeMedium: 'huge',
    titleFontSizeSmall: 'large',
    metadataFontSizeSmall: 'bigger',
    mainCategoryFontSizeLarge,
    mainCategoryFontSizeMedium,
    mainCategoryFontSizeSmall,
    horizontalGapSmall: 0.5,
    horizontalGapMedium: 0.75,
    horizontalGapLarge: 0.75,
    verticalGapSmall: 0.5,
    verticalGapMedium: 0.75,
    verticalGapLarge: 0.75,
    aspectRatioSmall: {
      x: 16,
      y: 9
    },
    mainCategoryHorizontalGapLarge: 0.25,
    mainCategoryHorizontalGapMedium: 0.25,
    showMainCategoryInLargeScreen,
    showMainCategoryInMediumScreen,
    showMainCategoryInSmallScreen
  }, componentConfigThemeKey$O);
  const themeContextMinorCard = useThemeOverride({
    titleFontSizeLarge: titleFontSizeLargeForHeadlineCard,
    titleFontSizeMedium: titleFontSizeMediumForHeadlineCard,
    titleFontSizeSmall: titleFontSizeSmallForHeadlineCard,
    metadataFontSizeSmall: 'bigger',
    wrapperGapSmall: 0.5,
    wrapperGapMedium: 0.75,
    wrapperGapLarge: 0.75,
    horizontalGapSmall: 0.25,
    horizontalGapMedium: 0,
    horizontalGapLarge: 0.5,
    showMainCategoryInLargeScreen,
    showMainCategoryInMediumScreen,
    showMainCategoryInSmallScreen
  }, componentConfigThemeKey$g);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(paddingStyle, styles.wrapper)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextFirstCard
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, cards[0], {
    imageWidths: imageWidthsForMainCard,
    imageHeightCalculationMethods: onTopCardImageHeightCalculationMethods
  }))), /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextMinorCard
  }, /*#__PURE__*/React.createElement("div", {
    className: css(styles.minorCardsWrapper)
  }, /*#__PURE__*/React.createElement(HeadlineCard, cards[1]), showDivider ? /*#__PURE__*/React.createElement("div", {
    className: css(styles.dividerBetweenCards)
  }) : null, /*#__PURE__*/React.createElement(HeadlineCard, cards[2]), showDivider ? /*#__PURE__*/React.createElement("div", {
    className: css(styles.dividerBetweenCards)
  }) : null, /*#__PURE__*/React.createElement(HeadlineCard, cards[3]), showDivider ? /*#__PURE__*/React.createElement("div", {
    className: css(styles.dividerBetweenCards)
  }) : null))));
};

const createStyle$1 = () => StyleSheet.create({
  wrapper: {
    display: 'grid',
    boxSizing: 'border-box',
    [MEDIA_BREAKPOINTS.large]: {
      gridTemplateColumns: '1fr 1fr',
      gridColumnGap: `${baseUnit}px`
    },
    [MEDIA_BREAKPOINTS.medium]: {
      gridTemplateColumns: '1fr',
      gridRowGap: `${baseUnit * 1.5}px`
    },
    [MEDIA_BREAKPOINTS.small]: {
      gridTemplateColumns: '1fr',
      gridRowGap: `${baseUnit * 1.5}px`
    }
  }
});

const HalfScreenWrapper = props => {
  const {
    children,
    maxWidth,
    paddingFactors
  } = props;
  const style = createStyle$1();
  const sectionStyle = getSectionStyle$1(maxWidth);
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  return /*#__PURE__*/React.createElement("div", {
    className: css(style.wrapper, sectionStyle, paddingStyle)
  }, children);
};

const componentConfigThemeKey$1 = 'oneOTCThreeHCVertical';
const imageWidthsOnTopCard = createImageWidths(360, 720, 540);
const imageWidthsHorizontalCard = createImageWidths(360, 360, 360);

const getStyles$4 = themeProps => {
  const {
    largeHorizontalGap,
    mediumHorizontalGap,
    smallHorizontalGap,
    dividerColor,
    dividerWidth,
    showDividersInLargeScreen,
    showDividersInMediumScreen,
    showDividersInSmallScreen
  } = themeProps;
  const dividerStyle = {
    backgroundColor: dividerColor,
    display: 'block',
    width: '100%',
    height: `${dividerWidth}px`
  };
  return StyleSheet.create({
    section: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      [MEDIA_BREAKPOINTS.large]: {
        gridRowGap: `${largeHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridRowGap: `${smallHorizontalGap * baseUnit}px`
      }
    },
    horizontalCards: {
      display: 'grid',
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateRows: showDividersInLargeScreen ? 'repeat(2, 1fr auto) 1fr' : '1fr 1fr 1fr',
        gridRowGap: `${largeHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateRows: showDividersInMediumScreen ? 'repeat(2, 1fr auto) 1fr' : '1fr 1fr 1fr',
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateRows: showDividersInSmallScreen ? 'repeat(2, 1fr auto) 1fr' : '1fr 1fr 1fr',
        gridRowGap: `${smallHorizontalGap * baseUnit}px`
      }
    },
    dividerBetweenCards: {
      [MEDIA_BREAKPOINTS.large]: showDividersInLargeScreen ? dividerStyle : {
        display: 'none'
      },
      [MEDIA_BREAKPOINTS.medium]: showDividersInMediumScreen ? dividerStyle : {
        display: 'none'
      },
      [MEDIA_BREAKPOINTS.small]: showDividersInSmallScreen ? dividerStyle : {
        display: 'none'
      }
    }
  });
};

const OneOTCThreeHCVertical = props => {
  const {
    cards,
    paddingFactors = {
      large: 0.5,
      medium: 0.5,
      small: 0
    }
  } = props;
  const themeProps = useTheme(componentConfigThemeKey$1);
  const {
    titleFontSizeSmallForOnTopCard,
    metadataFontSizeSmallForOnTopCard,
    mainCategoryFontSizeSmallForOnTopCard,
    verticalGapLargeForOnTopCard,
    horizontalGapLargeForOnTopCard,
    verticalGapMediumForOnTopCard,
    horizontalGapMediumForOnTopCard,
    titleFontSizeLargeForHorizontalCard,
    titleFontSizeMediumForHorizontalCard,
    titleFontSizeSmallForHorizontalCard,
    metadataFontSizeLargeForHorizontalCard,
    metadataFontSizeMediumForHorizontalCard,
    metadataFontSizeSmallForHorizontalCard,
    mainCategoryFontSizeSmallForHorizontalCard,
    verticalGapLargeForHorizontalCard,
    verticalGapMediumForHorizontalCard,
    verticalGapSmallForHorizontalCard,
    horizontalGapLargeForHorizontalCard,
    horizontalGapMediumForHorizontalCard,
    aspectRatioSmallForHorizontalCard,
    aspectRatioMediumForHorizontalCard,
    aspectRatioLargeForHorizontalCard,
    horizontalCardProportionsSmall,
    horizontalCardProportionsMedium,
    horizontalCardProportionsLarge,
    showAuthorInLargeScreen,
    showAuthorInMediumScreen,
    showAuthorInSmallScreen,
    showDescriptionInLargeScreen,
    showDescriptionInMediumScreen,
    showDescriptionInSmallScreen,
    showDateInLargeScreen,
    showDateInMediumScreen,
    showDateInSmallScreen,
    showDividersInSmallScreen,
    showDividersInMediumScreen,
    showDividersInLargeScreen
  } = themeProps;
  const showDivider = showDividersInLargeScreen || showDividersInMediumScreen || showDividersInSmallScreen;
  const styles = getStyles$4(themeProps);
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const onTopCardHeightCalculation = createImageHeightCalculationMethods('ASPECT_RATIO', 'ASPECT_RATIO', 'ASPECT_RATIO');
  const themeContextOTC = useThemeOverride({
    titleFontSizeSmall: titleFontSizeSmallForOnTopCard,
    metadataFontSizeSmall: metadataFontSizeSmallForOnTopCard,
    mainCategoryFontSizeSmall: mainCategoryFontSizeSmallForOnTopCard,
    verticalGapLarge: verticalGapLargeForOnTopCard,
    horizontalGapLarge: horizontalGapLargeForOnTopCard,
    verticalGapMedium: verticalGapMediumForOnTopCard,
    horizontalGapMedium: horizontalGapMediumForOnTopCard
  }, componentConfigThemeKey$O);
  const themeContextHC = useThemeOverride({
    titleFontSizeLarge: titleFontSizeLargeForHorizontalCard,
    titleFontSizeMedium: titleFontSizeMediumForHorizontalCard,
    titleFontSizeSmall: titleFontSizeSmallForHorizontalCard,
    metadataFontSizeLarge: metadataFontSizeLargeForHorizontalCard,
    metadataFontSizeMedium: metadataFontSizeMediumForHorizontalCard,
    metadataFontSizeSmall: metadataFontSizeSmallForHorizontalCard,
    mainCategoryFontSizeSmall: mainCategoryFontSizeSmallForHorizontalCard,
    verticalGapLarge: verticalGapLargeForHorizontalCard,
    verticalGapMedium: verticalGapMediumForHorizontalCard,
    verticalGapSmall: verticalGapSmallForHorizontalCard,
    horizontalGapLarge: horizontalGapLargeForHorizontalCard,
    horizontalGapMedium: horizontalGapMediumForHorizontalCard,
    aspectRatioSmall: aspectRatioSmallForHorizontalCard,
    aspectRatioMedium: aspectRatioMediumForHorizontalCard,
    aspectRatioLarge: aspectRatioLargeForHorizontalCard,
    cardProportionsSmall: horizontalCardProportionsSmall,
    cardProportionsMedium: horizontalCardProportionsMedium,
    cardProportionsLarge: horizontalCardProportionsLarge,
    showAuthorInLargeScreen,
    showAuthorInMediumScreen,
    showAuthorInSmallScreen,
    showDescriptionInLargeScreen,
    showDescriptionInMediumScreen,
    showDescriptionInSmallScreen,
    showDateInLargeScreen,
    showDateInMediumScreen,
    showDateInSmallScreen
  }, componentConfigThemeKey$K);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css(styles.section, paddingStyle)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextOTC
  }, /*#__PURE__*/React.createElement(OnTopCard, _extends$1({}, cards[0], {
    imageWidths: imageWidthsOnTopCard,
    imageHeightCalculationMethods: onTopCardHeightCalculation,
    lazyLoad: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: css(styles.horizontalCards)
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeContextHC
  }, /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({}, cards[1], {
    imageWidths: imageWidthsHorizontalCard
  })), showDivider ? /*#__PURE__*/React.createElement("div", {
    className: css(styles.dividerBetweenCards)
  }) : null, /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({}, cards[2], {
    imageWidths: imageWidthsHorizontalCard
  })), showDivider ? /*#__PURE__*/React.createElement("div", {
    className: css(styles.dividerBetweenCards)
  }) : null, /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({}, cards[3], {
    imageWidths: imageWidthsHorizontalCard
  }))))));
};

const componentConfigThemeKey = 'threeVCThreeHCThreeVCThreeHC';

const createStyle = themeProps => {
  const {
    largeHorizontalGap,
    largeVerticalGap,
    mediumHorizontalGap,
    smallHorizontalGap
  } = themeProps;
  return StyleSheet.create({
    wrapper: {
      display: 'grid'
    },
    verticalCardsGrid: {
      display: 'grid',
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: '1fr 1fr 1fr',
        gridColumnGap: `${largeVerticalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateColumns: '1fr',
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateColumns: '1fr',
        gridRowGap: `${smallHorizontalGap * baseUnit}px`
      },
      marginTop: `${baseUnit}px`,
      marginBottom: `${baseUnit}px`
    },
    horizontalCardsGrid: {
      display: 'grid',
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: '1fr',
        gridRowGap: `${largeHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateColumns: '1fr',
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateColumns: '1fr',
        gridRowGap: `${smallHorizontalGap * baseUnit}px`
      }
    }
  });
};

const ThreeVCThreeHCThreeVCThreeHC = props => {
  const {
    cards,
    paddingFactors
  } = props;
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const themeProps = useTheme(componentConfigThemeKey);
  const {
    showMainCategoryInLargeScreen,
    showMainCategoryInMediumScreen,
    showMainCategoryInSmallScreen
  } = themeProps;
  const style = createStyle(themeProps);
  const themeContextVC = useThemeOverride({
    titleFontSizeLarge: 'large',
    titleFontSizeMedium: 'large',
    titleFontSizeSmall: 'large',
    metadataFontSizeLarge: 'bigger',
    metadataFontSizeMedium: 'bigger',
    metadataFontSizeSmall: 'bigger',
    mainCategoryFontSizeLarge: 'bigger',
    mainCategoryFontSizeMedium: 'bigger',
    mainCategoryFontSizeSmall: 'big',
    verticalGapLarge: 1,
    verticalGapMedium: 1,
    verticalGapSmall: 0.5,
    horizontalGapLarge: 1,
    horizontalGapMedium: 1,
    horizontalGapSmall: 0.5,
    titleAlignment: 'CENTER',
    descriptionAlignment: 'CENTER',
    metadataAlignment: 'CENTER',
    mainCategoryAlignment: 'START',
    showMainCategoryInLargeScreen,
    showMainCategoryInMediumScreen,
    showMainCategoryInSmallScreen
  }, componentConfigThemeKey$M);
  const themeContextHC = useThemeOverride({
    titleFontSizeLarge: 'large',
    titleFontSizeMedium: 'large',
    titleFontSizeSmall: 'large',
    metadataFontSizeLarge: 'bigger',
    metadataFontSizeMedium: 'bigger',
    metadataFontSizeSmall: 'bigger',
    mainCategoryFontSizeLarge: 'bigger',
    mainCategoryFontSizeMedium: 'bigger',
    mainCategoryFontSizeSmall: 'big',
    verticalGapLarge: 1,
    verticalGapMedium: 1,
    verticalGapSmall: 0.5,
    horizontalGapLarge: 1,
    horizontalGapMedium: 1,
    horizontalGapSmall: 0.5,
    cardProportionsLarge: {
      x: 1,
      y: 1
    },
    showMainCategoryInLargeScreen,
    showMainCategoryInMediumScreen,
    showMainCategoryInSmallScreen
  }, componentConfigThemeKey$K);
  const imagesWidthsVC = createImageWidths(360, 360, 360);
  const imagesWidthsHC = createImageWidths(180, 360, 540);

  const createGrids = (cardsProps, index) => {
    return index % 2 === 0 ? /*#__PURE__*/React.createElement("div", {
      className: css(paddingStyle, style.verticalCardsGrid),
      key: index
    }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
      value: themeContextVC
    }, cardsProps.map((card, cardIndex) => /*#__PURE__*/React.createElement(VerticalCard, _extends$1({
      key: cardIndex
    }, card, {
      imageWidths: imagesWidthsVC
    }))))) : /*#__PURE__*/React.createElement("div", {
      className: css(paddingStyle, style.horizontalCardsGrid),
      key: index
    }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
      value: themeContextHC
    }, cardsProps.map((card, cardIndex) => /*#__PURE__*/React.createElement(HorizontalCard, _extends$1({
      key: cardIndex
    }, card, {
      imageWidths: imagesWidthsHC
    })))));
  };

  return /*#__PURE__*/React.createElement(ErrorBoundary, null, cards && cards.length > 0 && getArticlesInChunks(cards, 3).map(createGrids));
};

const creatStyle = (horizontalGapLarge, horizontalGapMedium, horizontalGapSmall, verticalGapLarge, verticalGapMedium, verticalGapSmall, backgroundColor, textColor, marginFactor) => {
  const {
    largeMarginFactor,
    mediumMarginFactor,
    smallMarginFactor
  } = marginFactor;
  return StyleSheet.create({
    style: {
      backgroundColor,
      color: textColor,
      width: 'fit-content',
      display: 'block',
      [MEDIA_BREAKPOINTS.large]: {
        padding: `${horizontalGapLarge * baseUnit}px ${verticalGapLarge * baseUnit}px`,
        marginLeft: `${largeMarginFactor * baseUnit}px`,
        marginTop: `${0.75 * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        padding: `${horizontalGapMedium * baseUnit}px ${verticalGapMedium * baseUnit}px`,
        marginLeft: `${mediumMarginFactor * baseUnit}px`,
        marginTop: `${0.5 * baseUnit}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        padding: `${horizontalGapSmall * baseUnit}px ${verticalGapSmall * baseUnit}px`,
        marginLeft: `${smallMarginFactor * baseUnit}px`,
        marginTop: `${0.5 * baseUnit}px`
      }
    }
  }).style;
};

const MainCategory = props => {
  const {
    displayName,
    link,
    marginFactor,
    isActive
  } = props;
  const {
    mainCategoryFontSizeLarge,
    mainCategoryFontSizeMedium,
    mainCategoryFontSizeSmall,
    mainCategoryTextColor,
    mainCategoryBackgroundColor,
    mainCategoryVerticalGapLarge,
    mainCategoryVerticalGapMedium,
    mainCategoryVerticalGapSmall,
    mainCategoryHorizontalGapLarge,
    mainCategoryHorizontalGapMedium,
    mainCategoryHorizontalGapSmall
  } = useTheme(componentConfigurationKey$o);
  const style = creatStyle(mainCategoryHorizontalGapLarge, mainCategoryHorizontalGapMedium, mainCategoryHorizontalGapSmall, mainCategoryVerticalGapLarge, mainCategoryVerticalGapMedium, mainCategoryVerticalGapSmall, mainCategoryBackgroundColor, mainCategoryTextColor, marginFactor);
  const analyticsEventContext = {
    category: 'Article',
    action: 'Main Category clicked'
  };
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(EventContext.Provider, {
    value: analyticsEventContext
  }, isActive ? /*#__PURE__*/React.createElement(Link, {
    href: link,
    className: css(style)
  }, /*#__PURE__*/React.createElement(Span, {
    fontSizeLarge: mainCategoryFontSizeLarge,
    fontSizeMedium: mainCategoryFontSizeMedium,
    fontSizeSmall: mainCategoryFontSizeSmall
  }, displayName)) : /*#__PURE__*/React.createElement(Span, {
    styles: semanticCSS(style),
    fontSizeLarge: mainCategoryFontSizeLarge,
    fontSizeMedium: mainCategoryFontSizeMedium,
    fontSizeSmall: mainCategoryFontSizeSmall
  }, displayName)));
};

const getStyles$3 = (largeScreenMarginFactors, baseUnit) => StyleSheet.create({
  wrapper: {
    boxSizing: 'border-box',
    display: 'grid',
    gridTemplateColumns: 'minmax(0,1fr)',
    [MEDIA_BREAKPOINTS.large]: {
      marginLeft: `${largeScreenMarginFactors.left * baseUnit}px`,
      marginRight: `${largeScreenMarginFactors.right * baseUnit}px`
    }
  }
});

const OpenWeb = ({
  md5hashPostCanonicalUrl,
  postCanonicalUrl,
  spotId,
  tags,
  largeScreenMarginFactors = {
    left: 0,
    right: 0
  }
}) => {
  const tagsString = Array.isArray(tags) ? tags.join(', ') : tags;
  const {
    baseUnit
  } = useTheme();
  const styles = getStyles$3(largeScreenMarginFactors, baseUnit);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    defer: true,
    src: `https://launcher.spot.im/spot/${spotId}`,
    "data-spotim-module": "spotim-launcher",
    "data-post-url": postCanonicalUrl,
    "data-post-id": md5hashPostCanonicalUrl,
    "data-article-tags": tagsString
  })), /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapper)
  }, /*#__PURE__*/React.createElement("div", {
    "data-spotim-module": "pitc"
  }), /*#__PURE__*/React.createElement("div", {
    "data-spotim-module": "conversation",
    "data-post-id": md5hashPostCanonicalUrl,
    "data-spot-id": spotId
  })));
};

const OpenWebAMP = ({
  postId,
  spotId
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("link", {
    href: "https://fonts.googleapis.com/css?family=Open+Sans&display=swap",
    rel: "stylesheet"
  }), /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-template": "amp-mustache",
    src: "https://cdn.ampproject.org/v0/amp-mustache-0.2.js"
  }), /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-iframe",
    src: "https://cdn.ampproject.org/v0/amp-iframe-0.1.js"
  }), /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-carousel",
    src: "https://cdn.ampproject.org/v0/amp-carousel-0.1.js"
  }), /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-ad",
    src: "https://cdn.ampproject.org/v0/amp-ad-0.1.js"
  }), /*#__PURE__*/React.createElement("script", {
    async: undefined,
    "custom-element": "amp-list",
    src: "https://cdn.ampproject.org/v0/amp-list-0.1.js"
  }), /*#__PURE__*/React.createElement("style", null, `
            .pitc > * {
              box-sizing: border-box;
            }
            .pitc-cover > img {
              object-fit: cover;
              overflow: hidden;
            }
            .pitc-article-title {
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
            }
            .pitc-comment-text {
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
            }
            .pitc-username {
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
            }
            @media only screen and (min-device-width: 320px) and (max-device-width: 350px) {
              .pitc-comment-text {
              -webkit-line-clamp: 1;
              }
            }
            @media only screen and (min-device-width: 350px) and (max-device-width: 400px) {
              .pitc-comment-text {
                -webkit-line-clamp: 2;
              }
            }
            @media only screen and (min-device-width: 320px) and (max-device-width: 350px) {
              .pitc-article-title {
                -webkit-line-clamp: 1;
              }
            }
            @media only screen and (min-device-width: 350px) and (max-device-width: 400px) {
              .pitc-article-title {
                -webkit-line-clamp: 2;
              }
            }
          `)), /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: `
        <div style="padding:8px">
          <amp-list width="auto" height="400" layout="fixed-height" items="items" src="https://recirculation.spot.im/spot/json/${spotId}">
            <template type="amp-mustache" id="amp-spotim-rc">
              <div class="pitc">
                <div style="font-family:Open Sans;height:35px;margin-top:15px;margin-bottom:10px;font-size:18px;font-weight:800;color:#373e44">
                  Popular in the Community
                </div>
                <amp-carousel type="slides" width="400" height="400" layout="responsive" autoplay="" delay="6000">
                  {{#values}}
                  <div style="font-family:Open Sans;width:95%;height:95%;position:relative;border-radius:7px;background-color:#fff;box-shadow:0 2px 10px 0 rgba(0, 0, 0, 0.1)">
                    <a style="text-decoration:none;color:#000" href="{{ url }}">
                      <div style="border-top-left-radius:7px;border-top-right-radius:7px;height:50%;width:100%">
                        <amp-img class="pitc-cover" style="border-top-left-radius:7px;border-top-right-radius:7px" src="{{ image }}" width="600" height="300" layout="responsive" alt="{{ title }}"></amp-img>
                        <div style="background-image:linear-gradient( to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.9));width:100%;height:50%;position:absolute;bottom:50%;left:0"></div>
                        <div class="pitc-article-title" style="font-family:Open Sans;margin-bottom:15px;margin-left:15px;margin-right:15px;text-align:left;font-size:16px;font-weight:600;position:absolute;bottom:50%;left:0%;color:#fff;display:-webkit-box;overflow:hidden">
                          {{ title }}
                        </div>
                      </div>
                      <div style="height:50%;width:100%;padding:15px;font-size:15px;line-height:normal;display:flex;flex-direction:column;justify-content:space-between;box-sizing:border-box;position:relative;font-weight:normal">
                        <div style="font-family:Open Sans;display:flex;flex-direction:row;margin-bottom:12px;line-height:30px;text-align:center">
                          <amp-img width="30" height="30" src="{{ avatar }}"></amp-img>
                          <div class="pitc-username" style="font-family:Open Sans;font-weight:600;margin-left:8px;display:-webkit-box;overflow:hidden;word-break:break-all">
                            {{ username }}
                          </div>
                          <div style="font-family:Open Sans;margin-left:7px;margin-right:5px;color:#727579">·</div>
                          <div style="font-family:Open Sans;color:#727579">
                            {{ time }}
                          </div>
                        </div>
                        <div class="pitc-comment-text" style="font-family:Open Sans;color:#373e44;margin-bottom:15px;display:-webkit-box;overflow:hidden">
                          {{ messageText }}
                        </div>
                        <div style="font-family:Open Sans;margin-bottom:0;margin-top:auto;display:flex;flex-direction:row;font-size:14px;font-weight:600">
                          <svg style="height:18px;width:18px;margin-right:5px;display:inline" viewBox="0 0 12 14">
                            <path fill="#DB3737" fill-rule="nonzero" d="M4.429 14C2.857 13.53.666 11.476.517 9.048.368 6.621 1.2 5.181 2.702 3.56 3.704 2.479 4.415 1.292 4.835 0 6.683 1.454 8.28 4.292 8.28 7.327c.673-.549 1.173-1.355 1.501-2.42 1.391 1.29 2.003 3.278 1.595 5.184C10.97 11.985 9.143 13.53 7.57 14v-.412c1.572-.906 2.59-2.717 2.347-5a5.116 5.116 0 0 1-3.132 1.882c.078-3.045-.39-5.302-1.4-6.771C4.224 5.393 3.14 5.944 2.53 7.327c-1.174 2.66.326 5.355 1.898 6.261V14z"></path>
                          </svg>
                          Top Comment
                        </div>
                      </div>
                    </a>
                  </div>
                  {{/values}}
                </amp-carousel>
              </div>
            </template>
          </amp-list>
          <a data-spmark="ad-choice" href="https://dynamic-cdn.spot.im/yad/optout.html" target="_blank">
            <amp-img src="https://publisher-assets.spot.im/yad/ad-choises.png" width="9px" height="9px"></amp-img>
          </a>
          <amp-list width="auto" height="1" layout="fixed-height" items="items" style="text-align:center" src="https://spotops.spot.im/spot/${spotId}/recirculation/amp">
            <template type="amp-mustache">
              {{#isDisplay}}
              <amp-ad type="{{type}}" width="{{width}}" height="{{height}}" data-slot="{{ code }}" json='{"targeting":{"ampRCSpotId":["${spotId}"]}}' rtc-config='{"vendors":{"IndexExchange":{"SITE_ID":58771}},"timeoutMillis":1000}'>
                <div placeholder=""></div>
                <div fallback=""></div>
              </amp-ad>
              {{/isDisplay}}{{#isAniviewVideo}}
              <amp-ad type="{{type}}" width="{{width}}" height="{{height}}" data-playonview="1" data-pauseonunseen="1" data-publisherid="5e0e296628a061270b21ccab" data-channelid="{{code}}" data-ref1="AV_CUSTOM1={{seller_id}}&AV_CUSTOM2=${spotId}" data-passbackurl="https://play.aniview.com/57b31584f83f1518108b4568/5e71193539e7c102b4435af3/spotimpassback.js"></amp-ad>
              {{/isAniviewVideo}}{{#isSRVideo}}
              <amp-ad type="{{type}}" width="{{width}}" height="{{height}}" data-blade_player_type="{{type}}" data-blade_player_id="{{code}}" data-blade_api_key="587dfc37febaab0002000001" data-blade_macros="{sub_id:spotId=${spotId}&source=recirculation_amp}"></amp-ad>
              {{/isSRVideo}}
            </template>
          </amp-list>
          <amp-iframe width="375" height="350" sandbox="allow-scripts allow-same-origin allow-popups allow-top-navigation" layout="responsive" frameborder="0" src="https://amp.spot.im/production.html?redirect=true&spot_im_highlight_immediate=true&spotId=${spotId}&postId=${postId}">
            <amp-img placeholder="true" height="815" layout="fill" src="//amp.spot.im/loader.png"></amp-img>
            <div overflow="" class="spot-im-amp-overflow" tabindex="0" role="button" aria-label="Read more">
              Load more...
            </div>
          </amp-iframe>
        </div>
        `
    }
  }));
};

const getStyles$2 = baseUnit => {
  return StyleSheet.create({
    wrapper: {
      display: 'flex',
      justifyContent: 'center',
      margin: 'auto',
      [MEDIA_BREAKPOINTS.large]: {
        marginTop: `${baseUnit * 4}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        marginTop: `${baseUnit * 2}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        marginTop: `${baseUnit}px`
      }
    }
  });
};

const getLinkStyle$1 = (baseUnit, nextDisabledBackgroundColor, nextBackgroundColor, nextDisabledTextColor, nextTextColor, isDisabled) => {
  return StyleSheet.create({
    style: {
      padding: `${baseUnit / 2}px ${baseUnit * 4}px`,
      textAlign: 'center',
      backgroundColor: isDisabled ? nextDisabledBackgroundColor : nextBackgroundColor,
      color: isDisabled ? nextDisabledTextColor : nextTextColor
    }
  });
};

const SlideshowBottomBarAmp = ({
  nextLink,
  nextText
}) => {
  const {
    baseUnit,
    slideshowButtonBackgroundColor,
    slideshowButtonDisabledBackgroundColor,
    slideshowButtonDisabledTextColor,
    slideshowButtonTextColor
  } = useTheme(componentConfigurationKey$o);
  const isDisabled = !nextLink;
  const styles = getStyles$2(baseUnit);
  const linkStyle = getLinkStyle$1(baseUnit, slideshowButtonDisabledBackgroundColor, slideshowButtonBackgroundColor, slideshowButtonDisabledTextColor, slideshowButtonTextColor, isDisabled);
  return /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapper)
  }, /*#__PURE__*/React.createElement(LinkWithButtonStyle, {
    href: nextLink,
    additionalStyle: linkStyle,
    disabled: isDisabled
  }, /*#__PURE__*/React.createElement(Span, null, nextText)));
};

const getStyles$1 = (baseUnit, slideNumberTextColor, dividerColor, blockStyle) => {
  return StyleSheet.create({
    wrapper: { ...blockStyle,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: `${baseUnit}px auto 0 auto`,
      position: 'relative'
    },
    divider: {
      height: '1px',
      backgroundColor: dividerColor,
      width: '100%',
      margin: `0 ${baseUnit / 2}px`
    },
    currentSlide: {
      whiteSpace: 'nowrap',
      color: slideNumberTextColor
    },
    anchor: {
      position: 'absolute',
      top: '-25px'
    }
  });
};

const getLinkStyle = (baseUnit, shouldShow, backgroundColor, disabledBackgroundColor, textColor, disabledTextColor) => {
  return StyleSheet.create({
    style: {
      padding: `${baseUnit / 2}px ${baseUnit}px`,
      backgroundColor: shouldShow ? backgroundColor : disabledBackgroundColor,
      color: shouldShow ? textColor : disabledTextColor
    }
  });
};

const SlideshowTopBarAmp = ({
  prevLink,
  nextLink,
  currentSlide,
  totalSlides,
  prevText,
  nextText,
  ofText,
  blockWidths,
  overrideBlockPadding,
  anchorId
}) => {
  const themeProps = useTheme(componentConfigurationKey$o);
  const {
    baseUnit,
    slideshowButtonBackgroundColor,
    slideshowButtonDisabledBackgroundColor,
    slideshowButtonTextColor,
    slideshowButtonDisabledTextColor,
    slideshowNumberColor,
    slideshowDividerColor
  } = themeProps;
  const showPrev = !!prevLink;
  const showNext = !!nextLink;
  const blockStyle = createBlockStyle$1(blockWidths, overrideBlockPadding);
  const styles = getStyles$1(baseUnit, slideshowNumberColor, slideshowDividerColor, blockStyle);
  const prevStyle = getLinkStyle(baseUnit, showPrev, slideshowButtonBackgroundColor, slideshowButtonDisabledBackgroundColor, slideshowButtonTextColor, slideshowButtonDisabledTextColor);
  const nextStyle = getLinkStyle(baseUnit, showNext, slideshowButtonBackgroundColor, slideshowButtonDisabledBackgroundColor, slideshowButtonTextColor, slideshowButtonDisabledTextColor);
  const onKeyboarEvent = React.useCallback(e => {
    if (e.key === 'ArrowLeft' && showPrev) {
      window.location.href = prevLink;
    } else if (e.key === 'ArrowRight' && showNext) {
      window.location.href = nextLink;
    }
  }, [showNext, showPrev, nextLink, prevLink]);
  React.useEffect(() => {
    window.addEventListener('keyup', onKeyboarEvent);
    return () => {
      window.removeEventListener('keyup', onKeyboarEvent);
    };
  }, [onKeyboarEvent]);
  const anchorIdAttribute = anchorId ? {
    id: anchorId
  } : {};
  return /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapper)
  }, /*#__PURE__*/React.createElement("div", _extends$1({
    className: css(styles.anchor)
  }, anchorIdAttribute)), /*#__PURE__*/React.createElement(LinkWithButtonStyle, {
    href: prevLink,
    additionalStyle: prevStyle,
    disabled: !showPrev
  }, /*#__PURE__*/React.createElement(Span, null, prevText)), /*#__PURE__*/React.createElement("div", {
    className: css(styles.divider)
  }), currentSlide !== null && /*#__PURE__*/React.createElement(Span, {
    styles: semanticCSS(styles.currentSlide)
  }, `${currentSlide + 1} ${ofText} ${totalSlides}`), /*#__PURE__*/React.createElement("div", {
    className: css(styles.divider)
  }), /*#__PURE__*/React.createElement(LinkWithButtonStyle, {
    href: nextLink,
    additionalStyle: nextStyle,
    disabled: !showNext
  }, /*#__PURE__*/React.createElement(Span, null, nextText)));
};

const SlideshowAmp = ({
  children,
  ...topBarProps
}) => {
  const {
    nextLink,
    nextText,
    totalSlides
  } = topBarProps;

  if (totalSlides === 0) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SlideshowTopBarAmp, topBarProps), children, /*#__PURE__*/React.createElement(SlideshowBottomBarAmp, {
    nextLink: nextLink,
    nextText: nextText
  }));
};

const componentConfigurationKey = 'articleDisclaimer';

const getWrapperStyle$1 = ({
  textColor,
  dividersColor,
  showDividersInSmallScreen,
  showDividersInMediumScreen,
  showDividersInLargeScreen,
  horizontalGapInLargeScreen,
  horizontalGapInMediumScreen,
  horizontalGapInSmallScreen,
  textAlignment,
  baseUnit
}) => {
  const dividersStyleForBeforeAndAfterPseudoElements = {
    content: '""',
    display: 'block',
    borderTop: `1px solid ${dividersColor}`
  };
  return StyleSheet.create({
    style: {
      color: textColor,
      fontStyle: 'italic',
      display: 'block',
      textAlign: textAlignment === consts.ALIGNMENT_OPTIONS.CENTER ? 'center' : 'left',
      [MEDIA_BREAKPOINTS.large]: showDividersInLargeScreen ? {
        ':before': { ...dividersStyleForBeforeAndAfterPseudoElements,
          marginBottom: `${horizontalGapInLargeScreen * baseUnit}px`
        },
        ':after': { ...dividersStyleForBeforeAndAfterPseudoElements,
          marginTop: `${horizontalGapInLargeScreen * baseUnit}px`
        }
      } : {
        padding: `${horizontalGapInLargeScreen * baseUnit}px 0`
      },
      [MEDIA_BREAKPOINTS.medium]: showDividersInMediumScreen ? {
        ':before': { ...dividersStyleForBeforeAndAfterPseudoElements,
          marginBottom: `${horizontalGapInMediumScreen * baseUnit}px`
        },
        ':after': { ...dividersStyleForBeforeAndAfterPseudoElements,
          marginTop: `${horizontalGapInMediumScreen * baseUnit}px`
        }
      } : {
        padding: `${horizontalGapInMediumScreen * baseUnit}px 0`
      },
      [MEDIA_BREAKPOINTS.small]: showDividersInSmallScreen ? {
        ':before': { ...dividersStyleForBeforeAndAfterPseudoElements,
          marginBottom: `${horizontalGapInSmallScreen * baseUnit}px`
        },
        ':after': { ...dividersStyleForBeforeAndAfterPseudoElements,
          marginTop: `${horizontalGapInSmallScreen * baseUnit}px`
        }
      } : {
        padding: `${horizontalGapInSmallScreen * baseUnit}px 0`
      }
    }
  }).style;
};

const getDefaultBlocksWidthsStyle = defaultBlocksWidths => {
  return StyleSheet.create({
    style: { ...createBlockStyle$1(defaultBlocksWidths)
    }
  }).style;
};

const Disclaimer = props => {
  const {
    text,
    defaultBlocksWidths
  } = props;
  const theme = useTheme(componentConfigurationKey);
  const {
    fontSizeLarge,
    fontSizeMedium,
    fontSizeSmall,
    fontSizesStyles,
    baseUnit
  } = theme;
  const {
    marginBetweenBlocksFactor
  } = useTheme(componentConfigurationKey$c);
  const wrapperStyle = getWrapperStyle$1(theme);
  const textStyle = getStyleBySize(fontSizesStyles, {
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge
  });
  const defaultBlocksWidthsStyle = getDefaultBlocksWidthsStyle(defaultBlocksWidths);
  return /*#__PURE__*/React__default.createElement("small", {
    className: css(wrapperStyle, textStyle, createBlockStyleSheet(baseUnit, marginBetweenBlocksFactor).style, defaultBlocksWidthsStyle)
  }, text);
};

const createStyles = (baseUnit, isSingleButton) => StyleSheet.create({
  container: {
    display: 'grid',
    justifyContent: 'center',
    gridTemplateColumns: isSingleButton ? '1fr' : '1fr 1fr',
    margin: '0 auto',
    overflowAnchor: 'none',
    [MEDIA_BREAKPOINTS.large]: {
      marginTop: `${baseUnit * 2}px`,
      marginBottom: `${baseUnit}px`,
      columnGap: `${baseUnit * 0.75}px`,
      width: isSingleButton ? '350px' : '450px'
    },
    [MEDIA_BREAKPOINTS.medium]: {
      marginTop: `${baseUnit * 1.5}px`,
      marginBottom: `${baseUnit * 0.5}px`,
      columnGap: `${baseUnit * 0.75}px`,
      width: isSingleButton ? '350px' : '450px'
    },
    [MEDIA_BREAKPOINTS.small]: {
      marginTop: `${baseUnit}px`,
      marginBottom: 0,
      paddingLeft: '10px',
      paddingRight: '10px',
      columnGap: `${baseUnit / 2}px`,
      width: '-webkit-fill-available'
    }
  }
});

const linkPadding = StyleSheet.create({
  style: {
    padding: '8px 16px'
  }
});
const PaginationButtonGroup = ({
  prevURL,
  nextURL,
  prevText,
  nextText
}) => {
  const {
    baseUnit
  } = useTheme();
  const showPrev = !!prevURL;
  const showNext = !!nextURL;
  const style = createStyles(baseUnit, !(showPrev && showNext));
  return /*#__PURE__*/React__default.createElement("div", {
    className: css(style.container)
  }, showPrev ? /*#__PURE__*/React__default.createElement(LinkWithButtonStyle, {
    href: prevURL,
    additionalStyle: linkPadding,
    secondary: true
  }, prevText) : null, showNext ? /*#__PURE__*/React__default.createElement(LinkWithButtonStyle, {
    href: nextURL,
    additionalStyle: linkPadding
  }, nextText) : null);
};

const getStyles = baseUnit => {
  return StyleSheet.create({
    wrapper: {
      display: 'grid',
      width: '100%',
      gridTemplateRows: '1fr',
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: '1fr 300px',
        gridColumnGap: `${baseUnit * 2}px`,
        marginTop: `${baseUnit * 2}px`
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateColumns: '1fr',
        marginTop: `${baseUnit * 0.75}px`
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateColumns: '1fr',
        marginTop: `${baseUnit * 0.75}px`
      }
    }
  });
};

const WidgetContentAndSidebar = props => {
  const {
    adId1,
    adId2,
    children,
    adOnSuccess2,
    adOnSuccess1
  } = props;
  const {
    baseUnit
  } = useTheme();
  const styles = getStyles(baseUnit);
  return /*#__PURE__*/React.createElement("div", {
    className: css(styles.wrapper)
  }, /*#__PURE__*/React.createElement("main", null, children), /*#__PURE__*/React.createElement(PostAside, {
    adId1: adId1,
    adId2: adId2,
    adOnSuccess1: adOnSuccess1,
    adOnSuccess2: adOnSuccess2,
    disableDefaultWrapperPadding: true
  }));
};

const decorationLineHeight = 4;

const getTitlesWrapperStyle = () => {
  return StyleSheet.create({
    style: {
      width: '100%',
      display: 'grid',
      gridRowGap: `${baseUnit * 0.5}px`
    }
  }).style;
};

const getWrapperStyle = () => {
  return StyleSheet.create({
    style: {
      width: '100%',
      display: 'grid',
      gridRowGap: `${baseUnit}px`
    }
  }).style;
};

const TitleWithSubtitleAndDivider = props => {
  const {
    title,
    subtitle
  } = props;
  const titlesWrapperStyle = getTitlesWrapperStyle();
  const wrapperStyle = getWrapperStyle();
  return /*#__PURE__*/React__default.createElement("div", {
    className: css(wrapperStyle)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css(titlesWrapperStyle)
  }, title ? /*#__PURE__*/React__default.createElement(PrimarySectionTitle, null, title) : null, subtitle ? /*#__PURE__*/React__default.createElement(SecondarySectionTitle, null, subtitle) : null), /*#__PURE__*/React__default.createElement(DecorationLine, {
    height: decorationLineHeight
  }));
};

const createOnClickEvent = cardIndex => {
  return () => {
    window.mmClientApi = window.mmClientApi || [];
    window.mmClientApi.push('analytics', {
      event_category: 'Article',
      event_action: 'manual recommendation clicked',
      event_label: `link=[${cardIndex + 1}]`
    });
  };
};

const ManualPostsRecommendation = props => {
  const {
    cards
  } = props;
  const cardsWithOnClickEvents = cards.map((card, index) => ({ ...card,
    onClick: createOnClickEvent(index)
  }));
  const viewabilityCallback = React__default.useCallback(() => {
    // @ts-ignore
    window.mmClientApi = window.mmClientApi || []; // @ts-ignore

    window.mmClientApi.push('analytics', {
      event_category: 'Article',
      event_action: 'manual recommendation viewable impression',
      event_label: ''
    });
  }, []);
  return /*#__PURE__*/React__default.createElement(ViewabilityElement, {
    viewabilityCallback: viewabilityCallback,
    threshold: 1
  }, /*#__PURE__*/React__default.createElement(OneOTCThreeVC, {
    cards: cardsWithOnClickEvents
  }));
};

export { AMPAd, AMPAnalytics, AMPAppContent, AMPArticleContent, AMPArticleTitleWrapper, AMPCover, AMPHeaderAndSideBar, AMPImage, AMPMainWrapper, AMPRecommendationsAdvertisement, AMPSocialContainer, AMPSponsor, Ad, AmpFooter, AmpHeaderHeights, AmpWebFonts, AnnouncementCard, AppContent, ArticleContent, ArticleDividerWithIcon, ArticleImage, ArticleMainImage, ArticleOnTopTitle, ArticleTitle, ArticleTitleWithoutMetaData, Author, AuthorPremium, AuthorsWithRoundImage, Button, ContentAndSidebar, ContentWithoutSidebar, DisableMainCategory, Disclaimer, EmbedPostMainContent, Error$1 as Error, ErrorBoundary, ErrorReporting, ExternalScripts, FiveHLCNumberedList, Footer, FourHC, FourHCFourVC, FourVC, FourVCForOneThird, FourVCOneOTC, FullWidthOTC, FullWidthPostMainContent, H1, H2, HUGE_SCREEN_SIZE, HalfScreenWrapper, Header, HeaderHeights, HeadlinesArticleList, HighlightsArticleList, HoverAuthorsWithRoundImage, ImageWithCaptionAndIcon, LARGE_SCREEN_SIZE, LinkWithButtonStyle, LoadMoreButtonWrapper, MEDIA_BREAKPOINTS, MMPlayerPlaceHolder, MainCategory, MainWrapperForAmpHeaderNavigation, MainWrapperForNavigation, ManualPostsRecommendation, MetaHeaderTags, NineHCForOneThird, OldHeader, OnTopCardsPostRecommendations, OneHC, OneHCThreeVC, OneOTCFourVC, OneOTCThreeHCVertical, OneOTCThreeHLC, OneOTCThreeVC, OneOnTopThreeHorizontalArticleList, OneThreeArticleList, OneThreeOTC, OneTwoOTCHorizontal, OneTwoOnTopFullWidth, OneTwoTwoOTC, OpenWeb, OpenWebAMP, PaginationButtonGroup, PostAside, PostContentWithAside, PostMainContent, PostMetaHeaderTags, PostWithoutSidebarMainContent, PrimarySectionTitle, Quote, RecommendationsAdvertisement, SafeArticleContentWrapper, ScrollableArticleList, SecondarySectionTitle, Section, SectionDividerWithIcon, SectionHeader, SectionHeaderWithBackground, SectionOnTopTitle, SectionWithTitle, ShareButton, SixHC, SixHCForTwoThirds, SixSixArticleList, SixSixPostRecommendations, Slideshow, SlideshowAmp, Sponsor, SwitchableShareMenu, ThemeProviderWithFonts, ThreeHC, ThreeHCOneOTC, ThreeThreeVC, ThreeVC, ThreeVCExpandable, ThreeVCThreeHCThreeVCThreeHC, TitleDotsBackgroundImage, TitleWithSubtitleAndDivider, TrianglesIconForDivider, TwoOTCFourHLC, TwoOneTwoArticleList, TwoThirdsOneThirdWrapper, TwoTwoOTC, ViewabilityElement, WebFonts, WidgetContentAndSidebar, baseUnit };
//# sourceMappingURL=components.bundle.esm.js.map
